/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Blob: { input: any; output: any };
  Date: { input: any; output: any };
  DateTime: { input: any; output: any };
  JSONObject: { input: any; output: any };
  Long: { input: any; output: any };
  PhoneNumber: { input: any; output: any };
  TimeIntervalInMillis: { input: any; output: any };
  TimestampInMillis: { input: any; output: any };
};

export type AiVideoTags = {
  __typename?: 'AIVideoTags';
  potential_cellphone_usage?: Maybe<Scalars['Boolean']['output']>;
  seatbelt_detection?: Maybe<SeatbeltDetection>;
};

export type AccessPoints = {
  __typename?: 'AccessPoints';
  /** The wifi list for the fleet. */
  access_points?: Maybe<Array<Maybe<WifiSetting>>>;
};

export type AcessibleFleets = {
  __typename?: 'AcessibleFleets';
  associated_at?: Maybe<Scalars['String']['output']>;
  fleet_id?: Maybe<Scalars['String']['output']>;
  groups_restriction?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  role?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type ActivationTask = {
  __typename?: 'ActivationTask';
  category: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ActivationTaskInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ActivitiesSummary = {
  __typename?: 'ActivitiesSummary';
  completed: ExecutionDigestSummary;
  not_completed: ExecutionDigestSummary;
  total: Scalars['Int']['output'];
  waiting: ExecutionDigestSummary;
};

export type ActivitiesSummaryInput = {
  devices_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  drivers_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  end_time?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  routes_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  start_time?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  text_filter?: InputMaybe<Scalars['String']['input']>;
  vehicles_ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Activity = {
  __typename?: 'Activity';
  additional_info?: Maybe<Scalars['String']['output']>;
  arrival_time?: Maybe<Scalars['TimestampInMillis']['output']>;
  completion_status?: Maybe<ActivityCompletionStatus>;
  created_at: Scalars['TimestampInMillis']['output'];
  destination: Destination;
  device_id?: Maybe<Scalars['String']['output']>;
  driver_id?: Maybe<Scalars['ID']['output']>;
  driver_name?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['TimestampInMillis']['output']>;
  executed_duration?: Maybe<Scalars['TimeIntervalInMillis']['output']>;
  executed_end_time?: Maybe<Scalars['TimestampInMillis']['output']>;
  fleet_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  load_size?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  planned_distance_in_meters?: Maybe<Scalars['Int']['output']>;
  planned_duration?: Maybe<Scalars['TimeIntervalInMillis']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  proof_of_conclusion?: Maybe<OldProofOfConclusion>;
  route_id?: Maybe<Scalars['ID']['output']>;
  route_name?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['TimestampInMillis']['output']>;
  time_windows?: Maybe<Array<TimeWindow>>;
  type: ActivityType;
  updated_at: Scalars['TimestampInMillis']['output'];
  vehicle_id?: Maybe<Scalars['ID']['output']>;
  visit_status: ActivityVisitStatus;
  waiting_time?: Maybe<Scalars['TimeIntervalInMillis']['output']>;
};

export enum ActivityCompletionStatus {
  Completed = 'COMPLETED',
  NotCompleted = 'NOT_COMPLETED',
  PartiallyCompleted = 'PARTIALLY_COMPLETED',
  Planned = 'PLANNED',
}

export type ActivityReport = {
  __typename?: 'ActivityReport';
  completion_status?: Maybe<ActivityCompletionStatus>;
  destination: Destination;
  driver?: Maybe<Driver>;
  duration: PlannedVsExecutedDurationTimeInMillis;
  end_time: PlannedVsExecutedTimestampInMillis;
  id: Scalars['ID']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  observations?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  start_time: PlannedVsExecutedTimestampInMillis;
  time_windows?: Maybe<Array<TimeWindow>>;
  type: ActivityType;
  vehicle?: Maybe<VehicleDto>;
  visit_status: ActivityVisitStatus;
};

export enum ActivityRouteRelation {
  ActivitiesWithinRoute = 'ACTIVITIES_WITHIN_ROUTE',
  ActivitiesWithoutRoute = 'ACTIVITIES_WITHOUT_ROUTE',
  AllActivities = 'ALL_ACTIVITIES',
}

export enum ActivityType {
  End = 'END',
  Start = 'START',
  Stop = 'STOP',
}

export type ActivityUpdate = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input_activity?: InputMaybe<InputActivity>;
  type?: InputMaybe<ActivityType>;
};

export type ActivityVehicleAssociationInput = {
  device_id?: InputMaybe<Scalars['String']['input']>;
  driver_id?: InputMaybe<Scalars['ID']['input']>;
  driver_name?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  vehicle_id?: InputMaybe<Scalars['ID']['input']>;
};

export enum ActivityVisitStatus {
  NotVisited = 'NOT_VISITED',
  OnSite = 'ON_SITE',
  Pending = 'PENDING',
  Visited = 'VISITED',
}

export type AdasEvents = {
  __typename?: 'AdasEvents';
  forward_collision_warning: SensibilityConfiguration;
  min_speed_trigger_in_km_per_h: Scalars['Int']['output'];
  /** Distância insegura. Null when the fleet never set it apart: it then follows forward_collision_warning */
  tail_gating?: Maybe<SensibilityConfiguration>;
};

export type AdasEventsInput = {
  forward_collision_warning: SensibilityConfigurationInput;
  min_speed_trigger_in_km_per_h: Scalars['Int']['input'];
  tail_gating?: InputMaybe<SensibilityConfigurationInput>;
};

export type AddDriver = {
  cpf?: InputMaybe<Scalars['String']['input']>;
  driver_license?: InputMaybe<Scalars['String']['input']>;
  first_license_acquirement_date?: InputMaybe<Scalars['Date']['input']>;
  license_category?: InputMaybe<Scalars['String']['input']>;
  license_expiration_date?: InputMaybe<Scalars['Date']['input']>;
  name: Scalars['String']['input'];
  phone_number?: InputMaybe<Scalars['String']['input']>;
  profile_image_base64?: InputMaybe<Scalars['String']['input']>;
  registry_id?: InputMaybe<Scalars['String']['input']>;
};

export type AddressInformation = {
  __typename?: 'AddressInformation';
  additionalInformation?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type AggregatedSpeedEventsSummary = {
  __typename?: 'AggregatedSpeedEventsSummary';
  highEvents: Scalars['Int']['output'];
  higherEvents: Scalars['Int']['output'];
  mediumEvents: Scalars['Int']['output'];
  totalEvents: Scalars['Int']['output'];
};

export type ApplyGroupRecommendationInput = {
  name: Scalars['String']['input'];
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleIds: Array<Scalars['ID']['input']>;
};

/** How archived videos are treated when listing media */
export enum ArchivedMediaFilter {
  /** Hide archived videos */
  Exclude = 'EXCLUDE',
  /** Archived and not archived videos */
  Include = 'INCLUDE',
  /** Only archived videos, the most recently archived first */
  Only = 'ONLY',
}

export type AssociatedContact = {
  __typename?: 'AssociatedContact';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type AssociationConfig = {
  __typename?: 'AssociationConfig';
  entire_fleet_association_config?: Maybe<EntireFleetAssociationConfig>;
};

export type AssociationConfigInput = {
  entire_fleet_association_config: EntireFleetAssociationConfigInput;
};

export type AudioCoachingDevicesInfo = {
  __typename?: 'AudioCoachingDevicesInfo';
  /** The status of the camera audio. */
  audio_status: AudioStatus;
  /** Device identifier. A number between 10 and 15 digits */
  device_id: Scalars['String']['output'];
  /** Last time that the camera changed from config in RFC 3339 format */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type AudioCoachingDevicesInfoPage = {
  __typename?: 'AudioCoachingDevicesInfoPage';
  content?: Maybe<Array<Maybe<AudioCoachingDevicesInfo>>>;
  empty?: Maybe<Scalars['Boolean']['output']>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  number_of_elements?: Maybe<Scalars['Int']['output']>;
  pageable?: Maybe<PageableObject>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<SortType>;
  total_elements?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export type AudioFileResponse = {
  __typename?: 'AudioFileResponse';
  /** Public HTTPS URL to download the audio file from S3. */
  audioUrl: Scalars['String']['output'];
};

export enum AudioStatus {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Off = 'OFF',
  /** ON is deprecated and should be replaced with LOW, MEDIUM or HIGH */
  On = 'ON',
}

export type AvgFuelConsumptionAndCostPerKmResponse = {
  __typename?: 'AvgFuelConsumptionAndCostPerKmResponse';
  avgCostPerKm: Scalars['Float']['output'];
  avgFuelConsumption: Scalars['Float']['output'];
  chartGroup?: Maybe<Scalars['String']['output']>;
  endInterval: Scalars['String']['output'];
  isCompleted: Scalars['Boolean']['output'];
  startInterval: Scalars['String']['output'];
};

export type BatchCreateDriverItemInput = {
  cpf?: InputMaybe<Scalars['String']['input']>;
  driver_license?: InputMaybe<Scalars['String']['input']>;
  first_license_acquirement_date?: InputMaybe<Scalars['Date']['input']>;
  license_category?: InputMaybe<Scalars['String']['input']>;
  license_expiration_date?: InputMaybe<Scalars['Date']['input']>;
  name: Scalars['String']['input'];
  phone_number?: InputMaybe<Scalars['String']['input']>;
  registry_id?: InputMaybe<Scalars['String']['input']>;
};

export type BatchCreateDriversInput = {
  drivers: Array<BatchCreateDriverItemInput>;
};

export type BatchCreateIdentificationTokenItemInput = {
  driverId?: InputMaybe<Scalars['ID']['input']>;
  tokenId: Scalars['String']['input'];
};

export type BatchCreateIdentificationTokensInput = {
  items: Array<BatchCreateIdentificationTokenItemInput>;
};

export type BatchCreateVehicleInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  branding?: InputMaybe<BrandingInput>;
  fuel?: InputMaybe<FuelInput>;
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  licensePlate: Scalars['String']['input'];
  size?: InputMaybe<Scalars['String']['input']>;
  speedInKmh?: InputMaybe<Scalars['Int']['input']>;
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BatchSuggestionInput = {
  plates?: InputMaybe<Array<Scalars['String']['input']>>;
  vins?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BatchSuggestionsResponse = {
  __typename?: 'BatchSuggestionsResponse';
  results: Array<VehicleSuggestionEntry>;
};

export type Billet = {
  __typename?: 'Billet';
  barCode?: Maybe<Scalars['String']['output']>;
  boletoLink?: Maybe<Scalars['String']['output']>;
  cardCode?: Maybe<Scalars['String']['output']>;
  cardName?: Maybe<Scalars['String']['output']>;
  dataEmissao?: Maybe<Scalars['String']['output']>;
  dataVencimento?: Maybe<Scalars['String']['output']>;
  datePayment?: Maybe<Scalars['String']['output']>;
  diaProRata?: Maybe<Scalars['String']['output']>;
  digitableLine?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  idCompany?: Maybe<Scalars['Long']['output']>;
  idContract?: Maybe<Scalars['String']['output']>;
  idDoc?: Maybe<Scalars['String']['output']>;
  nfeDataEmissao?: Maybe<Scalars['String']['output']>;
  nfeHoraEmissao?: Maybe<Scalars['String']['output']>;
  nfeIdContract?: Maybe<Scalars['String']['output']>;
  nfeLink?: Maybe<Scalars['String']['output']>;
  nfeTitleValue?: Maybe<Scalars['String']['output']>;
  nrDocEntry?: Maybe<Scalars['String']['output']>;
  nrDocumento?: Maybe<Scalars['String']['output']>;
  nrNfse?: Maybe<Scalars['String']['output']>;
  nrNoteEntry?: Maybe<Scalars['String']['output']>;
  payedValue?: Maybe<Scalars['String']['output']>;
  runnedAt?: Maybe<Scalars['Int']['output']>;
  seqCode?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  titleValue?: Maybe<Scalars['String']['output']>;
  validFrom?: Maybe<Scalars['DateTime']['output']>;
  validTo?: Maybe<Scalars['DateTime']['output']>;
};

export type Branding = {
  __typename?: 'Branding';
  brand?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type BrandingInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
}

export type CameraConfigurationInfo = {
  __typename?: 'CameraConfigurationInfo';
  /** The status of the camera audio. */
  audio_status?: Maybe<AudioStatus>;
  /** Device identifier. A number between 10 and 15 digits */
  device_id: Scalars['String']['output'];
  /** The duty type of the vehicle. */
  duty_type?: Maybe<DutyType>;
  /** Recording resolution of the camera */
  recording_resolution?: Maybe<RecordingResolution>;
  /** The desired speed limit to audio warning */
  speed_limit_warning_in_kmph?: Maybe<Scalars['Float']['output']>;
  /** Last time that the camera changed from config in RFC 3339 format */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type CameraConfigurationInfoPage = {
  __typename?: 'CameraConfigurationInfoPage';
  content?: Maybe<Array<Maybe<CameraConfigurationInfo>>>;
  empty?: Maybe<Scalars['Boolean']['output']>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  number_of_elements?: Maybe<Scalars['Int']['output']>;
  pageable?: Maybe<PageableObject>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<SortType>;
  total_elements?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export type CameraConfigurationUpdateInput = {
  /** The status of the camera audio. */
  audio_status?: InputMaybe<AudioStatus>;
  /** Device identifier. A number between 10 and 15 digits */
  device_id: Scalars['String']['input'];
  /** The duty type of the vehicle. */
  duty_type?: InputMaybe<DutyType>;
  /** Recording resolution of the camera */
  recording_resolution?: InputMaybe<RecordingResolution>;
  /** The desired speed limit to audio warning */
  speed_limit_warning_in_kmph?: InputMaybe<Scalars['Float']['input']>;
};

export type CameraEventsConfiguration = {
  __typename?: 'CameraEventsConfiguration';
  entire_fleet_camera_events_configuration: EventsConfiguration;
};

export type CancelOperationalSituationInput = {
  id: Scalars['ID']['input'];
};

export type Category = {
  __typename?: 'Category';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CategoryCost = {
  __typename?: 'CategoryCost';
  cost: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/**
 * Move de 1 a 100 tratativas para o mesmo status, tudo ou nada. RESOLVED exige `note` (1 a 500
 * caracteres) e `assigneeUserId` de um usuário da frota; o responsável só é aceito ao resolver.
 */
export type ChangeChecklistNonConformityStatusInput = {
  assigneeUserId?: InputMaybe<Scalars['ID']['input']>;
  expectedVersions?: InputMaybe<Array<ChecklistNonConformityVersionInput>>;
  ids: Array<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  targetStatus: ChecklistNonConformityStatus;
};

export type CheckContent = {
  __typename?: 'CheckContent';
  checked?: Maybe<Scalars['Boolean']['output']>;
};

export type Checklist = {
  __typename?: 'Checklist';
  completed_count?: Maybe<Scalars['Int']['output']>;
  /**
   * Compliance of the response as a whole, rolled up from its questions by ryuk.
   * Nullable on purpose: older ryuk versions do not send it, and templates never carry one.
   */
  compliance_status?: Maybe<ChecklistComplianceStatus>;
  context?: Maybe<Context>;
  created_at: Scalars['Float']['output'];
  created_by: Scalars['String']['output'];
  fields: Array<Field>;
  groups: Array<ChecklistConfiguredGroup>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  non_conform_field_count?: Maybe<Scalars['Int']['output']>;
  pending_photos_field_count?: Maybe<Scalars['Int']['output']>;
  /**
   * True when the response still has a field that requires photos and has not received them yet.
   * Nullable on purpose: ryuk only started sending it in #215, so older versions resolve to null.
   */
  photos_pending?: Maybe<Scalars['Boolean']['output']>;
  template: Scalars['Boolean']['output'];
  template_active?: Maybe<Scalars['Boolean']['output']>;
  template_created_at?: Maybe<Scalars['Float']['output']>;
  template_created_by?: Maybe<Scalars['String']['output']>;
  template_id?: Maybe<Scalars['String']['output']>;
  vehicle_group_ids?: Maybe<Array<Scalars['ID']['output']>>;
  vehicle_ids?: Maybe<Array<Scalars['ID']['output']>>;
  vehicles: Array<ChecklistConfiguredVehicle>;
  version: Scalars['Int']['output'];
};

/**
 * Whether picking an option counts as conform. Set by the manager on the template and copied into
 * each answer when it is created.
 */
export enum ChecklistCompliance {
  Conform = 'CONFORM',
  NonConform = 'NON_CONFORM',
}

/**
 * Compliance of a response as a whole. NOT_APPLICABLE covers a response whose template marks no
 * option, including every response answered before compliance existed.
 */
export enum ChecklistComplianceStatus {
  Conform = 'CONFORM',
  NonConform = 'NON_CONFORM',
  NotApplicable = 'NOT_APPLICABLE',
}

export type ChecklistConfiguredGroup = {
  __typename?: 'ChecklistConfiguredGroup';
  id: Scalars['ID']['output'];
  path: Scalars['String']['output'];
};

export type ChecklistConfiguredVehicle = {
  __typename?: 'ChecklistConfiguredVehicle';
  group_id?: Maybe<Scalars['ID']['output']>;
  group_path: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ChecklistNonConformitiesFilter = {
  /** Só as tratativas que têm ocorrência nesta resposta. */
  checklistId?: InputMaybe<Scalars['ID']['input']>;
  driverNames?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Busca no título da pergunta, na placa e no nome do motorista. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Padrão 25. */
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ChecklistNonConformitySort>;
  /** Início do período, sobre a última reprovação. */
  startDate?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  statuses?: InputMaybe<Array<ChecklistNonConformityStatus>>;
  templateIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Tratativa (na interface) de um item não conforme de checklist: uma pergunta de um modelo que reprovou
 * num veículo, acompanhada até alguém tratar. Reprovações seguidas da mesma pergunta no mesmo veículo
 * viram ocorrências da mesma tratativa enquanto ela está ativa.
 */
export type ChecklistNonConformity = {
  __typename?: 'ChecklistNonConformity';
  /** Quem foi indicado como responsável ao resolver. Nulo se o usuário não existe mais na frota. */
  assignee?: Maybe<FleetUser>;
  checklistTemplate: ChecklistNonConformityTemplate;
  /** Motorista da última reprovação, pelo nome: o checklist não guarda id de motorista. */
  driverName?: Maybe<Scalars['String']['output']>;
  firstDetectedAt: Scalars['TimestampInMillis']['output'];
  /** Trilha imutável, da entrada mais nova para a mais antiga. */
  history?: Maybe<Array<ChecklistNonConformityHistoryEntry>>;
  id: Scalars['ID']['output'];
  /** Resposta da última reprovação, para abrir o checklist completo. */
  lastChecklistId: Scalars['ID']['output'];
  lastDetectedAt: Scalars['TimestampInMillis']['output'];
  /** Placa registrada na última reprovação. */
  licensePlate?: Maybe<Scalars['String']['output']>;
  occurrenceCount: Scalars['Int']['output'];
  /** Respostas que reprovaram, da mais nova para a mais antiga. */
  occurrences?: Maybe<Array<ChecklistNonConformityOccurrence>>;
  /** Identidade estável da pergunta no modelo, a mesma de `Field.questionKey`. */
  questionKey: Scalars['ID']['output'];
  /** Título da pergunta na última reprovação. */
  questionTitle: Scalars['String']['output'];
  /** Observação da última mudança de status para RESOLVED ou DISMISSED. */
  resolutionNote?: Maybe<Scalars['String']['output']>;
  status: ChecklistNonConformityStatus;
  statusChangedAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  /** Quem fez a última mudança de status. Nulo quando foi o sistema ou o usuário não existe mais. */
  statusChangedBy?: Maybe<FleetUser>;
  /** O veículo hoje. Nulo se ele foi excluído; a placa da reprovação continua em `licensePlate`. */
  vehicle?: Maybe<VehicleDto>;
  vehicleId: Scalars['ID']['output'];
  /** Envie em `expectedVersions` para que a mudança de status recuse um estado que outra pessoa já alterou. */
  version: Scalars['Int']['output'];
};

export type ChecklistNonConformityHistoryEntry = {
  __typename?: 'ChecklistNonConformityHistoryEntry';
  actor?: Maybe<FleetUser>;
  /** Nome de quem agiu no momento do registro. Nulo quando foi o sistema. */
  actorName?: Maybe<Scalars['String']['output']>;
  assignee?: Maybe<FleetUser>;
  /** Resposta que causou a entrada, quando foi uma reprovação, retirada ou auto-resolução. */
  checklistId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['TimestampInMillis']['output'];
  fromStatus?: Maybe<ChecklistNonConformityStatus>;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  toStatus?: Maybe<ChecklistNonConformityStatus>;
  type: ChecklistNonConformityHistoryEntryType;
};

export enum ChecklistNonConformityHistoryEntryType {
  /** Primeira reprovação: abriu a tratativa. */
  Detected = 'DETECTED',
  /** Nova reprovação da mesma pergunta no mesmo veículo enquanto a tratativa estava ativa. */
  OccurrenceAdded = 'OCCURRENCE_ADDED',
  /** A resposta foi editada para conforme ou apagada, e deixou de sustentar a tratativa. */
  OccurrenceWithdrawn = 'OCCURRENCE_WITHDRAWN',
  StatusChanged = 'STATUS_CHANGED',
}

export type ChecklistNonConformityOccurrence = {
  __typename?: 'ChecklistNonConformityOccurrence';
  checklistId: Scalars['ID']['output'];
  detectedAt: Scalars['TimestampInMillis']['output'];
  driverName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Preenchido quando a resposta foi editada para conforme ou apagada. */
  withdrawnAt?: Maybe<Scalars['TimestampInMillis']['output']>;
};

export type ChecklistNonConformityPageInfo = {
  __typename?: 'ChecklistNonConformityPageInfo';
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ChecklistNonConformityPaginated = {
  __typename?: 'ChecklistNonConformityPaginated';
  content: Array<ChecklistNonConformity>;
  page: ChecklistNonConformityPageInfo;
};

export type ChecklistNonConformitySort = {
  column?: ChecklistNonConformitySortColumn;
  order?: Order;
};

export enum ChecklistNonConformitySortColumn {
  FirstDetectedAt = 'FIRST_DETECTED_AT',
  LastDetectedAt = 'LAST_DETECTED_AT',
  OccurrenceCount = 'OCCURRENCE_COUNT',
  QuestionTitle = 'QUESTION_TITLE',
  Status = 'STATUS',
}

/**
 * Onde a tratativa está. AUTO_RESOLVED só o sistema aplica, quando a resposta seguinte do mesmo veículo
 * vem conforme; RESOLVED e AUTO_RESOLVED são finais e DISMISSED é o único estado que pode ser reaberto.
 */
export enum ChecklistNonConformityStatus {
  AutoResolved = 'AUTO_RESOLVED',
  Dismissed = 'DISMISSED',
  InTreatment = 'IN_TREATMENT',
  Open = 'OPEN',
  Resolved = 'RESOLVED',
}

/** Contagem por status para os mesmos filtros da fila. */
export type ChecklistNonConformitySummary = {
  __typename?: 'ChecklistNonConformitySummary';
  autoResolved: Scalars['Int']['output'];
  dismissed: Scalars['Int']['output'];
  inTreatment: Scalars['Int']['output'];
  open: Scalars['Int']['output'];
  resolved: Scalars['Int']['output'];
};

/** O modelo de checklist em que a pergunta reprovou. O nome continua disponível mesmo com o modelo apagado. */
export type ChecklistNonConformityTemplate = {
  __typename?: 'ChecklistNonConformityTemplate';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ChecklistNonConformityVersionInput = {
  id: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};

export type ChecklistVehicle = {
  __typename?: 'ChecklistVehicle';
  alias?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  device_id: Scalars['String']['output'];
  /** @deprecated Snapshot from the driver app; stays null when the vehicle joined its group after the association opened (BUG-2708). Use `Context.group_path` instead. */
  group_id?: Maybe<Scalars['String']['output']>;
  license_plate?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
};

export type ChecklistsNames = {
  __typename?: 'ChecklistsNames';
  names: Array<Maybe<Scalars['String']['output']>>;
};

export type ChecklistsPage = {
  __typename?: 'ChecklistsPage';
  page: PaginatedChecklists;
};

export type ClientInformation = {
  __typename?: 'ClientInformation';
  additionalInformation?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  installationDoneByClient?: Maybe<Scalars['Boolean']['output']>;
  installationProblem?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  responsibleForTrackingScheduling?: Maybe<Scalars['String']['output']>;
  secondaryPhone?: Maybe<Scalars['String']['output']>;
};

export type CoachingEvidence = {
  __typename?: 'CoachingEvidence';
  files?: Maybe<Array<Maybe<CoachingEvidenceFile>>>;
  id?: Maybe<Scalars['ID']['output']>;
  media?: Maybe<MediaResponse>;
  media_id?: Maybe<Scalars['ID']['output']>;
  safety_occurrences?: Maybe<Array<Maybe<SafetyOccurrence>>>;
  type?: Maybe<CoachingEvidenceType>;
};

export type CoachingEvidenceFile = {
  __typename?: 'CoachingEvidenceFile';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  file_timestamp?: Maybe<Scalars['Int']['output']>;
  file_type: CoachingFileType;
  file_url: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export enum CoachingEvidenceType {
  Media = 'MEDIA',
}

export type CoachingFeedback = {
  __typename?: 'CoachingFeedback';
  coaching_evidences?: Maybe<Array<Maybe<CoachingEvidence>>>;
  created_at: Scalars['DateTime']['output'];
  created_by_user?: Maybe<FleetUser>;
  driver?: Maybe<Driver>;
  feedback_action?: Maybe<CoachingFeedbackAction>;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  note_author?: Maybe<FleetUser>;
  note_created_at?: Maybe<Scalars['DateTime']['output']>;
  status: CoachingFeedbackStatus;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by_user?: Maybe<FleetUser>;
};

export enum CoachingFeedbackAction {
  Dismissal = 'DISMISSAL',
  Guidance = 'GUIDANCE',
  NoAction = 'NO_ACTION',
  Suspension = 'SUSPENSION',
  Warning = 'WARNING',
}

export type CoachingFeedbackInput = {
  driverIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  fromUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  mediaId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  safetyOccurrenceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Array<InputMaybe<CoachingFeedbackStatus>>>;
  toUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CoachingFeedbackPage = {
  __typename?: 'CoachingFeedbackPage';
  content?: Maybe<Array<Maybe<CoachingFeedback>>>;
  empty: Scalars['Boolean']['output'];
  first: Scalars['Boolean']['output'];
  last: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  number_of_elements: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  total_elements: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export enum CoachingFeedbackStatus {
  AddingEvidences = 'ADDING_EVIDENCES',
  Applying = 'APPLYING',
  Finished = 'FINISHED',
}

export enum CoachingFileType {
  CustomUpload = 'CUSTOM_UPLOAD',
  Thumbnail = 'THUMBNAIL',
  VideoFrame = 'VIDEO_FRAME',
}

export type CoblerInformation = {
  __typename?: 'CoblerInformation';
  contactResponsible?: Maybe<Scalars['String']['output']>;
  responsible?: Maybe<Scalars['String']['output']>;
  schedulingResponsible?: Maybe<Scalars['String']['output']>;
  technicianResponsible?: Maybe<Scalars['String']['output']>;
};

export type ColumnMapEntryInput = {
  key: Scalars['String']['input'];
  value: ColumnMapInput;
};

export type ColumnMapInput = {
  name: Scalars['String']['input'];
  position: Scalars['String']['input'];
};

export type CompletionData = {
  __typename?: 'CompletionData';
  fleetSize?: Maybe<Scalars['Int']['output']>;
  openTicketsToInstall?: Maybe<Scalars['Int']['output']>;
  vehicleInstalledCount?: Maybe<Scalars['Int']['output']>;
};

export enum ConditionCategory {
  DeviceHealthStatusObservationPeriodNormal = 'DEVICE_HEALTH_STATUS_OBSERVATION_PERIOD_NORMAL',
  DeviceHealthStatusObservationPeriodNormalUnavailable = 'DEVICE_HEALTH_STATUS_OBSERVATION_PERIOD_NORMAL_UNAVAILABLE',
  DeviceHealthStatusObservationPeriodUnavailable = 'DEVICE_HEALTH_STATUS_OBSERVATION_PERIOD_UNAVAILABLE',
  GeofenceIn = 'GEOFENCE_IN',
  GeofenceInOut = 'GEOFENCE_IN_OUT',
  GeofenceOut = 'GEOFENCE_OUT',
  IdleEngine_3Minutes = 'IDLE_ENGINE_3_MINUTES',
  IdleEngine_5Minutes = 'IDLE_ENGINE_5_MINUTES',
  IdleEngine_10Minutes = 'IDLE_ENGINE_10_MINUTES',
  IdleEngine_15Minutes = 'IDLE_ENGINE_15_MINUTES',
  IdleEngine_30Minutes = 'IDLE_ENGINE_30_MINUTES',
}

export type ConferenceEventResponse = {
  __typename?: 'ConferenceEventResponse';
  actorId?: Maybe<Scalars['ID']['output']>;
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  occurredAt: Scalars['TimestampInMillis']['output'];
  payload?: Maybe<Scalars['JSONObject']['output']>;
};

export type ConferenceReviewResponse = {
  __typename?: 'ConferenceReviewResponse';
  createdAt: Scalars['TimestampInMillis']['output'];
  id: Scalars['ID']['output'];
  observation?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  reviewedBy?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<ConferenceReviewStatus>;
};

export enum ConferenceReviewStatus {
  MarkedSuspicious = 'MARKED_SUSPICIOUS',
  Reviewed = 'REVIEWED',
}

/**
 * O mesmo pacote retornado tanto pela consulta quanto pelas duas mutations de
 * revisão (BE-14/BE-15, ADR-008) -- marcar ou reabrir já devolve o drawer
 * inteiro atualizado, sem round-trip extra.
 */
export type ConferenceTransactionResponse = {
  __typename?: 'ConferenceTransactionResponse';
  /**
   * Estado da conferência, calculado pelo frentista na leitura (ADR-011): AWAITING_EVALUATION,
   * NO_DIVERGENCE, NEEDS_REVIEW, REVIEWED ou MARKED_SUSPICIOUS. É String e não enum de propósito, como
   * `ruleEvaluations.result` e `events.eventType`: um estado novo do frentista não pode derrubar a query.
   */
  conferenceStatus: Scalars['String']['output'];
  evaluatedAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  events: Array<ConferenceEventResponse>;
  review?: Maybe<ConferenceReviewResponse>;
  ruleEvaluations: Array<RuleEvaluationResponse>;
  transaction: FuelTransactionResponse;
};

export type ContactInformation = {
  __typename?: 'ContactInformation';
  bestContactTime?: Maybe<Scalars['String']['output']>;
  bestWayToContact?: Maybe<Scalars['String']['output']>;
  contactMethod?: Maybe<Scalars['String']['output']>;
  contactMethodForResponsibleForInstallation?: Maybe<Scalars['String']['output']>;
};

export type Context = {
  __typename?: 'Context';
  address?: Maybe<Scalars['String']['output']>;
  app_version: Scalars['String']['output'];
  /**
   * Vehicle's group path, resolved server-side by ryuk (see BUG-2708). Prefer over
   * `vehicle.group_id`. `0/` means the fleet root (not the same as null); null means ryuk had
   * nothing to resolve from.
   */
  group_path?: Maybe<Scalars['String']['output']>;
  vehicle?: Maybe<ChecklistVehicle>;
};

export type Coordinate = {
  __typename?: 'Coordinate';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type CoordinateInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type CreateCheckpointManualInput = {
  odometerInKm: Scalars['Long']['input'];
  odometerReferenceDate: Scalars['String']['input'];
  vehicleId: Scalars['ID']['input'];
};

export type CreateFleetAudioMessageInput = {
  /** The text content to be converted to audio using text-to-speech. */
  message: Scalars['String']['input'];
  /** Optional name/identifier for the audio message. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFuelTransactionInput = {
  costCenterDescription?: InputMaybe<Scalars['String']['input']>;
  costCenterId?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  driverName?: InputMaybe<Scalars['String']['input']>;
  fuelType: Scalars['String']['input'];
  integrationId?: InputMaybe<Scalars['ID']['input']>;
  licensePlate: Scalars['String']['input'];
  merchant?: InputMaybe<MerchantCreateInput>;
  odometerInKm: Scalars['Float']['input'];
  quantityInLiters: Scalars['Float']['input'];
  totalCost: Scalars['Float']['input'];
  transactionTime: Scalars['String']['input'];
};

export type CreateMaintenanceHistoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  occurrenceAt: Scalars['DateTime']['input'];
  odometerInKms?: InputMaybe<Scalars['Float']['input']>;
  /** Parada que originou o registro, quando ele vem da sugestão. */
  operationalSituationId?: InputMaybe<Scalars['ID']['input']>;
  parts?: InputMaybe<Array<InputMaybe<MaintenancePartInput>>>;
  reminderId?: InputMaybe<Scalars['ID']['input']>;
  totalPrice?: InputMaybe<Scalars['Float']['input']>;
  types: Array<InputMaybe<Scalars['String']['input']>>;
  vehicleId: Scalars['ID']['input'];
};

export type CreateMaintenancePartsInput = {
  description: Scalars['String']['input'];
};

export type CreateManualOdometerResponse = {
  __typename?: 'CreateManualOdometerResponse';
  manualOdometer: ManualOdometer;
  vehicle: VehicleDto;
};

export type CreateMediaRequest = {
  /** Device identifier. A string between 10 and 15 characters. */
  device_id?: InputMaybe<Scalars['String']['input']>;
  /**
   * Enable email notification when the requested media is available.
   * If empty will be considered as false.
   */
  enable_email_notification?: InputMaybe<Scalars['Boolean']['input']>;
  /** Desired media end Unix timestamp in millis. */
  end_time: Scalars['TimestampInMillis']['input'];
  /**
   * Allow a full timelapse media of the selected period.
   * If empty it will be considered false.
   */
  is_timelapse?: InputMaybe<Scalars['Boolean']['input']>;
  /** Desired media start Unix timestamp in millis. */
  start_time: Scalars['TimestampInMillis']['input'];
  /**
   * Fleet policy trigger that originated the request.
   * Only set when the media is requested from an alert; the request origin itself
   * is derived downstream, not sent by the client.
   */
  triggerId?: InputMaybe<Scalars['ID']['input']>;
  /** Trip identifier. */
  trip_id?: InputMaybe<Scalars['String']['input']>;
  /** Vehicle identifier. An UUID */
  vehicle_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateMediaResponse = {
  __typename?: 'CreateMediaResponse';
  /** Device identifier. A string between 10 and 15 characters. */
  device_id?: Maybe<Scalars['String']['output']>;
  /** List of emails that will be notified when the request is completed. */
  emails_to_notify?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Desired media end Unix timestamp in millis. */
  end_time: Scalars['TimestampInMillis']['output'];
  /** MediaId from the created media. */
  media_id?: Maybe<Scalars['ID']['output']>;
  /** Desired media start Unix timestamp in millis. */
  start_time: Scalars['TimestampInMillis']['output'];
  /** Vehicle identifier. An UUID */
  vehicle_id?: Maybe<Scalars['ID']['output']>;
};

export type CreateOperationalSituationInput = {
  /** Não é aceito para RESERVE de dispositivo, porque a flag legada isSpare não seria reposta na expiração. */
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Lembrete de manutenção que originou a situação, quando ela vem da sugestão. */
  reminderId?: InputMaybe<Scalars['ID']['input']>;
  situation: OperationalSituationType;
  /** Default: agora. Não pode ser no futuro. */
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  targetId: Scalars['String']['input'];
  targetType: OperationalSituationTargetType;
};

export type CreateReminderInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  recurrenceInDays?: InputMaybe<Scalars['Int']['input']>;
  recurrenceInKm?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title: ReminderTitleInput;
  vehicles: Array<CreateReminderVehicleInput>;
};

export type CreateReminderVehicleInput = {
  id: Scalars['ID']['input'];
  nextRecurrenceDate?: InputMaybe<Scalars['DateTime']['input']>;
  nextRecurrenceInKm?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateVehicleInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  branding?: InputMaybe<BrandingInput>;
  driverId?: InputMaybe<Scalars['ID']['input']>;
  fuel?: InputMaybe<FuelInput>;
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  installedDeviceId?: InputMaybe<Scalars['String']['input']>;
  licensePlate: Scalars['String']['input'];
  size?: InputMaybe<Scalars['String']['input']>;
  speedInKmh?: InputMaybe<Scalars['Int']['input']>;
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateVehiclesBatchInput = {
  vehicles: Array<BatchCreateVehicleInput>;
};

export type CrmOrder = {
  __typename?: 'CrmOrder';
  associatedContact?: Maybe<AssociatedContact>;
  createdAt?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  deviceTotalQuantity?: Maybe<DeviceTotalQuantity>;
  fleetId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  orderClass?: Maybe<Scalars['String']['output']>;
  pipeline?: Maybe<Scalars['String']['output']>;
  responsibleName?: Maybe<Scalars['String']['output']>;
  tickets?: Maybe<Array<Maybe<ITicket>>>;
};

export type CustomDashboard = {
  __typename?: 'CustomDashboard';
  description: Scalars['String']['output'];
  externalDashboardId: Scalars['String']['output'];
  filters: Array<CustomDashboardFilter>;
  fleets: Array<CustomDashboardFleet>;
  id: Scalars['ID']['output'];
  isPublic: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type CustomDashboardFilter = {
  __typename?: 'CustomDashboardFilter';
  filterKey: Scalars['String']['output'];
  filterName: Scalars['String']['output'];
};

export type CustomDashboardFleet = {
  __typename?: 'CustomDashboardFleet';
  fleetId: Scalars['ID']['output'];
  groupsRestrictions: Array<Scalars['String']['output']>;
};

export type DateInformation = {
  __typename?: 'DateInformation';
  installedDate?: Maybe<Scalars['String']['output']>;
  preferredDay1?: Maybe<Scalars['String']['output']>;
  preferredDay2?: Maybe<Scalars['String']['output']>;
  preferredDay3?: Maybe<Scalars['String']['output']>;
  preferredHour1?: Maybe<Scalars['String']['output']>;
  preferredHour2?: Maybe<Scalars['String']['output']>;
  preferredHour3?: Maybe<Scalars['String']['output']>;
  scheduledDay?: Maybe<Scalars['String']['output']>;
  scheduledHour?: Maybe<Scalars['String']['output']>;
};

export type DateRange = {
  end: Scalars['Float']['input'];
  start: Scalars['Float']['input'];
};

export type DeleteActivitiesIds = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DeleteChecklist = {
  id: Scalars['ID']['input'];
};

export type DeleteDriver = {
  id: Scalars['ID']['input'];
};

export type DeleteFuelTransactionsInput = {
  transactionIds: Array<Scalars['ID']['input']>;
};

export type DeleteMaintenanceHistoryInput = {
  id: Scalars['ID']['input'];
};

export type DeleteMaintenancePartsInput = {
  id: Scalars['ID']['input'];
};

export type DeleteMaintenanceReminderInput = {
  id: Scalars['ID']['input'];
};

export type DeleteRoutesInput = {
  ids: Array<Scalars['ID']['input']>;
  propagation_type?: InputMaybe<Scalars['String']['input']>;
};

export type Destination = {
  __typename?: 'Destination';
  city?: Maybe<Scalars['String']['output']>;
  coordinate: Coordinate;
  country?: Maybe<Scalars['String']['output']>;
  neighborhood?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street_address?: Maybe<Scalars['String']['output']>;
  street_complement?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
};

export type DestinationInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  coordinate: CoordinateInput;
  country?: InputMaybe<Scalars['String']['input']>;
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street_address?: InputMaybe<Scalars['String']['input']>;
  street_complement?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
};

export type Device = {
  __typename?: 'Device';
  activeObservationPeriodTrigger?: Maybe<Trigger>;
  associatedAt: Scalars['DateTime']['output'];
  capabilities: DeviceCapabilities;
  cobliId: Scalars['String']['output'];
  deviceModel?: Maybe<Scalars['String']['output']>;
  disablerStatus?: Maybe<DisablerStatus>;
  fleetId: Scalars['ID']['output'];
  generalStatus: DeviceGeneralStatus;
  generalType: DeviceGeneralType;
  healthStatus: DeviceHealthStatusType;
  id: Scalars['String']['output'];
  isNew: Scalars['Boolean']['output'];
  /** @deprecated Use operationalSituation: uma situação RESERVE ativa significa reserva */
  isSpare: Scalars['Boolean']['output'];
  lastLocation?: Maybe<LastLocation>;
  lastMovingStateTime?: Maybe<Scalars['String']['output']>;
  operationalSituation?: Maybe<OperationalSituation>;
  sdCardHealthStatus?: Maybe<DeviceSdCardHealthStatus>;
  statusSummary: DeviceStatusSummary;
  tracking?: Maybe<DeviceTracking>;
  type: DeviceType;
  vehicle?: Maybe<VehicleDto>;
  vehicleDissociatedAt?: Maybe<Scalars['DateTime']['output']>;
  vehicleId?: Maybe<Scalars['ID']['output']>;
};

export type DeviceCapabilities = {
  __typename?: 'DeviceCapabilities';
  reportsVehicleCan: Scalars['Boolean']['output'];
  reportsVideo: Scalars['Boolean']['output'];
};

export type DeviceCause = {
  __typename?: 'DeviceCause';
  cause: DeviceCauseKey;
  status: DeviceStatusType;
};

export enum DeviceCauseKey {
  Damaged = 'DAMAGED',
  Disconnected = 'DISCONNECTED',
  InDevolution = 'IN_DEVOLUTION',
  LosingData = 'LOSING_DATA',
  Normal = 'NORMAL',
  NoSignal = 'NO_SIGNAL',
  NoSufficientData = 'NO_SUFFICIENT_DATA',
  SdCardProblem = 'SD_CARD_PROBLEM',
  Syncing = 'SYNCING',
  Unavailable = 'UNAVAILABLE',
}

export type DeviceConfiguration = {
  __typename?: 'DeviceConfiguration';
  actual_parameters?: Maybe<Array<Parameter>>;
  device: DeviceDetails;
  id: Scalars['String']['output'];
  target_parameters?: Maybe<Array<Parameter>>;
};

export type DeviceDeliveryTime = {
  __typename?: 'DeviceDeliveryTime';
  deviceId: Scalars['String']['output'];
  mediaType: MediaType;
  p50Ms: Scalars['Float']['output'];
  /** Número de solicitações concluídas que sustentam a mediana. */
  sampleSize: Scalars['Int']['output'];
};

export type DeviceDestination = {
  __typename?: 'DeviceDestination';
  address?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type DeviceDetails = {
  __typename?: 'DeviceDetails';
  associated_at: Scalars['DateTime']['output'];
  chip_number: Scalars['String']['output'];
  chip_operator: Scalars['String']['output'];
  cobli_id: Scalars['String']['output'];
  fleet_id: Scalars['ID']['output'];
  icc_id: Scalars['String']['output'];
  id: Scalars['String']['output'];
  imei: Scalars['String']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type DeviceFields = {
  __typename?: 'DeviceFields';
  capabilities: DeviceCapabilities;
  cobliId: Scalars['String']['output'];
  lastLocation: LastLocation;
  type: Scalars['String']['output'];
};

export enum DeviceGeneralStatus {
  Damaged = 'DAMAGED',
  Disconnected = 'DISCONNECTED',
  InDevolution = 'IN_DEVOLUTION',
  LosingData = 'LOSING_DATA',
  Normal = 'NORMAL',
  NoSignal = 'NO_SIGNAL',
  NoSufficientData = 'NO_SUFFICIENT_DATA',
  Syncing = 'SYNCING',
  Unavailable = 'UNAVAILABLE',
}

export enum DeviceGeneralType {
  Blocker = 'BLOCKER',
  Can = 'CAN',
  CanIbutton = 'CAN_IBUTTON',
  CanIbuttonImmobilizer = 'CAN_IBUTTON_IMMOBILIZER',
  Dashcam = 'DASHCAM',
  Fake = 'FAKE',
  Ibutton = 'IBUTTON',
  IbuttonImmobilizer = 'IBUTTON_IMMOBILIZER',
  Immobilizer = 'IMMOBILIZER',
  Installed = 'INSTALLED',
  Multicam = 'MULTICAM',
  PlugAndPlay = 'PLUG_AND_PLAY',
  PlugAndPlayIbutton = 'PLUG_AND_PLAY_IBUTTON',
  Removable = 'REMOVABLE',
  Unknown = 'UNKNOWN',
}

export enum DeviceHealthStatusType {
  Damaged = 'DAMAGED',
  DeviceWithoutFleet = 'DEVICE_WITHOUT_FLEET',
  Disconnected = 'DISCONNECTED',
  Normal = 'NORMAL',
  NoSignal = 'NO_SIGNAL',
  NoSufficientData = 'NO_SUFFICIENT_DATA',
  Syncing = 'SYNCING',
  Unavailable = 'UNAVAILABLE',
  Unknown = 'UNKNOWN',
}

export type DeviceParameterStatus = {
  __typename?: 'DeviceParameterStatus';
  device: Device;
  parameter_name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type DeviceParameterValue = {
  __typename?: 'DeviceParameterValue';
  device: Device;
  value?: Maybe<Scalars['String']['output']>;
};

export enum DeviceSdCardHealthStatus {
  Ok = 'OK',
  SdCardProblem = 'SD_CARD_PROBLEM',
}

export type DeviceShippingInformation = {
  __typename?: 'DeviceShippingInformation';
  quantidadeChaveiroString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioInstaladoLevesBloqueadorString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioInstaladoLevesOuPesadosClienteString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioInstaladoLevesOuPesadosCobliCamGeracao2ProString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioInstaladoLevesOuPesadosCobliCamGeracao2String?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioInstaladoLevesOuPesadosCobliCamString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioInstaladoLevesOuPesadosIdentificadorString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioInstaladoLevesOuPesadosImobilizadorString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioInstaladoLevesOuPesadosString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioInstaladoMotosOuMaquinariosClienteString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioInstaladoMotosOuMaquinariosString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioRemovivelLevesOuPesadosBuzzerString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioRemovivelLevesOuPesadosIdentificadorString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioRemovivelLevesString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioRemovivelPesadosString?: Maybe<Scalars['Int']['output']>;
};

export type DeviceStatusSubscription = {
  __typename?: 'DeviceStatusSubscription';
  active: Scalars['Boolean']['output'];
  fleet_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  user_id: Scalars['ID']['output'];
  vehicle_group_ids?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  vehicle_ids?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
};

export type DeviceStatusSubscriptionInput = {
  active: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  vehicle_group_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  vehicle_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type DeviceStatusSummary = {
  __typename?: 'DeviceStatusSummary';
  causes: Array<DeviceCause>;
  status: DeviceStatusType;
};

export enum DeviceStatusType {
  Check = 'CHECK',
  Critical = 'CRITICAL',
  Healthy = 'HEALTHY',
}

export type DeviceTotalQuantity = {
  __typename?: 'DeviceTotalQuantity';
  camera?: Maybe<Scalars['Int']['output']>;
  identifiers?: Maybe<Scalars['Int']['output']>;
  immobilizer?: Maybe<Scalars['Int']['output']>;
  installed?: Maybe<Scalars['Int']['output']>;
  redeCan?: Maybe<Scalars['Int']['output']>;
  removable?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type DeviceTracking = {
  __typename?: 'DeviceTracking';
  conclusionTime?: Maybe<Scalars['String']['output']>;
  destination?: Maybe<DeviceDestination>;
  tempGeofenceId?: Maybe<Scalars['String']['output']>;
};

export enum DeviceType {
  Blocker = 'Blocker',
  Buzzer = 'Buzzer',
  Can = 'Can',
  CanIbutton = 'CanIbutton',
  CanIbuttonImmobillizer = 'CanIbuttonImmobillizer',
  Dashcam = 'Dashcam',
  Immobilizer = 'Immobilizer',
  Multicam = 'Multicam',
  Obd = 'OBD',
  ObdRemovable = 'OBD_Removable',
  PlugAndPlayBuzzer = 'PlugAndPlayBuzzer',
  Solar = 'Solar',
  Unknown = 'Unknown',
  IButton = 'iButton',
  IButtonImmobilizer = 'iButtonImmobilizer',
}

export type DeviceVehicle = {
  __typename?: 'DeviceVehicle';
  alias?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  cobliId?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  licensePlate?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
};

export type DevolutionClientInformation = {
  __typename?: 'DevolutionClientInformation';
  clientCnpj?: Maybe<Scalars['String']['output']>;
};

export type DevolutionDeviceInformation = {
  __typename?: 'DevolutionDeviceInformation';
  devolutionDevicesCobliIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  devolutionDevicesEsn?: Maybe<Scalars['String']['output']>;
  devolutionDevicesIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  heavyDevolutionRemovableQuantity?: Maybe<Scalars['Int']['output']>;
  heavyOrLightDevolutionInstalledBuzzerQuantity?: Maybe<Scalars['Int']['output']>;
  heavyOrLightDevolutionInstalledCoblicamQuantity?: Maybe<Scalars['Int']['output']>;
  heavyOrLightDevolutionInstalledIdentifierQuantity?: Maybe<Scalars['Int']['output']>;
  heavyOrLightDevolutionInstalledImmobilizerQuantity?: Maybe<Scalars['Int']['output']>;
  heavyOrLightDevolutionInstalledQuantity?: Maybe<Scalars['Int']['output']>;
  heavyOrLightDevolutionRemovableBuzzerQuantity?: Maybe<Scalars['Int']['output']>;
  heavyOrLightDevolutionRemovableIdentifierQuantity?: Maybe<Scalars['Int']['output']>;
  lightDevolutionInstalledBlockerQuantity?: Maybe<Scalars['Int']['output']>;
  lightDevolutionRemovableQuantity?: Maybe<Scalars['Int']['output']>;
  motorcycleOrMachineryDevolutionInstalledClientQuantity?: Maybe<Scalars['Int']['output']>;
  motorcycleOrMachineryDevolutionInstalledQuantity?: Maybe<Scalars['Int']['output']>;
};

export type DevolutionDeviceTickets = {
  __typename?: 'DevolutionDeviceTickets';
  cobliId?: Maybe<Scalars['String']['output']>;
  deviceId: Scalars['String']['output'];
  devolutionTickets: Tickets;
  fleetId: Scalars['String']['output'];
};

export type DevolutionInformation = {
  __typename?: 'DevolutionInformation';
  clientInformation?: Maybe<DevolutionClientInformation>;
  deviceInformation?: Maybe<DevolutionDeviceInformation>;
  devolutionDeadline?: Maybe<Scalars['String']['output']>;
  fleetId?: Maybe<Scalars['String']['output']>;
  fleetName?: Maybe<Scalars['String']['output']>;
  penaltyPrice?: Maybe<Scalars['Float']['output']>;
  shippingInformation?: Maybe<DevolutionShippingInformation>;
  supplyDevolucaoTipo?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type DevolutionShippingInformation = {
  __typename?: 'DevolutionShippingInformation';
  devolutionArrivalOfDevicesAtCobli?: Maybe<Scalars['String']['output']>;
  devolutionPostageDate?: Maybe<Scalars['String']['output']>;
  devolutionShippingCode?: Maybe<Scalars['String']['output']>;
  devolutionShippingCodeOrScheduleDate?: Maybe<Scalars['String']['output']>;
  devolutionShippingType?: Maybe<Scalars['String']['output']>;
};

export type DisablerDto = {
  __typename?: 'DisablerDTO';
  lastDisablingAction?: Maybe<Scalars['String']['output']>;
  lastDisablingActionTime?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export enum DisablerStatus {
  DisablePending = 'DisablePending',
  Disabled = 'Disabled',
  Disabling = 'Disabling',
  EnablePending = 'EnablePending',
  Enabled = 'Enabled',
}

export type DmsEvents = {
  __typename?: 'DmsEvents';
  distracted_driving: SensibilityConfiguration;
  eyes_closed: SensibilityConfiguration;
  min_speed_trigger_in_km_per_h: Scalars['Int']['output'];
  /** Driver absent. Streamax only */
  no_driver_detected?: Maybe<SensibilityConfiguration>;
  /** Streamax only */
  occupancy?: Maybe<SensibilityConfiguration>;
  /** People in the cabin (driver included) that trigger the occupancy alarm, 2–6 */
  occupancy_people_limit?: Maybe<Scalars['Int']['output']>;
  phone_usage: SensibilityConfiguration;
  /** Driver without the seat belt: on/off only. Streamax only */
  seat_belt?: Maybe<EnabledConfiguration>;
  smoking: SensibilityConfiguration;
  yawn: SensibilityConfiguration;
};

export type DmsEventsInput = {
  distracted_driving: SensibilityConfigurationInput;
  eyes_closed: SensibilityConfigurationInput;
  min_speed_trigger_in_km_per_h: Scalars['Int']['input'];
  no_driver_detected?: InputMaybe<SensibilityConfigurationInput>;
  occupancy?: InputMaybe<SensibilityConfigurationInput>;
  occupancy_people_limit?: InputMaybe<Scalars['Int']['input']>;
  phone_usage: SensibilityConfigurationInput;
  seat_belt?: InputMaybe<EnabledConfigurationInput>;
  smoking: SensibilityConfigurationInput;
  yawn: SensibilityConfigurationInput;
};

export type Driver = {
  __typename?: 'Driver';
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Motorista sem registro na user-api é NOT_INVITED. Anulável: sem permissão, só este campo cai (ADR-0002). */
  appAccess?: Maybe<DriverAppAccess>;
  assigned?: Maybe<Scalars['Boolean']['output']>;
  cpf?: Maybe<Scalars['String']['output']>;
  driver_code?: Maybe<Scalars['String']['output']>;
  driver_license?: Maybe<Scalars['String']['output']>;
  first_license_acquirement_date?: Maybe<Scalars['Date']['output']>;
  fleet_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  identification_token?: Maybe<IdentificationTokenV2>;
  /** @deprecated Use `identification_token` field instead. */
  identifier?: Maybe<Scalars['String']['output']>;
  license_category?: Maybe<LicenseCategory>;
  license_expiration_date?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  phone_number?: Maybe<Scalars['PhoneNumber']['output']>;
  profile_image_url?: Maybe<Scalars['String']['output']>;
  registry_id?: Maybe<Scalars['String']['output']>;
  score?: Maybe<DriverScore>;
  vehicle?: Maybe<VehicleDto>;
};

/** Situação de um motorista em relação ao app do motorista: se já foi convidado e se já entrou. */
export type DriverAppAccess = {
  __typename?: 'DriverAppAccess';
  firstAppAccessAt?: Maybe<Scalars['String']['output']>;
  inviteCount: Scalars['Int']['output'];
  lastInviteChannel?: Maybe<DriverAppInviteChannel>;
  lastInvitedAt?: Maybe<Scalars['String']['output']>;
  status: DriverAppAccessStatus;
};

export enum DriverAppAccessStatus {
  Accessed = 'ACCESSED',
  Invited = 'INVITED',
  NotInvited = 'NOT_INVITED',
}

export enum DriverAppInviteChannel {
  Copy = 'COPY',
  Whatsapp = 'WHATSAPP',
}

export type DriverAssignmentInput = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  driverId?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type DriverAuthorization = {
  __typename?: 'DriverAuthorization';
  authorizationId: Scalars['ID']['output'];
  device?: Maybe<Device>;
  driver: Driver;
  identificationToken?: Maybe<IdentificationTokenV2>;
};

export type DriverFaceClusterUpdate = {
  /** Driver Face Cluster id. UUID */
  driver_face_cluster_id?: InputMaybe<Scalars['ID']['input']>;
  /** Driver identifier. UUID */
  driver_id?: InputMaybe<Scalars['ID']['input']>;
};

export type DriverFaceClustersInfo = {
  __typename?: 'DriverFaceClustersInfo';
  /** Time that the Driver Face Cluster was created in RFC 3339 format */
  created_at: Scalars['DateTime']['output'];
  /** Cobli driver identifier assigned to the cluster. */
  driver?: Maybe<Driver>;
  /** Driver Face Cluster identifier. An UUID */
  id: Scalars['ID']['output'];
  /** Driver Face Cluster image profile URL. An URL */
  profile_image_url: DriverPhoto;
  /**
   * Time the current suggestion was rejected by a manager, in RFC 3339 format.
   * Null when the suggestion has not been rejected.
   */
  rejected_at?: Maybe<Scalars['DateTime']['output']>;
  /** Number of Driver Face Cluster image URLs. Represents how many images are present in the list of sample_image_urls. */
  sample_image_url_count: Scalars['Int']['output'];
  /**
   * Driver Face Cluster list of images URL. A list of images URL
   * @deprecated Use sample_images instead.
   */
  sample_image_urls: Array<Maybe<DriverPhoto>>;
  /** Driver Face Cluster list of images with capture metadata. */
  sample_images: Array<Maybe<SampleImageDto>>;
  /** The suggested driver for this unnamed cluster. */
  suggested_driver?: Maybe<Driver>;
  /**
   * Origin of the current driver suggestion. One of DRIVER_APP or
   * EMBEDDING_NEAREST_NEIGHBOR. Kept as a String (not an enum) so new upstream
   * values don't break GraphQL serialization or couple backend/BFF deploys.
   * Null when there is no suggestion.
   */
  suggestion_source?: Maybe<Scalars['String']['output']>;
  /** Last time that the Driver Face Cluster was updated in RFC 3339 format */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

/** DriverFaceCluster data for the media */
export type DriverFaceClustersMedia = {
  __typename?: 'DriverFaceClustersMedia';
  /** Cobli driver. */
  driver?: Maybe<Driver>;
  /** Cobli driver identifier assigned to the cluster. An UUID */
  driver_id: Scalars['ID']['output'];
  /** Driver Face Cluster identifier. An UUID */
  id: Scalars['ID']['output'];
  /** Driver Face Cluster image profile URL. An URL */
  profile_image_url: DriverPhoto;
};

export type DriverFaceClustersSuggestion = {
  __typename?: 'DriverFaceClustersSuggestion';
  /** The candidate clusters for the driver */
  candidate_clusters: Array<Maybe<DriverFaceClustersInfo>>;
  /** Cobli driver suggested to the candidate clusters. */
  driver?: Maybe<Driver>;
};

export type DriverFaceIdRegistration = {
  __typename?: 'DriverFaceIdRegistration';
  driverId: Scalars['ID']['output'];
  lastSampleImageAt?: Maybe<Scalars['DateTime']['output']>;
  sampleImageCount: Scalars['Int']['output'];
  status: FaceIdRegistrationStatus;
};

export type DriverInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  assigned?: InputMaybe<Scalars['Boolean']['input']>;
  driver_code?: InputMaybe<Scalars['String']['input']>;
  first_license_acquirement_date?: InputMaybe<Scalars['Date']['input']>;
  fleet_id: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  license_category?: InputMaybe<LicenseCategory>;
  license_expiration_date?: InputMaybe<Scalars['Date']['input']>;
  name: Scalars['String']['input'];
  phone_number?: InputMaybe<Scalars['PhoneNumber']['input']>;
  score?: InputMaybe<DriverScoreInput>;
};

export type DriverLastAssociation = {
  __typename?: 'DriverLastAssociation';
  associatedAt?: Maybe<Scalars['String']['output']>;
  deviceId: Scalars['String']['output'];
  driverId?: Maybe<Scalars['String']['output']>;
  driverName?: Maybe<Scalars['String']['output']>;
};

export type DriverNominateTripImageInput = {
  /** The id of the driver. */
  driver_id?: InputMaybe<Scalars['String']['input']>;
  /** A feedback from the user marking that the driver is visible or not */
  driver_visibility?: InputMaybe<DriverVisibility>;
  /** The id of the image. */
  image_id: Scalars['String']['input'];
  /** The signed url of the image. */
  image_url?: InputMaybe<Scalars['String']['input']>;
  /** The operation. */
  operation: NominationOperation;
  /** The id of the trip. */
  trip_id: Scalars['String']['input'];
};

/** Driver Face Cluster image profile URL. An URL */
export type DriverPhoto = {
  __typename?: 'DriverPhoto';
  /** A FaceBox containing the coordinates of the face in the picture. A FaceBox */
  box?: Maybe<FaceBox>;
  /** An URL for a image profile URL. An URL */
  image_url: Scalars['String']['output'];
};

export type DriverScore = {
  __typename?: 'DriverScore';
  distance_driven?: Maybe<Scalars['Float']['output']>;
  driver_id?: Maybe<Scalars['ID']['output']>;
  events_rates?: Maybe<EventRates>;
  score?: Maybe<Scalars['Float']['output']>;
  start_timestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type DriverScoreInput = {
  distance_driven?: InputMaybe<Scalars['Float']['input']>;
  driver_id?: InputMaybe<Scalars['ID']['input']>;
  events_rates?: InputMaybe<EventRatesInput>;
  score?: InputMaybe<Scalars['Float']['input']>;
  start_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DriverSpeedRow = {
  __typename?: 'DriverSpeedRow';
  driver: Driver;
  evolution: Scalars['Int']['output'];
  highEventsCount: Scalars['Int']['output'];
  higherEventsCount: Scalars['Int']['output'];
  kmsPerEvent: Scalars['Float']['output'];
  mediumEventsCount: Scalars['Int']['output'];
  percentageAboveLimit: Scalars['Float']['output'];
  totalEventsCount: Scalars['Int']['output'];
  totalTimeAboveLimitInMinutes: Scalars['Int']['output'];
  totalTripDurationInMinutes: Scalars['Int']['output'];
};

export type DriverSpeedRowInput = {
  driver_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  end_date: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  start_date: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};

export enum DriverVisibility {
  NotVisible = 'NOT_VISIBLE',
  Visible = 'VISIBLE',
}

export enum DutyType {
  Heavy = 'HEAVY',
  Light = 'LIGHT',
  Medium = 'MEDIUM',
}

export type EnabledConfiguration = {
  __typename?: 'EnabledConfiguration';
  enabled: Scalars['Boolean']['output'];
};

export type EnabledConfigurationInput = {
  enabled: Scalars['Boolean']['input'];
};

export type EndOperationalSituationInput = {
  /** Omitido = encerra agora. Agendar um fim futuro não é aceito para RESERVE de dispositivo. */
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
};

export type EntireFleetAssociationConfig = {
  __typename?: 'EntireFleetAssociationConfig';
  is_on?: Maybe<Scalars['Boolean']['output']>;
};

export type EntireFleetAssociationConfigInput = {
  is_on: Scalars['Boolean']['input'];
};

export type EventRates = {
  __typename?: 'EventRates';
  fast_acceleration?: Maybe<Scalars['Float']['output']>;
  hard_break?: Maybe<Scalars['Float']['output']>;
  high_speed?: Maybe<Scalars['Float']['output']>;
  speedy_turn?: Maybe<Scalars['Float']['output']>;
};

export type EventRatesInput = {
  fast_acceleration?: InputMaybe<Scalars['Float']['input']>;
  hard_break?: InputMaybe<Scalars['Float']['input']>;
  high_speed?: InputMaybe<Scalars['Float']['input']>;
  speedy_turn?: InputMaybe<Scalars['Float']['input']>;
};

export enum EventTrigger {
  Anomaly = 'ANOMALY',
  AntiDestruction = 'ANTI_DESTRUCTION',
  Collision = 'COLLISION',
  DistractedDriving = 'DISTRACTED_DRIVING',
  Eating = 'EATING',
  EyesClosed = 'EYES_CLOSED',
  Fatigue = 'FATIGUE',
  FrontCollisionWarning = 'FRONT_COLLISION_WARNING',
  GSensorWakeup = 'G_SENSOR_WAKEUP',
  HarshAcceleration = 'HARSH_ACCELERATION',
  HarshBreaking = 'HARSH_BREAKING',
  HarshCornering = 'HARSH_CORNERING',
  IdleSpeed = 'IDLE_SPEED',
  IllegalShutdown = 'ILLEGAL_SHUTDOWN',
  InsufficientElectricityAlarm = 'INSUFFICIENT_ELECTRICITY_ALARM',
  LaneDrift = 'LANE_DRIFT',
  LeftTurnSpeeding = 'LEFT_TURN_SPEEDING',
  LowVoltage = 'LOW_VOLTAGE',
  MaxSpeedExceeded = 'MAX_SPEED_EXCEEDED',
  Missingface = 'MISSINGFACE',
  NotWearingSeatBelts = 'NOT_WEARING_SEAT_BELTS',
  Overcrowding = 'OVERCROWDING',
  PassengerNotWearingSeatBelts = 'PASSENGER_NOT_WEARING_SEAT_BELTS',
  PedestrianCollision = 'PEDESTRIAN_COLLISION',
  PhoneUsage = 'PHONE_USAGE',
  SeriousTheft = 'SERIOUS_THEFT',
  Smoking = 'SMOKING',
  Sos = 'SOS',
  SpeedLimitSign = 'SPEED_LIMIT_SIGN',
  StopSignViolated = 'STOP_SIGN_VIOLATED',
  Tailgating = 'TAILGATING',
  TemperatureAbnormal = 'TEMPERATURE_ABNORMAL',
  TrafficSpeedViolated = 'TRAFFIC_SPEED_VIOLATED',
  Unknown = 'UNKNOWN',
  VideoBlock = 'VIDEO_BLOCK',
  Yawn = 'YAWN',
}

export type EventVideo = {
  __typename?: 'EventVideo';
  /** Event trigger. */
  event_trigger: EventTrigger;
  /** Event latitude. */
  latitude: Scalars['Float']['output'];
  /** Event longitude. */
  longitude: Scalars['Float']['output'];
  /** The url of the content media. */
  media_url: Scalars['String']['output'];
  /** Event speed. */
  speed: Scalars['Float']['output'];
  /** Speed limit of the road. Only available when event trigger is TRAFFICSPEEDVIOLATED. */
  speed_sign?: Maybe<Scalars['Int']['output']>;
  /** The url to the thumbnail image of a video. */
  thumbnail_url: Scalars['String']['output'];
};

export type EventsConfiguration = {
  __typename?: 'EventsConfiguration';
  adas_events: AdasEvents;
  dms_events: DmsEvents;
  face_identification_audio_alert_enabled?: Maybe<Scalars['Boolean']['output']>;
  harsh_events: HarshEventsByDutyType;
  /** Streamax only. Null when the fleet never set it (the device keeps its default) */
  idle_speed?: Maybe<IdleSpeedConfiguration>;
  ignition_off_record_settings?: Maybe<Scalars['Int']['output']>;
};

export type EventsConfigurationInput = {
  adas_events: AdasEventsInput;
  dms_events: DmsEventsInput;
  face_identification_audio_alert_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  harsh_events: HarshEventsByDutyTypeInput;
  idle_speed?: InputMaybe<IdleSpeedConfigurationInput>;
  ignition_off_record_settings?: InputMaybe<Scalars['Int']['input']>;
};

export type Expense = {
  __typename?: 'Expense';
  category: Category;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  deletedBy?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  observation?: Maybe<Scalars['String']['output']>;
  occurredAt: Scalars['DateTime']['output'];
  source?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<Supplier>;
  totalCost: Scalars['Float']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['ID']['output']>;
  vehicle: ExpenseVehicle;
};

export type ExpensePaginatedResponse = {
  __typename?: 'ExpensePaginatedResponse';
  content: Array<Expense>;
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ExpenseVehicle = {
  __typename?: 'ExpenseVehicle';
  alias?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  groupPath?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  licensePlate?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  tagNames: Array<Scalars['String']['output']>;
};

export type ExpensesImportColumnMap = {
  categoryName?: InputMaybe<ImportColumnMapInput>;
  licensePlate?: InputMaybe<ImportColumnMapInput>;
  observation?: InputMaybe<ImportColumnMapInput>;
  occurredAt?: InputMaybe<ImportColumnMapInput>;
  supplierName?: InputMaybe<ImportColumnMapInput>;
  totalCost?: InputMaybe<ImportColumnMapInput>;
  type?: InputMaybe<ImportColumnMapInput>;
};

export type ExpensesListInput = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endDate: Scalars['DateTime']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  tagNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleModels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleSizes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** A FaceBox containing the coordinates of the face in the picture. A FaceBox */
export type FaceBox = {
  __typename?: 'FaceBox';
  x_max: Scalars['Int']['output'];
  x_min: Scalars['Int']['output'];
  y_max: Scalars['Int']['output'];
  y_min: Scalars['Int']['output'];
};

export type FaceIdCoverageChart = {
  __typename?: 'FaceIdCoverageChart';
  data: Array<FaceIdCoveragePoint>;
  metadata: FaceIdCoverageMetadata;
};

export type FaceIdCoverageMetadata = {
  __typename?: 'FaceIdCoverageMetadata';
  averageCoveragePercentage: Scalars['Float']['output'];
  fromTimestamp: Scalars['Float']['output'];
  identifiedEventsTotal: Scalars['Int']['output'];
  toTimestamp: Scalars['Float']['output'];
  validEventsTotal: Scalars['Int']['output'];
};

export type FaceIdCoveragePoint = {
  __typename?: 'FaceIdCoveragePoint';
  bucketStart: Scalars['Float']['output'];
  coveragePercentage: Scalars['Float']['output'];
  identifiedEvents: Scalars['Int']['output'];
  validEvents: Scalars['Int']['output'];
};

export enum FaceIdRegistrationStatus {
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE',
}

export type Field = {
  __typename?: 'Field';
  /**
   * Compliance of this answered question, decided by ryuk when the response was created, so clients
   * read it instead of replaying the rule over the options. Null on a template question and on a
   * response older than the feature.
   */
  compliance_status?: Maybe<ChecklistCompliance>;
  content: FieldContentType;
  id: Scalars['ID']['output'];
  photos_urls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * Stable identity of the question across template edits; field ids change on every write. Echo it
   * back when saving a template, or ryuk can only recover it by title. Inherited, never chosen, on a
   * response.
   */
  questionKey?: Maybe<Scalars['ID']['output']>;
  required: Scalars['Boolean']['output'];
  should_request_photos?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
  type: FieldType;
};

export type FieldContentType = CheckContent | SelectContent | TextContent;

export type FieldControlInformation = {
  __typename?: 'FieldControlInformation';
  fieldObservations?: Maybe<Scalars['String']['output']>;
  technicalTeamObservation?: Maybe<Scalars['String']['output']>;
};

export enum FieldType {
  Check = 'CHECK',
  MultiSelect = 'MULTI_SELECT',
  SingleSelect = 'SINGLE_SELECT',
  Text = 'TEXT',
}

export type Filters = {
  wantedAlertTypes?: InputMaybe<Array<InputMaybe<UserNotificationSettingsType>>>;
  wantedGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  wantedVehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type Fleet = {
  __typename?: 'Fleet';
  acceptance_terms?: Maybe<Scalars['JSONObject']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  global_score?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  managers?: Maybe<Array<Maybe<Manager>>>;
  name?: Maybe<Scalars['String']['output']>;
  periodical_scores?: Maybe<Scalars['JSONObject']['output']>;
};

export type FleetAudioMessage = {
  __typename?: 'FleetAudioMessage';
  /** Timestamp when the message was created in RFC 3339 format. */
  createdAt: Scalars['DateTime']['output'];
  /** The user who created the message. */
  createdBy: User;
  /** Fleet identifier that owns this audio message. */
  fleetId: Scalars['ID']['output'];
  /** Unique identifier for the audio message. */
  id: Scalars['ID']['output'];
  /** The text content of the audio message. */
  message: Scalars['String']['output'];
  /** URL to the generated MP3 file stored in S3. */
  mp3Url: Scalars['String']['output'];
  /** Optional name/identifier for the audio message. */
  name?: Maybe<Scalars['String']['output']>;
};

export type FleetAudioMessagePlayback = {
  __typename?: 'FleetAudioMessagePlayback';
  /** The audio message ID that was played. */
  audioMessageId: Scalars['ID']['output'];
  /** Whether the playback will be auto-cancelled if not successfully delivered within 1 hour. */
  cancelIfTimeout?: Maybe<Scalars['Boolean']['output']>;
  /** Timestamp when the playback record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The user who created the playback request. */
  createdBy: User;
  /** The device where the message was played. */
  device: Device;
  /** Optional driver associated with the playback. */
  driver?: Maybe<Driver>;
  /** Unique identifier for this playback record. */
  id: Scalars['ID']['output'];
  /** The audio message content/text. */
  message?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the playback was successfully delivered. */
  playedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Number of retry attempts made for this playback. */
  retryCount: Scalars['Int']['output'];
  /** Current status of the playback (PENDING, SUCCESS, ERROR, or CANCELLED). */
  status: PlaybackStatus;
  /** The vehicle on which the message was played. */
  vehicle: VehicleDto;
};

export type FleetAudioMessagePlaybackPage = {
  __typename?: 'FleetAudioMessagePlaybackPage';
  /** List of playback records for the requested vehicle. */
  content?: Maybe<Array<Maybe<FleetAudioMessagePlayback>>>;
  /** Whether the page is empty. */
  empty?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this is the first page. */
  first?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this is the last page. */
  last?: Maybe<Scalars['Boolean']['output']>;
  /** Zero-based page index. */
  number?: Maybe<Scalars['Int']['output']>;
  /** Number of elements in this page. */
  numberOfElements?: Maybe<Scalars['Int']['output']>;
  /** Pagination metadata. */
  pageable?: Maybe<PageableObject>;
  /** The size of the page. */
  size?: Maybe<Scalars['Int']['output']>;
  /** Sorting information. */
  sort?: Maybe<SortType>;
  /** Total number of elements across all pages. */
  totalElements?: Maybe<Scalars['Int']['output']>;
  /** Total number of pages. */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type FleetAutoAssociationSettings = {
  __typename?: 'FleetAutoAssociationSettings';
  association_config?: Maybe<AssociationConfig>;
  fleet_id?: Maybe<Scalars['String']['output']>;
  last_updated_by?: Maybe<Scalars['ID']['output']>;
  updated_at?: Maybe<Scalars['TimestampInMillis']['output']>;
};

export type FleetCompanyContract = {
  __typename?: 'FleetCompanyContract';
  address?: Maybe<Scalars['String']['output']>;
  billingDay?: Maybe<Scalars['String']['output']>;
  cnpj?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  companyStatus?: Maybe<Scalars['String']['output']>;
  contractSignedDate?: Maybe<Scalars['TimestampInMillis']['output']>;
  corporateName?: Maybe<Scalars['String']['output']>;
  dueDay?: Maybe<Scalars['String']['output']>;
  financialAdjustmentIndex?: Maybe<Scalars['String']['output']>;
  industry?: Maybe<Scalars['String']['output']>;
  lastRegistrationChangeDate?: Maybe<Scalars['String']['output']>;
  mrrCurrency?: Maybe<Scalars['String']['output']>;
  paymentFrequency?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  recentConversionEventName?: Maybe<Scalars['String']['output']>;
  responsavel?: Maybe<Scalars['String']['output']>;
  upsellBlockLoggedArea?: Maybe<Scalars['String']['output']>;
};

export type FleetCompanyContracts = {
  __typename?: 'FleetCompanyContracts';
  contracts?: Maybe<Array<Maybe<FleetCompanyContract>>>;
  fleetId: Scalars['ID']['output'];
};

export type FleetCompanyOnboardingStatus = {
  __typename?: 'FleetCompanyOnboardingStatus';
  hasAnyContractSignedInLast90Days: Scalars['Boolean']['output'];
  hasAnyOnboardingContract: Scalars['Boolean']['output'];
};

export type FleetDeliveryTime = {
  __typename?: 'FleetDeliveryTime';
  mediaType: MediaType;
  p50Ms: Scalars['Float']['output'];
  /**
   * Limiar de atraso. Vem sempre da frota, nunca do dispositivo.
   *
   * Medido sobre uma janela que termina 7 dias atrás, porque pedido recente ainda pode não ter
   * terminado e incluí-lo mede só quem já chegou. Nulo quando essa janela não tem amostra — estado
   * normal em frota nova, não erro.
   */
  p90Ms?: Maybe<Scalars['Float']['output']>;
  /**
   * Quantas solicitações sustentam o p90. É um número próprio porque a janela do p90 é outra:
   * ela termina 7 dias antes da janela da mediana.
   */
  p90SampleSize: Scalars['Int']['output'];
  sampleSize: Scalars['Int']['output'];
};

export type FleetEventsConfiguration = {
  __typename?: 'FleetEventsConfiguration';
  camera_events_config?: Maybe<CameraEventsConfiguration>;
  created_at: Scalars['String']['output'];
  fleet_id: Scalars['ID']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  updated_by_id?: Maybe<Scalars['ID']['output']>;
  updated_by_name?: Maybe<Scalars['String']['output']>;
};

export type FleetGeofenceRecommendation = {
  __typename?: 'FleetGeofenceRecommendation';
  address?: Maybe<Scalars['String']['output']>;
  area: Scalars['Float']['output'];
  color: Scalars['String']['output'];
  fleetId: Scalars['ID']['output'];
  format: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  radius: Scalars['Float']['output'];
  reason: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type FleetIdentificationHealthDto = {
  __typename?: 'FleetIdentificationHealthDTO';
  /** When the metric was computed (on-demand: the instant of the request), RFC 3339. */
  calculated_at: Scalars['DateTime']['output'];
  /**
   * M1 — percentage (0-100) of fleet drivers with a Cobli Cam photo processed into
   * an embedding. Manual uploads do not count. Reflects the current state (no window).
   */
  complete_registration_rate: Scalars['Float']['output'];
  /**
   * M2 — percentage (0-100) of valid video events identified with a driver over the
   * last 14 days.
   */
  identified_events_rate: Scalars['Float']['output'];
  /** Overall health state derived from the weighted score of M1 and M2. */
  state: FleetIdentificationHealthState;
};

/** Health state of a fleet's identification method. */
export enum FleetIdentificationHealthState {
  Critical = 'CRITICAL',
  Healthy = 'HEALTHY',
  Warning = 'WARNING',
}

export type FleetProducts = {
  __typename?: 'FleetProducts';
  products?: Maybe<Array<Maybe<Product>>>;
};

export type FleetUser = {
  __typename?: 'FleetUser';
  active?: Maybe<Scalars['Boolean']['output']>;
  creation_date?: Maybe<Scalars['String']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  fleet_id?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  granted_permissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  groups?: Maybe<Array<Maybe<VehiclesGroup>>>;
  groups_restriction?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  has_custom_permissions?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  last_login?: Maybe<Scalars['String']['output']>;
  occupation?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  timezone_offset?: Maybe<Scalars['String']['output']>;
};

export type FleetVehicleGroups = {
  __typename?: 'FleetVehicleGroups';
  created_at: Scalars['TimestampInMillis']['output'];
  creator_id: Scalars['ID']['output'];
  fleet_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  updated_at: Scalars['TimeIntervalInMillis']['output'];
  vehicle_ids: Array<Scalars['ID']['output']>;
};

/** How a fleet reviews its event videos. A fleet that never changed it has every option off. */
export type FleetVideoReviewConfiguration = {
  __typename?: 'FleetVideoReviewConfiguration';
  /** Dismissing an event video archives it instead */
  archiveInsteadOfDismiss?: Maybe<Scalars['Boolean']['output']>;
  /** Datetime of the last change. Null when the fleet never changed it */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID of the User that last changed it */
  updatedById?: Maybe<Scalars['ID']['output']>;
  /** Name of the User that last changed it */
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export type FootageVideo = {
  __typename?: 'FootageVideo';
  /** Unix timestamp in millis of request creation. */
  created_at: Scalars['TimestampInMillis']['output'];
  /** Information of the user that requested the media. */
  created_by?: Maybe<FleetUser>;
  /** Information of the fleet policy trigger that requested the media. */
  created_by_trigger?: Maybe<MediaRequestTrigger>;
  /** Media duration in seconds */
  duration: Scalars['TimestampInMillis']['output'];
  /** Footage end latitude. Only available if the media has been uploaded. */
  end_latitude?: Maybe<Scalars['Float']['output']>;
  /** Footage end longitude. Only available if the media has been uploaded. */
  end_longitude?: Maybe<Scalars['Float']['output']>;
  /** The url of the content media. Only available if the media has been uploaded. */
  media_url?: Maybe<Scalars['String']['output']>;
  /** Unix timestamp in millis of request status processing. */
  processed_at?: Maybe<Scalars['TimestampInMillis']['output']>;
  /** Request id of the footage. */
  request_id: Scalars['String']['output'];
  /** Status of footage request. */
  request_status: MediaRequestStatus;
  /** Footage start latitude. Only available if the media has been uploaded. */
  start_latitude?: Maybe<Scalars['Float']['output']>;
  /** Footage start longitude. Only available if the media has been uploaded. */
  start_longitude?: Maybe<Scalars['Float']['output']>;
  /**
   * Status of footage request.
   * @deprecated Use `requestStatus` field instead.
   */
  status: RequestedMediaStatus;
  /** The url to the thumbnail image of a video. Only available if the media has been uploaded. */
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  /** Unix timestamp in millis of request status update. */
  updated_at: Scalars['TimestampInMillis']['output'];
};

export type FuelCardAssociationResponse = {
  __typename?: 'FuelCardAssociationResponse';
  createdAt: Scalars['Float']['output'];
  deletedAt?: Maybe<Scalars['Float']['output']>;
  fleetId: Scalars['ID']['output'];
  fuelCardId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  providerLicensePlate: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Float']['output']>;
  vehicle?: Maybe<VehicleDto>;
};

export type FuelCardAssociationStatusInput = {
  fuelCardIds: Array<Scalars['ID']['input']>;
};

export type FuelCardAssociationStatusResponse = {
  __typename?: 'FuelCardAssociationStatusResponse';
  message?: Maybe<Scalars['String']['output']>;
};

export type FuelConsumptionGoalsResponse = {
  __typename?: 'FuelConsumptionGoalsResponse';
  goals: Array<VehicleFuelConsumptionGoalResponse>;
};

export type FuelDto = {
  __typename?: 'FuelDTO';
  consumption?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use `consumption` field. */
  fuelConsumption?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type FuelInput = {
  consumption?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Posto onde o abastecimento foi feito. Nulo na transação sem posto, como as lançadas via API, que o
 * frentista manda com os campos vazios.
 */
export type FuelStation = {
  __typename?: 'FuelStation';
  city?: Maybe<Scalars['String']['output']>;
  cnpj?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type FuelTransactionIntegrationResponse = {
  __typename?: 'FuelTransactionIntegrationResponse';
  createdAt: Scalars['TimestampInMillis']['output'];
  fleetId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  ignoreTransactionType: Scalars['Boolean']['output'];
};

export type FuelTransactionResponse = {
  __typename?: 'FuelTransactionResponse';
  cobliCostPerDrivenKm?: Maybe<Scalars['Float']['output']>;
  cobliDrivenMeters?: Maybe<Scalars['Long']['output']>;
  cobliFuelConsumption?: Maybe<Scalars['Float']['output']>;
  cobliOdometer?: Maybe<Scalars['Float']['output']>;
  commodity: Scalars['String']['output'];
  costCenterDescription?: Maybe<Scalars['String']['output']>;
  costCenterId?: Maybe<Scalars['String']['output']>;
  costPerDrivenKm?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['TimestampInMillis']['output'];
  createdBy: Scalars['String']['output'];
  creatorId?: Maybe<Scalars['ID']['output']>;
  deletedAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  deletedBy?: Maybe<Scalars['ID']['output']>;
  drivenMeters: Scalars['Long']['output'];
  driverName?: Maybe<Scalars['String']['output']>;
  fuelConsumption?: Maybe<Scalars['Float']['output']>;
  groupPath?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  merchant?: Maybe<MerchantResponse>;
  odometer?: Maybe<Scalars['Float']['output']>;
  providerCode?: Maybe<Scalars['String']['output']>;
  totalCost: Scalars['Float']['output'];
  transactionTime: Scalars['TimestampInMillis']['output'];
  unitCost: Scalars['Float']['output'];
  units: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  updatedBy?: Maybe<Scalars['ID']['output']>;
  vehicle?: Maybe<FuelTransactionVehicleResponse>;
};

export type FuelTransactionStatsByVehicleSummaryResponse = {
  __typename?: 'FuelTransactionStatsByVehicleSummaryResponse';
  avgCostPerLiter: Scalars['Float']['output'];
  sumCobliDrivenKms: Scalars['Float']['output'];
  sumFuelLiters: Scalars['Float']['output'];
};

export type FuelTransactionSummaryResponse = {
  __typename?: 'FuelTransactionSummaryResponse';
  avgCostPerKm: Scalars['Float']['output'];
  avgFuelConsumption: Scalars['Float']['output'];
  sumTotalCost: Scalars['Float']['output'];
};

export type FuelTransactionVehicleResponse = {
  __typename?: 'FuelTransactionVehicleResponse';
  cobliVehicle: VehicleDto;
  id: Scalars['ID']['output'];
  integration?: Maybe<FuelTransactionIntegrationResponse>;
  licensePlate?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  refFuelConsumption?: Maybe<Scalars['Float']['output']>;
};

export type FuelTransactionsImportColumnMap = {
  driverName?: InputMaybe<ImportColumnMapInput>;
  fuelType?: InputMaybe<ImportColumnMapInput>;
  licensePlate?: InputMaybe<ImportColumnMapInput>;
  merchantCity?: InputMaybe<ImportColumnMapInput>;
  merchantCnpj?: InputMaybe<ImportColumnMapInput>;
  merchantName?: InputMaybe<ImportColumnMapInput>;
  merchantState?: InputMaybe<ImportColumnMapInput>;
  odometer?: InputMaybe<ImportColumnMapInput>;
  quantityInLiters?: InputMaybe<ImportColumnMapInput>;
  totalCost?: InputMaybe<ImportColumnMapInput>;
  transactionTime?: InputMaybe<ImportColumnMapInput>;
};

export type GeofenceEvent = {
  __typename?: 'GeofenceEvent';
  eventType?: Maybe<Scalars['String']['output']>;
  geofence?: Maybe<GeofenceEventNestedGeofence>;
  id: Scalars['ID']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
};

export type GeofenceEventNestedGeofence = {
  __typename?: 'GeofenceEventNestedGeofence';
  category?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Geofences = {
  __typename?: 'Geofences';
  category?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type Geometry = {
  __typename?: 'Geometry';
  coordinates: Array<Maybe<Array<Maybe<Scalars['Float']['output']>>>>;
  type: Scalars['String']['output'];
};

export type GetChecklist = {
  id: Scalars['ID']['input'];
};

export type GetChecklistsNames = {
  template: Scalars['Boolean']['input'];
};

export type GetCompletedChecklists = {
  complianceFilter?: InputMaybe<Array<InputMaybe<ChecklistComplianceStatus>>>;
  createdByFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inputFilter?: InputMaybe<Scalars['String']['input']>;
  nameFilters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  period?: InputMaybe<DateRange>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Sort>;
  templateIdFilter?: InputMaybe<Scalars['String']['input']>;
  templateIdsFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleGroupIdsFilters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleIdFilters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleIdsFilters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GetFuelTransactionSummaryByPeriodTypeInput = {
  endDate: Scalars['String']['input'];
  fuelTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  groupPeriod: Scalars['String']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
  vehicleGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleSizes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetFuelTransactionsReportInput = {
  end: Scalars['TimestampInMillis']['input'];
  start: Scalars['TimestampInMillis']['input'];
  tz?: InputMaybe<Scalars['String']['input']>;
  vehicleGroupPaths?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetFuelTransactionsSummaryInput = {
  endDate: Scalars['String']['input'];
  fuelTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
  vehicleGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleSizes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetInsightInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  from: Scalars['String']['input'];
  groupPath?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
};

export type GetLatestMaintenanceInput = {
  timezone: Scalars['String']['input'];
  vehicleId: Scalars['ID']['input'];
};

export type GetMaintenanceHistoryInput = {
  endDate: Scalars['DateTime']['input'];
  maintenanceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  tagNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timezone: Scalars['String']['input'];
  vehicleGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleSizes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GetMaintenancePartsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
};

export type GetPagedFuelTransactionsInput = {
  endDate: Scalars['String']['input'];
  fuelTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
  vehicleGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleSizes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetReminderListInput = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tagNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  titleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleModels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleSizes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GetReminderStatusCountInput = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  tagNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  titleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleModels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleSizes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GetTemplateChecklists = {
  activeFilter?: InputMaybe<Scalars['Boolean']['input']>;
  createdByFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**
   * true keeps only templates with at least one option marked as conform or non conform; false keeps
   * only the unmarked ones. Filtered by ryuk before paging, so the page fields stay accurate.
   */
  hasComplianceFilter?: InputMaybe<Scalars['Boolean']['input']>;
  nameFilters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Sort>;
  vehicleGroupIdsFilters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleIdsFilters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GroupRecommendation = {
  __typename?: 'GroupRecommendation';
  appliedPayloadJson?: Maybe<Scalars['String']['output']>;
  dismissCount: Scalars['Int']['output'];
  fleetId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
  suggestedName: Scalars['String']['output'];
  vehicleIds: Array<Scalars['ID']['output']>;
};

export type GroupRecommendationEditInput = {
  suggestedName?: InputMaybe<Scalars['String']['input']>;
  vehicleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type HarshEvents = {
  __typename?: 'HarshEvents';
  acceleration: SensibilityConfiguration;
  braking: SensibilityConfiguration;
  cornering: SensibilityConfiguration;
  impact?: Maybe<SensibilityConfiguration>;
};

export type HarshEventsByDutyType = {
  __typename?: 'HarshEventsByDutyType';
  heavy: HarshEvents;
  light: HarshEvents;
  medium: HarshEvents;
};

export type HarshEventsByDutyTypeInput = {
  heavy: HarshEventsInput;
  light: HarshEventsInput;
  medium: HarshEventsInput;
};

export type HarshEventsInput = {
  acceleration: SensibilityConfigurationInput;
  braking: SensibilityConfigurationInput;
  cornering: SensibilityConfigurationInput;
  impact?: InputMaybe<SensibilityConfigurationInput>;
};

export type HomeProductivitySummary = {
  __typename?: 'HomeProductivitySummary';
  averageEngineOnTimeInMinutes: Scalars['Int']['output'];
  averageIdleOnTimeInMinutes: Scalars['Int']['output'];
  averageJourneyTimeInMinutes: Scalars['Int']['output'];
  averageStopTimeInMinutes: Scalars['Int']['output'];
};

export type HomeSpeedSummary = {
  __typename?: 'HomeSpeedSummary';
  roadEvents: AggregatedSpeedEventsSummary;
  vehicleEvents: AggregatedSpeedEventsSummary;
};

export type ICreatedUser = {
  __typename?: 'ICreatedUser';
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type IEnrollmentFormInfo = {
  __typename?: 'IEnrollmentFormInfo';
  invite: IInvite;
  occupations?: Maybe<Array<Maybe<IOccupation>>>;
};

export type IInvite = {
  __typename?: 'IInvite';
  emailAddress: Scalars['String']['output'];
  fleetId: Scalars['String']['output'];
};

export type IInviteAcceptForm = {
  full_name: Scalars['String']['input'];
  occupation?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};

export type IOccupation = {
  __typename?: 'IOccupation';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ITicket = {
  associatedDealId?: Maybe<Scalars['String']['output']>;
  closedDate?: Maybe<Scalars['TimestampInMillis']['output']>;
  createdAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  deletedAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  deviceCobliIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deviceIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deviceTotalQuantity?: Maybe<DeviceTotalQuantity>;
  fleetId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export enum IdentificationMethod {
  FaceIdentification = 'FACE_IDENTIFICATION',
  TripWithoutImage = 'TRIP_WITHOUT_IMAGE',
  UserConfirmation = 'USER_CONFIRMATION',
  UserEdit = 'USER_EDIT',
  WithoutIdentification = 'WITHOUT_IDENTIFICATION',
}

export type IdentificationToken = {
  __typename?: 'IdentificationToken';
  associated_to_driver_at?: Maybe<Scalars['TimestampInMillis']['output']>;
  associated_to_fleet_at?: Maybe<Scalars['TimestampInMillis']['output']>;
  cobli_internal_id: Scalars['String']['output'];
  driver_id?: Maybe<Scalars['ID']['output']>;
  fleet_id?: Maybe<Scalars['ID']['output']>;
  status: Scalars['String']['output'];
  token_id: Scalars['String']['output'];
  token_type: Scalars['String']['output'];
};

export type IdentificationTokenFilters = {
  driverIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  isLinkedToDriver?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IdentificationTokenLastUsage = {
  __typename?: 'IdentificationTokenLastUsage';
  location?: Maybe<Location>;
  timestamp?: Maybe<Scalars['TimestampInMillis']['output']>;
  vehicle?: Maybe<VehicleDto>;
};

export enum IdentificationTokenStatus {
  /** @deprecated Should use string instead of graphql */
  AwaitingReturn = 'awaiting_return',
  /** @deprecated Should use string instead of graphql */
  Broken = 'broken',
  /** @deprecated Should use string instead of graphql */
  Commodate = 'commodate',
  /** @deprecated Should use string instead of graphql */
  Donated = 'donated',
  /** @deprecated Should use string instead of graphql */
  External = 'external',
  /** @deprecated Should use string instead of graphql */
  InStock = 'in_stock',
  /** @deprecated Should use string instead of graphql */
  Indebted = 'indebted',
  /** @deprecated Should use string instead of graphql */
  Lost = 'lost',
  /** @deprecated Should use string instead of graphql */
  Refunded = 'refunded',
  /** @deprecated Should use string instead of graphql */
  Testing = 'testing',
  /** @deprecated Should use string instead of graphql */
  Unknown = 'unknown',
}

export type IdentificationTokenV2 = {
  __typename?: 'IdentificationTokenV2';
  alias?: Maybe<Scalars['String']['output']>;
  associatedToDriverAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  associatedToFleetAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  /** @deprecated Use associatedToDriverAt instead */
  associated_to_driver_at?: Maybe<Scalars['TimestampInMillis']['output']>;
  /** @deprecated Use associatedToFleetAt instead */
  associated_to_fleet_at?: Maybe<Scalars['TimestampInMillis']['output']>;
  cobliId?: Maybe<Scalars['String']['output']>;
  driverId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use driverId instead */
  driver_id?: Maybe<Scalars['ID']['output']>;
  fleetId: Scalars['ID']['output'];
  /** @deprecated Use fleetId instead */
  fleet_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['String']['output'];
  isExternal: Scalars['Boolean']['output'];
  /** @deprecated Use isExternal instead */
  is_external: Scalars['Boolean']['output'];
  lastUsage?: Maybe<IdentificationTokenLastUsage>;
  origin: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tokenId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use alias instead */
  token_alias: Scalars['String']['output'];
  /** @deprecated Use tokenId instead */
  token_id?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use type instead */
  token_type: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type IdleSpeedConfiguration = {
  __typename?: 'IdleSpeedConfiguration';
  enabled: Scalars['Boolean']['output'];
  /** Time stopped with the engine on before the alarm, 300–1800 seconds */
  threshold_seconds: Scalars['Int']['output'];
};

export type IdleSpeedConfigurationInput = {
  enabled: Scalars['Boolean']['input'];
  threshold_seconds: Scalars['Int']['input'];
};

export type ImportBatchResponse = {
  __typename?: 'ImportBatchResponse';
  count: Scalars['Long']['output'];
};

export type ImportColumnMap = {
  __typename?: 'ImportColumnMap';
  name: Scalars['String']['output'];
  position: Scalars['String']['output'];
};

export type ImportColumnMapInput = {
  name: Scalars['String']['input'];
  position: Scalars['String']['input'];
};

export type ImportErrorDto = {
  __typename?: 'ImportErrorDTO';
  field?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ImportExpensesBatchInput = {
  categoryId: Scalars['String']['input'];
  groupPath?: InputMaybe<Scalars['String']['input']>;
  observation?: InputMaybe<Scalars['String']['input']>;
  occurredAt: Scalars['String']['input'];
  supplierName?: InputMaybe<Scalars['String']['input']>;
  totalCost: Scalars['Float']['input'];
  type: Scalars['String']['input'];
  vehicleId: Scalars['String']['input'];
};

export type ImportFuelTransactionsBatchInput = {
  driverName?: InputMaybe<Scalars['String']['input']>;
  fuelType: Scalars['String']['input'];
  licensePlate: Scalars['String']['input'];
  merchant?: InputMaybe<MerchantCreateInput>;
  odometerInKm: Scalars['Float']['input'];
  quantityInLiters: Scalars['Float']['input'];
  totalCost: Scalars['Float']['input'];
  transactionTime: Scalars['String']['input'];
};

export type ImportMaintenanceBatchInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  occurrenceAt: Scalars['DateTime']['input'];
  odometerInKms: Scalars['Float']['input'];
  parts: Array<ImportMaintenancePartInput>;
  types: Array<Scalars['String']['input']>;
  vehicleId: Scalars['String']['input'];
};

export type ImportMaintenancePartInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  partName: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type ImportVehicleRowDto = {
  __typename?: 'ImportVehicleRowDTO';
  fuelConsumption?: Maybe<Scalars['Float']['output']>;
  fuelPrice?: Maybe<Scalars['Float']['output']>;
  fuelType?: Maybe<Scalars['String']['output']>;
  licensePlate: Scalars['String']['output'];
  size?: Maybe<Scalars['String']['output']>;
  speedLimitInKmh?: Maybe<Scalars['Int']['output']>;
};

export type Incidents = {
  __typename?: 'Incidents';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  time: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type InputActivity = {
  additional_info?: InputMaybe<Scalars['String']['input']>;
  destination: DestinationInput;
  device_id?: InputMaybe<Scalars['String']['input']>;
  driver_id?: InputMaybe<Scalars['ID']['input']>;
  driver_name?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['TimeIntervalInMillis']['input']>;
  load_size?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  time_windows?: InputMaybe<Array<TimeWindowInput>>;
  vehicle_id?: InputMaybe<Scalars['ID']['input']>;
};

export type InsertUserNotificationSettings = {
  active: Scalars['Boolean']['input'];
  settings_json: SettingsJsonInput;
  type: UserNotificationSettingsType;
};

export type Insight = {
  __typename?: 'Insight';
  action?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  driver?: Maybe<Driver>;
  fleetId: Scalars['ID']['output'];
  group?: Maybe<Array<Maybe<VehiclesGroup>>>;
  id: Scalars['ID']['output'];
  impact?: Maybe<Scalars['String']['output']>;
  insightText?: Maybe<Scalars['String']['output']>;
  seen: Scalars['Boolean']['output'];
  vehicle?: Maybe<VehicleDto>;
};

export type InsightEvaluation = {
  __typename?: 'InsightEvaluation';
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insight: Insight;
  spanId: Scalars['String']['output'];
  thumbDown?: Maybe<Scalars['Boolean']['output']>;
  thumbUp?: Maybe<Scalars['Boolean']['output']>;
  traceId: Scalars['String']['output'];
};

export type InsightThumbsDownInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  groupPath?: InputMaybe<Scalars['String']['input']>;
  insightId: Scalars['ID']['input'];
};

export type InsightThumbsUpInput = {
  groupPath?: InputMaybe<Scalars['String']['input']>;
  insightId: Scalars['ID']['input'];
};

export type InstallDeviceInVehicleInput = {
  deviceId: Scalars['String']['input'];
  vehicleId: Scalars['ID']['input'];
};

export type InstallationAddressInformation = {
  __typename?: 'InstallationAddressInformation';
  addressConfirmation?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
};

export type InstallationClientInformation = {
  __typename?: 'InstallationClientInformation';
  email?: Maybe<Scalars['String']['output']>;
  installationDoneByClient?: Maybe<Scalars['Boolean']['output']>;
  installationProblem?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  responsibleForTrackingScheduling?: Maybe<Scalars['String']['output']>;
};

export type InstallationCoblerInformation = {
  __typename?: 'InstallationCoblerInformation';
  responsible?: Maybe<Scalars['String']['output']>;
  responsibleScheduling?: Maybe<Scalars['String']['output']>;
  responsibleToContactClient?: Maybe<Scalars['String']['output']>;
  technicalResponsible?: Maybe<Scalars['String']['output']>;
};

export type InstallationContactInformation = {
  __typename?: 'InstallationContactInformation';
  bestTimeToContact?: Maybe<Scalars['String']['output']>;
  bestWayOfContact?: Maybe<Scalars['String']['output']>;
  meansToContact?: Maybe<Scalars['String']['output']>;
  meansToContactTheResponsibleForInstallation?: Maybe<Scalars['String']['output']>;
};

export type InstallationDateInformation = {
  __typename?: 'InstallationDateInformation';
  clientFirstPreferredScheduleDay?: Maybe<Scalars['String']['output']>;
  clientFirstPreferredScheduleHour?: Maybe<Scalars['String']['output']>;
  clientSecondPreferredScheduleDay?: Maybe<Scalars['String']['output']>;
  clientSecondPreferredScheduleHour?: Maybe<Scalars['String']['output']>;
  installationConfirmedAt?: Maybe<Scalars['String']['output']>;
  installedDate?: Maybe<Scalars['String']['output']>;
  scheduledDateTime?: Maybe<Scalars['String']['output']>;
  scheduledDay?: Maybe<Scalars['String']['output']>;
};

export type InstallationDeviceInformation = {
  __typename?: 'InstallationDeviceInformation';
  calculatedInstallDevices?: Maybe<Scalars['Int']['output']>;
  esnToInstall?: Maybe<Scalars['String']['output']>;
  esnToNotInstall?: Maybe<Scalars['String']['output']>;
  heavyOrLightVehiclesInstalledIdentifierQuantity?: Maybe<Scalars['Int']['output']>;
  heavyOrLightVehiclesInstalledImmobilizerQuantity?: Maybe<Scalars['Int']['output']>;
  heavyOrLightVehiclesInstalledQuantity?: Maybe<Scalars['Int']['output']>;
  heavyOrLightVehiclesInstalledQuantityCoblicam?: Maybe<Scalars['Int']['output']>;
  installationDevicesCobliIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  installationDevicesIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  installationEsns?: Maybe<Scalars['String']['output']>;
  installationInstalledEsns?: Maybe<Scalars['String']['output']>;
  installationNotInstalledEsns?: Maybe<Scalars['String']['output']>;
  lightVehiclesInstalledBlockerQuantity?: Maybe<Scalars['Int']['output']>;
  motorcyclesOrHeavyVehiclesInstalledQuantity?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type InstallationFieldControlInformation = {
  __typename?: 'InstallationFieldControlInformation';
  fieldAssociation?: Maybe<Scalars['String']['output']>;
  fieldClass?: Maybe<Scalars['String']['output']>;
  fieldControlObservation?: Maybe<Scalars['String']['output']>;
  observationToTheTechnicalTeam?: Maybe<Scalars['String']['output']>;
  supplyInstalacaoClasse?: Maybe<Scalars['String']['output']>;
  worker?: Maybe<Scalars['String']['output']>;
};

export type InstallationInformation = {
  __typename?: 'InstallationInformation';
  addressInformation?: Maybe<InstallationAddressInformation>;
  clientInformation?: Maybe<InstallationClientInformation>;
  coblerInformation?: Maybe<InstallationCoblerInformation>;
  contactInformation?: Maybe<InstallationContactInformation>;
  dateInformation?: Maybe<InstallationDateInformation>;
  deviceInformation?: Maybe<InstallationDeviceInformation>;
  fieldControlInformation?: Maybe<InstallationFieldControlInformation>;
  fleetId?: Maybe<Scalars['String']['output']>;
  installationConfirmedAt?: Maybe<Scalars['String']['output']>;
  installedDate?: Maybe<Scalars['String']['output']>;
  notResponsible?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ratedAt?: Maybe<Scalars['String']['output']>;
  responsibleUser?: Maybe<InstallationResponsibleUser>;
  scheduledDateTime?: Maybe<Scalars['String']['output']>;
  scheduledDay?: Maybe<Scalars['String']['output']>;
  vehicleInformation?: Maybe<InstallationVehicleInformation>;
};

export type InstallationResponsibleUser = {
  __typename?: 'InstallationResponsibleUser';
  createdAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fleetIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type InstallationVehicleInformation = {
  __typename?: 'InstallationVehicleInformation';
  plack?: Maybe<Scalars['String']['output']>;
  vehicles?: Maybe<Scalars['String']['output']>;
};

export type InvalidImportVehicleRowDto = {
  __typename?: 'InvalidImportVehicleRowDTO';
  data: ValidateImportVehicleRowDto;
  errors: Array<ImportErrorDto>;
};

export type Invite = {
  __typename?: 'Invite';
  creationDate: Scalars['TimestampInMillis']['output'];
  creatorId: Scalars['String']['output'];
  customPermissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  emailAddress: Scalars['String']['output'];
  fleetId: Scalars['String']['output'];
  groups?: Maybe<Array<Maybe<VehiclesGroup>>>;
  groupsRestriction?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  role: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type InviteForm = {
  custom_permissions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email_address: Scalars['String']['input'];
  groups_restriction: Array<InputMaybe<Scalars['String']['input']>>;
  role: Scalars['String']['input'];
  suggested_user_name?: InputMaybe<Scalars['String']['input']>;
};

export type InviteResponse = {
  __typename?: 'InviteResponse';
  email_address: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type LastAssociation = {
  __typename?: 'LastAssociation';
  cobliId?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  driver?: Maybe<DriverLastAssociation>;
  fleetId: Scalars['ID']['output'];
  lastLocation?: Maybe<LastLocation>;
  vehicle?: Maybe<VehicleLastAssociation>;
};

export type LastLocation = {
  __typename?: 'LastLocation';
  cobliIngestedAt?: Maybe<Scalars['Float']['output']>;
  deviceId: Scalars['String']['output'];
  heading?: Maybe<Scalars['Int']['output']>;
  idleOffDurationInMillis?: Maybe<Scalars['Float']['output']>;
  idleOnDurationInMillis?: Maybe<Scalars['Float']['output']>;
  ignitionOn?: Maybe<Scalars['Boolean']['output']>;
  isPlugged?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  pluggedUpdateTimestamp?: Maybe<Scalars['Float']['output']>;
  processedAt?: Maybe<Scalars['Float']['output']>;
  speed?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
  timeInMillis?: Maybe<Scalars['Float']['output']>;
};

export type LastPath = {
  __typename?: 'LastPath';
  event_time: Scalars['TimestampInMillis']['output'];
};

export type LastPathInput = {
  deviceId: Scalars['String']['input'];
};

export enum LicenseCategory {
  A = 'A',
  Ab = 'AB',
  Ac = 'AC',
  Acc = 'ACC',
  Ad = 'AD',
  Ae = 'AE',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
}

export type ListActivitiesInput = {
  activities_type?: InputMaybe<ActivityType>;
  completion_statuses?: InputMaybe<Array<ActivityCompletionStatus>>;
  drivers_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  end_in_millis?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  page: Scalars['Int']['input'];
  routes_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  size: Scalars['Int']['input'];
  sort?: InputMaybe<Sort>;
  start_in_millis?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  text_filter?: InputMaybe<Scalars['String']['input']>;
  vehicles_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  without_route?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ListRoutesInput = {
  driver_id?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  period: DateRange;
  size: Scalars['Int']['input'];
  sort?: InputMaybe<Sort>;
  text_filter?: InputMaybe<Scalars['String']['input']>;
  vehicle_id?: InputMaybe<Scalars['String']['input']>;
};

export type ListRoutesInputV2 = {
  drivers_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  page: Scalars['Int']['input'];
  period: DateRange;
  size: Scalars['Int']['input'];
  sort?: InputMaybe<Sort>;
  text_filter?: InputMaybe<Scalars['String']['input']>;
  vehicles_ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Location = {
  __typename?: 'Location';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type LoggedUser = {
  __typename?: 'LoggedUser';
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Nulo quando não há telefone cadastrado — a distinção que decide se é preciso pedir
   * o número. O upstream usa string vazia; aqui ela vira nulo.
   */
  phoneNumber?: Maybe<Scalars['PhoneNumber']['output']>;
};

export type Maintenance = {
  __typename?: 'Maintenance';
  apiVersion?: Maybe<Scalars['String']['output']>;
  createdBy: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  occurrenceAt?: Maybe<Scalars['DateTime']['output']>;
  odometerInKms?: Maybe<Scalars['Float']['output']>;
  /**
   * Parada (situação operacional) que originou este registro, quando ele veio da sugestão de registrar
   * manutenção. Referência ao fusca — pode apontar para uma parada que não existe mais.
   */
  operationalSituationId?: Maybe<Scalars['ID']['output']>;
  parts?: Maybe<Array<Maybe<MaintenancePart>>>;
  recurrences?: Maybe<Array<Maybe<Recurrence>>>;
  totalPrice?: Maybe<Scalars['Float']['output']>;
  types: Array<Maybe<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['DateTime']['output']>;
  vehicle?: Maybe<VehicleDto>;
};

export type MaintenanceImportColumnMap = {
  licensePlate?: InputMaybe<ImportColumnMapInput>;
  maintenanceObservation?: InputMaybe<ImportColumnMapInput>;
  occurrenceAt?: InputMaybe<ImportColumnMapInput>;
  odometerInKms?: InputMaybe<ImportColumnMapInput>;
  partName?: InputMaybe<ImportColumnMapInput>;
  partObservation?: InputMaybe<ImportColumnMapInput>;
  quantity?: InputMaybe<ImportColumnMapInput>;
  type?: InputMaybe<ImportColumnMapInput>;
  unitCost?: InputMaybe<ImportColumnMapInput>;
};

export type MaintenancePart = {
  __typename?: 'MaintenancePart';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  part?: Maybe<Part>;
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type MaintenancePartInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  partId: Scalars['ID']['input'];
  price?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type MaintenancePartResponse = {
  __typename?: 'MaintenancePartResponse';
  count: Scalars['Int']['output'];
  rows?: Maybe<Array<Maybe<MaintenancePart>>>;
};

export type MaintenanceReminderResponse = {
  __typename?: 'MaintenanceReminderResponse';
  count: Scalars['Int']['output'];
  rows: Array<ReminderDto>;
};

export type MaintenanceResponse = {
  __typename?: 'MaintenanceResponse';
  count: Scalars['Int']['output'];
  rows?: Maybe<Array<Maybe<Maintenance>>>;
};

export type MaintenanceStatus = {
  __typename?: 'MaintenanceStatus';
  days?: Maybe<Scalars['Int']['output']>;
  km?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

export type Manager = {
  __typename?: 'Manager';
  accessible_fleets?: Maybe<Array<Maybe<AcessibleFleets>>>;
  active?: Maybe<Scalars['Boolean']['output']>;
  creation_date?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fleets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fullname?: Maybe<Scalars['String']['output']>;
  groups_restriction?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  language?: Maybe<Scalars['String']['output']>;
  last_login?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['Int']['output']>;
};

export type ManualOdometer = {
  __typename?: 'ManualOdometer';
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  odometerAt: Scalars['String']['output'];
  odometerInKms: Scalars['Long']['output'];
};

export type MarkConferenceReviewInput = {
  observation?: InputMaybe<Scalars['String']['input']>;
  status: ConferenceReviewStatus;
  transactionId: Scalars['ID']['input'];
};

export type Media = {
  __typename?: 'Media';
  /** AI suggested driver */
  ai_suggested_driver?: Maybe<Driver>;
  /** AI suggested driver ID */
  ai_suggested_driver_id?: Maybe<Scalars['ID']['output']>;
  /** AI video tags */
  ai_video_tags?: Maybe<AiVideoTags>;
  /** Comments of the media */
  comments?: Maybe<Array<Maybe<MediaComment>>>;
  /** Device of the media */
  device?: Maybe<Device>;
  /** Device identifier. A number between 10 and 15 digits */
  device_id: Scalars['String']['output'];
  /** Driver associated with the Media */
  driver?: Maybe<Driver>;
  /** DriverFaceCluster data for the media */
  driver_face_cluster?: Maybe<DriverFaceClustersMedia>;
  /** Driver identifier UUID. Available only if a driver was assigned to the device ID at video start timestamp. */
  driver_id?: Maybe<Scalars['ID']['output']>;
  /**
   * Driver name. Available only if a driver was assigned to the device ID at video start timestamp.
   * @deprecated Use `driver` field instead
   */
  driver_name?: Maybe<Scalars['String']['output']>;
  /** Group path */
  group_path?: Maybe<Scalars['String']['output']>;
  /** Media ID */
  id: Scalars['ID']['output'];
  /** Is favorite media */
  is_favorite?: Maybe<Scalars['Boolean']['output']>;
  media_details: MediaDetails;
  /** Media status considering view count and safety review status. */
  media_status: MediaStatus;
  /** Type of media content. */
  media_type: MediaType;
  /**
   * User views count
   * @deprecated Use `mediaStatus` field instead.
   */
  media_view_count: Scalars['Int']['output'];
  /** Media safety review */
  safety_review?: Maybe<SafetyReview>;
  /** Event severity. */
  severity?: Maybe<Severity>;
  /** Detailed severity definition */
  severity_detail?: Maybe<SeverityDetail>;
  /** Video start Unix timestamp in millis. */
  timestamp: Scalars['TimestampInMillis']['output'];
  /** Driver associated before review */
  unreviewed_driver?: Maybe<Driver>;
  /** Vehicle details */
  vehicle?: Maybe<VehicleDto>;
  /** Group */
  vehicle_group?: Maybe<VehiclesGroup>;
  /** Vehicle identifier */
  vehicle_id?: Maybe<Scalars['ID']['output']>;
};

export type MediaComment = {
  __typename?: 'MediaComment';
  /** Content of the comment */
  content?: Maybe<Scalars['String']['output']>;
  /** Datetime of comment creation */
  created_at: Scalars['String']['output'];
  /** ID of the user that created the comment */
  created_by: Scalars['ID']['output'];
  /** User that created the comment */
  created_by_user: FleetUser;
  /** Media comment ID */
  id: Scalars['ID']['output'];
  /** Media ID associated with comment */
  media_id: Scalars['ID']['output'];
  /** Datetime of comment last update */
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type MediaDetails = EventVideo | FootageVideo;

export type MediaPage = {
  __typename?: 'MediaPage';
  content?: Maybe<Array<Maybe<Media>>>;
  empty?: Maybe<Scalars['Boolean']['output']>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  number_of_elements?: Maybe<Scalars['Int']['output']>;
  pageable?: Maybe<PageableObject>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<SortType>;
  total_elements?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export enum MediaRequestStatus {
  AmountExceeded = 'AMOUNT_EXCEEDED',
  CorruptedVideo = 'CORRUPTED_VIDEO',
  FailedRequest = 'FAILED_REQUEST',
  FinishedRequest = 'FINISHED_REQUEST',
  LmErrorFailed = 'LM_ERROR_FAILED',
  LmErrorUnavailable = 'LM_ERROR_UNAVAILABLE',
  ManualRetryRequest = 'MANUAL_RETRY_REQUEST',
  PendingRequest = 'PENDING_REQUEST',
  PeriodUnavailable = 'PERIOD_UNAVAILABLE',
  Requested = 'REQUESTED',
  RequestAcknowledged = 'REQUEST_ACKNOWLEDGED',
  RetryRequested = 'RETRY_REQUESTED',
  TimeoutRequest = 'TIMEOUT_REQUEST',
}

export type MediaRequestTrigger = {
  __typename?: 'MediaRequestTrigger';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rule_category?: Maybe<Scalars['String']['output']>;
};

export type MediaResponse = {
  __typename?: 'MediaResponse';
  /** Safety review description generated by AI */
  ai_description?: Maybe<Scalars['String']['output']>;
  /** AI video tags */
  ai_video_tags?: Maybe<AiVideoTags>;
  /** Url expiration date */
  expiration_date?: Maybe<Scalars['Long']['output']>;
  /** Media information data */
  media_info?: Maybe<Media>;
  /** Media Url generated and signed with expiration data */
  media_url?: Maybe<Scalars['String']['output']>;
  /** Suggested occurrences by AI */
  suggested_occurrences?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Videos from media */
  videos?: Maybe<Array<Maybe<VideoDto>>>;
};

export enum MediaStatus {
  Archived = 'ARCHIVED',
  Dismissed = 'DISMISSED',
  New = 'NEW',
  Relevant = 'RELEVANT',
  Watched = 'WATCHED',
}

export enum MediaType {
  EventVideo = 'EVENT_VIDEO',
  FootageVideo = 'FOOTAGE_VIDEO',
  Timelapse = 'TIMELAPSE',
}

export type MerchantCreateInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  cnpj?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type MerchantImportResponse = {
  __typename?: 'MerchantImportResponse';
  city?: Maybe<Scalars['String']['output']>;
  cnpj?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type MerchantResponse = {
  __typename?: 'MerchantResponse';
  city?: Maybe<Scalars['String']['output']>;
  cnpj?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['String']['output']>;
  lng?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type MerchantUpdateInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  cnpj?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptInvite?: Maybe<ICreatedUser>;
  addChecklist: Checklist;
  addDriver?: Maybe<Driver>;
  applyGroupRecommendation: GroupRecommendation;
  assignDriverToDevice?: Maybe<Scalars['Boolean']['output']>;
  /** If the requester is authorized to assign a driver to a cluster, a face association request will be created. */
  assignFaceCluster?: Maybe<Scalars['Boolean']['output']>;
  associateTokenToDriver?: Maybe<IdentificationTokenV2>;
  batchCreateDrivers: Array<Driver>;
  batchCreateIdentificationTokens: Array<IdentificationTokenV2>;
  batchSetFuelConsumptionGoals: FuelConsumptionGoalsResponse;
  /**
   * Cancela uma parada que ainda não começou, apagando o registro: uma parada que nunca aconteceu não
   * é histórico. Situação que já começou — ativa ou encerrada — é recusada; para essa, use
   * `endOperationalSituation`.
   */
  cancelOperationalSituation: Scalars['Boolean']['output'];
  /** If the requester is authorized to change the camera configuration, it will be changed. */
  changeCameraConfiguration?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Os erros do ryuk chegam com o status em `extensions.response.status`: 422 (transição inválida, nota ou
   * responsável faltando), 409 (alguém alterou antes, ou já existe outra tratativa ativa para a mesma pergunta
   * e veículo) e 404.
   */
  changeChecklistNonConformityStatus?: Maybe<Array<ChecklistNonConformity>>;
  completeFleetRecommendation: RecommendationActionResult;
  createActivities: Array<Activity>;
  createCheckpointManual: CreateManualOdometerResponse;
  /** Create a new fleet audio message. The message text is converted to audio using AWS Polly text-to-speech and stored in S3. */
  createFleetAudioMessage?: Maybe<FleetAudioMessage>;
  createFuelTransaction: FuelTransactionResponse;
  createMaintenanceHistory: Maintenance;
  createMaintenanceParts: Part;
  createMaintenanceReminder: Array<ReminderDto>;
  createMedia: CreateMediaResponse;
  /** Cria de 1 a 500 situações atomicamente: se um dos alvos falhar, nenhuma é criada. */
  createOperationalSituations: Array<OperationalSituation>;
  createRoutes?: Maybe<Array<Route>>;
  createVehicle: VehicleDto;
  createVehiclesBatch: Array<VehicleDto>;
  createVehiclesGroup?: Maybe<VehiclesGroup>;
  deleteActivities: Array<Scalars['ID']['output']>;
  deleteChecklist: Checklist;
  deleteDriver?: Maybe<Driver>;
  /** Delete a playback record. Only pending and failed playbacks can be deleted (not successful ones). */
  deleteFleetAudioMessagePlayback?: Maybe<Scalars['Boolean']['output']>;
  deleteFuelCardAssociation: FuelCardAssociationStatusResponse;
  deleteFuelTransactions: Scalars['Boolean']['output'];
  deleteInvite?: Maybe<Scalars['String']['output']>;
  deleteMaintenanceHistory?: Maybe<Scalars['Boolean']['output']>;
  deleteMaintenanceParts?: Maybe<Scalars['Boolean']['output']>;
  deleteMaintenanceReminder?: Maybe<Scalars['Boolean']['output']>;
  deleteRoutes: Array<Maybe<Scalars['ID']['output']>>;
  deleteToken?: Maybe<Scalars['String']['output']>;
  deleteVehicle?: Maybe<Scalars['ID']['output']>;
  deleteVehicleTag: Scalars['String']['output'];
  deleteVehiclesGroup?: Maybe<Scalars['ID']['output']>;
  disassociateTokenFromDriver?: Maybe<Scalars['String']['output']>;
  dismissFleetRecommendation: RecommendationActionResult;
  dismissGroupRecommendation: GroupRecommendation;
  /** Nominates a driver for a trip. */
  driverNominateTripImage?: Maybe<Scalars['Boolean']['output']>;
  endOperationalSituation: Scalars['Boolean']['output'];
  endRoute: Route;
  evaluateInsightThumbsDown?: Maybe<InsightEvaluation>;
  evaluateInsightThumbsUp?: Maybe<InsightEvaluation>;
  /** @deprecated Gerar no request esgota threads do Tomcat (incidente 2026-07-22/23). Use a query fleetGeofenceRecommendations; a geração virou job na user-api. */
  generateFleetGeofenceRecommendations: Array<FleetGeofenceRecommendation>;
  /** @deprecated Gerar no request esgota threads do Tomcat (incidente 2026-07-22/23). Use a query fleetGroupRecommendations; a geração virou job na user-api. */
  generateGroupRecommendation: Array<GroupRecommendation>;
  importExpenses: ImportBatchResponse;
  importFuelTransactions: ImportBatchResponse;
  importMaintenanceHistory: ImportBatchResponse;
  importSpreadsheet: Array<SpreadsheetImportResultAddress>;
  insertUserNotificationSettings?: Maybe<UserNotificationSettings>;
  /** Associa (instala) um dispositivo a um veículo. Espelha POST /vehicles/{vehicleId}/installed-device do fusca. */
  installDeviceInVehicle?: Maybe<Scalars['Boolean']['output']>;
  markConferenceReview: ConferenceTransactionResponse;
  /** Send an audio message to play on a specific device. Creates a playback record and attempts immediate delivery. */
  playFleetAudioMessage?: Maybe<FleetAudioMessagePlayback>;
  /** Registra que o convite para o app foi enviado (ou copiado) e devolve a situação atualizada. */
  registerDriverAppInvite?: Maybe<DriverAppAccess>;
  /**
   * Reject the current driver suggestion for a cluster. Idempotent: rejecting an
   * already-rejected suggestion is a no-op. Returns true on success.
   */
  rejectClusterSuggestion?: Maybe<Scalars['Boolean']['output']>;
  reopenConferenceReview: ConferenceTransactionResponse;
  restoreFuelCardAssociation: FuelCardAssociationStatusResponse;
  /** Retry a failed or pending playback. Resets status to PENDING and attempts delivery again. */
  retryFleetAudioMessagePlayback?: Maybe<FleetAudioMessagePlayback>;
  sendInvites?: Maybe<SendInvitesResponse>;
  /** Updates user feedback on a labeled image obstruction. */
  sendTripImageObstructionFeedback?: Maybe<Scalars['Boolean']['output']>;
  setupUserNotificationSettings?: Maybe<Array<Maybe<UserNotificationSettings>>>;
  startRoute: Route;
  toggleChecklistActive: Checklist;
  /**
   * Registra a frota como usuária da feature de recomendações, para o job saber quais frotas
   * visitar. Não gera nada.
   */
  touchFleetRecommendations: Scalars['Boolean']['output'];
  unassignDriverToDevice?: Maybe<Scalars['Boolean']['output']>;
  /** Desassocia (desinstala) o dispositivo atualmente instalado no veículo. Espelha DELETE /vehicles/{vehicleId}/installed-device do fusca. */
  uninstallDeviceFromVehicle?: Maybe<Scalars['Boolean']['output']>;
  updateActivity: Activity;
  /** If the requester is authorized to request the media, the faceId association will be updated. */
  updateAssociation?: Maybe<Scalars['Boolean']['output']>;
  /** If the requester is authorized to request the media, a media request will be created. */
  updateAudio?: Maybe<Scalars['Boolean']['output']>;
  updateChecklist: Checklist;
  updateContactTraining?: Maybe<Scalars['Boolean']['output']>;
  updateDeviceParameters: UpdateParameterResponse;
  /** @deprecated Use createOperationalSituations com situation RESERVE, ou endOperationalSituation com o id de Device.operationalSituation */
  updateDeviceSpareStatus?: Maybe<Scalars['Boolean']['output']>;
  updateDeviceStatusSubscription?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use createOperationalSituations, que aceita até 500 registros num request */
  updateDevicesSpareStatus?: Maybe<Scalars['Boolean']['output']>;
  updateDriver?: Maybe<Driver>;
  /** Update the events configuration for the requester's fleet cameras. */
  updateFleetEventsConfiguration?: Maybe<Scalars['Boolean']['output']>;
  /** Update how the requester's fleet reviews its event videos. Only users without group restriction can change it. */
  updateFleetVideoReviewConfiguration?: Maybe<FleetVideoReviewConfiguration>;
  updateFuelCardAssociation: FuelCardAssociationStatusResponse;
  updateFuelTransaction: FuelTransactionResponse;
  /**
   * Grava o telefone do usuário da sessão. Só o próprio usuário: o id vem da sessão,
   * nunca do cliente.
   */
  updateLoggedUserPhoneNumber: LoggedUser;
  updateMaintenanceHistory: Maintenance;
  updateMaintenanceParts: Part;
  updateMaintenanceReminder: ReminderDto;
  /**
   * Edita período e justificativa de uma situação que ainda não terminou. Situação já encerrada é
   * recusada: o histórico fica como aconteceu.
   */
  updateOperationalSituation: OperationalSituation;
  updateRouteV2: Route;
  /** If the requester is authorized to change the speed limit configuration, it will be changed. */
  updateSpeedLimitConfiguration?: Maybe<Scalars['Boolean']['output']>;
  updateUserActivationTask?: Maybe<UserActivationTask>;
  updateUserNotificationSettings?: Maybe<UserNotificationSettings>;
  updateUserTrainingMedia?: Maybe<UserTrainingMedia>;
  updateVehicle?: Maybe<VehicleDto>;
  updateVehicleImmobilizer?: Maybe<VehicleDto>;
  updateVehiclesGroup?: Maybe<VehiclesGroup>;
  validateImportVehicleSpreadsheet: ValidateImportVehicleSpreadsheetResponse;
  vehicleAssociations: Array<Activity>;
};

export type MutationAcceptInviteArgs = {
  input: IInviteAcceptForm;
  token: Scalars['String']['input'];
};

export type MutationAddChecklistArgs = {
  input?: InputMaybe<NewChecklist>;
};

export type MutationAddDriverArgs = {
  input?: InputMaybe<AddDriver>;
};

export type MutationApplyGroupRecommendationArgs = {
  fleetId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  input: ApplyGroupRecommendationInput;
};

export type MutationAssignDriverToDeviceArgs = {
  input: DriverAssignmentInput;
};

export type MutationAssignFaceClusterArgs = {
  input: Array<InputMaybe<DriverFaceClusterUpdate>>;
};

export type MutationAssociateTokenToDriverArgs = {
  driverId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type MutationBatchCreateDriversArgs = {
  input: BatchCreateDriversInput;
};

export type MutationBatchCreateIdentificationTokensArgs = {
  input: BatchCreateIdentificationTokensInput;
};

export type MutationBatchSetFuelConsumptionGoalsArgs = {
  input: Array<UpsertVehicleFuelConsumptionGoalInput>;
};

export type MutationCancelOperationalSituationArgs = {
  input: CancelOperationalSituationInput;
};

export type MutationChangeCameraConfigurationArgs = {
  input: Array<InputMaybe<CameraConfigurationUpdateInput>>;
};

export type MutationChangeChecklistNonConformityStatusArgs = {
  input: ChangeChecklistNonConformityStatusInput;
};

export type MutationCompleteFleetRecommendationArgs = {
  category: Scalars['String']['input'];
  fleetId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type MutationCreateActivitiesArgs = {
  input: Array<InputActivity>;
};

export type MutationCreateCheckpointManualArgs = {
  input: CreateCheckpointManualInput;
};

export type MutationCreateFleetAudioMessageArgs = {
  input: CreateFleetAudioMessageInput;
};

export type MutationCreateFuelTransactionArgs = {
  input: CreateFuelTransactionInput;
};

export type MutationCreateMaintenanceHistoryArgs = {
  input: CreateMaintenanceHistoryInput;
};

export type MutationCreateMaintenancePartsArgs = {
  input: CreateMaintenancePartsInput;
};

export type MutationCreateMaintenanceReminderArgs = {
  input: CreateReminderInput;
};

export type MutationCreateMediaArgs = {
  input: CreateMediaRequest;
};

export type MutationCreateOperationalSituationsArgs = {
  input: Array<CreateOperationalSituationInput>;
};

export type MutationCreateRoutesArgs = {
  input?: InputMaybe<RoutingSettings>;
};

export type MutationCreateVehicleArgs = {
  input: CreateVehicleInput;
};

export type MutationCreateVehiclesBatchArgs = {
  input: CreateVehiclesBatchInput;
};

export type MutationCreateVehiclesGroupArgs = {
  input: VehiclesGroupInput;
};

export type MutationDeleteActivitiesArgs = {
  input: DeleteActivitiesIds;
};

export type MutationDeleteChecklistArgs = {
  input?: InputMaybe<DeleteChecklist>;
};

export type MutationDeleteDriverArgs = {
  input?: InputMaybe<DeleteDriver>;
};

export type MutationDeleteFleetAudioMessagePlaybackArgs = {
  audioMessageId: Scalars['ID']['input'];
  playbackId: Scalars['ID']['input'];
};

export type MutationDeleteFuelCardAssociationArgs = {
  input: FuelCardAssociationStatusInput;
};

export type MutationDeleteFuelTransactionsArgs = {
  input: DeleteFuelTransactionsInput;
};

export type MutationDeleteInviteArgs = {
  token: Scalars['String']['input'];
};

export type MutationDeleteMaintenanceHistoryArgs = {
  input: DeleteMaintenanceHistoryInput;
};

export type MutationDeleteMaintenancePartsArgs = {
  input: DeleteMaintenancePartsInput;
};

export type MutationDeleteMaintenanceReminderArgs = {
  input: DeleteMaintenanceReminderInput;
};

export type MutationDeleteRoutesArgs = {
  input?: InputMaybe<DeleteRoutesInput>;
};

export type MutationDeleteTokenArgs = {
  id: Scalars['String']['input'];
};

export type MutationDeleteVehicleArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteVehicleTagArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteVehiclesGroupArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDisassociateTokenFromDriverArgs = {
  id: Scalars['String']['input'];
};

export type MutationDismissFleetRecommendationArgs = {
  category: Scalars['String']['input'];
  fleetId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type MutationDismissGroupRecommendationArgs = {
  fleetId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type MutationDriverNominateTripImageArgs = {
  input?: InputMaybe<Array<InputMaybe<DriverNominateTripImageInput>>>;
};

export type MutationEndOperationalSituationArgs = {
  input: EndOperationalSituationInput;
};

export type MutationEndRouteArgs = {
  input?: InputMaybe<RouteStartOrEndInput>;
};

export type MutationEvaluateInsightThumbsDownArgs = {
  input: InsightThumbsDownInput;
};

export type MutationEvaluateInsightThumbsUpArgs = {
  input: InsightThumbsUpInput;
};

export type MutationGenerateFleetGeofenceRecommendationsArgs = {
  fleetId: Scalars['ID']['input'];
};

export type MutationGenerateGroupRecommendationArgs = {
  fleetId: Scalars['ID']['input'];
};

export type MutationImportExpensesArgs = {
  input: Array<ImportExpensesBatchInput>;
};

export type MutationImportFuelTransactionsArgs = {
  input: Array<ImportFuelTransactionsBatchInput>;
};

export type MutationImportMaintenanceHistoryArgs = {
  input: Array<ImportMaintenanceBatchInput>;
};

export type MutationImportSpreadsheetArgs = {
  input: Array<SpreadsheetRow>;
};

export type MutationInsertUserNotificationSettingsArgs = {
  input?: InputMaybe<InsertUserNotificationSettings>;
};

export type MutationInstallDeviceInVehicleArgs = {
  input: InstallDeviceInVehicleInput;
};

export type MutationMarkConferenceReviewArgs = {
  input: MarkConferenceReviewInput;
};

export type MutationPlayFleetAudioMessageArgs = {
  audioMessageId: Scalars['ID']['input'];
  input: PlayFleetAudioMessageInput;
};

export type MutationRegisterDriverAppInviteArgs = {
  channel: DriverAppInviteChannel;
  driverId: Scalars['ID']['input'];
};

export type MutationRejectClusterSuggestionArgs = {
  clusterId: Scalars['ID']['input'];
};

export type MutationReopenConferenceReviewArgs = {
  input: ReopenConferenceReviewInput;
};

export type MutationRestoreFuelCardAssociationArgs = {
  input: FuelCardAssociationStatusInput;
};

export type MutationRetryFleetAudioMessagePlaybackArgs = {
  audioMessageId: Scalars['ID']['input'];
  playbackId: Scalars['ID']['input'];
};

export type MutationSendInvitesArgs = {
  input?: InputMaybe<Array<InputMaybe<InviteForm>>>;
};

export type MutationSendTripImageObstructionFeedbackArgs = {
  input?: InputMaybe<SendImageObstructionFeedback>;
};

export type MutationSetupUserNotificationSettingsArgs = {
  input?: InputMaybe<Array<InputMaybe<InsertUserNotificationSettings>>>;
};

export type MutationStartRouteArgs = {
  input?: InputMaybe<RouteStartOrEndInput>;
};

export type MutationToggleChecklistActiveArgs = {
  input?: InputMaybe<ToggleChecklistActive>;
};

export type MutationTouchFleetRecommendationsArgs = {
  fleetId: Scalars['ID']['input'];
};

export type MutationUnassignDriverToDeviceArgs = {
  input: DriverAssignmentInput;
};

export type MutationUninstallDeviceFromVehicleArgs = {
  input: UninstallDeviceFromVehicleInput;
};

export type MutationUpdateActivityArgs = {
  input: ActivityUpdate;
};

export type MutationUpdateAssociationArgs = {
  input: AssociationConfigInput;
};

export type MutationUpdateAudioArgs = {
  input: Array<InputMaybe<UpdateAudioRequest>>;
};

export type MutationUpdateChecklistArgs = {
  input?: InputMaybe<UpdateChecklist>;
};

export type MutationUpdateContactTrainingArgs = {
  input: UpdateContactTrainingInfoInput;
};

export type MutationUpdateDeviceParametersArgs = {
  input: UpdateDeviceParameter;
};

export type MutationUpdateDeviceSpareStatusArgs = {
  input: UpdateDeviceSpareStatusInput;
};

export type MutationUpdateDeviceStatusSubscriptionArgs = {
  input?: InputMaybe<DeviceStatusSubscriptionInput>;
};

export type MutationUpdateDevicesSpareStatusArgs = {
  input: Array<UpdateDeviceSpareStatusInput>;
};

export type MutationUpdateDriverArgs = {
  input?: InputMaybe<UpdateDriver>;
};

export type MutationUpdateFleetEventsConfigurationArgs = {
  input: UpdateEventsConfigurationInput;
};

export type MutationUpdateFleetVideoReviewConfigurationArgs = {
  input: UpdateFleetVideoReviewConfigurationInput;
};

export type MutationUpdateFuelCardAssociationArgs = {
  input: UpdateFuelCardAssociationInput;
};

export type MutationUpdateFuelTransactionArgs = {
  input: UpdateFuelTransactionInput;
};

export type MutationUpdateLoggedUserPhoneNumberArgs = {
  input: UpdateLoggedUserPhoneNumberInput;
};

export type MutationUpdateMaintenanceHistoryArgs = {
  input: UpdateMaintenanceHistoryInput;
};

export type MutationUpdateMaintenancePartsArgs = {
  input: UpdateMaintenancePartsInput;
};

export type MutationUpdateMaintenanceReminderArgs = {
  input: UpdateReminderInput;
};

export type MutationUpdateOperationalSituationArgs = {
  input: UpdateOperationalSituationInput;
};

export type MutationUpdateRouteV2Args = {
  input?: InputMaybe<RouteUpdate>;
};

export type MutationUpdateSpeedLimitConfigurationArgs = {
  input?: InputMaybe<SpeedLimitUpdateInput>;
};

export type MutationUpdateUserActivationTaskArgs = {
  input: UserActivationTaskInput;
};

export type MutationUpdateUserNotificationSettingsArgs = {
  input?: InputMaybe<UpdateUserNotificationSettings>;
};

export type MutationUpdateUserTrainingMediaArgs = {
  input: UpdateUserTrainingMediaInput;
};

export type MutationUpdateVehicleArgs = {
  id: Scalars['ID']['input'];
  input: UpdateVehicleInput;
};

export type MutationUpdateVehicleImmobilizerArgs = {
  input: UpdateVehicleImmobilizerInput;
};

export type MutationUpdateVehiclesGroupArgs = {
  id: Scalars['ID']['input'];
  input: VehiclesGroupInput;
};

export type MutationValidateImportVehicleSpreadsheetArgs = {
  input: ValidateImportVehicleSpreadsheetInput;
};

export type MutationVehicleAssociationsArgs = {
  input: Array<ActivityVehicleAssociationInput>;
};

export type NewChecklist = {
  context?: InputMaybe<NewChecklistContext>;
  fields: Array<NewChecklistField>;
  name: Scalars['String']['input'];
  template: Scalars['Boolean']['input'];
  vehicle_group_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicle_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  version: Scalars['Int']['input'];
};

export type NewChecklistContext = {
  address?: InputMaybe<Scalars['String']['input']>;
  app_version: Scalars['String']['input'];
  vehicle?: InputMaybe<NewChecklistVehicle>;
};

export type NewChecklistField = {
  content: Scalars['String']['input'];
  /** Echo the key read from `Field.questionKey`; omit it for a new question. */
  questionKey?: InputMaybe<Scalars['ID']['input']>;
  required: Scalars['Boolean']['input'];
  should_request_photos?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  type: FieldType;
};

export type NewChecklistVehicle = {
  brand?: InputMaybe<Scalars['String']['input']>;
  device_id: Scalars['String']['input'];
  group_id?: InputMaybe<Scalars['String']['input']>;
  license_plate?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
};

export enum NominationOperation {
  Confirm = 'CONFIRM',
  Edit = 'EDIT',
}

export type OldProofOfConclusion = {
  __typename?: 'OldProofOfConclusion';
  activity_id?: Maybe<Scalars['ID']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  alias?: Maybe<Scalars['String']['output']>;
  client?: Maybe<Scalars['String']['output']>;
  completed_at: Scalars['TimestampInMillis']['output'];
  fleet_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  img_urls: Array<Scalars['String']['output']>;
  license_plate?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  observation?: Maybe<Scalars['String']['output']>;
  saved_at: Scalars['TimestampInMillis']['output'];
  user_id: Scalars['ID']['output'];
  user_name: Scalars['String']['output'];
  vehicle_id?: Maybe<Scalars['ID']['output']>;
};

export type OperationSummary = {
  __typename?: 'OperationSummary';
  activities: ActivitiesSummary;
  routes: RoutesSummary;
};

export type OperationSummaryInput = {
  activity_route_relation?: InputMaybe<ActivityRouteRelation>;
  devices_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  drivers_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  period: DateRange;
  text_filter?: InputMaybe<Scalars['String']['input']>;
  vehicles_ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OperationalSituation = {
  __typename?: 'OperationalSituation';
  /**
   * Se a situação está ativa no momento da leitura. Mantido para os clientes anteriores ao `status`;
   * uma situação SCHEDULED não é ativa.
   * @deprecated Use status: uma situação agendada não é ativa nem encerrada
   */
  active: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Quem registrou a situação. Nulo nas linhas criadas pelo backfill do is_spare, que
   * são anteriores à coluna no backend.
   */
  createdBy?: Maybe<FleetUser>;
  /**
   * Nulo = sem prazo definido. Uma data no passado faz a situação deixar de ser ativa — a expiração é
   * avaliada na leitura, não existe job de encerramento.
   */
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  /**
   * Lembrete de manutenção que gerou esta situação, quando ela nasceu da sugestão. Referência ao
   * serviço de manutenção — pode apontar para um lembrete que não existe mais.
   */
  reminderId?: Maybe<Scalars['ID']['output']>;
  situation: OperationalSituationType;
  startsAt: Scalars['DateTime']['output'];
  status: OperationalSituationStatus;
  target?: Maybe<OperationalSituationTarget>;
  /** UUID do veículo ou ESN do dispositivo, conforme targetType. */
  targetId: Scalars['String']['output'];
  targetType: OperationalSituationTargetType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OperationalSituationPage = {
  __typename?: 'OperationalSituationPage';
  content: Array<OperationalSituation>;
  page: OperationalSituationPageInfo;
};

export type OperationalSituationPageInfo = {
  __typename?: 'OperationalSituationPageInfo';
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type OperationalSituationSort = {
  column?: OperationalSituationSortColumn;
  order?: Order;
};

/**
 * Colunas ordenáveis. Enum em vez de string livre porque o backend ordena por nome de propriedade
 * JPA: uma coluna inexistente virava 500 lá, ou seja, um erro de digitação do front acordava o
 * alerta de produção. Aqui o schema recusa na borda.
 */
export enum OperationalSituationSortColumn {
  CreatedAt = 'CREATED_AT',
  EndsAt = 'ENDS_AT',
  Situation = 'SITUATION',
  StartsAt = 'STARTS_AT',
  TargetId = 'TARGET_ID',
  TargetType = 'TARGET_TYPE',
}

/**
 * Onde a situação está no tempo, derivado na leitura — não existe job movendo entre os estados.
 * SCHEDULED só passou a ser alcançável quando a situação passou a aceitar início futuro.
 */
export enum OperationalSituationStatus {
  /** Já começou e não terminou. É o único estado que torna o recurso indisponível. */
  Active = 'ACTIVE',
  /** Já passou do ends_at. */
  Ended = 'ENDED',
  /** Começa no futuro: o recurso ainda não está indisponível. */
  Scheduled = 'SCHEDULED',
}

/**
 * O recurso ao qual a situação se aplica. Nulo quando o recurso já foi excluído — o backend preserva
 * a situação como histórico.
 */
export type OperationalSituationTarget = Device | VehicleDto;

export enum OperationalSituationTargetType {
  Device = 'DEVICE',
  Vehicle = 'VEHICLE',
}

export enum OperationalSituationType {
  Maintenance = 'MAINTENANCE',
  Reserve = 'RESERVE',
}

export type OperationalSituationsFilter = {
  /**
   * true = ativas agora; false = já encerradas; omitido = todas. Não distingue as agendadas: para
   * filtrar por SCHEDULED é preciso o filtro equivalente no fusca, que ainda não existe.
   */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Só as que encerraram entre este instante e agora. Combine com active: false para pegar as paradas
   * recém-terminadas em vez do histórico inteiro do alvo.
   */
  endedSince?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  situation?: InputMaybe<OperationalSituationType>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<OperationalSituationSort>;
  /** Deve ser acompanhado de targetType. Para VEHICLE precisa ser um UUID válido. */
  targetId?: InputMaybe<Scalars['String']['input']>;
  targetType?: InputMaybe<OperationalSituationTargetType>;
};

export type OptionContent = {
  __typename?: 'OptionContent';
  checked?: Maybe<Scalars['Boolean']['output']>;
  compliance?: Maybe<ChecklistCompliance>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export enum Order {
  Asc = 'asc',
  Desc = 'desc',
}

export type PageDriverFaceClustersInfo = {
  __typename?: 'PageDriverFaceClustersInfo';
  content?: Maybe<Array<Maybe<DriverFaceClustersInfo>>>;
  empty?: Maybe<Scalars['Boolean']['output']>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  number_of_elements?: Maybe<Scalars['Int']['output']>;
  pageable?: Maybe<PageableObject>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<SortType>;
  total_elements?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export type PageDriverFaceClustersSuggestion = {
  __typename?: 'PageDriverFaceClustersSuggestion';
  content?: Maybe<Array<Maybe<DriverFaceClustersSuggestion>>>;
  empty?: Maybe<Scalars['Boolean']['output']>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  number_of_elements?: Maybe<Scalars['Int']['output']>;
  pageable?: Maybe<PageableObject>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<SortType>;
  total_elements?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export type PageImageTrip = {
  __typename?: 'PageImageTrip';
  content?: Maybe<Array<Maybe<TripImage>>>;
  empty?: Maybe<Scalars['Boolean']['output']>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  number_of_elements?: Maybe<Scalars['Int']['output']>;
  pageable?: Maybe<PageableObject>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<SortType>;
  total_elements?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export type PagePeriodicImage = {
  __typename?: 'PagePeriodicImage';
  content: Array<PeriodicImage>;
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageRunningWithoutDriverVehicles = {
  __typename?: 'PageRunningWithoutDriverVehicles';
  content: Array<RunningWithoutDriverVehicle>;
  page: RunningWithoutDriverPageInfo;
};

export type PageTrip = {
  __typename?: 'PageTrip';
  content?: Maybe<Array<Maybe<Trip>>>;
  empty?: Maybe<Scalars['Boolean']['output']>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  number_of_elements?: Maybe<Scalars['Int']['output']>;
  pageable?: Maybe<PageableObject>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<SortType>;
  total_elements?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export type PageableObject = {
  __typename?: 'PageableObject';
  offset?: Maybe<Scalars['Int']['output']>;
  page_number?: Maybe<Scalars['Int']['output']>;
  page_size?: Maybe<Scalars['Int']['output']>;
  paged?: Maybe<Scalars['Boolean']['output']>;
  sort?: Maybe<SortType>;
  unpaged?: Maybe<Scalars['Boolean']['output']>;
};

export type PagedFuelTransaction = {
  __typename?: 'PagedFuelTransaction';
  cobliDrivenKms?: Maybe<Scalars['Float']['output']>;
  /**
   * Odômetro virtual da telemetria Cobli no momento do abastecimento: conta a partir da instalação ou de
   * um valor configurado, e pode não bater com o painel do veículo.
   */
  cobliOdometer?: Maybe<Scalars['Float']['output']>;
  conferenceStatus?: Maybe<Scalars['String']['output']>;
  costPerLiter: Scalars['Float']['output'];
  createdAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  createdBy: Scalars['String']['output'];
  creatorId?: Maybe<Scalars['ID']['output']>;
  /**
   * Km desde o abastecimento anterior pelo odômetro informado. O medido pela telemetria é
   * `cobliDrivenKms`.
   */
  drivenKms?: Maybe<Scalars['Float']['output']>;
  driverName?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  fuelLiters: Scalars['Float']['output'];
  fuelPumpFileUrl?: Maybe<Scalars['String']['output']>;
  fuelType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  odometer?: Maybe<Scalars['Float']['output']>;
  odometerFileUrl?: Maybe<Scalars['String']['output']>;
  recalculatedAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  /**
   * Origem do lançamento. É String e não enum, como `conferenceStatus`: uma origem nova do frentista
   * não pode derrubar a query.
   */
  source?: Maybe<Scalars['String']['output']>;
  station?: Maybe<FuelStation>;
  totalCost: Scalars['Float']['output'];
  totalCount: Scalars['Int']['output'];
  transactionCode?: Maybe<Scalars['String']['output']>;
  transactionTime: Scalars['TimestampInMillis']['output'];
  vehicle: PagedVehicleResponse;
};

export type PagedFuelTransactionStatsByVehicle = {
  __typename?: 'PagedFuelTransactionStatsByVehicle';
  avgCostPerKm?: Maybe<Scalars['Float']['output']>;
  avgCostPerLiter: Scalars['Float']['output'];
  consumptionAvg?: Maybe<Scalars['Float']['output']>;
  consumptionGoal?: Maybe<Scalars['Float']['output']>;
  fuelType: Scalars['String']['output'];
  sumCobliDrivenKms?: Maybe<Scalars['Float']['output']>;
  sumFuelLiters: Scalars['Float']['output'];
  sumTotalCost: Scalars['Float']['output'];
  totalCount: Scalars['Int']['output'];
  vehicleGroup?: Maybe<Scalars['String']['output']>;
  vehicleGroupName?: Maybe<Scalars['String']['output']>;
  vehicleId: Scalars['ID']['output'];
  vehicleLicensePlate: Scalars['String']['output'];
  vehicleModel?: Maybe<Scalars['String']['output']>;
};

export type PagedFuelTransactionStatsByVehicleResponse = {
  __typename?: 'PagedFuelTransactionStatsByVehicleResponse';
  content: Array<PagedFuelTransactionStatsByVehicle>;
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PagedFuelTransactionsResponse = {
  __typename?: 'PagedFuelTransactionsResponse';
  content: Array<PagedFuelTransaction>;
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PagedVehicleResponse = {
  __typename?: 'PagedVehicleResponse';
  group?: Maybe<VehicleGroupDto>;
  id: Scalars['ID']['output'];
  licensePlate: Scalars['String']['output'];
  model?: Maybe<Scalars['String']['output']>;
};

export type PaginatedActivities = {
  __typename?: 'PaginatedActivities';
  content: Array<Maybe<Activity>>;
  empty: Scalars['Boolean']['output'];
  first: Scalars['Boolean']['output'];
  last: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  number_of_elements: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  total_elements: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export type PaginatedChecklists = {
  __typename?: 'PaginatedChecklists';
  content: Array<Maybe<Checklist>>;
  empty: Scalars['Boolean']['output'];
  first: Scalars['Boolean']['output'];
  last: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  number_of_elements: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  total_elements: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export type PaginatedRoutes = {
  __typename?: 'PaginatedRoutes';
  content: Array<Maybe<Route>>;
  empty: Scalars['Boolean']['output'];
  first: Scalars['Boolean']['output'];
  last: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  number_of_elements: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  total_elements: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export type PaginatedUserAlerts = {
  __typename?: 'PaginatedUserAlerts';
  content: Array<Maybe<UserAlert>>;
  empty: Scalars['Boolean']['output'];
  first: Scalars['Boolean']['output'];
  last: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  number_of_elements: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  total_elements: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export type PaginatedVehiclesV1 = {
  __typename?: 'PaginatedVehiclesV1';
  content: Array<VehicleV1>;
  totalElements: Scalars['Int']['output'];
};

export type PaginatedVehiclesV1Input = {
  groupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
};

export type Parameter = {
  __typename?: 'Parameter';
  created_at?: Maybe<Scalars['TimestampInMillis']['output']>;
  name: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['TimestampInMillis']['output']>;
  value: Scalars['String']['output'];
};

export type ParameterInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type Part = {
  __typename?: 'Part';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type Path = {
  __typename?: 'Path';
  associationSource?: Maybe<Scalars['String']['output']>;
  driver?: Maybe<VehicleDriverDto>;
  endLatitude?: Maybe<Scalars['Float']['output']>;
  endLongitude?: Maybe<Scalars['Float']['output']>;
  endTime: Scalars['Float']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  startLatitude?: Maybe<Scalars['Float']['output']>;
  startLongitude?: Maybe<Scalars['Float']['output']>;
  startTime: Scalars['Float']['output'];
  type: Scalars['String']['output'];
  vehicle?: Maybe<VehicleDto>;
};

export type PathGeojson = {
  __typename?: 'PathGeojson';
  geometry: Geometry;
  properties: Properties;
  type: Scalars['String']['output'];
};

export type PeriodicImage = {
  __typename?: 'PeriodicImage';
  /**
   * The camera the still came from. Nullable on purpose: this is the one field whose value can arrive
   * outside the enum — the pooler gaining a channel this schema does not know yet — and a non-null
   * enum would nullify the whole page instead of just this field.
   */
  channel?: Maybe<PeriodicImageChannel>;
  /** Identifier. */
  id: Scalars['ID']['output'];
  /** Signed URL for the still. */
  imageUrl: Scalars['String']['output'];
  /** The moment captured, as a Unix timestamp in millis. */
  timestamp: Scalars['TimestampInMillis']['output'];
};

export enum PeriodicImageChannel {
  Cabin = 'CABIN',
  ChannelFive = 'CHANNEL_FIVE',
  ChannelFour = 'CHANNEL_FOUR',
  ChannelThree = 'CHANNEL_THREE',
  Driver = 'DRIVER',
  Pip = 'PIP',
  Road = 'ROAD',
}

export type PlannedVsExecutedDurationTimeInMillis = {
  __typename?: 'PlannedVsExecutedDurationTimeInMillis';
  executed?: Maybe<Scalars['Long']['output']>;
  planned?: Maybe<Scalars['Long']['output']>;
};

export type PlannedVsExecutedInt = {
  __typename?: 'PlannedVsExecutedInt';
  executed?: Maybe<Scalars['Int']['output']>;
  planned?: Maybe<Scalars['Int']['output']>;
};

export type PlannedVsExecutedTimestampInMillis = {
  __typename?: 'PlannedVsExecutedTimestampInMillis';
  executed?: Maybe<Scalars['TimestampInMillis']['output']>;
  planned: Scalars['TimestampInMillis']['output'];
};

export type PlayFleetAudioMessageInput = {
  /** If true, auto-cancel the audio playback if not successfully sent within 1 hour. */
  cancelIfTimeout?: InputMaybe<Scalars['Boolean']['input']>;
  /** Device identifier (10-15 digits). */
  deviceId: Scalars['String']['input'];
  /** Optional driver ID associated with this playback. */
  driverId?: InputMaybe<Scalars['ID']['input']>;
  /** Optional driver name associated with this playback. */
  driverName?: InputMaybe<Scalars['String']['input']>;
  /** The vehicle ID on which to play the audio message. */
  vehicleId: Scalars['ID']['input'];
};

export enum PlaybackStatus {
  /** Playback was cancelled. */
  Cancelled = 'CANCELLED',
  /** Playback delivery failed. */
  Error = 'ERROR',
  /** Playback is pending delivery to the device. */
  Pending = 'PENDING',
  /** Playback was successfully delivered and played on the device. */
  Success = 'SUCCESS',
}

export type Product = {
  __typename?: 'Product';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ProofOfConclusion = {
  __typename?: 'ProofOfConclusion';
  activityId?: Maybe<Scalars['ID']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  client?: Maybe<Scalars['String']['output']>;
  completedAt: Scalars['TimestampInMillis']['output'];
  fleetId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  imgUrls: Array<Scalars['String']['output']>;
  licensePlate?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  observation?: Maybe<Scalars['String']['output']>;
  savedAt: Scalars['TimestampInMillis']['output'];
  userId: Scalars['ID']['output'];
  userName: Scalars['String']['output'];
  vehicle?: Maybe<VehicleDto>;
  vehicleId?: Maybe<Scalars['ID']['output']>;
};

export enum PropagationType {
  AllRoutes = 'ALL_ROUTES',
  OnlyThisRoute = 'ONLY_THIS_ROUTE',
}

export type Properties = {
  __typename?: 'Properties';
  jumpsPeriods?: Maybe<Array<Array<Scalars['Float']['output']>>>;
  speeds?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  timestamps: Array<Maybe<Scalars['Float']['output']>>;
};

export type Query = {
  __typename?: 'Query';
  activationTasks: Array<ActivationTask>;
  activities: PaginatedActivities;
  activity: Activity;
  activitySummary: ActivitiesSummary;
  alert: PaginatedUserAlerts;
  /** Get association status of the requester's fleet cameras. */
  association?: Maybe<FleetAutoAssociationSettings>;
  /** Get audio coaching status of the requester's fleet cameras. */
  audio?: Maybe<AudioCoachingDevicesInfoPage>;
  avgFuelConsumptionAndCostPerKm: Array<AvgFuelConsumptionAndCostPerKmResponse>;
  billets?: Maybe<Array<Maybe<Billet>>>;
  billetsByCompanies?: Maybe<Array<Maybe<Billet>>>;
  /** Get audio coaching status of the requester's fleet cameras. */
  cameraConfiguration?: Maybe<CameraConfigurationInfoPage>;
  categories?: Maybe<Array<Maybe<Category>>>;
  checklist: Checklist;
  checklistNonConformities?: Maybe<ChecklistNonConformityPaginated>;
  /**
   * Nulo, com o 404 do ryuk em `extensions.response.status`, quando a tratativa não existe na frota ou fora dos
   * grupos do usuário.
   */
  checklistNonConformity?: Maybe<ChecklistNonConformity>;
  /** Ignora `statuses` do filtro: conta todos os status para os demais filtros. */
  checklistNonConformitySummary?: Maybe<ChecklistNonConformitySummary>;
  checklistsNames: ChecklistsNames;
  coachingFeedback?: Maybe<CoachingFeedbackPage>;
  coachingFeedbackDetails?: Maybe<CoachingFeedback>;
  companyOnboardingStatus?: Maybe<FleetCompanyOnboardingStatus>;
  completedChecklists: ChecklistsPage;
  completionData?: Maybe<CompletionData>;
  conferenceTransactionById: ConferenceTransactionResponse;
  contracts?: Maybe<FleetCompanyContracts>;
  customDashboard: CustomDashboard;
  customDashboards: Array<CustomDashboard>;
  deviceConfiguration: DeviceConfiguration;
  deviceStatusSubscription: DeviceStatusSubscription;
  devices: Array<Device>;
  devolutionTicketsByDeviceId: Tickets;
  driverById: Driver;
  /** Get driver face clusters of the requester's fleet cameras. */
  driverFaceClustersInfo?: Maybe<PageDriverFaceClustersInfo>;
  driverFaceClustersSuggestions?: Maybe<PageDriverFaceClustersSuggestion>;
  driverFaceIdRegistrations: Array<DriverFaceIdRegistration>;
  driverSpeedRow?: Maybe<Array<DriverSpeedRow>>;
  drivers: Array<Maybe<Driver>>;
  driversById: Array<Maybe<Driver>>;
  driversCount: Scalars['Int']['output'];
  driversWithCompleteFaceIdRegistrationCount: Scalars['Int']['output'];
  /** Get a summary of media counts grouped by severity levels */
  eventsSeveritiesSummary?: Maybe<SeveritiesSummary>;
  expenses: ExpensePaginatedResponse;
  faceIdCoverageChart: FaceIdCoverageChart;
  /** Get the geolocation (latitude, longitude) of a specific face image by its ID. Returns null when the location service has no data within the tolerance window for the image's device and timestamp. */
  faceImageGeolocation?: Maybe<Coordinate>;
  fleet?: Maybe<Fleet>;
  /**
   * Get playback history for a vehicle with pagination support.
   * Results are ordered by creation date in descending order by default (newest first).
   */
  fleetAudioMessagePlaybacks?: Maybe<FleetAudioMessagePlaybackPage>;
  fleetDevicesParameterStatus: Array<DeviceParameterStatus>;
  fleetDevicesParameterValues: Array<DeviceParameterValue>;
  fleetEventsConfiguration?: Maybe<FleetEventsConfiguration>;
  /** Recomendações de locais de interesse já persistidas para a frota. Só lê. */
  fleetGeofenceRecommendations: Array<FleetGeofenceRecommendation>;
  /**
   * Recomendações de grupos já persistidas para a frota. Só lê: a geração vive num job agendado
   * na user-api.
   */
  fleetGroupRecommendations: Array<GroupRecommendation>;
  /**
   * Identification-method health of the requester's fleet: how well the fleet
   * registered its drivers (M1) and how many of its video events are being
   * attributed to a driver (M2), plus the resulting health state. The fleet is
   * derived from the session; no argument is needed.
   */
  fleetIdentificationHealth?: Maybe<FleetIdentificationHealthDto>;
  /** Get fleet products */
  fleetProducts?: Maybe<FleetProducts>;
  /** Returns the users of the fleet */
  fleetUsers?: Maybe<Array<Maybe<FleetUser>>>;
  fleetVehicleGroups?: Maybe<Array<Maybe<FleetVehicleGroups>>>;
  /** How the requester's fleet reviews its event videos. */
  fleetVideoReviewConfiguration?: Maybe<FleetVideoReviewConfiguration>;
  fuelCardAssociations: Array<FuelCardAssociationResponse>;
  fuelTransactionById: FuelTransactionResponse;
  fuelTransactionStatsByVehicleSummary: FuelTransactionStatsByVehicleSummaryResponse;
  fuelTransactionsSummary: FuelTransactionSummaryResponse;
  /**
   * Get the public S3 URL for an audio file by playback ID.
   * The URL is valid for download and does not require authentication.
   */
  getAudioFile: AudioFileResponse;
  /** Check if fleet has camera */
  hasCameraFlag?: Maybe<Scalars['Boolean']['output']>;
  /** Check if fleet has camera (cached 1d) */
  hasCameraFlagCached?: Maybe<Scalars['Boolean']['output']>;
  hasFaceIdIdentificationHistory: Scalars['Boolean']['output'];
  /** Check if fleet has redecan */
  hasRedeCan?: Maybe<Scalars['Boolean']['output']>;
  homeProductivitySummary?: Maybe<HomeProductivitySummary>;
  homeSpeedSummary?: Maybe<HomeSpeedSummary>;
  homeSummaryDevices: Scalars['Int']['output'];
  homeSummaryGeofences: Scalars['Int']['output'];
  homeSummaryVehicles: Scalars['Int']['output'];
  insights?: Maybe<Array<Maybe<Insight>>>;
  inviteInfo?: Maybe<IEnrollmentFormInfo>;
  lastAssociation?: Maybe<LastAssociation>;
  lastPath?: Maybe<LastPath>;
  latestMaintenanceByVehicle?: Maybe<Maintenance>;
  /**
   * Identidade e contato do usuário da sessão.
   *
   * Existe para quem precisa saber se há telefone cadastrado — o número só chegava
   * ao cliente na resposta do login, e quem pergunta depois não tinha por onde.
   * Frotas, permissões e preferências continuam nas queries próprias.
   */
  loggedUser?: Maybe<LoggedUser>;
  maintenanceHistory: MaintenanceResponse;
  maintenanceParts: MaintenancePartResponse;
  /** Get media events and footages of the requester's fleet. */
  media?: Maybe<MediaPage>;
  /** Daily recommendations of relevant medias. */
  mediaDailyRecommendations?: Maybe<MediaPage>;
  /** Used to view a media. If the requester is authorized to watch the media, it will return a generated signed media URL and its expiration date. */
  mediaView?: Maybe<MediaResponse>;
  operationSummary: OperationSummary;
  operationalSituations: OperationalSituationPage;
  orderById?: Maybe<CrmOrder>;
  orders: Array<Maybe<CrmOrder>>;
  pagedFuelTransactionStatsByVehicle: PagedFuelTransactionStatsByVehicleResponse;
  pagedFuelTransactions: PagedFuelTransactionsResponse;
  paginatedVehiclesV1: PaginatedVehiclesV1;
  paths?: Maybe<Array<Maybe<Path>>>;
  pendingInvites?: Maybe<Array<Maybe<Invite>>>;
  proofsOfConclusion: Array<ProofOfConclusion>;
  reminderList: MaintenanceReminderResponse;
  reminderStatusSummary: ReminderStatusCount;
  reminderTitles: Array<ReminderTitle>;
  riskEvents: Array<RiskEvent>;
  route: Route;
  routes: PaginatedRoutes;
  routesReport: Array<RouteReport>;
  routesV2: PaginatedRoutes;
  runningWithoutDriverVehicles: PageRunningWithoutDriverVehicles;
  safetyRankingParams: SafetyRankingParams;
  safetyRankingProductType: SafetyRankingProductType;
  safetyRankingProductivity: SafetyRankingProductivity;
  safetyRankingScores: SafetyRankingScores;
  /** Gets the Safety Review historic records */
  safetyReviewHistory?: Maybe<SafetyReviewHistoryPage>;
  schedulingHolidays: Array<Scalars['String']['output']>;
  settings: Array<Maybe<UserNotificationSettings>>;
  sumTotalCostByFuelType: Array<SumTotalCostByFuelTypeResponse>;
  suppliers?: Maybe<Array<Maybe<Supplier>>>;
  templateChecklists: ChecklistsPage;
  tokens?: Maybe<Array<IdentificationToken>>;
  tokensV2?: Maybe<Array<IdentificationTokenV2>>;
  tracking?: Maybe<Tracking>;
  /** Returns all the training videos. */
  trainingVideos?: Maybe<Array<Maybe<TrainingVideo>>>;
  /** Returns all the training videos aggregated by category. */
  trainingVideosByCategory?: Maybe<Array<Maybe<TrainingVideos>>>;
  /** Get camera trips from a given device ID. */
  trip?: Maybe<PageTrip>;
  /** Get trip image history of the requester's fleet */
  tripImage?: Maybe<PageImageTrip>;
  /** Get camera trip images from a single trip. */
  tripImagesDetails?: Maybe<TripImage>;
  /**
   * Stills captured by the camera during a trip, to judge the window before requesting footage.
   * Distinct from `tripImage`, which is the driver-nomination history of a trip.
   */
  tripPeriodicImages?: Maybe<PagePeriodicImage>;
  tripsByVehicle?: Maybe<PageTrip>;
  unnamedFaceClustersCount: Scalars['Int']['output'];
  upcomingTickets?: Maybe<UpcomingTickets>;
  userActivationTasks: Array<UserActivationTask>;
  /** Returns the user attributes for the given user id. */
  userAttributes?: Maybe<UserAttributes>;
  /** Returns the user default roles for the given user id. */
  userDefaultRoles?: Maybe<Array<Maybe<UserDefaultRoles>>>;
  /** Returns the user fleets for the given user id. */
  userFleets?: Maybe<Array<Maybe<UserFleets>>>;
  /** Returns the user preferences for the given user id. */
  userPreferences?: Maybe<UserPreferences>;
  /** Returns user metadata for training media */
  userTrainingMedia?: Maybe<Array<Maybe<UserTrainingMedia>>>;
  validateExpensesImport: ValidateExpensesImportResponse;
  validateFuelTransactionsImport: ValidateFuelTransactionsImportResponse;
  validateMaintenanceImport: ValidateMaintenanceImportResponse;
  vehicle?: Maybe<VehicleDto>;
  vehicleDeviceAssociationReportByDevice: VehicleDeviceAssociationInfoResponse;
  vehicleDeviceAssociationReportByVehicle: VehicleDeviceAssociationInfoResponse;
  vehicleDriverAuthorizations?: Maybe<VehicleDriverAuthorization>;
  vehicleExpenses: VehicleExpensesPaginatedResponse;
  vehicleGroups?: Maybe<Array<Maybe<VehiclesGroup>>>;
  vehicleModels: Array<Branding>;
  vehiclePastAssociations?: Maybe<Array<Maybe<VehiclePastAssociationDto>>>;
  vehicleSuggestionsBatch: BatchSuggestionsResponse;
  vehicleTags?: Maybe<Array<VehicleTag>>;
  /** Get images by vehicle and an image timestamp */
  vehicleTimestampImagesDetails?: Maybe<VehicleImages>;
  vehicleTracking?: Maybe<Tracking>;
  /** Returns trackings of route steps (trip/stop) that intersects a segment */
  vehicleTrackingSegment?: Maybe<VehicleTrackingSegmentType>;
  vehicleTripDistance: VehicleTripDistanceResponse;
  vehicles?: Maybe<Array<Maybe<VehicleDto>>>;
  vehiclesRunningWithoutDriverCount: Scalars['Int']['output'];
  /**
   * Quanto uma solicitação de vídeo costuma levar, agregado pelo pooler sobre os últimos 30 dias.
   *
   * A amostra tem só solicitações concluídas, de origem manual, e feitas com o veículo ligado e
   * transmitindo — sem esse recorte a mediana mistura minutos de câmera ligada com horas de carro
   * parado esperando ligar, e não descreve nenhum dos dois casos.
   *
   * O p90 só existe por frota de propósito: cerca de 22% dos dispositivos juntam as 20 solicitações
   * concluídas que um quantil alto precisa para significar alguma coisa. Quem consome decide o
   * tamanho mínimo de amostra a partir de `sampleSize`.
   */
  videoDeliveryTime: VideoDeliveryTime;
  wifiSettings?: Maybe<AccessPoints>;
};

export type QueryActivationTasksArgs = {
  input?: InputMaybe<ActivationTaskInput>;
};

export type QueryActivitiesArgs = {
  input: ListActivitiesInput;
};

export type QueryActivityArgs = {
  input: Scalars['ID']['input'];
};

export type QueryActivitySummaryArgs = {
  input: ActivitiesSummaryInput;
};

export type QueryAlertArgs = {
  filters?: InputMaybe<Filters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  period?: InputMaybe<DateRange>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Sort>;
};

export type QueryAudioArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryAvgFuelConsumptionAndCostPerKmArgs = {
  input: GetFuelTransactionSummaryByPeriodTypeInput;
};

export type QueryBilletsArgs = {
  companyId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type QueryBilletsByCompaniesArgs = {
  companyIds: Array<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCameraConfigurationArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryChecklistArgs = {
  input?: InputMaybe<GetChecklist>;
};

export type QueryChecklistNonConformitiesArgs = {
  filter?: InputMaybe<ChecklistNonConformitiesFilter>;
};

export type QueryChecklistNonConformityArgs = {
  id: Scalars['ID']['input'];
};

export type QueryChecklistNonConformitySummaryArgs = {
  filter?: InputMaybe<ChecklistNonConformitiesFilter>;
};

export type QueryChecklistsNamesArgs = {
  input?: InputMaybe<GetChecklistsNames>;
};

export type QueryCoachingFeedbackArgs = {
  input?: InputMaybe<CoachingFeedbackInput>;
};

export type QueryCoachingFeedbackDetailsArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCompanyOnboardingStatusArgs = {
  fleetId: Scalars['String']['input'];
};

export type QueryCompletedChecklistsArgs = {
  input?: InputMaybe<GetCompletedChecklists>;
};

export type QueryConferenceTransactionByIdArgs = {
  input: Scalars['ID']['input'];
};

export type QueryContractsArgs = {
  fleetId: Scalars['String']['input'];
};

export type QueryCustomDashboardArgs = {
  input: Scalars['String']['input'];
};

export type QueryDeviceConfigurationArgs = {
  input: Scalars['String']['input'];
};

export type QueryDevicesArgs = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryDevolutionTicketsByDeviceIdArgs = {
  cobliId?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryDriverByIdArgs = {
  input?: InputMaybe<WantedDriverId>;
};

export type QueryDriverFaceClustersInfoArgs = {
  driverIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fromTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  hasBeenNominated?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  samplesPerCluster?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withoutSampleImageUrls?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryDriverFaceClustersSuggestionsArgs = {
  driverIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryDriverFaceIdRegistrationsArgs = {
  driverIds: Array<Scalars['ID']['input']>;
};

export type QueryDriverSpeedRowArgs = {
  input: DriverSpeedRowInput;
};

export type QueryDriversByIdArgs = {
  input?: InputMaybe<WantedDrivers>;
};

export type QueryDriversCountArgs = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryDriversWithCompleteFaceIdRegistrationCountArgs = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryEventsSeveritiesSummaryArgs = {
  descriptionTextQuery?: InputMaybe<Scalars['String']['input']>;
  deviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  driverIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  eventTriggers?: InputMaybe<Array<InputMaybe<EventTrigger>>>;
  fromTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  mediaStatus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  safetyOccurrenceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  suggestedOccurrences?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type QueryExpensesArgs = {
  input: ExpensesListInput;
};

export type QueryFaceIdCoverageChartArgs = {
  fromTimestamp: Scalars['Float']['input'];
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timezone: Scalars['String']['input'];
  toTimestamp: Scalars['Float']['input'];
};

export type QueryFaceImageGeolocationArgs = {
  imageId: Scalars['ID']['input'];
};

export type QueryFleetArgs = {
  fleetId: Scalars['String']['input'];
};

export type QueryFleetAudioMessagePlaybacksArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleId: Scalars['ID']['input'];
};

export type QueryFleetDevicesParameterStatusArgs = {
  parameterName: Scalars['String']['input'];
};

export type QueryFleetDevicesParameterValuesArgs = {
  parameterName: Scalars['String']['input'];
};

export type QueryFleetGeofenceRecommendationsArgs = {
  fleetId: Scalars['ID']['input'];
};

export type QueryFleetGroupRecommendationsArgs = {
  fleetId: Scalars['ID']['input'];
};

export type QueryFleetUsersArgs = {
  fleetId: Scalars['String']['input'];
};

export type QueryFleetVehicleGroupsArgs = {
  fleetId: Scalars['String']['input'];
};

export type QueryFuelCardAssociationsArgs = {
  input?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFuelTransactionByIdArgs = {
  input: Scalars['ID']['input'];
};

export type QueryFuelTransactionStatsByVehicleSummaryArgs = {
  input: GetFuelTransactionsSummaryInput;
};

export type QueryFuelTransactionsSummaryArgs = {
  input: GetFuelTransactionsSummaryInput;
};

export type QueryGetAudioFileArgs = {
  playbackId: Scalars['ID']['input'];
};

export type QueryHasFaceIdIdentificationHistoryArgs = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryHomeProductivitySummaryArgs = {
  end_date: Scalars['String']['input'];
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  start_date: Scalars['String']['input'];
  tz: Scalars['String']['input'];
};

export type QueryHomeSpeedSummaryArgs = {
  begin: Scalars['Float']['input'];
  end: Scalars['Float']['input'];
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  interval_in_days: Scalars['Int']['input'];
  tz: Scalars['String']['input'];
};

export type QueryHomeSummaryVehiclesArgs = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryInsightsArgs = {
  input: GetInsightInput;
};

export type QueryInviteInfoArgs = {
  token: Scalars['String']['input'];
};

export type QueryLastAssociationArgs = {
  deviceId: Scalars['String']['input'];
};

export type QueryLastPathArgs = {
  input: LastPathInput;
};

export type QueryLatestMaintenanceByVehicleArgs = {
  input: GetLatestMaintenanceInput;
};

export type QueryMaintenanceHistoryArgs = {
  input: GetMaintenanceHistoryInput;
};

export type QueryMaintenancePartsArgs = {
  input?: InputMaybe<GetMaintenancePartsInput>;
};

export type QueryMediaArgs = {
  aiVideoTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  archived?: InputMaybe<ArchivedMediaFilter>;
  createdBy?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  descriptionTextQuery?: InputMaybe<Scalars['String']['input']>;
  deviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  driverFaceClusterIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  driverIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  eventTriggers?: InputMaybe<Array<InputMaybe<EventTrigger>>>;
  footageStatusesToCount?: InputMaybe<Array<InputMaybe<RequestedMediaStatus>>>;
  fromCreatedAtTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  fromTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  isRequestedByTrigger?: InputMaybe<Scalars['Boolean']['input']>;
  mediaStatus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mediaTypes?: InputMaybe<Array<InputMaybe<MediaType>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  requestOrigins?: InputMaybe<Array<InputMaybe<RequestOrigin>>>;
  requestStatus?: InputMaybe<Array<InputMaybe<MediaRequestStatus>>>;
  safetyOccurrenceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  severities?: InputMaybe<Array<InputMaybe<Severity>>>;
  severitiesToCount?: InputMaybe<Array<InputMaybe<Severity>>>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  suggestedOccurrences?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toCreatedAtTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  toTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  triggerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type QueryMediaDailyRecommendationsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type QueryMediaViewArgs = {
  mediaId?: InputMaybe<Scalars['ID']['input']>;
  shouldGenerateDescription?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryOperationSummaryArgs = {
  input: OperationSummaryInput;
};

export type QueryOperationalSituationsArgs = {
  filter?: InputMaybe<OperationalSituationsFilter>;
};

export type QueryOrderByIdArgs = {
  id: Scalars['ID']['input'];
};

export type QueryPagedFuelTransactionStatsByVehicleArgs = {
  input: GetPagedFuelTransactionsInput;
};

export type QueryPagedFuelTransactionsArgs = {
  input: GetPagedFuelTransactionsInput;
};

export type QueryPaginatedVehiclesV1Args = {
  input: PaginatedVehiclesV1Input;
};

export type QueryPathsArgs = {
  associationMethods?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endTime: Scalars['Float']['input'];
  startTime: Scalars['Float']['input'];
  tz: Scalars['String']['input'];
  vehicleId: Scalars['ID']['input'];
};

export type QueryProofsOfConclusionArgs = {
  activityId?: InputMaybe<Scalars['ID']['input']>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  period?: InputMaybe<DateRange>;
};

export type QueryReminderListArgs = {
  input: GetReminderListInput;
};

export type QueryReminderStatusSummaryArgs = {
  input: GetReminderStatusCountInput;
};

export type QueryRiskEventsArgs = {
  input: RiskEventsInput;
};

export type QueryRouteArgs = {
  input: Scalars['ID']['input'];
};

export type QueryRoutesArgs = {
  input?: InputMaybe<ListRoutesInput>;
};

export type QueryRoutesReportArgs = {
  input: DateRange;
};

export type QueryRoutesV2Args = {
  input?: InputMaybe<ListRoutesInputV2>;
};

export type QueryRunningWithoutDriverVehiclesArgs = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  timezone: Scalars['String']['input'];
};

export type QuerySafetyRankingParamsArgs = {
  input: SafetyRankingParamsInput;
};

export type QuerySafetyRankingProductivityArgs = {
  input: SafetyRankingInput;
};

export type QuerySafetyRankingScoresArgs = {
  input: SafetyRankingInput;
};

export type QuerySafetyReviewHistoryArgs = {
  mediaId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QuerySumTotalCostByFuelTypeArgs = {
  input: GetFuelTransactionSummaryByPeriodTypeInput;
};

export type QueryTemplateChecklistsArgs = {
  input?: InputMaybe<GetTemplateChecklists>;
};

export type QueryTokensArgs = {
  input?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryTokensV2Args = {
  input?: InputMaybe<IdentificationTokenFilters>;
};

export type QueryTrackingArgs = {
  input?: InputMaybe<TrackingInput>;
};

export type QueryTripArgs = {
  deviceId: Scalars['String']['input'];
  footageAvailabilityStatus?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  fromTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
};

export type QueryTripImageArgs = {
  driverIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  driverVisibilities?: InputMaybe<Array<InputMaybe<DriverVisibility>>>;
  fromTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  identificationMethod?: InputMaybe<Array<InputMaybe<IdentificationMethod>>>;
  isObstructed?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type QueryTripImagesDetailsArgs = {
  tripId: Scalars['String']['input'];
};

export type QueryTripPeriodicImagesArgs = {
  channels?: InputMaybe<Array<InputMaybe<PeriodicImageChannel>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tripId: Scalars['String']['input'];
};

export type QueryTripsByVehicleArgs = {
  footageAvailabilityStatus?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  fromTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  vehicleId: Scalars['ID']['input'];
};

export type QueryUnnamedFaceClustersCountArgs = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryUserAttributesArgs = {
  input?: InputMaybe<UserInput>;
};

export type QueryUserDefaultRolesArgs = {
  input?: InputMaybe<UserInput>;
};

export type QueryUserFleetsArgs = {
  input?: InputMaybe<UserInput>;
};

export type QueryUserPreferencesArgs = {
  input?: InputMaybe<UserInput>;
};

export type QueryValidateExpensesImportArgs = {
  input: ValidateExpensesImportInput;
};

export type QueryValidateFuelTransactionsImportArgs = {
  input: ValidateFuelTransactionsImportInput;
};

export type QueryValidateMaintenanceImportArgs = {
  input: ValidateMaintenanceImportInput;
};

export type QueryVehicleArgs = {
  id: Scalars['ID']['input'];
};

export type QueryVehicleDeviceAssociationReportByDeviceArgs = {
  input: VehicleDeviceAssociationInfoInput;
};

export type QueryVehicleDeviceAssociationReportByVehicleArgs = {
  input: VehicleDeviceAssociationInfoInput;
};

export type QueryVehicleDriverAuthorizationsArgs = {
  vehicleId: Scalars['ID']['input'];
};

export type QueryVehicleExpensesArgs = {
  input: VehiclesExpensesInput;
};

export type QueryVehicleGroupsArgs = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryVehiclePastAssociationsArgs = {
  referenceTimestamp: Scalars['String']['input'];
  vehicleId: Scalars['ID']['input'];
};

export type QueryVehicleSuggestionsBatchArgs = {
  input: BatchSuggestionInput;
};

export type QueryVehicleTimestampImagesDetailsArgs = {
  image_timestamp: Scalars['Float']['input'];
  images_before: Scalars['Int']['input'];
  vehicle_id: Scalars['String']['input'];
};

export type QueryVehicleTrackingArgs = {
  input?: InputMaybe<VehicleTrackingInput>;
};

export type QueryVehicleTrackingSegmentArgs = {
  input: VehicleTrackingSegmentInput;
};

export type QueryVehicleTripDistanceArgs = {
  input: VehicleTripDistanceInput;
};

export type QueryVehiclesArgs = {
  alias?: InputMaybe<Scalars['String']['input']>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryVehiclesRunningWithoutDriverCountArgs = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timezone: Scalars['String']['input'];
};

export type RecommendationActionResult = {
  __typename?: 'RecommendationActionResult';
  completedBy?: Maybe<Scalars['ID']['output']>;
  dismissedAt?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  fleetId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export enum RecordingResolution {
  Hd = 'HD',
  Nhd = 'NHD',
}

export type Recurrence = {
  __typename?: 'Recurrence';
  description?: Maybe<Scalars['String']['output']>;
  everyDays?: Maybe<Scalars['Int']['output']>;
  everyKms?: Maybe<Scalars['Int']['output']>;
};

export enum RecurrencyFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  None = 'NONE',
  Weekly = 'WEEKLY',
}

export type ReminderDto = {
  __typename?: 'ReminderDTO';
  description?: Maybe<Scalars['String']['output']>;
  fleetId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  lastMaintenanceDate?: Maybe<Scalars['DateTime']['output']>;
  nextOccurrenceDate?: Maybe<Scalars['DateTime']['output']>;
  nextOccurrenceInKm?: Maybe<Scalars['Float']['output']>;
  recurrenceInDays?: Maybe<Scalars['Int']['output']>;
  recurrenceInKm?: Maybe<Scalars['Int']['output']>;
  status: MaintenanceStatus;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  vehicle: VehicleDto;
};

export type ReminderStatusCount = {
  __typename?: 'ReminderStatusCount';
  delayed?: Maybe<Scalars['Int']['output']>;
  onTime?: Maybe<Scalars['Int']['output']>;
  warning?: Maybe<Scalars['Int']['output']>;
};

export type ReminderTitle = {
  __typename?: 'ReminderTitle';
  id: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export type ReminderTitleInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ReopenConferenceReviewInput = {
  transactionId: Scalars['ID']['input'];
};

/** How a footage request was originated. */
export enum RequestOrigin {
  /** Requested by the alert rule itself, with no person involved. */
  AutomaticAlert = 'AUTOMATIC_ALERT',
  /** Requested by a person through the video flow. */
  Manual = 'MANUAL',
  /** Requested by a person from an alert occurrence. */
  ManualAlert = 'MANUAL_ALERT',
}

export enum RequestedMediaStatus {
  /** @deprecated Use `MediaRequestStatus` instead. */
  Acknowledge = 'ACKNOWLEDGE',
  /** @deprecated Use `MediaRequestStatus` instead. */
  Canceled = 'CANCELED',
  /** @deprecated Use `MediaRequestStatus` instead. */
  Corrupted = 'CORRUPTED',
  /** @deprecated Use `MediaRequestStatus` instead. */
  Failed = 'FAILED',
  /** @deprecated Use `MediaRequestStatus` instead. */
  Finished = 'FINISHED',
  /** @deprecated Use `MediaRequestStatus` instead. */
  Pending = 'PENDING',
  /** @deprecated Use `MediaRequestStatus` instead. */
  Started = 'STARTED',
  /** @deprecated Use `MediaRequestStatus` instead. */
  Unavailable = 'UNAVAILABLE',
}

export type Return = ITicket & {
  __typename?: 'Return';
  addressInformation?: Maybe<AddressInformation>;
  arrivalOfDevicesAtCobli?: Maybe<Scalars['String']['output']>;
  associatedDealId?: Maybe<Scalars['String']['output']>;
  clientCNPJ?: Maybe<Scalars['String']['output']>;
  clientInformation?: Maybe<ClientInformation>;
  closedDate?: Maybe<Scalars['TimestampInMillis']['output']>;
  coblerInformation?: Maybe<CoblerInformation>;
  contactInformation?: Maybe<ContactInformation>;
  createdAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  dateInformation?: Maybe<DateInformation>;
  deadline?: Maybe<Scalars['TimestampInMillis']['output']>;
  deletedAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  deviceCobliIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deviceIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deviceTotalQuantity?: Maybe<DeviceTotalQuantity>;
  fieldControlInformation?: Maybe<FieldControlInformation>;
  fleetId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  penaltyPrice?: Maybe<Scalars['Float']['output']>;
  pipeline?: Maybe<Scalars['String']['output']>;
  postingDate?: Maybe<Scalars['String']['output']>;
  responsibleUser?: Maybe<User>;
  returnType?: Maybe<Scalars['String']['output']>;
  scheduleDate?: Maybe<Scalars['String']['output']>;
  shippingCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  vehicleInformation?: Maybe<VehicleInformation>;
};

export type RiskEvent = {
  __typename?: 'RiskEvent';
  coordinates: Coordinate;
  device: RiskEventDevice;
  driver: RiskEventDriver;
  media?: Maybe<Media>;
  timestamp: Scalars['DateTime']['output'];
  type: RiskEventType;
};

export type RiskEventMediaArgs = {
  input: RiskEventsInput;
};

export type RiskEventDevice = {
  __typename?: 'RiskEventDevice';
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type RiskEventDriver = {
  __typename?: 'RiskEventDriver';
  id: Scalars['ID']['output'];
};

export enum RiskEventType {
  Anomaly = 'ANOMALY',
  DistractedDriving = 'DISTRACTED_DRIVING',
  HarshAcceleration = 'HARSH_ACCELERATION',
  HarshBreaking = 'HARSH_BREAKING',
  HarshCornering = 'HARSH_CORNERING',
  LaneDrift = 'LANE_DRIFT',
  StopSignViolated = 'STOP_SIGN_VIOLATED',
  Tailgating = 'TAILGATING',
  TrafficSpeedViolated = 'TRAFFIC_SPEED_VIOLATED',
  Unknown = 'UNKNOWN',
}

export type RiskEventsInput = {
  driver_id: Scalars['ID']['input'];
  end: Scalars['TimestampInMillis']['input'];
  media_types?: InputMaybe<Array<MediaType>>;
  severities?: InputMaybe<Array<Severity>>;
  start: Scalars['TimestampInMillis']['input'];
  triggers?: InputMaybe<Array<EventTrigger>>;
};

export type RoadSpeedLimitAlert = UserAlert & {
  __typename?: 'RoadSpeedLimitAlert';
  driver?: Maybe<Driver>;
  driver_id?: Maybe<Scalars['ID']['output']>;
  duration_in_millis?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  processed_at: Scalars['Float']['output'];
  severity?: Maybe<Severity>;
  speed_in_km_h?: Maybe<Scalars['Int']['output']>;
  speed_limit_in_km_h?: Maybe<Scalars['Int']['output']>;
  type: UserNotificationSettingsType;
  vehicle_group_id?: Maybe<Scalars['ID']['output']>;
  vehicle_id: Scalars['ID']['output'];
};

export type RoadSpeedLimitSettings = {
  __typename?: 'RoadSpeedLimitSettings';
  duration_above_limit_in_millis: Scalars['Int']['output'];
  severity: Severity;
  vehicle_group_ids: Array<Maybe<Scalars['ID']['output']>>;
};

export type Route = {
  __typename?: 'Route';
  activities: Array<Activity>;
  break?: Maybe<RouteBreak>;
  created_at: Scalars['TimestampInMillis']['output'];
  device_id?: Maybe<Scalars['String']['output']>;
  driver_id?: Maybe<Scalars['ID']['output']>;
  driver_name?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['TimestampInMillis']['output']>;
  executed_end_time?: Maybe<Scalars['TimestampInMillis']['output']>;
  executed_start_time?: Maybe<Scalars['TimestampInMillis']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  planned_distance_in_meters: Scalars['Int']['output'];
  planned_duration: Scalars['TimeIntervalInMillis']['output'];
  points: Array<Coordinate>;
  propagation_type?: Maybe<PropagationType>;
  recurrency?: Maybe<RouteRecurrency>;
  settings?: Maybe<RouteSettings>;
  shared_id?: Maybe<Scalars['ID']['output']>;
  start_time: Scalars['TimestampInMillis']['output'];
  status: RouteStatus;
  type: RouteType;
  updated_at: Scalars['TimestampInMillis']['output'];
  vehicle_id?: Maybe<Scalars['ID']['output']>;
};

export type RouteBreak = {
  __typename?: 'RouteBreak';
  duration: Scalars['TimeIntervalInMillis']['output'];
  end_time: Scalars['TimestampInMillis']['output'];
  start_time: Scalars['TimestampInMillis']['output'];
};

export type RouteBreakInput = {
  duration: Scalars['TimeIntervalInMillis']['input'];
  end_time: Scalars['TimestampInMillis']['input'];
  start_time: Scalars['TimestampInMillis']['input'];
};

export type RouteRecurrency = {
  __typename?: 'RouteRecurrency';
  days_of_month?: Maybe<Array<Scalars['Int']['output']>>;
  days_of_week?: Maybe<Array<Scalars['Int']['output']>>;
  frequency: RecurrencyFrequency;
  id?: Maybe<Scalars['ID']['output']>;
  repeat_interval: Scalars['Int']['output'];
  until_date?: Maybe<Scalars['TimestampInMillis']['output']>;
  week_numbers?: Maybe<Array<Scalars['Int']['output']>>;
};

export type RouteRecurrencyUpdate = {
  days_of_month?: InputMaybe<Array<Scalars['Int']['input']>>;
  days_of_week?: InputMaybe<Array<Scalars['Int']['input']>>;
  frequency: RecurrencyFrequency;
  id?: InputMaybe<Scalars['ID']['input']>;
  repeat_interval: Scalars['Int']['input'];
  until_date?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  week_numbers?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type RouteReport = {
  __typename?: 'RouteReport';
  activities: Array<ActivityReport>;
  distance?: Maybe<PlannedVsExecutedInt>;
  driver?: Maybe<Driver>;
  duration?: Maybe<PlannedVsExecutedDurationTimeInMillis>;
  end_time?: Maybe<PlannedVsExecutedTimestampInMillis>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<PlannedVsExecutedTimestampInMillis>;
  status?: Maybe<RouteStatus>;
  vehicle?: Maybe<VehicleDto>;
};

export type RouteSettings = {
  __typename?: 'RouteSettings';
  break_window?: Maybe<RouteBreak>;
  objectives: Array<RoutingObjective>;
  routing_type: RouteType;
  vehicle_average_cargo_capacity?: Maybe<Scalars['Int']['output']>;
  working_hours: WorkingHours;
};

export type RouteSettingsInput = {
  break_window?: InputMaybe<RouteBreakInput>;
  objectives: Array<RoutingObjective>;
  routing_type: RouteType;
  vehicle_average_cargo_capacity?: InputMaybe<Scalars['Int']['input']>;
  working_hours: WorkingHoursInput;
};

export type RouteStartOrEndInput = {
  id: Scalars['ID']['input'];
  time: Scalars['Long']['input'];
};

export enum RouteStatus {
  Delayed = 'DELAYED',
  Executed = 'EXECUTED',
  InProgress = 'IN_PROGRESS',
  PartiallyExecuted = 'PARTIALLY_EXECUTED',
  Planned = 'PLANNED',
  Unexecuted = 'UNEXECUTED',
}

export enum RouteType {
  Manual = 'MANUAL',
  Optimized = 'OPTIMIZED',
}

export type RouteUpdate = {
  activities?: InputMaybe<Array<InputMaybe<ActivityUpdate>>>;
  device_id?: InputMaybe<Scalars['String']['input']>;
  driver_id?: InputMaybe<Scalars['ID']['input']>;
  driver_name?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  propagation_type?: InputMaybe<PropagationType>;
  recurrency?: InputMaybe<RouteRecurrencyUpdate>;
  settings?: InputMaybe<RouteSettingsInput>;
  vehicle_id?: InputMaybe<Scalars['ID']['input']>;
};

export type RoutesSummary = {
  __typename?: 'RoutesSummary';
  routes_with_vehicle: ExecutionDigestSummary;
  routes_without_vehicle: ExecutionDigestSummary;
  total: Scalars['Int']['output'];
};

export enum RoutingObjective {
  MinCompletionTime = 'MIN_COMPLETION_TIME',
  MinTransportTime = 'MIN_TRANSPORT_TIME',
  MinVehicles = 'MIN_VEHICLES',
}

export type RoutingOptimization = {
  break?: InputMaybe<RouteBreakInput>;
  end_route_destination?: InputMaybe<DestinationInput>;
  num_vehicles: Scalars['Int']['input'];
  objectives?: InputMaybe<Array<RoutingObjective>>;
  vehicle_average_cargo_capacity?: InputMaybe<Scalars['Int']['input']>;
  working_hours: WorkingHoursInput;
};

export type RoutingSettings = {
  activities: Array<InputActivity>;
  optimization?: InputMaybe<RoutingOptimization>;
  start_time: Scalars['TimestampInMillis']['input'];
  type: RouteType;
};

export enum RuleCategory {
  DeviceHealthStatusObservationPeriod = 'DEVICE_HEALTH_STATUS_OBSERVATION_PERIOD',
  Geofence = 'GEOFENCE',
  IdleEngine = 'IDLE_ENGINE',
}

export type RuleEvaluationResponse = {
  __typename?: 'RuleEvaluationResponse';
  evaluatedAt: Scalars['TimestampInMillis']['output'];
  evidence?: Maybe<Scalars['JSONObject']['output']>;
  id: Scalars['ID']['output'];
  result: Scalars['String']['output'];
  ruleCode: Scalars['String']['output'];
  ruleVersion: Scalars['Int']['output'];
  severity?: Maybe<Scalars['String']['output']>;
};

export enum RuleMode {
  BackgroundPolicy = 'BACKGROUND_POLICY',
  FleetPolicy = 'FLEET_POLICY',
}

export type RunningWithoutDriverPageInfo = {
  __typename?: 'RunningWithoutDriverPageInfo';
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type RunningWithoutDriverVehicle = {
  __typename?: 'RunningWithoutDriverVehicle';
  totalTripCount: Scalars['Int']['output'];
  unassignedTripCount: Scalars['Int']['output'];
  unnamedClusters: Array<UnnamedFaceCluster>;
  vehicle?: Maybe<VehicleDto>;
};

export type SafetyOccurrence = {
  __typename?: 'SafetyOccurrence';
  /** Safety occurrence ID */
  id: Scalars['ID']['output'];
  /** Safety occurrence name */
  name: Scalars['String']['output'];
};

export type SafetyRankingInput = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  timezone: Scalars['String']['input'];
};

export type SafetyRankingParams = {
  __typename?: 'SafetyRankingParams';
  cameraCorrectionWeights: SafetyRankingParamsValues;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  params: SafetyRankingParamsValues;
  telemetryCorrectionWeights: SafetyRankingParamsValues;
  user?: Maybe<FleetUser>;
};

export type SafetyRankingParamsInput = {
  referenceDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SafetyRankingParamsValues = {
  __typename?: 'SafetyRankingParamsValues';
  distractedDriving?: Maybe<Scalars['Float']['output']>;
  eyesClosed?: Maybe<Scalars['Float']['output']>;
  fastAcceleration?: Maybe<Scalars['Float']['output']>;
  hardBreak?: Maybe<Scalars['Float']['output']>;
  ignoreDismissedEvents?: Maybe<Scalars['Boolean']['output']>;
  minDistanceInKm?: Maybe<Scalars['Int']['output']>;
  phoneUsage?: Maybe<Scalars['Float']['output']>;
  roadSpeedLimit?: Maybe<Scalars['Float']['output']>;
  smoking?: Maybe<Scalars['Float']['output']>;
  speedyTurn?: Maybe<Scalars['Float']['output']>;
  tailgating?: Maybe<Scalars['Float']['output']>;
  vehicleSpeedLimit?: Maybe<Scalars['Float']['output']>;
  yawn?: Maybe<Scalars['Float']['output']>;
};

export type SafetyRankingProductType = {
  __typename?: 'SafetyRankingProductType';
  productType: Scalars['String']['output'];
};

export type SafetyRankingProductivity = {
  __typename?: 'SafetyRankingProductivity';
  averageKmPerVehicle: Scalars['Float']['output'];
};

export type SafetyRankingScoreDetail = {
  __typename?: 'SafetyRankingScoreDetail';
  discount: Scalars['Float']['output'];
  eventType: Scalars['String']['output'];
  frequency: Scalars['Float']['output'];
  occurrences: Scalars['Int']['output'];
};

export type SafetyRankingScoreRow = {
  __typename?: 'SafetyRankingScoreRow';
  drivenDistanceInKm: Scalars['Int']['output'];
  drivenTimeInMinutes: Scalars['Int']['output'];
  kmsPerEvent?: Maybe<Scalars['Float']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  scoreDetail: Array<SafetyRankingScoreDetail>;
  totalEventsCount?: Maybe<Scalars['Int']['output']>;
  variation?: Maybe<Scalars['Int']['output']>;
};

export type SafetyRankingScores = {
  __typename?: 'SafetyRankingScores';
  averageFleetScore?: Maybe<Scalars['Int']['output']>;
  classifiedCount: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
  lastRankUpdate?: Maybe<Scalars['DateTime']['output']>;
  rows: Array<SafetyRankingScoreRow>;
  unclassifiedCount: Scalars['Int']['output'];
};

export type SafetyReview = {
  __typename?: 'SafetyReview';
  /** Datetime the video was archived. Null when it is not archived */
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID of the User that archived the video. Null when it is not archived */
  archivedById?: Maybe<Scalars['ID']['output']>;
  /** Name of the User that archived the video. Null when it is not archived */
  archivedByName?: Maybe<Scalars['String']['output']>;
  /** Where the video was archived from. Null when it is not archived */
  archivedOrigin?: Maybe<SafetyReviewOrigin>;
  /** Datetime of review creation */
  created_at: Scalars['String']['output'];
  /** ID of the User that first reviewed */
  created_by: Scalars['ID']['output'];
  /** Indicates the reason for dismissal */
  dismiss_reason?: Maybe<Scalars['String']['output']>;
  /** Cobli driver associated with review. */
  driver?: Maybe<Driver>;
  /** Driver ID associated with review */
  driver_id?: Maybe<Scalars['ID']['output']>;
  /**
   * Name of the driver associated with review
   * @deprecated Use `driver` field instead
   */
  driver_name?: Maybe<Scalars['String']['output']>;
  /** Fleet ID */
  fleet_id: Scalars['ID']['output'];
  /** Safety review ID */
  id: Scalars['ID']['output'];
  /** Safety occurrences associated with review */
  occurrences?: Maybe<Array<Maybe<SafetyOccurrence>>>;
  /** First Driver ID associated before review */
  original_media_driver_id?: Maybe<Scalars['ID']['output']>;
  /** First Severity associated before review */
  original_media_severity?: Maybe<Scalars['String']['output']>;
  /** reviewed Severity */
  severity?: Maybe<Scalars['String']['output']>;
  /** Current safety review status */
  status?: Maybe<Scalars['String']['output']>;
  /** Datetime of review last update */
  updated_at: Scalars['String']['output'];
  /** ID of the User that last updated */
  updated_by: Scalars['ID']['output'];
  /** User that last updated */
  updated_by_user?: Maybe<FleetUser>;
};

export type SafetyReviewHistory = {
  __typename?: 'SafetyReviewHistory';
  /** What the record registers. Null on records written before it existed */
  action?: Maybe<SafetyReviewHistoryAction>;
  /** Datetime of the History record creation */
  created_at: Scalars['String']['output'];
  /** ID of the History record */
  id: Scalars['ID']['output'];
  /** Where the change came from. Null on records written before it existed */
  origin?: Maybe<SafetyReviewOrigin>;
  /** Safety Review entity snapshot */
  snapshot: SafetyReviewSnapshot;
  /** User who created the record */
  user?: Maybe<FleetUser>;
  /** ID of the User who created the record */
  user_id: Scalars['ID']['output'];
};

/** What a review history record registers */
export enum SafetyReviewHistoryAction {
  Archived = 'ARCHIVED',
  Created = 'CREATED',
  Unarchived = 'UNARCHIVED',
  Updated = 'UPDATED',
}

export type SafetyReviewHistoryPage = {
  __typename?: 'SafetyReviewHistoryPage';
  content?: Maybe<Array<Maybe<SafetyReviewHistory>>>;
  empty?: Maybe<Scalars['Boolean']['output']>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  number_of_elements?: Maybe<Scalars['Int']['output']>;
  pageable?: Maybe<PageableObject>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<SortType>;
  total_elements?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

/** Where a review change came from */
export enum SafetyReviewOrigin {
  Api = 'API',
  Panel = 'PANEL',
}

export type SafetyReviewSnapshot = {
  __typename?: 'SafetyReviewSnapshot';
  /** Indicates the reason for dismissal */
  dismiss_reason?: Maybe<Scalars['String']['output']>;
  /** Driver associated at the snapshot time */
  driver?: Maybe<Driver>;
  /** Driver ID associated at the snapshot time */
  driver_id?: Maybe<Scalars['ID']['output']>;
  /** Safety Occurrences at the snapshot time */
  occurrences?: Maybe<Array<Maybe<SafetyOccurrence>>>;
  /** Severity at the snapshot time */
  severity?: Maybe<Scalars['String']['output']>;
  /** Review status at the snapshot time */
  status?: Maybe<Scalars['String']['output']>;
};

export type SampleImageDto = {
  __typename?: 'SampleImageDTO';
  /** Date and time when the image was captured. */
  captured_at: Scalars['DateTime']['output'];
  /** Identifier of the captured face image. UUID */
  image_id: Scalars['ID']['output'];
  /** An URL for the captured image. */
  image_url: Scalars['String']['output'];
  /** Vehicle where the image was captured. */
  vehicle?: Maybe<VehicleDto>;
};

export type Scheduling = ITicket & {
  __typename?: 'Scheduling';
  addressInformation?: Maybe<AddressInformation>;
  associatedDealId?: Maybe<Scalars['String']['output']>;
  clientInformation?: Maybe<ClientInformation>;
  closedDate?: Maybe<Scalars['TimestampInMillis']['output']>;
  coblerInformation?: Maybe<CoblerInformation>;
  contactInformation?: Maybe<ContactInformation>;
  createdAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  dateInformation?: Maybe<DateInformation>;
  deletedAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  deviceCobliIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deviceIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deviceTotalQuantity?: Maybe<DeviceTotalQuantity>;
  fieldControlInformation?: Maybe<FieldControlInformation>;
  fleetId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  installedDate?: Maybe<Scalars['TimestampInMillis']['output']>;
  pipeline?: Maybe<Scalars['String']['output']>;
  scheduledDate?: Maybe<Scalars['TimestampInMillis']['output']>;
  scheduledTime?: Maybe<Scalars['TimestampInMillis']['output']>;
  schedulingSubCategory?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  vehicleInformation?: Maybe<VehicleInformation>;
};

export type SeatbeltDetection = {
  __typename?: 'SeatbeltDetection';
  with_seatbelt?: Maybe<Scalars['Boolean']['output']>;
};

export type SelectContent = {
  __typename?: 'SelectContent';
  options: Array<OptionContent>;
};

export type SendImageObstructionFeedback = {
  /** Image UUID identifier */
  image_id: Scalars['String']['input'];
  /** User given feedback class */
  obstruction_feedback: Scalars['String']['input'];
  /** Trip identifier */
  trip_id: Scalars['String']['input'];
};

export type SendInviteResponse = {
  __typename?: 'SendInviteResponse';
  invites?: Maybe<Array<Maybe<InviteResponse>>>;
  status: Scalars['String']['output'];
};

export type SendInvitesResponse = {
  __typename?: 'SendInvitesResponse';
  invites?: Maybe<SendInviteResponse>;
};

export enum Sensibility {
  Default = 'DEFAULT',
  Maximum = 'MAXIMUM',
  Minimum = 'MINIMUM',
  ModeratelyHigh = 'MODERATELY_HIGH',
  ModeratelyLow = 'MODERATELY_LOW',
}

export type SensibilityConfiguration = {
  __typename?: 'SensibilityConfiguration';
  enabled: Scalars['Boolean']['output'];
  sensibility: Sensibility;
};

export type SensibilityConfigurationInput = {
  enabled: Scalars['Boolean']['input'];
  sensibility: Sensibility;
};

export type Servicos = {
  __typename?: 'Servicos';
  coAbanQtdDesinstalacaoInstaladoMotosOuMaquinariosCliente?: Maybe<Scalars['Int']['output']>;
  coAbanQtdDesinstalacaoInstaladoVeiculosLevesOuPesadosCliente?: Maybe<Scalars['Int']['output']>;
  coAbanQtdDesinstalacaoInstaladoVeiculosLevesOuPesadosCoblicam?: Maybe<Scalars['Int']['output']>;
  coAbanQtdDesinstalacaoRemovivelVeiculosPesados?: Maybe<Scalars['Int']['output']>;
  csAbanQtdDesinstalacao2130?: Maybe<Scalars['Int']['output']>;
  csAbanQtdDesinstalacao2630?: Maybe<Scalars['Int']['output']>;
  csAbanQtdDesinstalacao2630Bloqueador?: Maybe<Scalars['Int']['output']>;
  csAbanQtdDesinstalacao2630Ibutton?: Maybe<Scalars['Int']['output']>;
  csAbanQtdDesinstalacao3030?: Maybe<Scalars['Int']['output']>;
  quantidadeDesinstalacaoInstaladoLevesOuPesadosBuzzer?: Maybe<Scalars['Int']['output']>;
  quantidadeDesinstalacaoInstaladoLevesOuPesadosCameraFadiga?: Maybe<Scalars['Int']['output']>;
  quantidadeDesinstalacaoInstaladoLevesOuPesadosCameraFadigaPremium?: Maybe<Scalars['Int']['output']>;
  quantidadeDesinstalacaoRemovivelLevesOuPesadosBuzzer?: Maybe<Scalars['Int']['output']>;
  quantidadeDesinstalacaoRemovivelLevesOuPesadosIdentificador?: Maybe<Scalars['Int']['output']>;
  supplyDesinstalacaoCalculoTotal?: Maybe<Scalars['Int']['output']>;
};

export type SettingsJson = RoadSpeedLimitSettings | StopIdleTimeSettings | VehicleSpeedLimitSettings;

export type SettingsJsonInput = {
  /** ROAD SPEED LIMIT. VEHICLE SPEED LIMIT also uses the duration */
  duration_above_limit_in_millis?: InputMaybe<Scalars['Int']['input']>;
  /** STOP IDLE TIME */
  duration_idle_in_millis?: InputMaybe<Scalars['Int']['input']>;
  severity?: InputMaybe<Severity>;
  vehicle_group_ids: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type SeveritiesSummary = {
  __typename?: 'SeveritiesSummary';
  high: Scalars['Int']['output'];
  higher: Scalars['Int']['output'];
  low: Scalars['Int']['output'];
  medium: Scalars['Int']['output'];
};

export enum Severity {
  High = 'HIGH',
  Higher = 'HIGHER',
  Low = 'LOW',
  Medium = 'MEDIUM',
}

export type SeverityDetail = {
  __typename?: 'SeverityDetail';
  id: Scalars['ID']['output'];
  /** List of identified risk factors */
  risk_factors?: Maybe<Array<Maybe<SeverityRiskFactor>>>;
  /** Severity level according to score */
  severity_level: Severity;
  /** Severity score */
  severity_score?: Maybe<Scalars['Int']['output']>;
};

export type SeverityRiskFactor = {
  __typename?: 'SeverityRiskFactor';
  /** Customized details for the risk kind */
  custom_details?: Maybe<Scalars['JSONObject']['output']>;
  id: Scalars['ID']['output'];
  /** Identifier of the risk kind */
  type: Scalars['String']['output'];
  /** Risk factor multiplier value */
  value: Scalars['Float']['output'];
};

export type Shipping = ITicket & {
  __typename?: 'Shipping';
  addressInformation?: Maybe<AddressInformation>;
  associatedDealId?: Maybe<Scalars['String']['output']>;
  closedDate?: Maybe<Scalars['TimestampInMillis']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  deletedAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  deviceCobliIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deviceIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deviceTotalQuantity?: Maybe<DeviceTotalQuantity>;
  devicesWithInstallation?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  devicesWithoutInstallation?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  estimatedTimeOfArrival?: Maybe<Scalars['String']['output']>;
  fleetId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  pipeline?: Maybe<Scalars['String']['output']>;
  shippingCompany?: Maybe<Scalars['String']['output']>;
  shippingCompanyLink?: Maybe<Scalars['String']['output']>;
  shippingDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  trackingCode?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ShippingInformation = {
  __typename?: 'ShippingInformation';
  address?: Maybe<Scalars['String']['output']>;
  deviceInformation?: Maybe<DeviceShippingInformation>;
  estimatedReceivingDate?: Maybe<Scalars['String']['output']>;
  shippingCompany?: Maybe<Scalars['String']['output']>;
  shippingCompanyLink?: Maybe<Scalars['String']['output']>;
  trackingCode?: Maybe<Scalars['String']['output']>;
};

export type Sort = {
  column: Scalars['String']['input'];
  order: Order;
};

export type SortType = {
  __typename?: 'SortType';
  empty?: Maybe<Scalars['Boolean']['output']>;
  sorted?: Maybe<Scalars['Boolean']['output']>;
  unsorted?: Maybe<Scalars['Boolean']['output']>;
};

export type SpeedEvent = {
  __typename?: 'SpeedEvent';
  driverName?: Maybe<Scalars['String']['output']>;
  durationAboveInMillis?: Maybe<Scalars['Float']['output']>;
  eventTime: Scalars['Float']['output'];
  location: Location;
  medianBasedSeverity?: Maybe<Scalars['String']['output']>;
  medianSpeedInKmh?: Maybe<Scalars['Float']['output']>;
  severity: Scalars['String']['output'];
  speedInKmh: Scalars['Float']['output'];
  speedLimitInKmh: Scalars['Float']['output'];
  startTime?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
};

export type SpeedLimitUpdateInput = {
  /** Device identifier. A number between 10 and 15 digits */
  device_id: Scalars['String']['input'];
  /** The duty type of the vehicle. */
  duty_type?: InputMaybe<DutyType>;
  /** The desired speed limit */
  speed_limit_warning_in_kmph?: InputMaybe<Scalars['Float']['input']>;
};

export type SpreadsheetActivity = {
  __typename?: 'SpreadsheetActivity';
  additional_info?: Maybe<Scalars['String']['output']>;
  destination?: Maybe<SpreadsheetDestination>;
  duration?: Maybe<Scalars['TimeIntervalInMillis']['output']>;
  load_size?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['String']['output']>;
  start_hour?: Maybe<Scalars['String']['output']>;
  time_windows?: Maybe<Array<Maybe<SpreadsheetTimeWindow>>>;
};

export type SpreadsheetDestination = {
  __typename?: 'SpreadsheetDestination';
  city?: Maybe<Scalars['String']['output']>;
  coordinate: Coordinate;
  country?: Maybe<Scalars['String']['output']>;
  neighborhood?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street_address?: Maybe<Scalars['String']['output']>;
  street_complement?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
};

export type SpreadsheetImportResultAddress = {
  __typename?: 'SpreadsheetImportResultAddress';
  activity?: Maybe<SpreadsheetActivity>;
  query_address: Scalars['String']['output'];
  /**
   * Values of this row that could not be interpreted. Null when the importer reported none, so a
   * caller must treat null and empty as the same thing: nothing was lost.
   */
  warnings?: Maybe<Array<SpreadsheetMappingWarning>>;
};

/**
 * A value the import could not interpret. Without it, the setting is dropped and the response is
 * indistinguishable from one where the customer never asked for it.
 */
export type SpreadsheetMappingWarning = {
  __typename?: 'SpreadsheetMappingWarning';
  /** Which field of the row was not interpreted, e.g. `time_window`. */
  field: Scalars['String']['output'];
  /** The value exactly as it arrived, so the caller can point at the offending cell. */
  raw_value: Scalars['String']['output'];
};

export type SpreadsheetRow = {
  additional_info?: InputMaybe<Scalars['String']['input']>;
  address: Scalars['String']['input'];
  load_size?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  start_hour?: InputMaybe<Scalars['String']['input']>;
  time_window?: InputMaybe<Scalars['String']['input']>;
};

export type SpreadsheetTimeWindow = {
  __typename?: 'SpreadsheetTimeWindow';
  earliest?: Maybe<Scalars['TimestampInMillis']['output']>;
  latest?: Maybe<Scalars['TimestampInMillis']['output']>;
};

export type StopIdleTimeAlert = UserAlert & {
  __typename?: 'StopIdleTimeAlert';
  driver?: Maybe<Driver>;
  driver_id?: Maybe<Scalars['ID']['output']>;
  duration_in_millis?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  processed_at: Scalars['Float']['output'];
  type: UserNotificationSettingsType;
  vehicle_group_id?: Maybe<Scalars['ID']['output']>;
  vehicle_id: Scalars['ID']['output'];
};

export type StopIdleTimeSettings = {
  __typename?: 'StopIdleTimeSettings';
  duration_idle_in_millis: Scalars['Int']['output'];
  vehicle_group_ids: Array<Maybe<Scalars['ID']['output']>>;
};

export type Stops = {
  __typename?: 'Stops';
  driverName?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['Float']['output'];
  geofences: Array<Maybe<Geofences>>;
  hasFilteredIdleOnTime?: Maybe<Scalars['Boolean']['output']>;
  idleOffInMillis: Scalars['Float']['output'];
  idleOnInMillis: Scalars['Float']['output'];
  location: Location;
  startTime: Scalars['Float']['output'];
};

export type SumTotalCostByFuelTypeResponse = {
  __typename?: 'SumTotalCostByFuelTypeResponse';
  endInterval: Scalars['String']['output'];
  fuelType: Scalars['String']['output'];
  isCompleted: Scalars['Boolean']['output'];
  startInterval: Scalars['String']['output'];
  totalCost: Scalars['Float']['output'];
};

export type Summary = {
  __typename?: 'Summary';
  totalDistance: Scalars['Float']['output'];
  totalDuration: Scalars['Float']['output'];
  totalFuelCost: Scalars['Float']['output'];
  totalGeofenceEvents: Scalars['Int']['output'];
  totalSpeedEvents: Scalars['Int']['output'];
  totalStops: Scalars['Int']['output'];
};

export type Supplier = {
  __typename?: 'Supplier';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type TextContent = {
  __typename?: 'TextContent';
  value?: Maybe<Scalars['String']['output']>;
};

export type Ticket = {
  __typename?: 'Ticket';
  closedDate?: Maybe<Scalars['String']['output']>;
  conclusionDate?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createDate?: Maybe<Scalars['String']['output']>;
  devolutionInformation?: Maybe<DevolutionInformation>;
  id: Scalars['String']['output'];
  installationInformation?: Maybe<InstallationInformation>;
  lastActivityDate?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['String']['output']>;
  nextActivityDate?: Maybe<Scalars['String']['output']>;
  notesLastUpdated?: Maybe<Scalars['String']['output']>;
  notesNextActivityDate?: Maybe<Scalars['String']['output']>;
  originTicketId?: Maybe<Scalars['String']['output']>;
  panelFormTest?: Maybe<Scalars['Boolean']['output']>;
  pipeline?: Maybe<Scalars['String']['output']>;
  pipelineStage?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  resolution?: Maybe<Scalars['String']['output']>;
  servicos?: Maybe<Servicos>;
  shippingInformation?: Maybe<ShippingInformation>;
  sourceType?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  ticketAssociatedDealId?: Maybe<Scalars['String']['output']>;
};

export type Tickets = {
  __typename?: 'Tickets';
  tickets?: Maybe<Array<Ticket>>;
  total: Scalars['Int']['output'];
};

export type TimeWindow = {
  __typename?: 'TimeWindow';
  earliest: Scalars['TimestampInMillis']['output'];
  latest: Scalars['TimestampInMillis']['output'];
};

export type TimeWindowInput = {
  earliest: Scalars['TimestampInMillis']['input'];
  latest: Scalars['TimestampInMillis']['input'];
};

export type ToggleChecklistActive = {
  active: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type TotalAndIdsReportSummary = {
  __typename?: 'TotalAndIdsReportSummary';
  ids: Array<Scalars['ID']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Tracking = {
  __typename?: 'Tracking';
  device?: Maybe<DeviceFields>;
  deviceId?: Maybe<Scalars['String']['output']>;
  drivers: Array<Maybe<Driver>>;
  endTime: Scalars['TimestampInMillis']['output'];
  geofenceEvents?: Maybe<Array<Maybe<GeofenceEvent>>>;
  groupIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  incidents?: Maybe<Array<Maybe<Incidents>>>;
  lastPath?: Maybe<LastPath>;
  pathGeojson: PathGeojson;
  roadSpeedEvents?: Maybe<Array<Maybe<SpeedEvent>>>;
  startTime: Scalars['TimestampInMillis']['output'];
  stops?: Maybe<Array<Maybe<Stops>>>;
  summary?: Maybe<Summary>;
  tz: Scalars['String']['output'];
  vehicle?: Maybe<VehicleFields>;
  vehicleId?: Maybe<Scalars['ID']['output']>;
  vehicleSpeedEvents?: Maybe<Array<Maybe<SpeedEvent>>>;
};

export type TrackingInput = {
  device_id: Scalars['String']['input'];
  end_time: Scalars['Float']['input'];
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  match?: InputMaybe<Scalars['Boolean']['input']>;
  start_time: Scalars['Float']['input'];
  tz: Scalars['String']['input'];
};

export type TrainingVideo = {
  __typename?: 'TrainingVideo';
  categoryId?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type TrainingVideoCategory = {
  __typename?: 'TrainingVideoCategory';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TrainingVideos = {
  __typename?: 'TrainingVideos';
  category?: Maybe<TrainingVideoCategory>;
  trainingVideos?: Maybe<Array<Maybe<TrainingVideo>>>;
};

export type Trigger = {
  __typename?: 'Trigger';
  active: Scalars['Boolean']['output'];
  allowNotifications: Scalars['Boolean']['output'];
  condition?: Maybe<TriggerCondition>;
  createdAt: Scalars['String']['output'];
  daysOfWeek: Array<Scalars['Int']['output']>;
  deviceIds: Array<Scalars['String']['output']>;
  endTime: Scalars['String']['output'];
  event?: Maybe<TriggerEvent>;
  geofenceIds: Array<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notifiedUsers: Array<Maybe<UserFleets>>;
  startTime: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  updatedBy?: Maybe<UserFleets>;
  vehicleGroupIds: Array<Scalars['ID']['output']>;
  vehicleIds: Array<Scalars['ID']['output']>;
};

export type TriggerCondition = {
  __typename?: 'TriggerCondition';
  category: ConditionCategory;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  params: Array<Maybe<Scalars['String']['output']>>;
  rule: TriggerConditionRule;
};

export type TriggerConditionRule = {
  __typename?: 'TriggerConditionRule';
  category: RuleCategory;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type TriggerEvent = {
  __typename?: 'TriggerEvent';
  nameIdentifier: Scalars['String']['output'];
};

export type TriggerListFilter = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  conditionId?: InputMaybe<Scalars['ID']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  daysOfWeek?: InputMaybe<Array<Scalars['Int']['input']>>;
  geofenceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  myNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requestVideo?: InputMaybe<Scalars['Boolean']['input']>;
  ruleCategory?: InputMaybe<RuleCategory>;
  ruleMode?: InputMaybe<RuleMode>;
  triggerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TriggerPage = {
  __typename?: 'TriggerPage';
  content?: Maybe<Array<Trigger>>;
  empty?: Maybe<Scalars['Boolean']['output']>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  number_of_elements?: Maybe<Scalars['Int']['output']>;
  pageable?: Maybe<PageableObject>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<SortType>;
  total_elements?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export type Trip = {
  __typename?: 'Trip';
  /** Trip end Unix timestamp in millis. */
  end_timestamp: Scalars['TimestampInMillis']['output'];
  /** Whether the trip has stills to preview before requesting footage. */
  hasImages?: Maybe<Scalars['Boolean']['output']>;
  /** Identifier. */
  id?: Maybe<Scalars['String']['output']>;
  /** Flag indicating whether the trip is available for requesting or not. */
  is_footage_available: Scalars['Boolean']['output'];
  /** Trip start Unix timestamp in millis. */
  start_timestamp: Scalars['TimestampInMillis']['output'];
};

export type TripImage = {
  __typename?: 'TripImage';
  /** Whether the trip images were marked with a driver visible or not visible */
  driver_visibility?: Maybe<DriverVisibility>;
  /** Trip end Unix timestamp in millis. */
  end_timestamp: Scalars['TimestampInMillis']['output'];
  /** Identification method utilized at the time. */
  identification_method: Scalars['String']['output'];
  /** The timestamp that the user has nominated an image formatted as Unix timestamp in millis. */
  nominated_at?: Maybe<Scalars['TimestampInMillis']['output']>;
  /** The user that nominated the trip. */
  nominated_by?: Maybe<User>;
  /** The driver recognized by the faceID. */
  recognized_driver?: Maybe<Driver>;
  /** Trip start Unix timestamp in millis. */
  start_timestamp: Scalars['TimestampInMillis']['output'];
  /** The id of the trip. */
  trip_id: Scalars['String']['output'];
  /** An image sample of the trip. */
  trip_image_sample?: Maybe<TripImageDetails>;
  /** List of images from the trip. It will only be filled when one single trip were selected. */
  trip_images?: Maybe<Array<Maybe<TripImageDetails>>>;
  /** The driver nominated by the user. */
  user_nominated_driver?: Maybe<Driver>;
  /** The id of the vehicle with the media. */
  vehicle: VehicleDto;
};

export type TripImageDetails = {
  __typename?: 'TripImageDetails';
  id: Scalars['ID']['output'];
  image_url: Scalars['String']['output'];
  is_obstructed?: Maybe<Scalars['Boolean']['output']>;
  obstruction_feedback?: Maybe<Scalars['String']['output']>;
};

export type UninstallDeviceFromVehicleInput = {
  vehicleId: Scalars['ID']['input'];
};

export type UnnamedFaceCluster = {
  __typename?: 'UnnamedFaceCluster';
  id: Scalars['ID']['output'];
  lastCapturedAt?: Maybe<Scalars['DateTime']['output']>;
  photoCount: Scalars['Int']['output'];
  thumbnailUrl: Scalars['String']['output'];
};

export type UpcomingTickets = {
  __typename?: 'UpcomingTickets';
  daysWithoutMovement?: Maybe<Scalars['Int']['output']>;
  hasUpsell?: Maybe<Scalars['Boolean']['output']>;
  nextBatchScheduledAt?: Maybe<Scalars['String']['output']>;
  tickets?: Maybe<Array<Maybe<ITicket>>>;
};

export type UpdateAssociationPayloadInput = {
  input: AssociationConfigInput;
};

export type UpdateAudioRequest = {
  /** The status of the camera audio. */
  audio_status: AudioStatus;
  /** Device identifier. A number between 10 and 15 digits */
  device_id: Scalars['String']['input'];
};

export type UpdateChecklist = {
  id: Scalars['ID']['input'];
  updatedChecklist: UpdatedChecklist;
};

export type UpdateContactTrainingInfoInput = {
  finishedVideos: Array<InputMaybe<VideoInfo>>;
  startedVideos: Array<InputMaybe<VideoInfo>>;
};

export type UpdateDeviceParameter = {
  device_id: Scalars['String']['input'];
  parameters: Array<ParameterInput>;
};

export type UpdateDeviceSpareStatusInput = {
  deviceId: Scalars['String']['input'];
  isSpare: Scalars['Boolean']['input'];
};

export type UpdateDriver = {
  cpf?: InputMaybe<Scalars['String']['input']>;
  driver_license?: InputMaybe<Scalars['String']['input']>;
  first_license_acquirement_date?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  license_category?: InputMaybe<Scalars['String']['input']>;
  license_expiration_date?: InputMaybe<Scalars['Date']['input']>;
  name: Scalars['String']['input'];
  phone_number?: InputMaybe<Scalars['String']['input']>;
  profile_image_base64?: InputMaybe<Scalars['String']['input']>;
  registry_id?: InputMaybe<Scalars['String']['input']>;
  remove_profile_image?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateEventsConfigurationInput = {
  events_configuration: EventsConfigurationInput;
};

export type UpdateFleetVideoReviewConfigurationInput = {
  /** Dismissing an event video archives it instead */
  archiveInsteadOfDismiss: Scalars['Boolean']['input'];
};

export type UpdateFuelCardAssociationInput = {
  id: Scalars['ID']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  vehicleId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateFuelTransactionInput = {
  commodity: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  merchant?: InputMaybe<MerchantUpdateInput>;
  odometerInKms?: InputMaybe<Scalars['Float']['input']>;
  totalCost: Scalars['Float']['input'];
  transactionerName?: InputMaybe<Scalars['String']['input']>;
  units: Scalars['Float']['input'];
};

export type UpdateLoggedUserPhoneNumberInput = {
  /** E.164 sem o `+`, como o cadastro guarda: `5511900000000`. Nulo apaga o telefone. */
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']['input']>;
};

export type UpdateMaintenanceHistoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  parts?: InputMaybe<Array<InputMaybe<MaintenancePartInput>>>;
  totalPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateMaintenancePartsInput = {
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

/**
 * Substitui o estado editável da situação. É PUT no fusca, não PATCH: o corpo carrega tudo o que é
 * editável, então omitir `endsAt` deixa a parada sem prazo e omitir `reason` limpa a justificativa —
 * que é o que torna possível remover uma data de retorno. Encerrar continua em endOperationalSituation.
 */
export type UpdateOperationalSituationInput = {
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Obrigatório: a substituição carrega o estado inteiro, não um delta. */
  startsAt: Scalars['DateTime']['input'];
};

export type UpdateParameterResponse = {
  __typename?: 'UpdateParameterResponse';
  device_id: Scalars['String']['output'];
  parameters: Array<Parameter>;
};

export type UpdateReminderInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  recurrenceInDays?: InputMaybe<Scalars['Int']['input']>;
  recurrenceInKm?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title: ReminderTitleInput;
};

export type UpdateUserNotificationSettings = {
  active: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  settings_json: SettingsJsonInput;
  type: UserNotificationSettingsType;
};

export type UpdateUserTrainingMediaInput = {
  action: UserTrainingMediaActionType;
  trainingMediaId: Scalars['ID']['input'];
};

export type UpdateVehicleImmobilizerInput = {
  driverIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  isImmobilizerEnabled: Scalars['Boolean']['input'];
  vehicleDriverAuthorizationMode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVehicleInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  driverId?: InputMaybe<Scalars['ID']['input']>;
  fuelConsumption?: InputMaybe<Scalars['Float']['input']>;
  fuelPrice?: InputMaybe<Scalars['Float']['input']>;
  fuelType?: InputMaybe<Scalars['String']['input']>;
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  speedInKmh?: InputMaybe<Scalars['Float']['input']>;
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatedChecklist = {
  context?: InputMaybe<NewChecklistContext>;
  fields: Array<NewChecklistField>;
  name: Scalars['String']['input'];
  template_active?: InputMaybe<Scalars['Boolean']['input']>;
  vehicle_group_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicle_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  version: Scalars['Int']['input'];
};

export type UpsertVehicleFuelConsumptionGoalInput = {
  /**
   * Combustível da meta: Gasolina, Etanol, Diesel, GNV ou Elétrico. Um veículo flex tem uma meta por
   * combustível. Sem ele, atualiza a única meta do veículo ou, se ele não tem nenhuma, usa o combustível
   * que o histórico de abastecimentos indica; com metas em mais de um combustível, é obrigatório.
   */
  fuelFamily?: InputMaybe<Scalars['String']['input']>;
  /** Meta de consumo em km/L. Aceita decimal (ex.: 8.6). */
  goal: Scalars['Float']['input'];
  vehicleId: Scalars['ID']['input'];
};

export type User = {
  __typename?: 'User';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type UserActivationTask = {
  __typename?: 'UserActivationTask';
  category: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  finished: Scalars['Boolean']['output'];
  fleet_id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  step_id?: Maybe<Scalars['ID']['output']>;
  task_id: Scalars['ID']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user_id: Scalars['ID']['output'];
};

export type UserActivationTaskInput = {
  finished: Scalars['Boolean']['input'];
  stepId: Scalars['ID']['input'];
  taskId?: InputMaybe<Scalars['ID']['input']>;
};

export type UserAlert = {
  driver?: Maybe<Driver>;
  driver_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  processed_at: Scalars['Float']['output'];
  type: UserNotificationSettingsType;
  vehicle_group_id?: Maybe<Scalars['ID']['output']>;
  vehicle_id: Scalars['ID']['output'];
};

export type UserAttributes = {
  __typename?: 'UserAttributes';
  creation_date?: Maybe<Scalars['String']['output']>;
  num_devices?: Maybe<Scalars['Int']['output']>;
};

export type UserDefaultRoles = {
  __typename?: 'UserDefaultRoles';
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UserFleets = {
  __typename?: 'UserFleets';
  active?: Maybe<Scalars['Boolean']['output']>;
  associated_at?: Maybe<Scalars['String']['output']>;
  fleet_id?: Maybe<Scalars['ID']['output']>;
  granted_permissions: Array<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<VehiclesGroup>>>;
  groups_restriction?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  has_no_valid_groups: Scalars['Boolean']['output'];
  has_only_groups_with_no_vehicles: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  managers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type UserInput = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UserNotificationSettings = {
  __typename?: 'UserNotificationSettings';
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  settings_json: SettingsJson;
  type: UserNotificationSettingsType;
};

export enum UserNotificationSettingsType {
  RoadSpeedLimit = 'ROAD_SPEED_LIMIT',
  StopIdleTime = 'STOP_IDLE_TIME',
  VehicleSpeedLimit = 'VEHICLE_SPEED_LIMIT',
}

export type UserPreferences = {
  __typename?: 'UserPreferences';
  created_at?: Maybe<Scalars['TimestampInMillis']['output']>;
  filtered_groups?: Maybe<Array<Maybe<VehiclesGroup>>>;
  fleet_id?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  updated_at?: Maybe<Scalars['TimestampInMillis']['output']>;
  use_vehicles_cluster?: Maybe<Scalars['Boolean']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
  vehicle_group_ids?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
};

export type UserTrainingMedia = {
  __typename?: 'UserTrainingMedia';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  trainingMediaId?: Maybe<Scalars['ID']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export enum UserTrainingMediaActionType {
  Finish = 'FINISH',
  Start = 'START',
}

export type ValidateExpensesImportInput = {
  columnMap: ExpensesImportColumnMap;
  data: Array<ValidateExpensesImportInputItem>;
  timeZone: Scalars['String']['input'];
};

export type ValidateExpensesImportInputItem = {
  categoryName: Scalars['String']['input'];
  licensePlate: Scalars['String']['input'];
  observation?: InputMaybe<Scalars['String']['input']>;
  occurredAt: Scalars['String']['input'];
  rowIndex: Scalars['Int']['input'];
  supplierName?: InputMaybe<Scalars['String']['input']>;
  totalCost: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type ValidateExpensesImportItem = {
  __typename?: 'ValidateExpensesImportItem';
  categoryName: Scalars['String']['output'];
  licensePlate: Scalars['String']['output'];
  observation?: Maybe<Scalars['String']['output']>;
  occurredAt: Scalars['String']['output'];
  rowIndex: Scalars['Int']['output'];
  supplierName?: Maybe<Scalars['String']['output']>;
  totalCost: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ValidateExpensesImportResponse = {
  __typename?: 'ValidateExpensesImportResponse';
  invalidRows: Array<ValidateExpensesInvalidRowsResponse>;
  validRows: Array<ValidateExpensesValidRowsResponse>;
};

export type ValidateExpensesInvalidRowsResponse = {
  __typename?: 'ValidateExpensesInvalidRowsResponse';
  data: ValidateExpensesImportItem;
  errors: Array<ValidationError>;
};

export type ValidateExpensesValidRowsResponse = {
  __typename?: 'ValidateExpensesValidRowsResponse';
  categoryId: Scalars['String']['output'];
  groupPath?: Maybe<Scalars['String']['output']>;
  observation?: Maybe<Scalars['String']['output']>;
  occurredAt: Scalars['String']['output'];
  supplierName?: Maybe<Scalars['String']['output']>;
  totalCost: Scalars['Float']['output'];
  type: Scalars['String']['output'];
  vehicleId: Scalars['String']['output'];
};

export type ValidateFuelTransactionsImportInput = {
  columnMap: FuelTransactionsImportColumnMap;
  data: Array<ValidateFuelTransactionsImportInputItem>;
  timeZone: Scalars['String']['input'];
};

export type ValidateFuelTransactionsImportInputItem = {
  driverName?: InputMaybe<Scalars['String']['input']>;
  fuelType: Scalars['String']['input'];
  licensePlate: Scalars['String']['input'];
  merchantCity?: InputMaybe<Scalars['String']['input']>;
  merchantCnpj?: InputMaybe<Scalars['String']['input']>;
  merchantName?: InputMaybe<Scalars['String']['input']>;
  merchantState?: InputMaybe<Scalars['String']['input']>;
  odometer: Scalars['String']['input'];
  quantityInLiters: Scalars['String']['input'];
  rowIndex: Scalars['Int']['input'];
  totalCost: Scalars['String']['input'];
  transactionTime: Scalars['String']['input'];
};

export type ValidateFuelTransactionsImportItem = {
  __typename?: 'ValidateFuelTransactionsImportItem';
  driverName?: Maybe<Scalars['String']['output']>;
  fuelType: Scalars['String']['output'];
  licensePlate: Scalars['String']['output'];
  merchantCity?: Maybe<Scalars['String']['output']>;
  merchantCnpj?: Maybe<Scalars['String']['output']>;
  merchantName?: Maybe<Scalars['String']['output']>;
  merchantState?: Maybe<Scalars['String']['output']>;
  odometer: Scalars['String']['output'];
  quantityInLiters: Scalars['String']['output'];
  rowIndex: Scalars['Int']['output'];
  totalCost: Scalars['String']['output'];
  transactionTime: Scalars['String']['output'];
};

export type ValidateFuelTransactionsImportResponse = {
  __typename?: 'ValidateFuelTransactionsImportResponse';
  invalidRows: Array<ValidateFuelTransactionsInvalidRowsResponse>;
  validRows: Array<ValidateFuelTransactionsValidRowsResponse>;
};

export type ValidateFuelTransactionsInvalidRowsResponse = {
  __typename?: 'ValidateFuelTransactionsInvalidRowsResponse';
  data: ValidateFuelTransactionsImportItem;
  errors: Array<ValidationError>;
};

export type ValidateFuelTransactionsValidRowsResponse = {
  __typename?: 'ValidateFuelTransactionsValidRowsResponse';
  driverName?: Maybe<Scalars['String']['output']>;
  fuelType: Scalars['String']['output'];
  licensePlate: Scalars['String']['output'];
  merchant?: Maybe<MerchantImportResponse>;
  odometerInKm: Scalars['Float']['output'];
  quantityInLiters: Scalars['Float']['output'];
  totalCost: Scalars['Float']['output'];
  transactionTime: Scalars['String']['output'];
};

export type ValidateImportVehicleRowDto = {
  __typename?: 'ValidateImportVehicleRowDTO';
  fuelConsumption?: Maybe<Scalars['String']['output']>;
  fuelPrice?: Maybe<Scalars['String']['output']>;
  fuelType?: Maybe<Scalars['String']['output']>;
  licensePlate?: Maybe<Scalars['String']['output']>;
  rowIndex: Scalars['Int']['output'];
  size?: Maybe<Scalars['String']['output']>;
  speedLimitInKmh?: Maybe<Scalars['String']['output']>;
};

export type ValidateImportVehicleRowInput = {
  fuelConsumption?: InputMaybe<Scalars['String']['input']>;
  fuelPrice?: InputMaybe<Scalars['String']['input']>;
  fuelType?: InputMaybe<Scalars['String']['input']>;
  licensePlate: Scalars['String']['input'];
  rowIndex: Scalars['Int']['input'];
  size?: InputMaybe<Scalars['String']['input']>;
  speedLimitInKmh?: InputMaybe<Scalars['String']['input']>;
};

export type ValidateImportVehicleSpreadsheetInput = {
  columnMap: Array<ColumnMapEntryInput>;
  data: Array<ValidateImportVehicleRowInput>;
};

export type ValidateImportVehicleSpreadsheetResponse = {
  __typename?: 'ValidateImportVehicleSpreadsheetResponse';
  invalidRows: Array<InvalidImportVehicleRowDto>;
  validRows: Array<ImportVehicleRowDto>;
};

export type ValidateMaintenanceAggregatedPart = {
  __typename?: 'ValidateMaintenanceAggregatedPart';
  description?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
  rowIndex: Scalars['Int']['output'];
  serviceItemName?: Maybe<Scalars['String']['output']>;
  unitCost?: Maybe<Scalars['String']['output']>;
};

export type ValidateMaintenanceImportInput = {
  columnMap: MaintenanceImportColumnMap;
  data: Array<ValidateMaintenanceImportInputItem>;
  timeZone: Scalars['String']['input'];
};

export type ValidateMaintenanceImportInputItem = {
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  maintenanceObservations?: InputMaybe<Scalars['String']['input']>;
  occurrenceAt?: InputMaybe<Scalars['String']['input']>;
  odometerInKms?: InputMaybe<Scalars['String']['input']>;
  partName?: InputMaybe<Scalars['String']['input']>;
  partObservation?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  rowIndex: Scalars['Int']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  unitCost?: InputMaybe<Scalars['String']['input']>;
};

export type ValidateMaintenanceImportResponse = {
  __typename?: 'ValidateMaintenanceImportResponse';
  invalidRows: Array<ValidateMaintenanceInvalidRowsResponse>;
  validRows: Array<ValidateMaintenanceValidRowsResponse>;
};

export type ValidateMaintenanceInvalidPart = {
  __typename?: 'ValidateMaintenanceInvalidPart';
  partName?: Maybe<Scalars['String']['output']>;
  partObservation?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
  unitCost?: Maybe<Scalars['String']['output']>;
};

export type ValidateMaintenanceInvalidRow = {
  __typename?: 'ValidateMaintenanceInvalidRow';
  items?: Maybe<Array<Maybe<ValidateMaintenanceAggregatedPart>>>;
  licensePlate?: Maybe<Scalars['String']['output']>;
  maintenanceObservation?: Maybe<Scalars['String']['output']>;
  occurrenceAt?: Maybe<Scalars['String']['output']>;
  odometerInKms?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ValidateMaintenanceInvalidRowItem = {
  __typename?: 'ValidateMaintenanceInvalidRowItem';
  errors: Array<ValidationError>;
  itemsData: ValidateMaintenanceInvalidPart;
  rowIndex: Scalars['Int']['output'];
};

export type ValidateMaintenanceInvalidRowsResponse = {
  __typename?: 'ValidateMaintenanceInvalidRowsResponse';
  errors: Array<ValidationError>;
  items: Array<ValidateMaintenanceInvalidRowItem>;
  maintenanceData: ValidateMaintenanceInvalidRow;
};

export type ValidateMaintenancePart = {
  __typename?: 'ValidateMaintenancePart';
  partName: Scalars['String']['output'];
  partObservation?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  unitCost: Scalars['Float']['output'];
};

export type ValidateMaintenanceValidRowsResponse = {
  __typename?: 'ValidateMaintenanceValidRowsResponse';
  maintenanceObservations?: Maybe<Scalars['String']['output']>;
  occurrenceAt: Scalars['DateTime']['output'];
  odometerInKms: Scalars['Float']['output'];
  parts: Array<ValidateMaintenancePart>;
  type: Array<Scalars['String']['output']>;
  vehicle: VehicleDto;
};

export type ValidationError = {
  __typename?: 'ValidationError';
  column: ImportColumnMap;
  error: Scalars['String']['output'];
};

export type VehicleConsumptionGoal = {
  __typename?: 'VehicleConsumptionGoal';
  createdAt: Scalars['String']['output'];
  goal: Scalars['Float']['output'];
  source: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  vehicleId: Scalars['ID']['output'];
};

export type VehicleDto = {
  __typename?: 'VehicleDTO';
  alias?: Maybe<Scalars['String']['output']>;
  branding?: Maybe<Branding>;
  cobliId?: Maybe<Scalars['String']['output']>;
  consumptionGoal?: Maybe<VehicleConsumptionGoal>;
  device?: Maybe<Device>;
  deviceType?: Maybe<Scalars['String']['output']>;
  disablerStatus?: Maybe<DisablerDto>;
  driver?: Maybe<VehicleDriverDto>;
  esn?: Maybe<Scalars['String']['output']>;
  fleetId: Scalars['String']['output'];
  fuel?: Maybe<FuelDto>;
  fuelConsumption?: Maybe<Scalars['Float']['output']>;
  groupPath: Scalars['String']['output'];
  groups: Array<VehicleGroupDto>;
  id: Scalars['ID']['output'];
  immobilizerStatus?: Maybe<VehicleDriverAuthorizationStatus>;
  isAllowListEnabled?: Maybe<Scalars['Boolean']['output']>;
  isImmobilizerEnabled?: Maybe<Scalars['Boolean']['output']>;
  lastLocation?: Maybe<VehicleLastLocationDto>;
  licensePlate?: Maybe<Scalars['String']['output']>;
  model: VehicleModelDto;
  odometer?: Maybe<VehicleOdometer>;
  operationalSituation?: Maybe<OperationalSituation>;
  size?: Maybe<Scalars['String']['output']>;
  speedLimitInKmh?: Maybe<Scalars['Float']['output']>;
  tagId?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<VehicleTag>>;
  vehicleDriverAuthorizationMode: Scalars['String']['output'];
};

export type VehicleDeviceAssociationInfo = {
  __typename?: 'VehicleDeviceAssociationInfo';
  device?: Maybe<Device>;
  duration?: Maybe<Scalars['Int']['output']>;
  event?: Maybe<Scalars['String']['output']>;
  eventDate?: Maybe<Scalars['String']['output']>;
  fleetId?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['String']['output']>;
  userEmail?: Maybe<Scalars['String']['output']>;
  vehicle?: Maybe<VehicleDto>;
};

export type VehicleDeviceAssociationInfoInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  wantedDeviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  wantedEvents?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  wantedGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  wantedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**
   * Mantém as linhas cujo veículo OU dispositivo tem uma dessas situações ativa no momento da
   * consulta — não na data do evento, que o fusca não sabe responder. O serviço de analytics não
   * conhece situação operacional, então este filtro é aplicado no janus; exige frota na sessão e
   * uma falha do fusca vira erro, nunca resultado sem filtro.
   */
  wantedSituations?: InputMaybe<Array<OperationalSituationType>>;
  wantedUsers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  wantedVehicleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type VehicleDeviceAssociationInfoResponse = {
  __typename?: 'VehicleDeviceAssociationInfoResponse';
  associations: Array<VehicleDeviceAssociationInfo>;
  count?: Maybe<Scalars['Int']['output']>;
};

export type VehicleDriverAuthorization = {
  __typename?: 'VehicleDriverAuthorization';
  authorizations?: Maybe<Array<DriverAuthorization>>;
  vehicle: VehicleDto;
};

export enum VehicleDriverAuthorizationStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Processing = 'PROCESSING',
}

export type VehicleDriverDto = {
  __typename?: 'VehicleDriverDTO';
  active?: Maybe<Scalars['Boolean']['output']>;
  firstLicenseAcquirementDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  licenseCategory?: Maybe<Scalars['String']['output']>;
  licenseExpirationDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type VehicleExpense = {
  __typename?: 'VehicleExpense';
  categoryCosts: Array<CategoryCost>;
  costPerKm: Scalars['Float']['output'];
  distanceDrivenInKm: Scalars['Float']['output'];
  previousPeriodCostPerKm: Scalars['Float']['output'];
  previousPeriodTotalCost: Scalars['Float']['output'];
  totalCost: Scalars['Float']['output'];
  vehicle: ExpenseVehicle;
};

export type VehicleExpensesPaginatedResponse = {
  __typename?: 'VehicleExpensesPaginatedResponse';
  content: Array<VehicleExpense>;
  empty: Scalars['Boolean']['output'];
  first: Scalars['Boolean']['output'];
  last: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  numberOfElements: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type VehicleFields = {
  __typename?: 'VehicleFields';
  alias?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  fuelConsumption?: Maybe<Scalars['Float']['output']>;
  fuelPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  licensePlate?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
};

export type VehicleFuelConsumptionGoalResponse = {
  __typename?: 'VehicleFuelConsumptionGoalResponse';
  createdAt: Scalars['String']['output'];
  goal: Scalars['Float']['output'];
  source: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  vehicle: VehicleDto;
};

export type VehicleGroupDto = {
  __typename?: 'VehicleGroupDTO';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type VehicleImages = {
  __typename?: 'VehicleImages';
  images?: Maybe<Array<Maybe<TripImageDetails>>>;
  vehicle?: Maybe<VehicleDto>;
  vehicle_id?: Maybe<Scalars['String']['output']>;
};

export type VehicleInfo = {
  __typename?: 'VehicleInfo';
  make: Scalars['String']['output'];
  model: Scalars['String']['output'];
  plate: Scalars['String']['output'];
  vin: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export type VehicleInformation = {
  __typename?: 'VehicleInformation';
  licensePlates?: Maybe<Scalars['String']['output']>;
  models?: Maybe<Scalars['String']['output']>;
};

export type VehicleLastAssociation = {
  __typename?: 'VehicleLastAssociation';
  alias?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  fleetId: Scalars['ID']['output'];
  licensePlate?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  vehicleId?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type VehicleLastLocationDto = {
  __typename?: 'VehicleLastLocationDTO';
  cobliIngestedAt?: Maybe<Scalars['Float']['output']>;
  isPlugged?: Maybe<Scalars['Boolean']['output']>;
  timeInMillis?: Maybe<Scalars['Float']['output']>;
};

export type VehicleModelDto = {
  __typename?: 'VehicleModelDTO';
  brand?: Maybe<Scalars['String']['output']>;
  isSuggestion?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type VehicleOdometer = {
  __typename?: 'VehicleOdometer';
  createdAt: Scalars['TimestampInMillis']['output'];
  createdByUserName?: Maybe<Scalars['String']['output']>;
  createdOdometerInKm: Scalars['Long']['output'];
  odometerDateAt: Scalars['TimestampInMillis']['output'];
  odometerInKm: Scalars['Long']['output'];
  vehicleId: Scalars['ID']['output'];
};

export type VehiclePastAssociationDto = {
  __typename?: 'VehiclePastAssociationDTO';
  associatedAt: Scalars['String']['output'];
  associatedBy?: Maybe<FleetUser>;
  driver?: Maybe<VehicleDriverDto>;
  identificationMethod?: Maybe<Scalars['String']['output']>;
};

export type VehicleSpeedLimitAlert = UserAlert & {
  __typename?: 'VehicleSpeedLimitAlert';
  driver?: Maybe<Driver>;
  driver_id?: Maybe<Scalars['ID']['output']>;
  duration_in_millis?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  processed_at: Scalars['Float']['output'];
  speed_in_km_h?: Maybe<Scalars['Int']['output']>;
  speed_limit_in_km_h?: Maybe<Scalars['Int']['output']>;
  type: UserNotificationSettingsType;
  vehicle_group_id?: Maybe<Scalars['ID']['output']>;
  vehicle_id: Scalars['ID']['output'];
};

export type VehicleSpeedLimitSettings = {
  __typename?: 'VehicleSpeedLimitSettings';
  duration_above_limit_in_millis: Scalars['Int']['output'];
  vehicle_group_ids: Array<Maybe<Scalars['ID']['output']>>;
};

export type VehicleSuggestionEntry = {
  __typename?: 'VehicleSuggestionEntry';
  key: Scalars['String']['output'];
  value?: Maybe<VehicleInfo>;
};

export type VehicleTag = {
  __typename?: 'VehicleTag';
  name: Scalars['String']['output'];
};

export type VehicleTrackingInput = {
  end_time: Scalars['Float']['input'];
  match?: InputMaybe<Scalars['Boolean']['input']>;
  start_time: Scalars['Float']['input'];
  tz: Scalars['String']['input'];
  vehicle_id: Scalars['ID']['input'];
  with_jumps?: InputMaybe<Scalars['Boolean']['input']>;
  with_speed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VehicleTrackingSegmentInput = {
  allow_unfinished_step?: InputMaybe<Scalars['Boolean']['input']>;
  end_time: Scalars['Float']['input'];
  match?: InputMaybe<Scalars['Boolean']['input']>;
  segment_end: Scalars['Float']['input'];
  segment_start: Scalars['Float']['input'];
  start_time: Scalars['Float']['input'];
  tz: Scalars['String']['input'];
  vehicle_id: Scalars['ID']['input'];
};

export type VehicleTrackingSegmentType = {
  __typename?: 'VehicleTrackingSegmentType';
  end_time: Scalars['Float']['output'];
  has_route_steps?: Maybe<Scalars['Boolean']['output']>;
  match?: Maybe<Scalars['Boolean']['output']>;
  mediaEvents?: Maybe<Array<Maybe<Media>>>;
  start_time: Scalars['Float']['output'];
  tracking?: Maybe<Tracking>;
  tz: Scalars['String']['output'];
  vehicle_id: Scalars['ID']['output'];
};

export type VehicleTrackingSegmentTypeMediaEventsArgs = {
  event_triggers?: InputMaybe<Array<InputMaybe<EventTrigger>>>;
  media_types?: InputMaybe<Array<InputMaybe<MediaType>>>;
};

export type VehicleTripDistance = {
  __typename?: 'VehicleTripDistance';
  distance_driven_in_meters: Scalars['Float']['output'];
  vehicle_id: Scalars['ID']['output'];
};

export type VehicleTripDistanceInput = {
  begin: Scalars['TimestampInMillis']['input'];
  end: Scalars['TimestampInMillis']['input'];
  timezone: Scalars['String']['input'];
  vehicleIds: Array<Scalars['ID']['input']>;
};

export type VehicleTripDistanceResponse = {
  __typename?: 'VehicleTripDistanceResponse';
  content: Array<VehicleTripDistance>;
};

export type VehicleV1 = {
  __typename?: 'VehicleV1';
  alias?: Maybe<Scalars['String']['output']>;
  branding?: Maybe<Branding>;
  device?: Maybe<Device>;
  disablerStatus?: Maybe<DisablerDto>;
  driver?: Maybe<Driver>;
  fleetId: Scalars['String']['output'];
  fuel?: Maybe<FuelDto>;
  groupPath: Scalars['String']['output'];
  groups?: Maybe<VehicleGroupDto>;
  id: Scalars['ID']['output'];
  immobilizerStatus?: Maybe<VehicleDriverAuthorizationStatus>;
  isAllowListEnabled?: Maybe<Scalars['Boolean']['output']>;
  isImmobilizerEnabled?: Maybe<Scalars['Boolean']['output']>;
  lastLocation?: Maybe<VehicleLastLocationDto>;
  licensePlate?: Maybe<Scalars['String']['output']>;
  odometer?: Maybe<VehicleOdometer>;
  size?: Maybe<Scalars['String']['output']>;
  speedLimitInKmh?: Maybe<Scalars['Float']['output']>;
  tags?: Maybe<Array<VehicleTag>>;
  vehicleDriverAuthorizationMode: Scalars['String']['output'];
};

export type VehiclesExpensesInput = {
  endDate: Scalars['DateTime']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sortCategoryId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  tagNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timezone: Scalars['String']['input'];
  vehicleGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleModels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleSizes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type VehiclesGroup = {
  __typename?: 'VehiclesGroup';
  createdAt: Scalars['TimestampInMillis']['output'];
  creatorId: Scalars['ID']['output'];
  fleetId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  updatedAt: Scalars['TimestampInMillis']['output'];
  users: Array<Maybe<FleetUser>>;
  vehicles: Array<VehicleDto>;
};

export type VehiclesGroupInput = {
  fleetId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleIds: Array<Scalars['ID']['input']>;
};

export type VideoDto = {
  __typename?: 'VideoDTO';
  /** Channel in which the video was recorded */
  channel?: Maybe<Scalars['String']['output']>;
  /** Video URL on storage */
  url?: Maybe<Scalars['String']['output']>;
};

export type VideoDeliveryTime = {
  __typename?: 'VideoDeliveryTime';
  devices: Array<DeviceDeliveryTime>;
  fleet: Array<FleetDeliveryTime>;
};

export type VideoInfo = {
  category: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type WantedDriverId = {
  driverId: Scalars['ID']['input'];
};

export type WantedDrivers = {
  driverIds: Array<Scalars['ID']['input']>;
};

export type WifiSetting = {
  __typename?: 'WifiSetting';
  /** The date and time the wifi setting was created. */
  created_at: Scalars['DateTime']['output'];
  /** The name of the user who created the wifi setting. */
  created_by: Scalars['String']['output'];
  /** The id of the wifi setting. */
  id: Scalars['ID']['output'];
  /** The ssid of the wifi setting. */
  ssid: Scalars['String']['output'];
};

export type WorkingHours = {
  __typename?: 'WorkingHours';
  end_time: Scalars['TimestampInMillis']['output'];
  start_time: Scalars['TimestampInMillis']['output'];
};

export type WorkingHoursInput = {
  end_time: Scalars['TimestampInMillis']['input'];
  start_time: Scalars['TimestampInMillis']['input'];
};

export type ExecutionDigestSummary = {
  __typename?: 'executionDigestSummary';
  ids: Array<Scalars['ID']['output']>;
  total: Scalars['Int']['output'];
};

export type GetInviteInfoQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;

export type GetInviteInfoQuery = {
  __typename?: 'Query';
  inviteInfo?: {
    __typename?: 'IEnrollmentFormInfo';
    invite: { __typename?: 'IInvite'; emailAddress: string; fleetId: string };
    occupations?: Array<{ __typename?: 'IOccupation'; key: string; value: string } | null> | null;
  } | null;
};

export type AcceptInviteMutationVariables = Exact<{
  input: IInviteAcceptForm;
  token: Scalars['String']['input'];
}>;

export type AcceptInviteMutation = { __typename?: 'Mutation'; acceptInvite?: { __typename?: 'ICreatedUser'; id: string; fullName: string } | null };

export type GetPendingInvitesQueryVariables = Exact<{ [key: string]: never }>;

export type GetPendingInvitesQuery = {
  __typename?: 'Query';
  pendingInvites?: Array<{
    __typename?: 'Invite';
    emailAddress: string;
    creationDate: any;
    token: string;
    fleetId: string;
    creatorId: string;
    role: string;
    groupsRestriction?: Array<string | null> | null;
    customPermissions?: Array<string | null> | null;
    groups?: Array<{ __typename?: 'VehiclesGroup'; id: string; name: string; path: string } | null> | null;
  } | null> | null;
};

export type SendInvitesMutationVariables = Exact<{
  input: Array<InputMaybe<InviteForm>> | InputMaybe<InviteForm>;
}>;

export type SendInvitesMutation = {
  __typename?: 'Mutation';
  sendInvites?: {
    __typename?: 'SendInvitesResponse';
    invites?: { __typename?: 'SendInviteResponse'; status: string; invites?: Array<{ __typename?: 'InviteResponse'; email_address: string; token: string } | null> | null } | null;
  } | null;
};

export type DeleteInviteMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;

export type DeleteInviteMutation = { __typename?: 'Mutation'; deleteInvite?: string | null };

export type SafetyReviewHistoryQueryVariables = Exact<{
  mediaId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type SafetyReviewHistoryQuery = {
  __typename?: 'Query';
  safetyReviewHistory?: {
    __typename?: 'SafetyReviewHistoryPage';
    total_elements?: number | null;
    first?: boolean | null;
    last?: boolean | null;
    empty?: boolean | null;
    number?: number | null;
    number_of_elements?: number | null;
    size?: number | null;
    total_pages?: number | null;
    content?: Array<{
      __typename?: 'SafetyReviewHistory';
      id: string;
      user_id: string;
      created_at: string;
      action?: SafetyReviewHistoryAction | null;
      origin?: SafetyReviewOrigin | null;
      user?: { __typename?: 'FleetUser'; full_name?: string | null } | null;
      snapshot: {
        __typename?: 'SafetyReviewSnapshot';
        status?: string | null;
        driver_id?: string | null;
        severity?: string | null;
        dismiss_reason?: string | null;
        driver?: { __typename?: 'Driver'; name: string } | null;
        occurrences?: Array<{ __typename?: 'SafetyOccurrence'; id: string; name: string } | null> | null;
      };
    } | null> | null;
  } | null;
};

export type GetCameraAssociationQueryVariables = Exact<{ [key: string]: never }>;

export type GetCameraAssociationQuery = {
  __typename?: 'Query';
  association?: {
    __typename?: 'FleetAutoAssociationSettings';
    fleet_id?: string | null;
    updated_at?: any | null;
    last_updated_by?: string | null;
    association_config?: {
      __typename?: 'AssociationConfig';
      entire_fleet_association_config?: { __typename?: 'EntireFleetAssociationConfig'; is_on?: boolean | null } | null;
    } | null;
  } | null;
};

export type UpdateCameraAssociationMutationVariables = Exact<{
  input: AssociationConfigInput;
}>;

export type UpdateCameraAssociationMutation = { __typename?: 'Mutation'; updateAssociation?: boolean | null };

export type GetAudioQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type GetAudioQuery = {
  __typename?: 'Query';
  audio?: {
    __typename?: 'AudioCoachingDevicesInfoPage';
    empty?: boolean | null;
    first?: boolean | null;
    last?: boolean | null;
    number?: number | null;
    number_of_elements?: number | null;
    size?: number | null;
    total_elements?: number | null;
    total_pages?: number | null;
    content?: Array<{ __typename?: 'AudioCoachingDevicesInfo'; audio_status: AudioStatus; device_id: string; updated_at?: any | null } | null> | null;
  } | null;
};

export type UpdateAudioMutationVariables = Exact<{
  input: Array<InputMaybe<UpdateAudioRequest>> | InputMaybe<UpdateAudioRequest>;
}>;

export type UpdateAudioMutation = { __typename?: 'Mutation'; updateAudio?: boolean | null };

export type GetCameraConfigurationQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type GetCameraConfigurationQuery = {
  __typename?: 'Query';
  cameraConfiguration?: {
    __typename?: 'CameraConfigurationInfoPage';
    empty?: boolean | null;
    first?: boolean | null;
    last?: boolean | null;
    number?: number | null;
    number_of_elements?: number | null;
    size?: number | null;
    total_elements?: number | null;
    total_pages?: number | null;
    content?: Array<{
      __typename?: 'CameraConfigurationInfo';
      audio_status?: AudioStatus | null;
      device_id: string;
      updated_at?: any | null;
      duty_type?: DutyType | null;
      speed_limit_warning_in_kmph?: number | null;
    } | null> | null;
  } | null;
};

export type GetFleetCameraConfigurationQueryVariables = Exact<{ [key: string]: never }>;

export type GetFleetCameraConfigurationQuery = {
  __typename?: 'Query';
  fleetEventsConfiguration?: {
    __typename?: 'FleetEventsConfiguration';
    updated_at?: string | null;
    updated_by_name?: string | null;
    camera_events_config?: {
      __typename?: 'CameraEventsConfiguration';
      entire_fleet_camera_events_configuration: {
        __typename?: 'EventsConfiguration';
        ignition_off_record_settings?: number | null;
        face_identification_audio_alert_enabled?: boolean | null;
        dms_events: {
          __typename?: 'DmsEvents';
          min_speed_trigger_in_km_per_h: number;
          occupancy_people_limit?: number | null;
          distracted_driving: { __typename?: 'SensibilityConfiguration'; enabled: boolean; sensibility: Sensibility };
          yawn: { __typename?: 'SensibilityConfiguration'; enabled: boolean; sensibility: Sensibility };
          phone_usage: { __typename?: 'SensibilityConfiguration'; enabled: boolean; sensibility: Sensibility };
          eyes_closed: { __typename?: 'SensibilityConfiguration'; enabled: boolean; sensibility: Sensibility };
          smoking: { __typename?: 'SensibilityConfiguration'; enabled: boolean; sensibility: Sensibility };
          no_driver_detected?: { __typename?: 'SensibilityConfiguration'; enabled: boolean; sensibility: Sensibility } | null;
          occupancy?: { __typename?: 'SensibilityConfiguration'; enabled: boolean; sensibility: Sensibility } | null;
          seat_belt?: { __typename?: 'EnabledConfiguration'; enabled: boolean } | null;
        };
        adas_events: {
          __typename?: 'AdasEvents';
          min_speed_trigger_in_km_per_h: number;
          forward_collision_warning: { __typename?: 'SensibilityConfiguration'; enabled: boolean; sensibility: Sensibility };
          tail_gating?: { __typename?: 'SensibilityConfiguration'; enabled: boolean; sensibility: Sensibility } | null;
        };
        harsh_events: {
          __typename?: 'HarshEventsByDutyType';
          light: {
            __typename?: 'HarshEvents';
            acceleration: { __typename?: 'SensibilityConfiguration'; enabled: boolean; sensibility: Sensibility };
            braking: { __typename?: 'SensibilityConfiguration'; enabled: boolean; sensibility: Sensibility };
            cornering: { __typename?: 'SensibilityConfiguration'; enabled: boolean; sensibility: Sensibility };
            impact?: { __typename?: 'SensibilityConfiguration'; enabled: boolean; sensibility: Sensibility } | null;
          };
          medium: {
            __typename?: 'HarshEvents';
            acceleration: { __typename?: 'SensibilityConfiguration'; enabled: boolean; sensibility: Sensibility };
            braking: { __typename?: 'SensibilityConfiguration'; enabled: boolean; sensibility: Sensibility };
            cornering: { __typename?: 'SensibilityConfiguration'; enabled: boolean; sensibility: Sensibility };
            impact?: { __typename?: 'SensibilityConfiguration'; enabled: boolean; sensibility: Sensibility } | null;
          };
          heavy: {
            __typename?: 'HarshEvents';
            acceleration: { __typename?: 'SensibilityConfiguration'; enabled: boolean; sensibility: Sensibility };
            braking: { __typename?: 'SensibilityConfiguration'; enabled: boolean; sensibility: Sensibility };
            cornering: { __typename?: 'SensibilityConfiguration'; enabled: boolean; sensibility: Sensibility };
            impact?: { __typename?: 'SensibilityConfiguration'; enabled: boolean; sensibility: Sensibility } | null;
          };
        };
        idle_speed?: { __typename?: 'IdleSpeedConfiguration'; enabled: boolean; threshold_seconds: number } | null;
      };
    } | null;
  } | null;
};

export type QueryGetFleetWifiSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type QueryGetFleetWifiSettingsQuery = {
  __typename?: 'Query';
  wifiSettings?: {
    __typename?: 'AccessPoints';
    access_points?: Array<{ __typename?: 'WifiSetting'; id: string; ssid: string; created_at: any; created_by: string } | null> | null;
  } | null;
};

export type UpdateFleetEventsConfigurationMutationVariables = Exact<{
  input: UpdateEventsConfigurationInput;
}>;

export type UpdateFleetEventsConfigurationMutation = { __typename?: 'Mutation'; updateFleetEventsConfiguration?: boolean | null };

export type UpdateCameraConfigurationMutationVariables = Exact<{
  input: Array<InputMaybe<CameraConfigurationUpdateInput>> | InputMaybe<CameraConfigurationUpdateInput>;
}>;

export type UpdateCameraConfigurationMutation = { __typename?: 'Mutation'; changeCameraConfiguration?: boolean | null };

export type UpdateSpeedLimitConfigurationMutationVariables = Exact<{
  input?: InputMaybe<SpeedLimitUpdateInput>;
}>;

export type UpdateSpeedLimitConfigurationMutation = { __typename?: 'Mutation'; updateSpeedLimitConfiguration?: boolean | null };

export type AssignFaceClusterMutationVariables = Exact<{
  input: Array<InputMaybe<DriverFaceClusterUpdate>> | InputMaybe<DriverFaceClusterUpdate>;
}>;

export type AssignFaceClusterMutation = { __typename?: 'Mutation'; assignFaceCluster?: boolean | null };

export type RejectClusterSuggestionMutationVariables = Exact<{
  clusterId: Scalars['ID']['input'];
}>;

export type RejectClusterSuggestionMutation = { __typename?: 'Mutation'; rejectClusterSuggestion?: boolean | null };

export type GetDriverFaceClusterInfoQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  driverIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  hasBeenNominated?: InputMaybe<Scalars['Boolean']['input']>;
  withoutSampleImageUrls?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  fromTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  toTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  samplesPerCluster?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetDriverFaceClusterInfoQuery = {
  __typename?: 'Query';
  driverFaceClustersInfo?: {
    __typename?: 'PageDriverFaceClustersInfo';
    empty?: boolean | null;
    first?: boolean | null;
    last?: boolean | null;
    number?: number | null;
    number_of_elements?: number | null;
    size?: number | null;
    total_elements?: number | null;
    total_pages?: number | null;
    content?: Array<{
      __typename?: 'DriverFaceClustersInfo';
      created_at: any;
      id: string;
      sample_image_url_count: number;
      suggestion_source?: string | null;
      rejected_at?: any | null;
      updated_at?: any | null;
      driver?: {
        __typename?: 'Driver';
        id: string;
        name: string;
        fleet_id: string;
        assigned?: boolean | null;
        phone_number?: any | null;
        first_license_acquirement_date?: any | null;
        license_expiration_date?: any | null;
        license_category?: LicenseCategory | null;
        driver_code?: string | null;
        score?: { __typename?: 'DriverScore'; score?: number | null } | null;
      } | null;
      suggested_driver?: { __typename?: 'Driver'; id: string; name: string; fleet_id: string; driver_code?: string | null } | null;
      profile_image_url: { __typename?: 'DriverPhoto'; image_url: string };
      sample_image_urls: Array<{ __typename?: 'DriverPhoto'; image_url: string } | null>;
      sample_images: Array<{
        __typename?: 'SampleImageDTO';
        image_id: string;
        image_url: string;
        captured_at: any;
        vehicle?: {
          __typename?: 'VehicleDTO';
          id: string;
          licensePlate?: string | null;
          alias?: string | null;
          groups: Array<{ __typename?: 'VehicleGroupDTO'; id: string; name: string }>;
        } | null;
      } | null>;
    } | null> | null;
  } | null;
};

export type GetCameraFlagQueryVariables = Exact<{ [key: string]: never }>;

export type GetCameraFlagQuery = { __typename?: 'Query'; hasCameraFlag?: boolean | null };

export type GetFleetProductsQueryVariables = Exact<{ [key: string]: never }>;

export type GetFleetProductsQuery = {
  __typename?: 'Query';
  fleetProducts?: { __typename?: 'FleetProducts'; products?: Array<{ __typename?: 'Product'; id: string; name: string } | null> | null } | null;
};

export type GetTripImagePageQueryVariables = Exact<{
  fromTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  toTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  identificationMethod?: InputMaybe<Array<InputMaybe<IdentificationMethod>> | InputMaybe<IdentificationMethod>>;
  driverVisibilities?: InputMaybe<Array<InputMaybe<DriverVisibility>> | InputMaybe<DriverVisibility>>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  driverIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  isObstructed?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type GetTripImagePageQuery = {
  __typename?: 'Query';
  tripImage?: {
    __typename?: 'PageImageTrip';
    empty?: boolean | null;
    first?: boolean | null;
    last?: boolean | null;
    number?: number | null;
    number_of_elements?: number | null;
    size?: number | null;
    content?: Array<{
      __typename?: 'TripImage';
      start_timestamp: any;
      end_timestamp: any;
      identification_method: string;
      driver_visibility?: DriverVisibility | null;
      nominated_at?: any | null;
      trip_id: string;
      nominated_by?: { __typename?: 'User'; id: string; name: string } | null;
      recognized_driver?: { __typename?: 'Driver'; id: string; name: string } | null;
      trip_image_sample?: { __typename?: 'TripImageDetails'; id: string; image_url: string; is_obstructed?: boolean | null } | null;
      trip_images?: Array<{ __typename?: 'TripImageDetails'; image_url: string; id: string; is_obstructed?: boolean | null } | null> | null;
      user_nominated_driver?: { __typename?: 'Driver'; id: string; name: string } | null;
      vehicle: { __typename?: 'VehicleDTO'; id: string; licensePlate?: string | null; groups: Array<{ __typename?: 'VehicleGroupDTO'; id: string; name: string }> };
    } | null> | null;
  } | null;
};

export type GetTripImagesDetailsQueryVariables = Exact<{
  tripId: Scalars['String']['input'];
}>;

export type GetTripImagesDetailsQuery = {
  __typename?: 'Query';
  tripImagesDetails?: {
    __typename?: 'TripImage';
    start_timestamp: any;
    end_timestamp: any;
    identification_method: string;
    nominated_at?: any | null;
    trip_id: string;
    nominated_by?: { __typename?: 'User'; id: string; name: string } | null;
    recognized_driver?: { __typename?: 'Driver'; id: string; name: string } | null;
    trip_image_sample?: { __typename?: 'TripImageDetails'; id: string; image_url: string; is_obstructed?: boolean | null } | null;
    trip_images?: Array<{ __typename?: 'TripImageDetails'; image_url: string; id: string; is_obstructed?: boolean | null; obstruction_feedback?: string | null } | null> | null;
    user_nominated_driver?: { __typename?: 'Driver'; id: string; name: string } | null;
    vehicle: { __typename?: 'VehicleDTO'; id: string; licensePlate?: string | null; groups: Array<{ __typename?: 'VehicleGroupDTO'; id: string; name: string }> };
  } | null;
};

export type GetVehicleTimestampImagesDetailsQueryVariables = Exact<{
  vehicleId: Scalars['String']['input'];
  imageTimestamp: Scalars['Float']['input'];
  imagesBefore: Scalars['Int']['input'];
}>;

export type GetVehicleTimestampImagesDetailsQuery = {
  __typename?: 'Query';
  vehicleTimestampImagesDetails?: {
    __typename?: 'VehicleImages';
    vehicle_id?: string | null;
    images?: Array<{ __typename?: 'TripImageDetails'; id: string; image_url: string; obstruction_feedback?: string | null; is_obstructed?: boolean | null } | null> | null;
    vehicle?: { __typename?: 'VehicleDTO'; licensePlate?: string | null; groups: Array<{ __typename?: 'VehicleGroupDTO'; id: string; name: string }> } | null;
  } | null;
};

export type DriverNominateTripImageMutationVariables = Exact<{
  input?: InputMaybe<Array<DriverNominateTripImageInput> | DriverNominateTripImageInput>;
}>;

export type DriverNominateTripImageMutation = { __typename?: 'Mutation'; driverNominateTripImage?: boolean | null };

export type SendTripImageObstructionFeedbackMutationVariables = Exact<{
  input: SendImageObstructionFeedback;
}>;

export type SendTripImageObstructionFeedbackMutation = { __typename?: 'Mutation'; sendTripImageObstructionFeedback?: boolean | null };

export type GetTripPageQueryVariables = Exact<{
  vehicleId: Scalars['ID']['input'];
  fromTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  toTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  footageAvailabilityStatus?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>> | InputMaybe<Scalars['Boolean']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type GetTripPageQuery = {
  __typename?: 'Query';
  tripsByVehicle?: {
    __typename?: 'PageTrip';
    empty?: boolean | null;
    first?: boolean | null;
    last?: boolean | null;
    number?: number | null;
    number_of_elements?: number | null;
    size?: number | null;
    total_elements?: number | null;
    total_pages?: number | null;
    content?: Array<{ __typename?: 'Trip'; id?: string | null; start_timestamp: any; end_timestamp: any; is_footage_available: boolean; hasImages?: boolean | null } | null> | null;
  } | null;
};

export type DriversCountQueryVariables = Exact<{
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type DriversCountQuery = { __typename?: 'Query'; driversCount: number };

export type DriversWithCompleteFaceIdRegistrationCountQueryVariables = Exact<{
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type DriversWithCompleteFaceIdRegistrationCountQuery = { __typename?: 'Query'; driversWithCompleteFaceIdRegistrationCount: number };

export type UnnamedFaceClustersCountQueryVariables = Exact<{
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type UnnamedFaceClustersCountQuery = { __typename?: 'Query'; unnamedFaceClustersCount: number };

export type HasFaceIdIdentificationHistoryQueryVariables = Exact<{
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type HasFaceIdIdentificationHistoryQuery = { __typename?: 'Query'; hasFaceIdIdentificationHistory: boolean };

export type VehiclesRunningWithoutDriverCountQueryVariables = Exact<{
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  timezone: Scalars['String']['input'];
}>;

export type VehiclesRunningWithoutDriverCountQuery = { __typename?: 'Query'; vehiclesRunningWithoutDriverCount: number };

export type FaceIdCoverageChartQueryVariables = Exact<{
  fromTimestamp: Scalars['Float']['input'];
  toTimestamp: Scalars['Float']['input'];
  timezone: Scalars['String']['input'];
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type FaceIdCoverageChartQuery = {
  __typename?: 'Query';
  faceIdCoverageChart: {
    __typename?: 'FaceIdCoverageChart';
    metadata: {
      __typename?: 'FaceIdCoverageMetadata';
      fromTimestamp: number;
      toTimestamp: number;
      validEventsTotal: number;
      identifiedEventsTotal: number;
      averageCoveragePercentage: number;
    };
    data: Array<{ __typename?: 'FaceIdCoveragePoint'; bucketStart: number; validEvents: number; identifiedEvents: number; coveragePercentage: number }>;
  };
};

export type FleetIdentificationHealthQueryVariables = Exact<{ [key: string]: never }>;

export type FleetIdentificationHealthQuery = {
  __typename?: 'Query';
  fleetIdentificationHealth?: {
    __typename?: 'FleetIdentificationHealthDTO';
    state: FleetIdentificationHealthState;
    complete_registration_rate: number;
    identified_events_rate: number;
    calculated_at: any;
  } | null;
};

export type DriverFaceIdRegistrationsQueryVariables = Exact<{
  driverIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type DriverFaceIdRegistrationsQuery = {
  __typename?: 'Query';
  driverFaceIdRegistrations: Array<{
    __typename?: 'DriverFaceIdRegistration';
    driverId: string;
    status: FaceIdRegistrationStatus;
    sampleImageCount: number;
    lastSampleImageAt?: any | null;
  }>;
};

export type GetFaceImageGeolocationQueryVariables = Exact<{
  imageId: Scalars['ID']['input'];
}>;

export type GetFaceImageGeolocationQuery = { __typename?: 'Query'; faceImageGeolocation?: { __typename?: 'Coordinate'; latitude: number; longitude: number } | null };

export type CreateFleetAudioMessageMutationVariables = Exact<{
  input: CreateFleetAudioMessageInput;
}>;

export type CreateFleetAudioMessageMutation = {
  __typename?: 'Mutation';
  createFleetAudioMessage?: {
    __typename?: 'FleetAudioMessage';
    id: string;
    fleetId: string;
    name?: string | null;
    message: string;
    mp3Url: string;
    createdAt: any;
    createdBy: { __typename?: 'User'; id: string; name: string };
  } | null;
};

export type PlayFleetAudioMessageMutationVariables = Exact<{
  audioMessageId: Scalars['ID']['input'];
  input: PlayFleetAudioMessageInput;
}>;

export type PlayFleetAudioMessageMutation = {
  __typename?: 'Mutation';
  playFleetAudioMessage?: {
    __typename?: 'FleetAudioMessagePlayback';
    id: string;
    audioMessageId: string;
    message?: string | null;
    status: PlaybackStatus;
    retryCount: number;
    playedAt?: any | null;
    createdAt: any;
    vehicle: { __typename?: 'VehicleDTO'; id: string; licensePlate?: string | null };
    device: { __typename?: 'Device'; id: string };
    driver?: { __typename?: 'Driver'; id: string; name: string } | null;
    createdBy: { __typename?: 'User'; id: string; name: string };
  } | null;
};

export type GetFleetAudioMessagePlaybacksQueryVariables = Exact<{
  vehicleId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetFleetAudioMessagePlaybacksQuery = {
  __typename?: 'Query';
  fleetAudioMessagePlaybacks?: {
    __typename?: 'FleetAudioMessagePlaybackPage';
    first?: boolean | null;
    last?: boolean | null;
    number?: number | null;
    numberOfElements?: number | null;
    size?: number | null;
    totalElements?: number | null;
    totalPages?: number | null;
    content?: Array<{
      __typename?: 'FleetAudioMessagePlayback';
      id: string;
      audioMessageId: string;
      message?: string | null;
      status: PlaybackStatus;
      retryCount: number;
      playedAt?: any | null;
      createdAt: any;
      cancelIfTimeout?: boolean | null;
      vehicle: { __typename?: 'VehicleDTO'; id: string; licensePlate?: string | null };
      device: { __typename?: 'Device'; id: string };
      driver?: { __typename?: 'Driver'; id: string; name: string } | null;
      createdBy: { __typename?: 'User'; id: string; name: string };
    } | null> | null;
  } | null;
};

export type RetryFleetAudioMessagePlaybackMutationVariables = Exact<{
  audioMessageId: Scalars['ID']['input'];
  playbackId: Scalars['ID']['input'];
}>;

export type RetryFleetAudioMessagePlaybackMutation = {
  __typename?: 'Mutation';
  retryFleetAudioMessagePlayback?: {
    __typename?: 'FleetAudioMessagePlayback';
    id: string;
    audioMessageId: string;
    message?: string | null;
    status: PlaybackStatus;
    retryCount: number;
    playedAt?: any | null;
    createdAt: any;
    cancelIfTimeout?: boolean | null;
    vehicle: { __typename?: 'VehicleDTO'; id: string; licensePlate?: string | null };
    device: { __typename?: 'Device'; id: string };
    driver?: { __typename?: 'Driver'; id: string; name: string } | null;
    createdBy: { __typename?: 'User'; id: string; name: string };
  } | null;
};

export type DeleteFleetAudioMessagePlaybackMutationVariables = Exact<{
  audioMessageId: Scalars['ID']['input'];
  playbackId: Scalars['ID']['input'];
}>;

export type DeleteFleetAudioMessagePlaybackMutation = { __typename?: 'Mutation'; deleteFleetAudioMessagePlayback?: boolean | null };

export type GetAudioFileQueryVariables = Exact<{
  playbackId: Scalars['ID']['input'];
}>;

export type GetAudioFileQuery = { __typename?: 'Query'; getAudioFile: { __typename?: 'AudioFileResponse'; audioUrl: string } };

export type VideoDeliveryTimeQueryVariables = Exact<{ [key: string]: never }>;

export type VideoDeliveryTimeQuery = {
  __typename?: 'Query';
  videoDeliveryTime: {
    __typename?: 'VideoDeliveryTime';
    devices: Array<{ __typename?: 'DeviceDeliveryTime'; deviceId: string; mediaType: MediaType; sampleSize: number; p50Ms: number }>;
    fleet: Array<{ __typename?: 'FleetDeliveryTime'; mediaType: MediaType; sampleSize: number; p50Ms: number; p90SampleSize: number; p90Ms?: number | null }>;
  };
};

export type CompletionDataQueryVariables = Exact<{ [key: string]: never }>;

export type CompletionDataQuery = {
  __typename?: 'Query';
  completionData?: { __typename?: 'CompletionData'; vehicleInstalledCount?: number | null; fleetSize?: number | null; openTicketsToInstall?: number | null } | null;
};

export type UpcomingTicketsQueryVariables = Exact<{ [key: string]: never }>;

export type UpcomingTicketsQuery = {
  __typename?: 'Query';
  upcomingTickets?: {
    __typename?: 'UpcomingTickets';
    daysWithoutMovement?: number | null;
    hasUpsell?: boolean | null;
    nextBatchScheduledAt?: string | null;
    tickets?: Array<
      | {
          __typename?: 'Return';
          deadline?: any | null;
          postingDate?: string | null;
          scheduleDate?: string | null;
          id: string;
          type: string;
          status?: string | null;
          createdAt?: any | null;
          associatedDealId?: string | null;
          deviceTotalQuantity?: { __typename?: 'DeviceTotalQuantity'; total?: number | null; installed?: number | null } | null;
        }
      | {
          __typename?: 'Scheduling';
          scheduledDate?: any | null;
          installedDate?: any | null;
          id: string;
          type: string;
          status?: string | null;
          createdAt?: any | null;
          associatedDealId?: string | null;
          deviceTotalQuantity?: { __typename?: 'DeviceTotalQuantity'; total?: number | null; installed?: number | null } | null;
        }
      | {
          __typename?: 'Shipping';
          shippingDate?: string | null;
          estimatedTimeOfArrival?: string | null;
          id: string;
          type: string;
          status?: string | null;
          createdAt?: any | null;
          associatedDealId?: string | null;
          deviceTotalQuantity?: { __typename?: 'DeviceTotalQuantity'; total?: number | null; installed?: number | null } | null;
        }
      | null
    > | null;
  } | null;
};

export type UpdateContactTrainingInfoMutationVariables = Exact<{
  input: UpdateContactTrainingInfoInput;
}>;

export type UpdateContactTrainingInfoMutation = { __typename?: 'Mutation'; updateContactTraining?: boolean | null };

export type OrdersQueryVariables = Exact<{ [key: string]: never }>;

export type OrdersQuery = {
  __typename?: 'Query';
  orders: Array<{
    __typename?: 'CrmOrder';
    id: string;
    createdAt?: string | null;
    deletedAt?: string | null;
    fleetId?: string | null;
    orderClass?: string | null;
    details?: string | null;
    pipeline?: string | null;
    tickets?: Array<
      | {
          __typename?: 'Return';
          id: string;
          pipeline?: string | null;
          associatedDealId?: string | null;
          details?: string | null;
          fleetId?: string | null;
          status?: string | null;
          deviceIds?: Array<string | null> | null;
          deviceCobliIds?: Array<string | null> | null;
          clientCNPJ?: string | null;
          postingDate?: string | null;
          arrivalOfDevicesAtCobli?: string | null;
          scheduleDate?: string | null;
          shippingCode?: string | null;
          returnType?: string | null;
          type: string;
          createdAt?: any | null;
          deletedAt?: any | null;
          closedDate?: any | null;
          deadline?: any | null;
          penaltyPrice?: number | null;
          addressInformation?: { __typename?: 'AddressInformation'; zipCode?: string | null; address?: string | null; additionalInformation?: string | null } | null;
          clientInformation?: {
            __typename?: 'ClientInformation';
            name?: string | null;
            document?: string | null;
            email?: string | null;
            phone?: string | null;
            secondaryPhone?: string | null;
            responsibleForTrackingScheduling?: string | null;
            installationDoneByClient?: boolean | null;
            installationProblem?: string | null;
            additionalInformation?: string | null;
          } | null;
          coblerInformation?: {
            __typename?: 'CoblerInformation';
            responsible?: string | null;
            schedulingResponsible?: string | null;
            contactResponsible?: string | null;
            technicianResponsible?: string | null;
          } | null;
          contactInformation?: {
            __typename?: 'ContactInformation';
            contactMethod?: string | null;
            contactMethodForResponsibleForInstallation?: string | null;
            bestContactTime?: string | null;
            bestWayToContact?: string | null;
          } | null;
          dateInformation?: {
            __typename?: 'DateInformation';
            scheduledDay?: string | null;
            scheduledHour?: string | null;
            installedDate?: string | null;
            preferredDay1?: string | null;
            preferredDay2?: string | null;
            preferredDay3?: string | null;
            preferredHour1?: string | null;
            preferredHour2?: string | null;
            preferredHour3?: string | null;
          } | null;
          fieldControlInformation?: { __typename?: 'FieldControlInformation'; fieldObservations?: string | null; technicalTeamObservation?: string | null } | null;
          vehicleInformation?: { __typename?: 'VehicleInformation'; licensePlates?: string | null; models?: string | null } | null;
          deviceTotalQuantity?: {
            __typename?: 'DeviceTotalQuantity';
            removable?: number | null;
            installed?: number | null;
            camera?: number | null;
            immobilizer?: number | null;
            identifiers?: number | null;
            redeCan?: number | null;
            total?: number | null;
          } | null;
          responsibleUser?: { __typename?: 'User'; id: string; name: string } | null;
        }
      | {
          __typename?: 'Scheduling';
          id: string;
          pipeline?: string | null;
          schedulingSubCategory?: string | null;
          scheduledDate?: any | null;
          scheduledTime?: any | null;
          installedDate?: any | null;
          associatedDealId?: string | null;
          details?: string | null;
          fleetId?: string | null;
          status?: string | null;
          deviceIds?: Array<string | null> | null;
          deviceCobliIds?: Array<string | null> | null;
          type: string;
          createdAt?: any | null;
          deletedAt?: any | null;
          addressInformation?: { __typename?: 'AddressInformation'; zipCode?: string | null; address?: string | null; additionalInformation?: string | null } | null;
          clientInformation?: {
            __typename?: 'ClientInformation';
            name?: string | null;
            document?: string | null;
            email?: string | null;
            phone?: string | null;
            secondaryPhone?: string | null;
            responsibleForTrackingScheduling?: string | null;
            installationDoneByClient?: boolean | null;
            installationProblem?: string | null;
            additionalInformation?: string | null;
          } | null;
          coblerInformation?: {
            __typename?: 'CoblerInformation';
            responsible?: string | null;
            schedulingResponsible?: string | null;
            contactResponsible?: string | null;
            technicianResponsible?: string | null;
          } | null;
          contactInformation?: {
            __typename?: 'ContactInformation';
            contactMethod?: string | null;
            contactMethodForResponsibleForInstallation?: string | null;
            bestContactTime?: string | null;
            bestWayToContact?: string | null;
          } | null;
          dateInformation?: {
            __typename?: 'DateInformation';
            scheduledDay?: string | null;
            scheduledHour?: string | null;
            installedDate?: string | null;
            preferredDay1?: string | null;
            preferredDay2?: string | null;
            preferredDay3?: string | null;
            preferredHour1?: string | null;
            preferredHour2?: string | null;
            preferredHour3?: string | null;
          } | null;
          fieldControlInformation?: { __typename?: 'FieldControlInformation'; fieldObservations?: string | null; technicalTeamObservation?: string | null } | null;
          vehicleInformation?: { __typename?: 'VehicleInformation'; licensePlates?: string | null; models?: string | null } | null;
          deviceTotalQuantity?: {
            __typename?: 'DeviceTotalQuantity';
            removable?: number | null;
            installed?: number | null;
            camera?: number | null;
            immobilizer?: number | null;
            identifiers?: number | null;
            redeCan?: number | null;
            total?: number | null;
          } | null;
        }
      | {
          __typename?: 'Shipping';
          id: string;
          pipeline?: string | null;
          contactName?: string | null;
          shippingDate?: string | null;
          trackingCode?: string | null;
          shippingCompany?: string | null;
          shippingCompanyLink?: string | null;
          estimatedTimeOfArrival?: string | null;
          devicesWithInstallation?: Array<string | null> | null;
          devicesWithoutInstallation?: Array<string | null> | null;
          associatedDealId?: string | null;
          details?: string | null;
          fleetId?: string | null;
          status?: string | null;
          deviceIds?: Array<string | null> | null;
          deviceCobliIds?: Array<string | null> | null;
          type: string;
          createdAt?: any | null;
          deletedAt?: any | null;
          addressInformation?: { __typename?: 'AddressInformation'; zipCode?: string | null; address?: string | null; additionalInformation?: string | null } | null;
          deviceTotalQuantity?: {
            __typename?: 'DeviceTotalQuantity';
            removable?: number | null;
            installed?: number | null;
            camera?: number | null;
            immobilizer?: number | null;
            identifiers?: number | null;
            redeCan?: number | null;
            total?: number | null;
          } | null;
        }
      | null
    > | null;
    deviceTotalQuantity?: {
      __typename?: 'DeviceTotalQuantity';
      removable?: number | null;
      installed?: number | null;
      camera?: number | null;
      immobilizer?: number | null;
      identifiers?: number | null;
      redeCan?: number | null;
      total?: number | null;
    } | null;
    associatedContact?: { __typename?: 'AssociatedContact'; id: string; name: string; email?: string | null; phone?: string | null } | null;
  } | null>;
};

export type QueryQueryVariables = Exact<{ [key: string]: never }>;

export type QueryQuery = { __typename?: 'Query'; schedulingHolidays: Array<string> };

export type CustomDashboardsQueryVariables = Exact<{ [key: string]: never }>;

export type CustomDashboardsQuery = {
  __typename?: 'Query';
  customDashboards: Array<{
    __typename?: 'CustomDashboard';
    id: string;
    externalDashboardId: string;
    name: string;
    description: string;
    fleets: Array<{ __typename?: 'CustomDashboardFleet'; fleetId: string; groupsRestrictions: Array<string> }>;
    filters: Array<{ __typename?: 'CustomDashboardFilter'; filterKey: string; filterName: string }>;
  }>;
};

export type CustomDashboardQueryVariables = Exact<{
  input: Scalars['String']['input'];
}>;

export type CustomDashboardQuery = {
  __typename?: 'Query';
  customDashboard: {
    __typename?: 'CustomDashboard';
    id: string;
    externalDashboardId: string;
    name: string;
    description: string;
    fleets: Array<{ __typename?: 'CustomDashboardFleet'; fleetId: string; groupsRestrictions: Array<string> }>;
    filters: Array<{ __typename?: 'CustomDashboardFilter'; filterName: string; filterKey: string }>;
  };
};

export type VehicleFragment = {
  __typename?: 'VehicleDTO';
  id: string;
  licensePlate?: string | null;
  alias?: string | null;
  size?: string | null;
  model: {
    __typename?: 'VehicleModelDTO';
    brand?: string | null;
    name?: string | null;
    year?: string | null;
    version?: string | null;
    isSuggestion?: boolean | null;
    type?: string | null;
  };
  groups: Array<{ __typename?: 'VehicleGroupDTO'; id: string; name: string }>;
  driver?: {
    __typename?: 'VehicleDriverDTO';
    id?: string | null;
    name?: string | null;
    phoneNumbers?: Array<string | null> | null;
    active?: boolean | null;
    firstLicenseAcquirementDate?: string | null;
    licenseExpirationDate?: string | null;
    licenseCategory?: string | null;
  } | null;
  operationalSituation?: {
    __typename?: 'OperationalSituation';
    id: string;
    situation: OperationalSituationType;
    startsAt: any;
    endsAt?: any | null;
    reason?: string | null;
    active: boolean;
  } | null;
};

export type LastLocationFragment = {
  __typename?: 'LastLocation';
  cobliIngestedAt?: number | null;
  timeInMillis?: number | null;
  longitude?: number | null;
  latitude?: number | null;
  speed?: number | null;
  heading?: number | null;
  isPlugged?: boolean | null;
  ignitionOn?: boolean | null;
  pluggedUpdateTimestamp?: number | null;
  idleOnDurationInMillis?: number | null;
  idleOffDurationInMillis?: number | null;
};

export type TrackingFragment = {
  __typename?: 'DeviceTracking';
  tempGeofenceId?: string | null;
  conclusionTime?: string | null;
  destination?: { __typename?: 'DeviceDestination'; address?: string | null; lat?: number | null; lng?: number | null } | null;
};

export type DeviceActiveObservationPeriodTriggerFragment = { __typename?: 'Trigger'; createdAt: string };

export type DeviceFragment = {
  __typename?: 'Device';
  id: string;
  cobliId: string;
  fleetId: string;
  type: DeviceType;
  generalType: DeviceGeneralType;
  deviceModel?: string | null;
  healthStatus: DeviceHealthStatusType;
  generalStatus: DeviceGeneralStatus;
  isNew: boolean;
  isSpare: boolean;
  associatedAt: any;
  sdCardHealthStatus?: DeviceSdCardHealthStatus | null;
  disablerStatus?: DisablerStatus | null;
  lastMovingStateTime?: string | null;
  capabilities: { __typename?: 'DeviceCapabilities'; reportsVehicleCan: boolean; reportsVideo: boolean };
  statusSummary: { __typename?: 'DeviceStatusSummary'; status: DeviceStatusType; causes: Array<{ __typename?: 'DeviceCause'; cause: DeviceCauseKey; status: DeviceStatusType }> };
  tracking?: {
    __typename?: 'DeviceTracking';
    tempGeofenceId?: string | null;
    conclusionTime?: string | null;
    destination?: { __typename?: 'DeviceDestination'; address?: string | null; lat?: number | null; lng?: number | null } | null;
  } | null;
  lastLocation?: {
    __typename?: 'LastLocation';
    cobliIngestedAt?: number | null;
    timeInMillis?: number | null;
    longitude?: number | null;
    latitude?: number | null;
    speed?: number | null;
    heading?: number | null;
    isPlugged?: boolean | null;
    ignitionOn?: boolean | null;
    pluggedUpdateTimestamp?: number | null;
    idleOnDurationInMillis?: number | null;
    idleOffDurationInMillis?: number | null;
  } | null;
  vehicle?: {
    __typename?: 'VehicleDTO';
    id: string;
    licensePlate?: string | null;
    alias?: string | null;
    size?: string | null;
    model: {
      __typename?: 'VehicleModelDTO';
      brand?: string | null;
      name?: string | null;
      year?: string | null;
      version?: string | null;
      isSuggestion?: boolean | null;
      type?: string | null;
    };
    groups: Array<{ __typename?: 'VehicleGroupDTO'; id: string; name: string }>;
    driver?: {
      __typename?: 'VehicleDriverDTO';
      id?: string | null;
      name?: string | null;
      phoneNumbers?: Array<string | null> | null;
      active?: boolean | null;
      firstLicenseAcquirementDate?: string | null;
      licenseExpirationDate?: string | null;
      licenseCategory?: string | null;
    } | null;
    operationalSituation?: {
      __typename?: 'OperationalSituation';
      id: string;
      situation: OperationalSituationType;
      startsAt: any;
      endsAt?: any | null;
      reason?: string | null;
      active: boolean;
    } | null;
  } | null;
  activeObservationPeriodTrigger?: { __typename?: 'Trigger'; createdAt: string } | null;
};

export type DevicesQueryVariables = Exact<{
  includeLastMovingStateTime: Scalars['Boolean']['input'];
  includeLastLocation: Scalars['Boolean']['input'];
  includeVehicle: Scalars['Boolean']['input'];
  includeDisablerStatus: Scalars['Boolean']['input'];
  includeTracking: Scalars['Boolean']['input'];
  includeObservationPeriodTrigger: Scalars['Boolean']['input'];
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type DevicesQuery = {
  __typename?: 'Query';
  devices: Array<{
    __typename?: 'Device';
    id: string;
    cobliId: string;
    fleetId: string;
    type: DeviceType;
    generalType: DeviceGeneralType;
    deviceModel?: string | null;
    healthStatus: DeviceHealthStatusType;
    generalStatus: DeviceGeneralStatus;
    isNew: boolean;
    isSpare: boolean;
    associatedAt: any;
    sdCardHealthStatus?: DeviceSdCardHealthStatus | null;
    disablerStatus?: DisablerStatus | null;
    lastMovingStateTime?: string | null;
    capabilities: { __typename?: 'DeviceCapabilities'; reportsVehicleCan: boolean; reportsVideo: boolean };
    statusSummary: { __typename?: 'DeviceStatusSummary'; status: DeviceStatusType; causes: Array<{ __typename?: 'DeviceCause'; cause: DeviceCauseKey; status: DeviceStatusType }> };
    tracking?: {
      __typename?: 'DeviceTracking';
      tempGeofenceId?: string | null;
      conclusionTime?: string | null;
      destination?: { __typename?: 'DeviceDestination'; address?: string | null; lat?: number | null; lng?: number | null } | null;
    } | null;
    lastLocation?: {
      __typename?: 'LastLocation';
      cobliIngestedAt?: number | null;
      timeInMillis?: number | null;
      longitude?: number | null;
      latitude?: number | null;
      speed?: number | null;
      heading?: number | null;
      isPlugged?: boolean | null;
      ignitionOn?: boolean | null;
      pluggedUpdateTimestamp?: number | null;
      idleOnDurationInMillis?: number | null;
      idleOffDurationInMillis?: number | null;
    } | null;
    vehicle?: {
      __typename?: 'VehicleDTO';
      id: string;
      licensePlate?: string | null;
      alias?: string | null;
      size?: string | null;
      model: {
        __typename?: 'VehicleModelDTO';
        brand?: string | null;
        name?: string | null;
        year?: string | null;
        version?: string | null;
        isSuggestion?: boolean | null;
        type?: string | null;
      };
      groups: Array<{ __typename?: 'VehicleGroupDTO'; id: string; name: string }>;
      driver?: {
        __typename?: 'VehicleDriverDTO';
        id?: string | null;
        name?: string | null;
        phoneNumbers?: Array<string | null> | null;
        active?: boolean | null;
        firstLicenseAcquirementDate?: string | null;
        licenseExpirationDate?: string | null;
        licenseCategory?: string | null;
      } | null;
      operationalSituation?: {
        __typename?: 'OperationalSituation';
        id: string;
        situation: OperationalSituationType;
        startsAt: any;
        endsAt?: any | null;
        reason?: string | null;
        active: boolean;
      } | null;
    } | null;
    activeObservationPeriodTrigger?: { __typename?: 'Trigger'; createdAt: string } | null;
  }>;
};

export type DeviceIdsQueryVariables = Exact<{ [key: string]: never }>;

export type DeviceIdsQuery = { __typename?: 'Query'; devices: Array<{ __typename?: 'Device'; id: string }> };

export type DevicesSpareStatusQueryVariables = Exact<{ [key: string]: never }>;

export type DevicesSpareStatusQuery = {
  __typename?: 'Query';
  devices: Array<{ __typename?: 'Device'; id: string; isSpare: boolean; vehicle?: { __typename?: 'VehicleDTO'; id: string } | null }>;
};

export type LastDeviceAssociationQueryVariables = Exact<{
  deviceId: Scalars['String']['input'];
}>;

export type LastDeviceAssociationQuery = {
  __typename?: 'Query';
  lastAssociation?: {
    __typename?: 'LastAssociation';
    cobliId?: string | null;
    deviceId?: string | null;
    fleetId: string;
    driver?: { __typename?: 'DriverLastAssociation'; driverId?: string | null; driverName?: string | null } | null;
    lastLocation?: {
      __typename?: 'LastLocation';
      deviceId: string;
      time?: number | null;
      timeInMillis?: number | null;
      latitude?: number | null;
      longitude?: number | null;
      heading?: number | null;
      speed?: number | null;
      ignitionOn?: boolean | null;
      cobliIngestedAt?: number | null;
      processedAt?: number | null;
      isPlugged?: boolean | null;
      pluggedUpdateTimestamp?: number | null;
      idleOnDurationInMillis?: number | null;
      idleOffDurationInMillis?: number | null;
    } | null;
    vehicle?: {
      __typename?: 'VehicleLastAssociation';
      vehicleId?: string | null;
      fleetId: string;
      licensePlate?: string | null;
      alias?: string | null;
      model?: string | null;
      brand?: string | null;
      year?: string | null;
      type?: string | null;
    } | null;
  } | null;
};

export type AssignDriverToDeviceMutationVariables = Exact<{
  input: DriverAssignmentInput;
}>;

export type AssignDriverToDeviceMutation = { __typename?: 'Mutation'; assignDriverToDevice?: boolean | null };

export type UpdateDeviceSpareStatusMutationVariables = Exact<{
  input: UpdateDeviceSpareStatusInput;
}>;

export type UpdateDeviceSpareStatusMutation = { __typename?: 'Mutation'; updateDeviceSpareStatus?: boolean | null };

export type UpdateDevicesSpareStatusMutationVariables = Exact<{
  input: Array<UpdateDeviceSpareStatusInput> | UpdateDeviceSpareStatusInput;
}>;

export type UpdateDevicesSpareStatusMutation = { __typename?: 'Mutation'; updateDevicesSpareStatus?: boolean | null };

export type UnassignDriverToDeviceMutationVariables = Exact<{
  input: DriverAssignmentInput;
}>;

export type UnassignDriverToDeviceMutation = { __typename?: 'Mutation'; unassignDriverToDevice?: boolean | null };

export type LastPathQueryVariables = Exact<{
  input: LastPathInput;
}>;

export type LastPathQuery = { __typename?: 'Query'; lastPath?: { __typename?: 'LastPath'; event_time: any } | null };

export type DriversWithIdentifiersQueryVariables = Exact<{ [key: string]: never }>;

export type DriversWithIdentifiersQuery = {
  __typename?: 'Query';
  drivers: Array<{
    __typename?: 'Driver';
    id: string;
    name: string;
    fleet_id: string;
    assigned?: boolean | null;
    phone_number?: any | null;
    first_license_acquirement_date?: any | null;
    license_expiration_date?: any | null;
    license_category?: LicenseCategory | null;
    driver_code?: string | null;
    identifier?: string | null;
    cpf?: string | null;
    driver_license?: string | null;
    registry_id?: string | null;
    profile_image_url?: string | null;
    identification_token?: {
      __typename?: 'IdentificationTokenV2';
      id: string;
      alias?: string | null;
      tokenId?: string | null;
      type: string;
      status: string;
      isExternal: boolean;
      fleetId: string;
      driverId?: string | null;
    } | null;
  } | null>;
};

export type DriverIdsQueryVariables = Exact<{ [key: string]: never }>;

export type DriverIdsQuery = { __typename?: 'Query'; drivers: Array<{ __typename?: 'Driver'; id: string } | null> };

export type DriversWithVehiclesQueryVariables = Exact<{ [key: string]: never }>;

export type DriversWithVehiclesQuery = {
  __typename?: 'Query';
  drivers: Array<{
    __typename?: 'Driver';
    id: string;
    name: string;
    fleet_id: string;
    assigned?: boolean | null;
    phone_number?: any | null;
    first_license_acquirement_date?: any | null;
    license_expiration_date?: any | null;
    license_category?: LicenseCategory | null;
    driver_code?: string | null;
    cpf?: string | null;
    driver_license?: string | null;
    registry_id?: string | null;
    profile_image_url?: string | null;
    identification_token?: {
      __typename?: 'IdentificationTokenV2';
      id: string;
      alias?: string | null;
      tokenId?: string | null;
      type: string;
      status: string;
      isExternal: boolean;
      fleetId: string;
      driverId?: string | null;
    } | null;
    vehicle?: { __typename?: 'VehicleDTO'; id: string; licensePlate?: string | null; device?: { __typename?: 'Device'; id: string } | null } | null;
  } | null>;
};

export type DriverNamesQueryVariables = Exact<{ [key: string]: never }>;

export type DriverNamesQuery = { __typename?: 'Query'; drivers: Array<{ __typename?: 'Driver'; id: string; name: string } | null> };

export type DeleteDriverMutationVariables = Exact<{
  driverToDelete?: InputMaybe<DeleteDriver>;
}>;

export type DeleteDriverMutation = { __typename?: 'Mutation'; deleteDriver?: { __typename?: 'Driver'; id: string } | null };

export type UpdateDriverMutationVariables = Exact<{
  driverToUpdate?: InputMaybe<UpdateDriver>;
}>;

export type UpdateDriverMutation = {
  __typename?: 'Mutation';
  updateDriver?: {
    __typename?: 'Driver';
    id: string;
    name: string;
    fleet_id: string;
    assigned?: boolean | null;
    phone_number?: any | null;
    first_license_acquirement_date?: any | null;
    license_expiration_date?: any | null;
    license_category?: LicenseCategory | null;
    driver_code?: string | null;
    cpf?: string | null;
    driver_license?: string | null;
    registry_id?: string | null;
    profile_image_url?: string | null;
  } | null;
};

export type AddDriverMutationVariables = Exact<{
  driverToAdd?: InputMaybe<AddDriver>;
}>;

export type AddDriverMutation = {
  __typename?: 'Mutation';
  addDriver?: {
    __typename?: 'Driver';
    id: string;
    name: string;
    fleet_id: string;
    assigned?: boolean | null;
    phone_number?: any | null;
    first_license_acquirement_date?: any | null;
    license_expiration_date?: any | null;
    license_category?: LicenseCategory | null;
    driver_code?: string | null;
    profile_image_url?: string | null;
  } | null;
};

export type BatchCreateDriversMutationVariables = Exact<{
  input: BatchCreateDriversInput;
}>;

export type BatchCreateDriversMutation = {
  __typename?: 'Mutation';
  batchCreateDrivers: Array<{
    __typename?: 'Driver';
    id: string;
    name: string;
    fleet_id: string;
    phone_number?: any | null;
    cpf?: string | null;
    driver_license?: string | null;
    registry_id?: string | null;
    license_category?: LicenseCategory | null;
    first_license_acquirement_date?: any | null;
    license_expiration_date?: any | null;
  }>;
};

export type BilletFieldsFragment = {
  __typename?: 'Billet';
  id?: number | null;
  idDoc?: string | null;
  idCompany?: any | null;
  boletoLink?: string | null;
  subject?: string | null;
  fileName?: string | null;
  dataEmissao?: string | null;
  status?: string | null;
  dataVencimento?: string | null;
  barCode?: string | null;
  digitableLine?: string | null;
  titleValue?: string | null;
  nrDocumento?: string | null;
  nrNfse?: string | null;
  validFrom?: any | null;
  validTo?: any | null;
  runnedAt?: number | null;
  seqCode?: string | null;
  nrDocEntry?: string | null;
  nrNoteEntry?: string | null;
  cardCode?: string | null;
  cardName?: string | null;
  datePayment?: string | null;
  idContract?: string | null;
  payedValue?: string | null;
  diaProRata?: string | null;
  source?: string | null;
  nfeLink?: string | null;
  nfeDataEmissao?: string | null;
  nfeHoraEmissao?: string | null;
  nfeTitleValue?: string | null;
  nfeIdContract?: string | null;
};

export type BilletsQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
}>;

export type BilletsQuery = {
  __typename?: 'Query';
  billets?: Array<{
    __typename?: 'Billet';
    id?: number | null;
    idDoc?: string | null;
    idCompany?: any | null;
    boletoLink?: string | null;
    subject?: string | null;
    fileName?: string | null;
    dataEmissao?: string | null;
    status?: string | null;
    dataVencimento?: string | null;
    barCode?: string | null;
    digitableLine?: string | null;
    titleValue?: string | null;
    nrDocumento?: string | null;
    nrNfse?: string | null;
    validFrom?: any | null;
    validTo?: any | null;
    runnedAt?: number | null;
    seqCode?: string | null;
    nrDocEntry?: string | null;
    nrNoteEntry?: string | null;
    cardCode?: string | null;
    cardName?: string | null;
    datePayment?: string | null;
    idContract?: string | null;
    payedValue?: string | null;
    diaProRata?: string | null;
    source?: string | null;
    nfeLink?: string | null;
    nfeDataEmissao?: string | null;
    nfeHoraEmissao?: string | null;
    nfeTitleValue?: string | null;
    nfeIdContract?: string | null;
  } | null> | null;
};

export type BilletsByCompaniesQueryVariables = Exact<{
  companyIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
}>;

export type BilletsByCompaniesQuery = {
  __typename?: 'Query';
  billetsByCompanies?: Array<{
    __typename?: 'Billet';
    id?: number | null;
    idDoc?: string | null;
    idCompany?: any | null;
    boletoLink?: string | null;
    subject?: string | null;
    fileName?: string | null;
    dataEmissao?: string | null;
    status?: string | null;
    dataVencimento?: string | null;
    barCode?: string | null;
    digitableLine?: string | null;
    titleValue?: string | null;
    nrDocumento?: string | null;
    nrNfse?: string | null;
    validFrom?: any | null;
    validTo?: any | null;
    runnedAt?: number | null;
    seqCode?: string | null;
    nrDocEntry?: string | null;
    nrNoteEntry?: string | null;
    cardCode?: string | null;
    cardName?: string | null;
    datePayment?: string | null;
    idContract?: string | null;
    payedValue?: string | null;
    diaProRata?: string | null;
    source?: string | null;
    nfeLink?: string | null;
    nfeDataEmissao?: string | null;
    nfeHoraEmissao?: string | null;
    nfeTitleValue?: string | null;
    nfeIdContract?: string | null;
  } | null> | null;
};

export type RunningWithoutDriverVehiclesQueryVariables = Exact<{
  timezone: Scalars['String']['input'];
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
}>;

export type RunningWithoutDriverVehiclesQuery = {
  __typename?: 'Query';
  runningWithoutDriverVehicles: {
    __typename?: 'PageRunningWithoutDriverVehicles';
    page: { __typename?: 'RunningWithoutDriverPageInfo'; number: number; size: number; totalElements: number; totalPages: number };
    content: Array<{
      __typename?: 'RunningWithoutDriverVehicle';
      unassignedTripCount: number;
      totalTripCount: number;
      vehicle?: {
        __typename?: 'VehicleDTO';
        id: string;
        licensePlate?: string | null;
        alias?: string | null;
        groupPath: string;
        groups: Array<{ __typename?: 'VehicleGroupDTO'; id: string; name: string }>;
      } | null;
      unnamedClusters: Array<{ __typename?: 'UnnamedFaceCluster'; id: string; photoCount: number; thumbnailUrl: string; lastCapturedAt?: any | null }>;
    }>;
  };
};

export type GetFleetUsersQueryVariables = Exact<{
  fleetId: Scalars['String']['input'];
}>;

export type GetFleetUsersQuery = {
  __typename?: 'Query';
  fleetUsers?: Array<{
    __typename?: 'FleetUser';
    id?: string | null;
    active?: boolean | null;
    full_name?: string | null;
    language?: string | null;
    last_login?: string | null;
    email_address?: string | null;
    timezone_offset?: string | null;
    occupation?: string | null;
    creation_date?: string | null;
    fleet_id?: string | null;
    role?: string | null;
    groups_restriction?: Array<string | null> | null;
    has_custom_permissions?: boolean | null;
    granted_permissions?: Array<string | null> | null;
    groups?: Array<{ __typename?: 'VehiclesGroup'; id: string; name: string; path: string } | null> | null;
  } | null> | null;
};

export type ContractsQueryVariables = Exact<{
  fleetId: Scalars['String']['input'];
}>;

export type ContractsQuery = {
  __typename?: 'Query';
  contracts?: {
    __typename?: 'FleetCompanyContracts';
    fleetId: string;
    contracts?: Array<{
      __typename?: 'FleetCompanyContract';
      companyId: string;
      companyStatus?: string | null;
      corporateName?: string | null;
      cnpj?: string | null;
      contractSignedDate?: any | null;
      address?: string | null;
      phone?: string | null;
      industry?: string | null;
      responsavel?: string | null;
      lastRegistrationChangeDate?: string | null;
      mrrCurrency?: string | null;
      billingDay?: string | null;
      dueDay?: string | null;
      paymentMethod?: string | null;
      paymentFrequency?: string | null;
      financialAdjustmentIndex?: string | null;
      recentConversionEventName?: string | null;
      upsellBlockLoggedArea?: string | null;
    } | null> | null;
  } | null;
};

export type CompanyOnboardingStatusQueryVariables = Exact<{
  fleetId: Scalars['String']['input'];
}>;

export type CompanyOnboardingStatusQuery = {
  __typename?: 'Query';
  companyOnboardingStatus?: { __typename?: 'FleetCompanyOnboardingStatus'; hasAnyOnboardingContract: boolean; hasAnyContractSignedInLast90Days: boolean } | null;
};

export type ValidateFuelTransactionsImportQueryVariables = Exact<{
  input: ValidateFuelTransactionsImportInput;
}>;

export type ValidateFuelTransactionsImportQuery = {
  __typename?: 'Query';
  validateFuelTransactionsImport: {
    __typename?: 'ValidateFuelTransactionsImportResponse';
    validRows: Array<{
      __typename?: 'ValidateFuelTransactionsValidRowsResponse';
      licensePlate: string;
      transactionTime: string;
      odometerInKm: number;
      fuelType: string;
      quantityInLiters: number;
      totalCost: number;
      driverName?: string | null;
      merchant?: { __typename?: 'MerchantImportResponse'; cnpj?: string | null; name?: string | null; city?: string | null; state?: string | null } | null;
    }>;
    invalidRows: Array<{
      __typename?: 'ValidateFuelTransactionsInvalidRowsResponse';
      data: {
        __typename?: 'ValidateFuelTransactionsImportItem';
        licensePlate: string;
        transactionTime: string;
        odometer: string;
        fuelType: string;
        quantityInLiters: string;
        totalCost: string;
        merchantName?: string | null;
        merchantCnpj?: string | null;
        merchantCity?: string | null;
        merchantState?: string | null;
        driverName?: string | null;
        rowIndex: number;
      };
      errors: Array<{ __typename?: 'ValidationError'; error: string; column: { __typename?: 'ImportColumnMap'; name: string; position: string } }>;
    }>;
  };
};

export type ImportFuelTransactionsMutationVariables = Exact<{
  input: Array<ImportFuelTransactionsBatchInput> | ImportFuelTransactionsBatchInput;
}>;

export type ImportFuelTransactionsMutation = { __typename?: 'Mutation'; importFuelTransactions: { __typename?: 'ImportBatchResponse'; count: any } };

export type FuelCardAssociationsQueryVariables = Exact<{
  input?: InputMaybe<Scalars['String']['input']>;
}>;

export type FuelCardAssociationsQuery = {
  __typename?: 'Query';
  fuelCardAssociations: Array<{
    __typename?: 'FuelCardAssociationResponse';
    id: string;
    fleetId: string;
    fuelCardId: string;
    updatedAt?: number | null;
    createdAt: number;
    deletedAt?: number | null;
    providerLicensePlate: string;
    providerName: string;
    vehicle?: { __typename?: 'VehicleDTO'; id: string; licensePlate?: string | null } | null;
  }>;
};

export type UpdateFuelCardAssociationMutationVariables = Exact<{
  input: UpdateFuelCardAssociationInput;
}>;

export type UpdateFuelCardAssociationMutation = {
  __typename?: 'Mutation';
  updateFuelCardAssociation: { __typename?: 'FuelCardAssociationStatusResponse'; message?: string | null };
};

export type DeleteFuelCardAssociationMutationVariables = Exact<{
  input: FuelCardAssociationStatusInput;
}>;

export type DeleteFuelCardAssociationMutation = {
  __typename?: 'Mutation';
  deleteFuelCardAssociation: { __typename?: 'FuelCardAssociationStatusResponse'; message?: string | null };
};

export type RestoreFuelCardAssociationMutationVariables = Exact<{
  input: FuelCardAssociationStatusInput;
}>;

export type RestoreFuelCardAssociationMutation = {
  __typename?: 'Mutation';
  restoreFuelCardAssociation: { __typename?: 'FuelCardAssociationStatusResponse'; message?: string | null };
};

export type BatchSetFuelConsumptionGoalsMutationVariables = Exact<{
  input: Array<UpsertVehicleFuelConsumptionGoalInput> | UpsertVehicleFuelConsumptionGoalInput;
}>;

export type BatchSetFuelConsumptionGoalsMutation = {
  __typename?: 'Mutation';
  batchSetFuelConsumptionGoals: {
    __typename?: 'FuelConsumptionGoalsResponse';
    goals: Array<{
      __typename?: 'VehicleFuelConsumptionGoalResponse';
      goal: number;
      source: string;
      createdAt: string;
      updatedAt?: string | null;
      vehicle: { __typename?: 'VehicleDTO'; id: string };
    }>;
  };
};

export type FleetGeofenceRecommendationsQueryVariables = Exact<{
  fleetId: Scalars['ID']['input'];
}>;

export type FleetGeofenceRecommendationsQuery = {
  __typename?: 'Query';
  fleetGeofenceRecommendations: Array<{
    __typename?: 'FleetGeofenceRecommendation';
    id: string;
    fleetId: string;
    name: string;
    reason: string;
    address?: string | null;
    color: string;
    type: string;
    area: number;
    format: string;
    radius: number;
    longitude: number;
    latitude: number;
  }>;
};

export type CompleteFleetRecommendationMutationVariables = Exact<{
  fleetId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;

export type CompleteFleetRecommendationMutation = {
  __typename?: 'Mutation';
  completeFleetRecommendation: {
    __typename?: 'RecommendationActionResult';
    id: string;
    fleetId: string;
    finishedAt?: string | null;
    dismissedAt?: string | null;
    completedBy?: string | null;
  };
};

export type DismissFleetRecommendationMutationVariables = Exact<{
  fleetId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;

export type DismissFleetRecommendationMutation = {
  __typename?: 'Mutation';
  dismissFleetRecommendation: {
    __typename?: 'RecommendationActionResult';
    id: string;
    fleetId: string;
    finishedAt?: string | null;
    dismissedAt?: string | null;
    completedBy?: string | null;
  };
};

export type FleetGroupRecommendationsQueryVariables = Exact<{
  fleetId: Scalars['ID']['input'];
}>;

export type FleetGroupRecommendationsQuery = {
  __typename?: 'Query';
  fleetGroupRecommendations: Array<{
    __typename?: 'GroupRecommendation';
    id: string;
    fleetId: string;
    suggestedName: string;
    vehicleIds: Array<string>;
    reason: string;
    dismissCount: number;
    appliedPayloadJson?: string | null;
  }>;
};

export type TouchFleetRecommendationsMutationVariables = Exact<{
  fleetId: Scalars['ID']['input'];
}>;

export type TouchFleetRecommendationsMutation = { __typename?: 'Mutation'; touchFleetRecommendations: boolean };

export type ApplyGroupRecommendationMutationVariables = Exact<{
  fleetId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  input: ApplyGroupRecommendationInput;
}>;

export type ApplyGroupRecommendationMutation = {
  __typename?: 'Mutation';
  applyGroupRecommendation: {
    __typename?: 'GroupRecommendation';
    id: string;
    fleetId: string;
    suggestedName: string;
    vehicleIds: Array<string>;
    reason: string;
    dismissCount: number;
    appliedPayloadJson?: string | null;
  };
};

export type DismissGroupRecommendationMutationVariables = Exact<{
  fleetId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;

export type DismissGroupRecommendationMutation = {
  __typename?: 'Mutation';
  dismissGroupRecommendation: {
    __typename?: 'GroupRecommendation';
    id: string;
    fleetId: string;
    suggestedName: string;
    vehicleIds: Array<string>;
    reason: string;
    dismissCount: number;
    appliedPayloadJson?: string | null;
  };
};

export type GetHomeSummaryVehiclesQueryVariables = Exact<{
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type GetHomeSummaryVehiclesQuery = { __typename?: 'Query'; homeSummaryVehicles: number };

export type GetHomeSummaryGeofencesQueryVariables = Exact<{ [key: string]: never }>;

export type GetHomeSummaryGeofencesQuery = { __typename?: 'Query'; homeSummaryGeofences: number };

export type TokensQueryVariables = Exact<{
  fleetId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type TokensQuery = {
  __typename?: 'Query';
  tokens?: Array<{
    __typename?: 'IdentificationToken';
    token_id: string;
    cobli_internal_id: string;
    fleet_id?: string | null;
    driver_id?: string | null;
    associated_to_fleet_at?: any | null;
    status: string;
    token_type: string;
  }> | null;
};

export type DeleteTokenMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type DeleteTokenMutation = { __typename?: 'Mutation'; deleteToken?: string | null };

export type TokensV2QueryVariables = Exact<{
  input?: InputMaybe<IdentificationTokenFilters>;
}>;

export type TokensV2Query = {
  __typename?: 'Query';
  tokensV2?: Array<{
    __typename?: 'IdentificationTokenV2';
    id: string;
    alias?: string | null;
    type: string;
    driverId?: string | null;
    isExternal: boolean;
    origin: string;
    status: string;
    tokenId?: string | null;
    cobliId?: string | null;
    lastUsage?: {
      __typename?: 'IdentificationTokenLastUsage';
      timestamp?: any | null;
      location?: { __typename?: 'Location'; lat: number; lng: number } | null;
      vehicle?: { __typename?: 'VehicleDTO'; id: string; licensePlate?: string | null; groups: Array<{ __typename?: 'VehicleGroupDTO'; id: string }> } | null;
    } | null;
  }> | null;
};

export type TokensV2ExistsQueryVariables = Exact<{ [key: string]: never }>;

export type TokensV2ExistsQuery = { __typename?: 'Query'; tokensV2?: Array<{ __typename?: 'IdentificationTokenV2'; id: string }> | null };

export type AssociateTokenToDriverMutationVariables = Exact<{
  id: Scalars['String']['input'];
  driverId: Scalars['String']['input'];
}>;

export type AssociateTokenToDriverMutation = { __typename?: 'Mutation'; associateTokenToDriver?: { __typename?: 'IdentificationTokenV2'; id: string } | null };

export type DisassociateTokenFromDriverMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type DisassociateTokenFromDriverMutation = { __typename?: 'Mutation'; disassociateTokenFromDriver?: string | null };

export type MaintenanceHistoryQueryVariables = Exact<{
  input: GetMaintenanceHistoryInput;
}>;

export type MaintenanceHistoryQuery = {
  __typename?: 'Query';
  maintenanceHistory: {
    __typename?: 'MaintenanceResponse';
    count: number;
    rows?: Array<{
      __typename?: 'Maintenance';
      createdBy: string;
      description?: string | null;
      id: string;
      occurrenceAt?: any | null;
      odometerInKms?: number | null;
      totalPrice?: number | null;
      types: Array<string | null>;
      updatedAt?: any | null;
      updatedBy?: any | null;
      recurrences?: Array<{ __typename?: 'Recurrence'; description?: string | null; everyKms?: number | null; everyDays?: number | null } | null> | null;
      parts?: Array<{
        __typename?: 'MaintenancePart';
        description?: string | null;
        id: string;
        price?: number | null;
        quantity?: number | null;
        part?: { __typename?: 'Part'; description?: string | null; id: string } | null;
      } | null> | null;
      vehicle?: {
        __typename?: 'VehicleDTO';
        id: string;
        licensePlate?: string | null;
        alias?: string | null;
        size?: string | null;
        groups: Array<{ __typename?: 'VehicleGroupDTO'; id: string; name: string }>;
        branding?: { __typename?: 'Branding'; brand?: string | null; model?: string | null; year?: number | null } | null;
        tags?: Array<{ __typename?: 'VehicleTag'; name: string }> | null;
      } | null;
    } | null> | null;
  };
};

export type MaintenancePartsQueryVariables = Exact<{
  input: GetMaintenancePartsInput;
}>;

export type MaintenancePartsQuery = {
  __typename?: 'Query';
  maintenanceParts: {
    __typename?: 'MaintenancePartResponse';
    count: number;
    rows?: Array<{
      __typename?: 'MaintenancePart';
      description?: string | null;
      id: string;
      price?: number | null;
      quantity?: number | null;
      part?: { __typename?: 'Part'; description?: string | null; id: string } | null;
    } | null> | null;
  };
};

export type CreateMaintenanceHistoryMutationVariables = Exact<{
  input: CreateMaintenanceHistoryInput;
}>;

export type CreateMaintenanceHistoryMutation = {
  __typename?: 'Mutation';
  createMaintenanceHistory: {
    __typename?: 'Maintenance';
    id: string;
    types: Array<string | null>;
    occurrenceAt?: any | null;
    totalPrice?: number | null;
    odometerInKms?: number | null;
    description?: string | null;
    createdBy: string;
    updatedAt?: any | null;
    updatedBy?: any | null;
    parts?: Array<{
      __typename?: 'MaintenancePart';
      id: string;
      description?: string | null;
      price?: number | null;
      quantity?: number | null;
      part?: { __typename?: 'Part'; description?: string | null; id: string } | null;
    } | null> | null;
    recurrences?: Array<{ __typename?: 'Recurrence'; description?: string | null; everyKms?: number | null } | null> | null;
    vehicle?: {
      __typename?: 'VehicleDTO';
      id: string;
      licensePlate?: string | null;
      size?: string | null;
      branding?: { __typename?: 'Branding'; brand?: string | null; model?: string | null; year?: number | null } | null;
    } | null;
  };
};

export type UpdateMaintenanceHistoryMutationVariables = Exact<{
  input: UpdateMaintenanceHistoryInput;
}>;

export type UpdateMaintenanceHistoryMutation = {
  __typename?: 'Mutation';
  updateMaintenanceHistory: {
    __typename?: 'Maintenance';
    id: string;
    types: Array<string | null>;
    occurrenceAt?: any | null;
    totalPrice?: number | null;
    odometerInKms?: number | null;
    description?: string | null;
    updatedAt?: any | null;
    updatedBy?: any | null;
    createdBy: string;
    parts?: Array<{ __typename?: 'MaintenancePart'; id: string; description?: string | null; price?: number | null; quantity?: number | null } | null> | null;
    recurrences?: Array<{ __typename?: 'Recurrence'; description?: string | null; everyKms?: number | null } | null> | null;
  };
};

export type DeleteMaintenanceHistoryMutationVariables = Exact<{
  input: DeleteMaintenanceHistoryInput;
}>;

export type DeleteMaintenanceHistoryMutation = { __typename?: 'Mutation'; deleteMaintenanceHistory?: boolean | null };

export type CreateMaintenancePartsMutationVariables = Exact<{
  input: CreateMaintenancePartsInput;
}>;

export type CreateMaintenancePartsMutation = { __typename?: 'Mutation'; createMaintenanceParts: { __typename?: 'Part'; id: string; description?: string | null } };

export type UpdateMaintenancePartsMutationVariables = Exact<{
  input: UpdateMaintenancePartsInput;
}>;

export type UpdateMaintenancePartsMutation = { __typename?: 'Mutation'; updateMaintenanceParts: { __typename?: 'Part'; id: string; description?: string | null } };

export type DeleteMaintenancePartsMutationVariables = Exact<{
  input: DeleteMaintenancePartsInput;
}>;

export type DeleteMaintenancePartsMutation = { __typename?: 'Mutation'; deleteMaintenanceParts?: boolean | null };

export type ValidateMaintenanceImportQueryVariables = Exact<{
  input: ValidateMaintenanceImportInput;
}>;

export type ValidateMaintenanceImportQuery = {
  __typename?: 'Query';
  validateMaintenanceImport: {
    __typename?: 'ValidateMaintenanceImportResponse';
    validRows: Array<{
      __typename?: 'ValidateMaintenanceValidRowsResponse';
      type: Array<string>;
      occurrenceAt: any;
      odometerInKms: number;
      maintenanceObservations?: string | null;
      vehicle: { __typename?: 'VehicleDTO'; id: string };
      parts: Array<{ __typename?: 'ValidateMaintenancePart'; partName: string; unitCost: number; quantity?: number | null; partObservation?: string | null }>;
    }>;
    invalidRows: Array<{
      __typename?: 'ValidateMaintenanceInvalidRowsResponse';
      maintenanceData: {
        __typename?: 'ValidateMaintenanceInvalidRow';
        licensePlate?: string | null;
        type?: string | null;
        occurrenceAt?: string | null;
        odometerInKms?: string | null;
        maintenanceObservation?: string | null;
        items?: Array<{
          __typename?: 'ValidateMaintenanceAggregatedPart';
          serviceItemName?: string | null;
          unitCost?: string | null;
          quantity?: string | null;
          description?: string | null;
          rowIndex: number;
        } | null> | null;
      };
      errors: Array<{ __typename?: 'ValidationError'; error: string; column: { __typename?: 'ImportColumnMap'; name: string; position: string } }>;
      items: Array<{
        __typename?: 'ValidateMaintenanceInvalidRowItem';
        rowIndex: number;
        itemsData: { __typename?: 'ValidateMaintenanceInvalidPart'; partName?: string | null; unitCost?: string | null; quantity?: string | null; partObservation?: string | null };
        errors: Array<{ __typename?: 'ValidationError'; error: string; column: { __typename?: 'ImportColumnMap'; name: string; position: string } }>;
      }>;
    }>;
  };
};

export type ImportMaintenanceHistoryMutationVariables = Exact<{
  input: Array<ImportMaintenanceBatchInput> | ImportMaintenanceBatchInput;
}>;

export type ImportMaintenanceHistoryMutation = { __typename?: 'Mutation'; importMaintenanceHistory: { __typename?: 'ImportBatchResponse'; count: any } };

export type CreateMaintenanceReminderMutationVariables = Exact<{
  input: CreateReminderInput;
}>;

export type CreateMaintenanceReminderMutation = {
  __typename?: 'Mutation';
  createMaintenanceReminder: Array<{
    __typename?: 'ReminderDTO';
    id: string;
    title?: string | null;
    description?: string | null;
    recurrenceInKm?: number | null;
    nextOccurrenceInKm?: number | null;
    recurrenceInDays?: number | null;
    nextOccurrenceDate?: any | null;
    lastMaintenanceDate?: any | null;
    vehicle: { __typename?: 'VehicleDTO'; size?: string | null; id: string; licensePlate?: string | null };
    status: { __typename?: 'MaintenanceStatus'; name: string; km?: number | null; days?: number | null };
  }>;
};

export type UpdateMaintenanceReminderMutationVariables = Exact<{
  input: UpdateReminderInput;
}>;

export type UpdateMaintenanceReminderMutation = {
  __typename?: 'Mutation';
  updateMaintenanceReminder: {
    __typename?: 'ReminderDTO';
    id: string;
    title?: string | null;
    description?: string | null;
    recurrenceInKm?: number | null;
    nextOccurrenceInKm?: number | null;
    recurrenceInDays?: number | null;
    nextOccurrenceDate?: any | null;
    lastMaintenanceDate?: any | null;
    vehicle: { __typename?: 'VehicleDTO'; id: string; size?: string | null; licensePlate?: string | null };
    status: { __typename?: 'MaintenanceStatus'; name: string; km?: number | null; days?: number | null };
  };
};

export type DeleteMaintenanceReminderMutationVariables = Exact<{
  input: DeleteMaintenanceReminderInput;
}>;

export type DeleteMaintenanceReminderMutation = { __typename?: 'Mutation'; deleteMaintenanceReminder?: boolean | null };

export type ReminderTitlesQueryVariables = Exact<{ [key: string]: never }>;

export type ReminderTitlesQuery = { __typename?: 'Query'; reminderTitles: Array<{ __typename?: 'ReminderTitle'; id: string; value: string }> };

export type ReminderListQueryVariables = Exact<{
  input: GetReminderListInput;
}>;

export type ReminderListQuery = {
  __typename?: 'Query';
  reminderList: {
    __typename?: 'MaintenanceReminderResponse';
    count: number;
    rows: Array<{
      __typename?: 'ReminderDTO';
      id: string;
      title?: string | null;
      description?: string | null;
      recurrenceInKm?: number | null;
      nextOccurrenceInKm?: number | null;
      recurrenceInDays?: number | null;
      nextOccurrenceDate?: any | null;
      type?: string | null;
      lastMaintenanceDate?: any | null;
      fleetId: string;
      vehicle: {
        __typename?: 'VehicleDTO';
        id: string;
        alias?: string | null;
        deviceType?: string | null;
        licensePlate?: string | null;
        branding?: { __typename?: 'Branding'; brand?: string | null; model?: string | null; year?: number | null; type?: string | null } | null;
        model: {
          __typename?: 'VehicleModelDTO';
          brand?: string | null;
          name?: string | null;
          year?: string | null;
          version?: string | null;
          isSuggestion?: boolean | null;
          type?: string | null;
        };
        tags?: Array<{ __typename?: 'VehicleTag'; name: string }> | null;
        groups: Array<{ __typename?: 'VehicleGroupDTO'; id: string; name: string }>;
      };
      status: { __typename?: 'MaintenanceStatus'; name: string; km?: number | null; days?: number | null };
    }>;
  };
};

export type ReminderStatusSummaryQueryVariables = Exact<{
  input: GetReminderStatusCountInput;
}>;

export type ReminderStatusSummaryQuery = {
  __typename?: 'Query';
  reminderStatusSummary: { __typename?: 'ReminderStatusCount'; onTime?: number | null; warning?: number | null; delayed?: number | null };
};

export type LatestMaintenanceByVehicleQueryVariables = Exact<{
  input: GetLatestMaintenanceInput;
}>;

export type LatestMaintenanceByVehicleQuery = {
  __typename?: 'Query';
  latestMaintenanceByVehicle?: { __typename?: 'Maintenance'; id: string; occurrenceAt?: any | null; odometerInKms?: number | null; description?: string | null } | null;
};

export type CreateCheckpointManualMutationVariables = Exact<{
  input: CreateCheckpointManualInput;
}>;

export type CreateCheckpointManualMutation = {
  __typename?: 'Mutation';
  createCheckpointManual: {
    __typename?: 'CreateManualOdometerResponse';
    manualOdometer: { __typename?: 'ManualOdometer'; id: string; odometerAt: string; odometerInKms: any; createdBy?: string | null; createdAt: string };
    vehicle: { __typename?: 'VehicleDTO'; id: string; licensePlate?: string | null };
  };
};

export type OperationalSituationsQueryVariables = Exact<{
  filter?: InputMaybe<OperationalSituationsFilter>;
}>;

export type OperationalSituationsQuery = {
  __typename?: 'Query';
  operationalSituations: {
    __typename?: 'OperationalSituationPage';
    content: Array<{
      __typename?: 'OperationalSituation';
      id: string;
      targetType: OperationalSituationTargetType;
      targetId: string;
      situation: OperationalSituationType;
      startsAt: any;
      endsAt?: any | null;
      reason?: string | null;
      active: boolean;
      createdBy?: { __typename?: 'FleetUser'; id?: string | null; full_name?: string | null } | null;
      target?:
        | { __typename: 'Device'; cobliId: string; deviceId: string }
        | { __typename: 'VehicleDTO'; licensePlate?: string | null; alias?: string | null; vehicleId: string }
        | null;
    }>;
    page: { __typename?: 'OperationalSituationPageInfo'; number: number; size: number; totalElements: number; totalPages: number };
  };
};

export type CreateOperationalSituationsMutationVariables = Exact<{
  input: Array<CreateOperationalSituationInput> | CreateOperationalSituationInput;
}>;

export type CreateOperationalSituationsMutation = {
  __typename?: 'Mutation';
  createOperationalSituations: Array<{
    __typename?: 'OperationalSituation';
    id: string;
    targetType: OperationalSituationTargetType;
    targetId: string;
    situation: OperationalSituationType;
    startsAt: any;
    endsAt?: any | null;
    reason?: string | null;
    active: boolean;
  }>;
};

export type EndOperationalSituationMutationVariables = Exact<{
  input: EndOperationalSituationInput;
}>;

export type EndOperationalSituationMutation = { __typename?: 'Mutation'; endOperationalSituation: boolean };

export type GetPathsQueryVariables = Exact<{
  vehicleId: Scalars['ID']['input'];
  startTime: Scalars['Float']['input'];
  endTime: Scalars['Float']['input'];
  tz: Scalars['String']['input'];
  associationMethods?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type GetPathsQuery = {
  __typename?: 'Query';
  paths?: Array<{
    __typename?: 'Path';
    associationSource?: string | null;
    endLatitude?: number | null;
    endLongitude?: number | null;
    endTime: number;
    latitude?: number | null;
    longitude?: number | null;
    startLatitude?: number | null;
    startLongitude?: number | null;
    startTime: number;
    type: string;
    driver?: { __typename?: 'VehicleDriverDTO'; id?: string | null; name?: string | null } | null;
    vehicle?: {
      __typename?: 'VehicleDTO';
      id: string;
      licensePlate?: string | null;
      model: { __typename?: 'VehicleModelDTO'; brand?: string | null; name?: string | null };
      groups: Array<{ __typename?: 'VehicleGroupDTO'; id: string; name: string }>;
      driver?: { __typename?: 'VehicleDriverDTO'; id?: string | null; name?: string | null } | null;
    } | null;
  } | null> | null;
};

export type HomeProductivityQueryVariables = Exact<{
  start_date: Scalars['String']['input'];
  end_date: Scalars['String']['input'];
  tz: Scalars['String']['input'];
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type HomeProductivityQuery = {
  __typename?: 'Query';
  homeProductivitySummary?: {
    __typename?: 'HomeProductivitySummary';
    averageStopTimeInMinutes: number;
    averageIdleOnTimeInMinutes: number;
    averageEngineOnTimeInMinutes: number;
  } | null;
};

export type SafetyRankingProductivityQueryVariables = Exact<{
  timePeriodInput: SafetyRankingInput;
  dateInput: SafetyRankingParamsInput;
}>;

export type SafetyRankingProductivityQuery = {
  __typename?: 'Query';
  safetyRankingProductivity: { __typename?: 'SafetyRankingProductivity'; averageKmPerVehicle: number };
  safetyRankingProductType: { __typename?: 'SafetyRankingProductType'; productType: string };
  safetyRankingScores: {
    __typename?: 'SafetyRankingScores';
    count: number;
    classifiedCount: number;
    unclassifiedCount: number;
    averageFleetScore?: number | null;
    rows: Array<{
      __typename?: 'SafetyRankingScoreRow';
      rank?: number | null;
      productType?: string | null;
      score?: number | null;
      variation?: number | null;
      drivenDistanceInKm: number;
      drivenTimeInMinutes: number;
      kmsPerEvent?: number | null;
      totalEventsCount?: number | null;
      scoreDetail: Array<{ __typename?: 'SafetyRankingScoreDetail'; eventType: string; occurrences: number; frequency: number; discount: number }>;
    }>;
  };
  fleetEventsConfiguration?: {
    __typename?: 'FleetEventsConfiguration';
    id?: string | null;
    fleet_id: string;
    created_at: string;
    updated_at?: string | null;
    updated_by_id?: string | null;
    updated_by_name?: string | null;
    camera_events_config?: {
      __typename?: 'CameraEventsConfiguration';
      entire_fleet_camera_events_configuration: {
        __typename?: 'EventsConfiguration';
        dms_events: {
          __typename?: 'DmsEvents';
          min_speed_trigger_in_km_per_h: number;
          distracted_driving: { __typename?: 'SensibilityConfiguration'; enabled: boolean };
          yawn: { __typename?: 'SensibilityConfiguration'; enabled: boolean };
          phone_usage: { __typename?: 'SensibilityConfiguration'; enabled: boolean };
          eyes_closed: { __typename?: 'SensibilityConfiguration'; enabled: boolean };
          smoking: { __typename?: 'SensibilityConfiguration'; enabled: boolean };
        };
        adas_events: { __typename?: 'AdasEvents'; min_speed_trigger_in_km_per_h: number; forward_collision_warning: { __typename?: 'SensibilityConfiguration'; enabled: boolean } };
        harsh_events: {
          __typename?: 'HarshEventsByDutyType';
          light: {
            __typename?: 'HarshEvents';
            acceleration: { __typename?: 'SensibilityConfiguration'; enabled: boolean };
            braking: { __typename?: 'SensibilityConfiguration'; enabled: boolean };
            cornering: { __typename?: 'SensibilityConfiguration'; enabled: boolean };
            impact?: { __typename?: 'SensibilityConfiguration'; enabled: boolean } | null;
          };
          medium: {
            __typename?: 'HarshEvents';
            acceleration: { __typename?: 'SensibilityConfiguration'; enabled: boolean };
            braking: { __typename?: 'SensibilityConfiguration'; enabled: boolean };
            cornering: { __typename?: 'SensibilityConfiguration'; enabled: boolean };
            impact?: { __typename?: 'SensibilityConfiguration'; enabled: boolean } | null;
          };
          heavy: {
            __typename?: 'HarshEvents';
            acceleration: { __typename?: 'SensibilityConfiguration'; enabled: boolean };
            braking: { __typename?: 'SensibilityConfiguration'; enabled: boolean };
            cornering: { __typename?: 'SensibilityConfiguration'; enabled: boolean };
            impact?: { __typename?: 'SensibilityConfiguration'; enabled: boolean } | null;
          };
        };
      };
    } | null;
  } | null;
  safetyRankingParams: {
    __typename?: 'SafetyRankingParams';
    createdAt?: any | null;
    params: {
      __typename?: 'SafetyRankingParamsValues';
      distractedDriving?: number | null;
      yawn?: number | null;
      phoneUsage?: number | null;
      eyesClosed?: number | null;
      smoking?: number | null;
      tailgating?: number | null;
      fastAcceleration?: number | null;
      speedyTurn?: number | null;
      hardBreak?: number | null;
      roadSpeedLimit?: number | null;
      vehicleSpeedLimit?: number | null;
      minDistanceInKm?: number | null;
    };
    cameraCorrectionWeights: {
      __typename?: 'SafetyRankingParamsValues';
      distractedDriving?: number | null;
      yawn?: number | null;
      phoneUsage?: number | null;
      eyesClosed?: number | null;
      smoking?: number | null;
      tailgating?: number | null;
      fastAcceleration?: number | null;
      speedyTurn?: number | null;
      hardBreak?: number | null;
      roadSpeedLimit?: number | null;
      vehicleSpeedLimit?: number | null;
    };
    telemetryCorrectionWeights: {
      __typename?: 'SafetyRankingParamsValues';
      distractedDriving?: number | null;
      yawn?: number | null;
      phoneUsage?: number | null;
      eyesClosed?: number | null;
      smoking?: number | null;
      tailgating?: number | null;
      fastAcceleration?: number | null;
      speedyTurn?: number | null;
      hardBreak?: number | null;
      roadSpeedLimit?: number | null;
      vehicleSpeedLimit?: number | null;
    };
    user?: { __typename?: 'FleetUser'; full_name?: string | null } | null;
  };
};

export type DefaultSafetyRankingParamsQueryVariables = Exact<{
  input: SafetyRankingParamsInput;
}>;

export type DefaultSafetyRankingParamsQuery = {
  __typename?: 'Query';
  safetyRankingParams: {
    __typename?: 'SafetyRankingParams';
    params: {
      __typename?: 'SafetyRankingParamsValues';
      distractedDriving?: number | null;
      yawn?: number | null;
      phoneUsage?: number | null;
      eyesClosed?: number | null;
      smoking?: number | null;
      tailgating?: number | null;
      fastAcceleration?: number | null;
      speedyTurn?: number | null;
      hardBreak?: number | null;
      roadSpeedLimit?: number | null;
      vehicleSpeedLimit?: number | null;
      minDistanceInKm?: number | null;
      ignoreDismissedEvents?: boolean | null;
    };
  };
};

export type NextMonthSafetyRankingParamsQueryVariables = Exact<{
  input: SafetyRankingParamsInput;
}>;

export type NextMonthSafetyRankingParamsQuery = {
  __typename?: 'Query';
  safetyRankingParams: {
    __typename?: 'SafetyRankingParams';
    createdAt?: any | null;
    params: {
      __typename?: 'SafetyRankingParamsValues';
      distractedDriving?: number | null;
      yawn?: number | null;
      phoneUsage?: number | null;
      eyesClosed?: number | null;
      smoking?: number | null;
      tailgating?: number | null;
      fastAcceleration?: number | null;
      speedyTurn?: number | null;
      hardBreak?: number | null;
      roadSpeedLimit?: number | null;
      vehicleSpeedLimit?: number | null;
      minDistanceInKm?: number | null;
      ignoreDismissedEvents?: boolean | null;
    };
    user?: { __typename?: 'FleetUser'; full_name?: string | null } | null;
  };
};

export type GetHomeSpeedSummaryQueryVariables = Exact<{
  begin: Scalars['Float']['input'];
  end: Scalars['Float']['input'];
  tz: Scalars['String']['input'];
  intervalInDays: Scalars['Int']['input'];
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type GetHomeSpeedSummaryQuery = {
  __typename?: 'Query';
  homeSpeedSummary?: {
    __typename?: 'HomeSpeedSummary';
    roadEvents: { __typename?: 'AggregatedSpeedEventsSummary'; mediumEvents: number; highEvents: number; higherEvents: number; totalEvents: number };
    vehicleEvents: { __typename?: 'AggregatedSpeedEventsSummary'; mediumEvents: number; highEvents: number; higherEvents: number; totalEvents: number };
  } | null;
};

export type ExpensesQueryVariables = Exact<{
  input: ExpensesListInput;
}>;

export type ExpensesQuery = {
  __typename?: 'Query';
  expenses: {
    __typename?: 'ExpensePaginatedResponse';
    number: number;
    size: number;
    totalElements: number;
    totalPages: number;
    content: Array<{
      __typename?: 'Expense';
      id: string;
      occurredAt: any;
      type: string;
      totalCost: number;
      observation?: string | null;
      source?: string | null;
      createdAt: any;
      createdBy: string;
      updatedAt?: any | null;
      updatedBy?: string | null;
      deletedAt?: any | null;
      deletedBy?: string | null;
      vehicle: {
        __typename?: 'ExpenseVehicle';
        id: string;
        licensePlate?: string | null;
        groupPath?: string | null;
        groupName?: string | null;
        tagNames: Array<string>;
        model?: string | null;
        brand?: string | null;
        size?: string | null;
        alias?: string | null;
      };
      category: { __typename?: 'Category'; id: string; name: string };
      supplier?: { __typename?: 'Supplier'; id: string; name: string } | null;
    }>;
  };
};

export type CategoriesQueryVariables = Exact<{ [key: string]: never }>;

export type CategoriesQuery = { __typename?: 'Query'; categories?: Array<{ __typename?: 'Category'; id: string; name: string } | null> | null };

export type SuppliersQueryVariables = Exact<{ [key: string]: never }>;

export type SuppliersQuery = { __typename?: 'Query'; suppliers?: Array<{ __typename?: 'Supplier'; id: string; name: string } | null> | null };

export type VehicleExpensesQueryVariables = Exact<{
  input: VehiclesExpensesInput;
}>;

export type VehicleExpensesQuery = {
  __typename?: 'Query';
  vehicleExpenses: {
    __typename?: 'VehicleExpensesPaginatedResponse';
    empty: boolean;
    first: boolean;
    last: boolean;
    number: number;
    numberOfElements: number;
    size: number;
    totalElements: number;
    totalPages: number;
    content: Array<{
      __typename?: 'VehicleExpense';
      costPerKm: number;
      previousPeriodCostPerKm: number;
      previousPeriodTotalCost: number;
      distanceDrivenInKm: number;
      totalCost: number;
      categoryCosts: Array<{ __typename?: 'CategoryCost'; cost: number; id: string; name: string }>;
      vehicle: {
        __typename?: 'ExpenseVehicle';
        id: string;
        licensePlate?: string | null;
        size?: string | null;
        groupPath?: string | null;
        groupName?: string | null;
        tagNames: Array<string>;
        model?: string | null;
        brand?: string | null;
        alias?: string | null;
      };
    }>;
  };
};

export type ValidateExpensesImportQueryVariables = Exact<{
  input: ValidateExpensesImportInput;
}>;

export type ValidateExpensesImportQuery = {
  __typename?: 'Query';
  validateExpensesImport: {
    __typename?: 'ValidateExpensesImportResponse';
    validRows: Array<{
      __typename?: 'ValidateExpensesValidRowsResponse';
      occurredAt: string;
      vehicleId: string;
      groupPath?: string | null;
      categoryId: string;
      type: string;
      totalCost: number;
      supplierName?: string | null;
      observation?: string | null;
    }>;
    invalidRows: Array<{
      __typename?: 'ValidateExpensesInvalidRowsResponse';
      data: {
        __typename?: 'ValidateExpensesImportItem';
        occurredAt: string;
        licensePlate: string;
        categoryName: string;
        type: string;
        totalCost: string;
        supplierName?: string | null;
        observation?: string | null;
        rowIndex: number;
      };
      errors: Array<{ __typename?: 'ValidationError'; error: string; column: { __typename?: 'ImportColumnMap'; name: string; position: string } }>;
    }>;
  };
};

export type ImportExpensesBatchMutationVariables = Exact<{
  input: Array<ImportExpensesBatchInput> | ImportExpensesBatchInput;
}>;

export type ImportExpensesBatchMutation = { __typename?: 'Mutation'; importExpenses: { __typename?: 'ImportBatchResponse'; count: any } };

export type TrainingVideosQueryVariables = Exact<{ [key: string]: never }>;

export type TrainingVideosQuery = {
  __typename?: 'Query';
  trainingVideos?: Array<{
    __typename?: 'TrainingVideo';
    id?: string | null;
    categoryId?: string | null;
    url?: string | null;
    thumbnail?: string | null;
    name?: string | null;
    description?: string | null;
  } | null> | null;
};

export type TrainingVideosByCategoryQueryVariables = Exact<{ [key: string]: never }>;

export type TrainingVideosByCategoryQuery = {
  __typename?: 'Query';
  trainingVideosByCategory?: Array<{
    __typename?: 'TrainingVideos';
    category?: { __typename?: 'TrainingVideoCategory'; name?: string | null; title?: string | null; subtitle?: string | null } | null;
    trainingVideos?: Array<{
      __typename?: 'TrainingVideo';
      id?: string | null;
      categoryId?: string | null;
      url?: string | null;
      thumbnail?: string | null;
      name?: string | null;
      description?: string | null;
    } | null> | null;
  } | null> | null;
};

export type UserTrainingMediaQueryVariables = Exact<{ [key: string]: never }>;

export type UserTrainingMediaQuery = {
  __typename?: 'Query';
  userTrainingMedia?: Array<{
    __typename?: 'UserTrainingMedia';
    userId?: string | null;
    trainingMediaId?: string | null;
    startedAt?: any | null;
    finishedAt?: any | null;
    createdAt?: any | null;
  } | null> | null;
};

export type UpdateUserTrainingMediaMutationVariables = Exact<{
  input: UpdateUserTrainingMediaInput;
}>;

export type UpdateUserTrainingMediaMutation = {
  __typename?: 'Mutation';
  updateUserTrainingMedia?: {
    __typename?: 'UserTrainingMedia';
    createdAt?: any | null;
    finishedAt?: any | null;
    startedAt?: any | null;
    trainingMediaId?: string | null;
    userId?: string | null;
  } | null;
};

export type GetUserDataQueryVariables = Exact<{
  input?: InputMaybe<UserInput>;
}>;

export type GetUserDataQuery = {
  __typename?: 'Query';
  hasCameraFlag?: boolean | null;
  hasRedeCan?: boolean | null;
  userPreferences?: {
    __typename?: 'UserPreferences';
    id?: string | null;
    fleet_id?: string | null;
    user_id?: string | null;
    vehicle_group_ids?: Array<string | null> | null;
    use_vehicles_cluster?: boolean | null;
    updated_at?: any | null;
    created_at?: any | null;
  } | null;
  userAttributes?: { __typename?: 'UserAttributes'; creation_date?: string | null; num_devices?: number | null } | null;
  userFleets?: Array<{
    __typename?: 'UserFleets';
    id?: string | null;
    name?: string | null;
    active?: boolean | null;
    managers?: Array<string | null> | null;
    user_id?: string | null;
    fleet_id?: string | null;
    role?: string | null;
    groups_restriction?: Array<string | null> | null;
    associated_at?: string | null;
    granted_permissions: Array<string>;
    has_no_valid_groups: boolean;
    has_only_groups_with_no_vehicles: boolean;
  } | null> | null;
};

export type VehicleDeviceAssociationReportByDeviceQueryVariables = Exact<{
  input: VehicleDeviceAssociationInfoInput;
}>;

export type VehicleDeviceAssociationReportByDeviceQuery = {
  __typename?: 'Query';
  vehicleDeviceAssociationReportByDevice: {
    __typename?: 'VehicleDeviceAssociationInfoResponse';
    count?: number | null;
    associations: Array<{
      __typename?: 'VehicleDeviceAssociationInfo';
      fleetId?: string | null;
      event?: string | null;
      eventDate?: string | null;
      duration?: number | null;
      target?: string | null;
      userEmail?: string | null;
      device?: { __typename?: 'Device'; id: string; cobliId: string } | null;
      vehicle?: {
        __typename?: 'VehicleDTO';
        id: string;
        licensePlate?: string | null;
        tags?: Array<{ __typename?: 'VehicleTag'; name: string }> | null;
        groups: Array<{ __typename?: 'VehicleGroupDTO'; id: string; name: string }>;
        operationalSituation?: {
          __typename?: 'OperationalSituation';
          id: string;
          targetType: OperationalSituationTargetType;
          targetId: string;
          situation: OperationalSituationType;
          startsAt: any;
          endsAt?: any | null;
          reason?: string | null;
          active: boolean;
        } | null;
      } | null;
    }>;
  };
};

export type VehicleDeviceAssociationReportByVehicleQueryVariables = Exact<{
  input: VehicleDeviceAssociationInfoInput;
}>;

export type VehicleDeviceAssociationReportByVehicleQuery = {
  __typename?: 'Query';
  vehicleDeviceAssociationReportByVehicle: {
    __typename?: 'VehicleDeviceAssociationInfoResponse';
    count?: number | null;
    associations: Array<{
      __typename?: 'VehicleDeviceAssociationInfo';
      fleetId?: string | null;
      event?: string | null;
      eventDate?: string | null;
      duration?: number | null;
      target?: string | null;
      userEmail?: string | null;
      device?: { __typename?: 'Device'; id: string; cobliId: string } | null;
      vehicle?: {
        __typename?: 'VehicleDTO';
        id: string;
        licensePlate?: string | null;
        tags?: Array<{ __typename?: 'VehicleTag'; name: string }> | null;
        groups: Array<{ __typename?: 'VehicleGroupDTO'; id: string; name: string }>;
        operationalSituation?: {
          __typename?: 'OperationalSituation';
          id: string;
          targetType: OperationalSituationTargetType;
          targetId: string;
          situation: OperationalSituationType;
          startsAt: any;
          endsAt?: any | null;
          reason?: string | null;
          active: boolean;
        } | null;
      } | null;
    }>;
  };
};

export type VehicleGroupsQueryVariables = Exact<{
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type VehicleGroupsQuery = {
  __typename?: 'Query';
  vehicleGroups?: Array<{
    __typename?: 'VehiclesGroup';
    id: string;
    name: string;
    createdAt: any;
    updatedAt: any;
    creatorId: string;
    path: string;
    vehicles: Array<{ __typename?: 'VehicleDTO'; id: string }>;
  } | null> | null;
};

export type VehicleGroupIdsQueryVariables = Exact<{ [key: string]: never }>;

export type VehicleGroupIdsQuery = { __typename?: 'Query'; vehicleGroups?: Array<{ __typename?: 'VehiclesGroup'; id: string } | null> | null };

export type VehicleGroupsWithPathQueryVariables = Exact<{ [key: string]: never }>;

export type VehicleGroupsWithPathQuery = { __typename?: 'Query'; vehicleGroups?: Array<{ __typename?: 'VehiclesGroup'; id: string; name: string; path: string } | null> | null };

export type VehicleGroupsWithUsersQueryVariables = Exact<{
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type VehicleGroupsWithUsersQuery = {
  __typename?: 'Query';
  vehicleGroups?: Array<{
    __typename?: 'VehiclesGroup';
    id: string;
    name: string;
    createdAt: any;
    updatedAt: any;
    creatorId: string;
    vehicles: Array<{ __typename?: 'VehicleDTO'; id: string }>;
    users: Array<{ __typename?: 'FleetUser'; id?: string | null; groups_restriction?: Array<string | null> | null } | null>;
  } | null> | null;
};

export type CreateVehiclesGroupMutationVariables = Exact<{
  input: VehiclesGroupInput;
}>;

export type CreateVehiclesGroupMutation = {
  __typename?: 'Mutation';
  createVehiclesGroup?: {
    __typename?: 'VehiclesGroup';
    id: string;
    name: string;
    fleetId: string;
    createdAt: any;
    updatedAt: any;
    creatorId: string;
    vehicles: Array<{ __typename?: 'VehicleDTO'; id: string }>;
  } | null;
};

export type UpdateVehiclesGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: VehiclesGroupInput;
}>;

export type UpdateVehiclesGroupMutation = {
  __typename?: 'Mutation';
  updateVehiclesGroup?: {
    __typename?: 'VehiclesGroup';
    id: string;
    name: string;
    fleetId: string;
    createdAt: any;
    updatedAt: any;
    creatorId: string;
    vehicles: Array<{ __typename?: 'VehicleDTO'; id: string }>;
  } | null;
};

export type VehicleModelsQueryVariables = Exact<{ [key: string]: never }>;

export type VehicleModelsQuery = {
  __typename?: 'Query';
  vehicleModels: Array<{ __typename?: 'Branding'; brand?: string | null; model?: string | null; year?: number | null; type?: string | null }>;
};

export type VehicleTagsQueryVariables = Exact<{ [key: string]: never }>;

export type VehicleTagsQuery = { __typename?: 'Query'; vehicleTags?: Array<{ __typename?: 'VehicleTag'; name: string }> | null };

export type DeleteVehicleTagMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteVehicleTagMutation = { __typename?: 'Mutation'; deleteVehicleTag: string };

export type GetFleetProductTypeForWebhooksQueryVariables = Exact<{ [key: string]: never }>;

export type GetFleetProductTypeForWebhooksQuery = { __typename?: 'Query'; safetyRankingProductType: { __typename?: 'SafetyRankingProductType'; productType: string } };

export const TrackingFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Tracking' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DeviceTracking' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'destination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lng' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tempGeofenceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conclusionTime' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TrackingFragment, unknown>;
export const LastLocationFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LastLocation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'LastLocation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'cobliIngestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeInMillis' } },
          { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
          { kind: 'Field', name: { kind: 'Name', value: 'speed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPlugged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ignitionOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pluggedUpdateTimestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idleOnDurationInMillis' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idleOffDurationInMillis' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LastLocationFragment, unknown>;
export const VehicleFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Vehicle' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'VehicleDTO' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'model' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSuggestion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'driver' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumbers' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstLicenseAcquirementDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'licenseExpirationDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'licenseCategory' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operationalSituation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'situation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startsAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endsAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VehicleFragment, unknown>;
export const DeviceActiveObservationPeriodTriggerFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DeviceActiveObservationPeriodTrigger' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Trigger' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }] },
    },
  ],
} as unknown as DocumentNode<DeviceActiveObservationPeriodTriggerFragment, unknown>;
export const DeviceFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Device' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Device' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cobliId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'generalType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'capabilities' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reportsVehicleCan' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reportsVideo' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'healthStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'generalStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isNew' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSpare' } },
          { kind: 'Field', name: { kind: 'Name', value: 'associatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sdCardHealthStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'statusSummary' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'causes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cause' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disablerStatus' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'includeDisablerStatus' } } }],
              },
            ],
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMovingStateTime' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'includeLastMovingStateTime' } } }],
              },
            ],
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'includeTracking' } } }],
              },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Tracking' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastLocation' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'includeLastLocation' } } }],
              },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LastLocation' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicle' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'includeVehicle' } } }],
              },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Vehicle' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activeObservationPeriodTrigger' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  { kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'includeObservationPeriodTrigger' } } },
                ],
              },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DeviceActiveObservationPeriodTrigger' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Tracking' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DeviceTracking' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'destination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lng' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tempGeofenceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conclusionTime' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LastLocation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'LastLocation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'cobliIngestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeInMillis' } },
          { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
          { kind: 'Field', name: { kind: 'Name', value: 'speed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPlugged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ignitionOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pluggedUpdateTimestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idleOnDurationInMillis' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idleOffDurationInMillis' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Vehicle' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'VehicleDTO' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'model' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSuggestion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'driver' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumbers' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstLicenseAcquirementDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'licenseExpirationDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'licenseCategory' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operationalSituation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'situation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startsAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endsAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DeviceActiveObservationPeriodTrigger' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Trigger' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }] },
    },
  ],
} as unknown as DocumentNode<DeviceFragment, unknown>;
export const BilletFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BilletFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Billet' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idDoc' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idCompany' } },
          { kind: 'Field', name: { kind: 'Name', value: 'boletoLink' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dataEmissao' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dataVencimento' } },
          { kind: 'Field', name: { kind: 'Name', value: 'barCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'digitableLine' } },
          { kind: 'Field', name: { kind: 'Name', value: 'titleValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nrDocumento' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nrNfse' } },
          { kind: 'Field', name: { kind: 'Name', value: 'validFrom' } },
          { kind: 'Field', name: { kind: 'Name', value: 'validTo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'runnedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seqCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nrDocEntry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nrNoteEntry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cardCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cardName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'datePayment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idContract' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payedValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'diaProRata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nfeLink' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nfeDataEmissao' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nfeHoraEmissao' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nfeTitleValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nfeIdContract' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BilletFieldsFragment, unknown>;
export const GetInviteInfoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getInviteInfo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'inviteInfo' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'token' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'token' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'invite' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'occupations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetInviteInfoQuery, GetInviteInfoQueryVariables>;
export const AcceptInviteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'acceptInvite' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'IInviteAcceptForm' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'acceptInvite' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'token' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'token' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AcceptInviteMutation, AcceptInviteMutationVariables>;
export const GetPendingInvitesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getPendingInvites' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pendingInvites' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'creationDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'creatorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'groupsRestriction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customPermissions' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'groups' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'path' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPendingInvitesQuery, GetPendingInvitesQueryVariables>;
export const SendInvitesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'sendInvites' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'InviteForm' } } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendInvites' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'invites' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'invites' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'email_address' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendInvitesMutation, SendInvitesMutationVariables>;
export const DeleteInviteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteInvite' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteInvite' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'token' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'token' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteInviteMutation, DeleteInviteMutationVariables>;
export const SafetyReviewHistoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'safetyReviewHistory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mediaId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'size' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'safetyReviewHistory' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'mediaId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'mediaId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'page' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'size' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'size' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'sort' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total_elements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'first' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last' } },
                { kind: 'Field', name: { kind: 'Name', value: 'empty' } },
                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'number_of_elements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total_pages' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'user_id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'full_name' } }] },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'snapshot' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'driver_id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'driver' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }] },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'occurrences' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dismiss_reason' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SafetyReviewHistoryQuery, SafetyReviewHistoryQueryVariables>;
export const GetCameraAssociationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCameraAssociation' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'association' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'association_config' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entire_fleet_association_config' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'is_on' } }] },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'fleet_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_updated_by' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCameraAssociationQuery, GetCameraAssociationQueryVariables>;
export const UpdateCameraAssociationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateCameraAssociation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'AssociationConfigInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAssociation' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCameraAssociationMutation, UpdateCameraAssociationMutationVariables>;
export const GetAudioDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getAudio' },
      variableDefinitions: [
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'size' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audio' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'page' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'size' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'size' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'sort' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'audio_status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'device_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'empty' } },
                { kind: 'Field', name: { kind: 'Name', value: 'first' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last' } },
                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'number_of_elements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total_elements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total_pages' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAudioQuery, GetAudioQueryVariables>;
export const UpdateAudioDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateAudio' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateAudioRequest' } } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAudio' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateAudioMutation, UpdateAudioMutationVariables>;
export const GetCameraConfigurationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCameraConfiguration' },
      variableDefinitions: [
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'size' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cameraConfiguration' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'page' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'size' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'size' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'sort' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'audio_status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'device_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duty_type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'speed_limit_warning_in_kmph' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'empty' } },
                { kind: 'Field', name: { kind: 'Name', value: 'first' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last' } },
                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'number_of_elements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total_elements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total_pages' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCameraConfigurationQuery, GetCameraConfigurationQueryVariables>;
export const GetFleetCameraConfigurationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getFleetCameraConfiguration' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fleetEventsConfiguration' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updated_by_name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'camera_events_config' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entire_fleet_camera_events_configuration' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'dms_events' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'min_speed_trigger_in_km_per_h' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'distracted_driving' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'sensibility' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'yawn' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'sensibility' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'phone_usage' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'sensibility' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'eyes_closed' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'sensibility' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'smoking' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'sensibility' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'no_driver_detected' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'sensibility' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'occupancy' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'sensibility' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'occupancy_people_limit' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'seat_belt' },
                                    selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }] },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'adas_events' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'min_speed_trigger_in_km_per_h' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'forward_collision_warning' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'sensibility' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'tail_gating' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'sensibility' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'harsh_events' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'light' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'acceleration' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'sensibility' } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'braking' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'sensibility' } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'cornering' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'sensibility' } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'impact' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'sensibility' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'medium' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'acceleration' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'sensibility' } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'braking' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'sensibility' } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'cornering' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'sensibility' } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'impact' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'sensibility' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'heavy' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'acceleration' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'sensibility' } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'braking' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'sensibility' } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'cornering' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'sensibility' } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'impact' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'sensibility' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'ignition_off_record_settings' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'face_identification_audio_alert_enabled' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'idle_speed' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'threshold_seconds' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetFleetCameraConfigurationQuery, GetFleetCameraConfigurationQueryVariables>;
export const QueryGetFleetWifiSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'queryGetFleetWifiSettings' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wifiSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'access_points' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ssid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'created_by' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QueryGetFleetWifiSettingsQuery, QueryGetFleetWifiSettingsQueryVariables>;
export const UpdateFleetEventsConfigurationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateFleetEventsConfiguration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateEventsConfigurationInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateFleetEventsConfiguration' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateFleetEventsConfigurationMutation, UpdateFleetEventsConfigurationMutationVariables>;
export const UpdateCameraConfigurationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateCameraConfiguration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CameraConfigurationUpdateInput' } } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changeCameraConfiguration' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCameraConfigurationMutation, UpdateCameraConfigurationMutationVariables>;
export const UpdateSpeedLimitConfigurationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateSpeedLimitConfiguration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SpeedLimitUpdateInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSpeedLimitConfiguration' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateSpeedLimitConfigurationMutation, UpdateSpeedLimitConfigurationMutationVariables>;
export const AssignFaceClusterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'assignFaceCluster' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DriverFaceClusterUpdate' } } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignFaceCluster' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssignFaceClusterMutation, AssignFaceClusterMutationVariables>;
export const RejectClusterSuggestionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'rejectClusterSuggestion' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clusterId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rejectClusterSuggestion' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'clusterId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'clusterId' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RejectClusterSuggestionMutation, RejectClusterSuggestionMutationVariables>;
export const GetDriverFaceClusterInfoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getDriverFaceClusterInfo' },
      variableDefinitions: [
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'size' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'driverIds' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'hasBeenNominated' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'withoutSampleImageUrls' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'vehicleIds' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fromTimestamp' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'toTimestamp' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'samplesPerCluster' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'driverFaceClustersInfo' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'page' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'size' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'size' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'sort' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'driverIds' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'driverIds' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'hasBeenNominated' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'hasBeenNominated' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'withoutSampleImageUrls' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'withoutSampleImageUrls' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'vehicleIds' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'vehicleIds' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'fromTimestamp' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fromTimestamp' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'toTimestamp' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'toTimestamp' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'samplesPerCluster' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'samplesPerCluster' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'driver' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fleet_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'assigned' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'phone_number' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'first_license_acquirement_date' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'license_expiration_date' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'license_category' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'driver_code' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'score' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'score' } }] },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'suggested_driver' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fleet_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'driver_code' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'profile_image_url' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'image_url' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sample_image_urls' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'image_url' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sample_images' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'image_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'image_url' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'captured_at' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'vehicle' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'groups' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'sample_image_url_count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'suggestion_source' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rejected_at' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'empty' } },
                { kind: 'Field', name: { kind: 'Name', value: 'first' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last' } },
                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'number_of_elements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total_elements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total_pages' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDriverFaceClusterInfoQuery, GetDriverFaceClusterInfoQueryVariables>;
export const GetCameraFlagDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCameraFlag' },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hasCameraFlag' } }] },
    },
  ],
} as unknown as DocumentNode<GetCameraFlagQuery, GetCameraFlagQueryVariables>;
export const GetFleetProductsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getFleetProducts' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fleetProducts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'products' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetFleetProductsQuery, GetFleetProductsQueryVariables>;
export const GetTripImagePageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getTripImagePage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fromTimestamp' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'TimestampInMillis' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'toTimestamp' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'TimestampInMillis' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'identificationMethod' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentificationMethod' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'driverVisibilities' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DriverVisibility' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'vehicleIds' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'driverIds' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isObstructed' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'size' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tripImage' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'fromTimestamp' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fromTimestamp' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'toTimestamp' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'toTimestamp' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'identificationMethod' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'identificationMethod' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'driverVisibilities' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'driverVisibilities' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'vehicleIds' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'vehicleIds' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'driverIds' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'driverIds' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'isObstructed' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'isObstructed' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'page' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'size' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'size' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'sort' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'start_timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end_timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'identification_method' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'driver_visibility' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nominated_at' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nominated_by' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recognized_driver' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'trip_id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'trip_image_sample' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'image_url' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'is_obstructed' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'trip_images' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'image_url' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'is_obstructed' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user_nominated_driver' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vehicle' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'groups' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'empty' } },
                { kind: 'Field', name: { kind: 'Name', value: 'first' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last' } },
                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'number_of_elements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTripImagePageQuery, GetTripImagePageQueryVariables>;
export const GetTripImagesDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getTripImagesDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tripId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tripImagesDetails' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'tripId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'tripId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'start_timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end_timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'identification_method' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nominated_at' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nominated_by' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recognized_driver' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'trip_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'trip_image_sample' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image_url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'is_obstructed' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'trip_images' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'image_url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'is_obstructed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'obstruction_feedback' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user_nominated_driver' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vehicle' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'groups' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTripImagesDetailsQuery, GetTripImagesDetailsQueryVariables>;
export const GetVehicleTimestampImagesDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getVehicleTimestampImagesDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'vehicleId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'imageTimestamp' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'imagesBefore' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleTimestampImagesDetails' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'vehicle_id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'vehicleId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'image_timestamp' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'imageTimestamp' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'images_before' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'imagesBefore' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'vehicle_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'images' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image_url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'obstruction_feedback' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'is_obstructed' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vehicle' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'groups' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetVehicleTimestampImagesDetailsQuery, GetVehicleTimestampImagesDetailsQueryVariables>;
export const DriverNominateTripImageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'driverNominateTripImage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DriverNominateTripImageInput' } } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'driverNominateTripImage' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DriverNominateTripImageMutation, DriverNominateTripImageMutationVariables>;
export const SendTripImageObstructionFeedbackDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'sendTripImageObstructionFeedback' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SendImageObstructionFeedback' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendTripImageObstructionFeedback' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendTripImageObstructionFeedbackMutation, SendTripImageObstructionFeedbackMutationVariables>;
export const GetTripPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getTripPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'vehicleId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fromTimestamp' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'TimestampInMillis' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'toTimestamp' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'TimestampInMillis' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'footageAvailabilityStatus' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'size' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tripsByVehicle' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'vehicleId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'vehicleId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'fromTimestamp' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fromTimestamp' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'toTimestamp' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'toTimestamp' } } },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'footageAvailabilityStatus' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'footageAvailabilityStatus' } },
              },
              { kind: 'Argument', name: { kind: 'Name', value: 'page' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'size' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'size' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'sort' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'start_timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end_timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'is_footage_available' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasImages' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'empty' } },
                { kind: 'Field', name: { kind: 'Name', value: 'first' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last' } },
                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'number_of_elements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total_elements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total_pages' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTripPageQuery, GetTripPageQueryVariables>;
export const DriversCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'driversCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupIds' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'driversCount' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'groupIds' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'groupIds' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DriversCountQuery, DriversCountQueryVariables>;
export const DriversWithCompleteFaceIdRegistrationCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'driversWithCompleteFaceIdRegistrationCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupIds' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'driversWithCompleteFaceIdRegistrationCount' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'groupIds' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'groupIds' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DriversWithCompleteFaceIdRegistrationCountQuery, DriversWithCompleteFaceIdRegistrationCountQueryVariables>;
export const UnnamedFaceClustersCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'unnamedFaceClustersCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupIds' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unnamedFaceClustersCount' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'groupIds' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'groupIds' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UnnamedFaceClustersCountQuery, UnnamedFaceClustersCountQueryVariables>;
export const HasFaceIdIdentificationHistoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'hasFaceIdIdentificationHistory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupIds' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasFaceIdIdentificationHistory' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'groupIds' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'groupIds' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HasFaceIdIdentificationHistoryQuery, HasFaceIdIdentificationHistoryQueryVariables>;
export const VehiclesRunningWithoutDriverCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'vehiclesRunningWithoutDriverCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupIds' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'timezone' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehiclesRunningWithoutDriverCount' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'groupIds' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'groupIds' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'timezone' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'timezone' } } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VehiclesRunningWithoutDriverCountQuery, VehiclesRunningWithoutDriverCountQueryVariables>;
export const FaceIdCoverageChartDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'faceIdCoverageChart' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fromTimestamp' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'toTimestamp' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'timezone' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupIds' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faceIdCoverageChart' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'fromTimestamp' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fromTimestamp' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'toTimestamp' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'toTimestamp' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'timezone' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'timezone' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'groupIds' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'groupIds' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'fromTimestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'toTimestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'validEventsTotal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'identifiedEventsTotal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'averageCoveragePercentage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'bucketStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'validEvents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'identifiedEvents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'coveragePercentage' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FaceIdCoverageChartQuery, FaceIdCoverageChartQueryVariables>;
export const FleetIdentificationHealthDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fleetIdentificationHealth' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fleetIdentificationHealth' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'complete_registration_rate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'identified_events_rate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'calculated_at' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FleetIdentificationHealthQuery, FleetIdentificationHealthQueryVariables>;
export const DriverFaceIdRegistrationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'driverFaceIdRegistrations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'driverIds' } },
          type: { kind: 'NonNullType', type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'driverFaceIdRegistrations' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'driverIds' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'driverIds' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'driverId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sampleImageCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastSampleImageAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DriverFaceIdRegistrationsQuery, DriverFaceIdRegistrationsQueryVariables>;
export const GetFaceImageGeolocationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getFaceImageGeolocation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'imageId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faceImageGeolocation' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'imageId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'imageId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetFaceImageGeolocationQuery, GetFaceImageGeolocationQueryVariables>;
export const CreateFleetAudioMessageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createFleetAudioMessage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateFleetAudioMessageInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createFleetAudioMessage' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mp3Url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'createdBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateFleetAudioMessageMutation, CreateFleetAudioMessageMutationVariables>;
export const PlayFleetAudioMessageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'playFleetAudioMessage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'audioMessageId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'PlayFleetAudioMessageInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'playFleetAudioMessage' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'audioMessageId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'audioMessageId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'audioMessageId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vehicle' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'device' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'driver' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'retryCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'playedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'createdBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PlayFleetAudioMessageMutation, PlayFleetAudioMessageMutationVariables>;
export const GetFleetAudioMessagePlaybacksDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getFleetAudioMessagePlaybacks' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'vehicleId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'size' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fleetAudioMessagePlaybacks' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'vehicleId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'vehicleId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'page' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'size' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'size' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'audioMessageId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vehicle' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'device' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'driver' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'retryCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'playedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'cancelIfTimeout' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'first' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last' } },
                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'numberOfElements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalElements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetFleetAudioMessagePlaybacksQuery, GetFleetAudioMessagePlaybacksQueryVariables>;
export const RetryFleetAudioMessagePlaybackDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'retryFleetAudioMessagePlayback' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'audioMessageId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'playbackId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'retryFleetAudioMessagePlayback' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'audioMessageId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'audioMessageId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'playbackId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'playbackId' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'audioMessageId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vehicle' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'device' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'driver' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'retryCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'playedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'createdBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'cancelIfTimeout' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RetryFleetAudioMessagePlaybackMutation, RetryFleetAudioMessagePlaybackMutationVariables>;
export const DeleteFleetAudioMessagePlaybackDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteFleetAudioMessagePlayback' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'audioMessageId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'playbackId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteFleetAudioMessagePlayback' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'audioMessageId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'audioMessageId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'playbackId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'playbackId' } } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteFleetAudioMessagePlaybackMutation, DeleteFleetAudioMessagePlaybackMutationVariables>;
export const GetAudioFileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getAudioFile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'playbackId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAudioFile' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'playbackId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'playbackId' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'audioUrl' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAudioFileQuery, GetAudioFileQueryVariables>;
export const VideoDeliveryTimeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'videoDeliveryTime' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoDeliveryTime' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'devices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sampleSize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'p50Ms' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fleet' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sampleSize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'p50Ms' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'p90SampleSize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'p90Ms' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VideoDeliveryTimeQuery, VideoDeliveryTimeQueryVariables>;
export const CompletionDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'completionData' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completionData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'vehicleInstalledCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fleetSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openTicketsToInstall' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompletionDataQuery, CompletionDataQueryVariables>;
export const UpcomingTicketsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'upcomingTickets' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'upcomingTickets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'daysWithoutMovement' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasUpsell' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextBatchScheduledAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tickets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'associatedDealId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deviceTotalQuantity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'installed' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Scheduling' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'scheduledDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'installedDate' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Shipping' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'shippingDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'estimatedTimeOfArrival' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Return' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'deadline' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'postingDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'scheduleDate' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpcomingTicketsQuery, UpcomingTicketsQueryVariables>;
export const UpdateContactTrainingInfoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateContactTrainingInfo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateContactTrainingInfoInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateContactTraining' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateContactTrainingInfoMutation, UpdateContactTrainingInfoMutationVariables>;
export const OrdersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Orders' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orders' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orderClass' } },
                { kind: 'Field', name: { kind: 'Name', value: 'details' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tickets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Scheduling' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pipeline' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'addressInformation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'additionalInformation' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'clientInformation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'document' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'secondaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'responsibleForTrackingScheduling' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'installationDoneByClient' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'installationProblem' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'additionalInformation' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'coblerInformation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'responsible' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'schedulingResponsible' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'contactResponsible' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'technicianResponsible' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'contactInformation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'contactMethod' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'contactMethodForResponsibleForInstallation' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bestContactTime' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bestWayToContact' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'dateInformation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'scheduledDay' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'scheduledHour' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'installedDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'preferredDay1' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'preferredDay2' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'preferredDay3' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'preferredHour1' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'preferredHour2' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'preferredHour3' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fieldControlInformation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'fieldObservations' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'technicalTeamObservation' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'vehicleInformation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'licensePlates' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'models' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'schedulingSubCategory' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'scheduledDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'scheduledTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'installedDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'associatedDealId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'details' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceIds' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceCobliIds' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'deviceTotalQuantity' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'removable' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'installed' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'camera' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'immobilizer' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'identifiers' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'redeCan' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Return' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pipeline' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'addressInformation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'additionalInformation' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'clientInformation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'document' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'secondaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'responsibleForTrackingScheduling' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'installationDoneByClient' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'installationProblem' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'additionalInformation' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'coblerInformation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'responsible' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'schedulingResponsible' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'contactResponsible' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'technicianResponsible' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'contactInformation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'contactMethod' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'contactMethodForResponsibleForInstallation' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bestContactTime' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bestWayToContact' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'dateInformation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'scheduledDay' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'scheduledHour' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'installedDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'preferredDay1' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'preferredDay2' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'preferredDay3' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'preferredHour1' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'preferredHour2' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'preferredHour3' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fieldControlInformation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'fieldObservations' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'technicalTeamObservation' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'vehicleInformation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'licensePlates' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'models' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'associatedDealId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'details' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceIds' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceCobliIds' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'deviceTotalQuantity' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'removable' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'installed' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'camera' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'immobilizer' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'identifiers' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'redeCan' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'responsibleUser' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'clientCNPJ' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'postingDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'arrivalOfDevicesAtCobli' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'scheduleDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'shippingCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'returnType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'associatedDealId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'details' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceIds' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceCobliIds' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'closedDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deadline' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'penaltyPrice' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Shipping' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pipeline' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'contactName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'shippingDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'trackingCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'shippingCompany' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'shippingCompanyLink' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'estimatedTimeOfArrival' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'devicesWithInstallation' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'devicesWithoutInstallation' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'addressInformation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'additionalInformation' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'associatedDealId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'details' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceIds' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceCobliIds' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'deviceTotalQuantity' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'removable' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'installed' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'camera' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'immobilizer' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'identifiers' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'redeCan' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'associatedDealId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'details' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceCobliIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deviceTotalQuantity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'removable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'installed' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'camera' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'immobilizer' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'identifiers' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'redeCan' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'pipeline' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'deviceTotalQuantity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'removable' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'installed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'camera' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'immobilizer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'identifiers' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'redeCan' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'associatedContact' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrdersQuery, OrdersQueryVariables>;
export const QueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Query' },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'schedulingHolidays' } }] },
    },
  ],
} as unknown as DocumentNode<QueryQuery, QueryQueryVariables>;
export const CustomDashboardsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'customDashboards' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customDashboards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalDashboardId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fleets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'groupsRestrictions' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'filters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filterKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'filterName' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CustomDashboardsQuery, CustomDashboardsQueryVariables>;
export const CustomDashboardDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'customDashboard' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customDashboard' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalDashboardId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fleets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'groupsRestrictions' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'filters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filterName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'filterKey' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CustomDashboardQuery, CustomDashboardQueryVariables>;
export const DevicesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'devices' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeLastMovingStateTime' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeLastLocation' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeVehicle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeDisablerStatus' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeTracking' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeObservationPeriodTrigger' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupIds' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'devices' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'groupIds' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'groupIds' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Device' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Tracking' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DeviceTracking' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'destination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lng' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tempGeofenceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conclusionTime' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LastLocation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'LastLocation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'cobliIngestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeInMillis' } },
          { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
          { kind: 'Field', name: { kind: 'Name', value: 'speed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPlugged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ignitionOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pluggedUpdateTimestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idleOnDurationInMillis' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idleOffDurationInMillis' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Vehicle' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'VehicleDTO' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'model' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSuggestion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'driver' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumbers' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstLicenseAcquirementDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'licenseExpirationDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'licenseCategory' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operationalSituation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'situation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startsAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endsAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DeviceActiveObservationPeriodTrigger' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Trigger' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }] },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Device' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Device' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cobliId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'generalType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'capabilities' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reportsVehicleCan' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reportsVideo' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'healthStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'generalStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isNew' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSpare' } },
          { kind: 'Field', name: { kind: 'Name', value: 'associatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sdCardHealthStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'statusSummary' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'causes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cause' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disablerStatus' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'includeDisablerStatus' } } }],
              },
            ],
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMovingStateTime' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'includeLastMovingStateTime' } } }],
              },
            ],
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'includeTracking' } } }],
              },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Tracking' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastLocation' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'includeLastLocation' } } }],
              },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LastLocation' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicle' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'includeVehicle' } } }],
              },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Vehicle' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activeObservationPeriodTrigger' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  { kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'includeObservationPeriodTrigger' } } },
                ],
              },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DeviceActiveObservationPeriodTrigger' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DevicesQuery, DevicesQueryVariables>;
export const DeviceIdsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DeviceIds' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'devices' }, selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeviceIdsQuery, DeviceIdsQueryVariables>;
export const DevicesSpareStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DevicesSpareStatus' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'devices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSpare' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vehicle' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DevicesSpareStatusQuery, DevicesSpareStatusQueryVariables>;
export const LastDeviceAssociationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'lastDeviceAssociation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deviceId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAssociation' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'deviceId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'deviceId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'cobliId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'driver' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'driverId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'driverName' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastLocation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'time' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timeInMillis' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'speed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ignitionOn' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cobliIngestedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'processedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isPlugged' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pluggedUpdateTimestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'idleOnDurationInMillis' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'idleOffDurationInMillis' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vehicle' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'vehicleId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'model' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LastDeviceAssociationQuery, LastDeviceAssociationQueryVariables>;
export const AssignDriverToDeviceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AssignDriverToDevice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DriverAssignmentInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignDriverToDevice' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssignDriverToDeviceMutation, AssignDriverToDeviceMutationVariables>;
export const UpdateDeviceSpareStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateDeviceSpareStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateDeviceSpareStatusInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDeviceSpareStatus' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateDeviceSpareStatusMutation, UpdateDeviceSpareStatusMutationVariables>;
export const UpdateDevicesSpareStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateDevicesSpareStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateDeviceSpareStatusInput' } } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDevicesSpareStatus' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateDevicesSpareStatusMutation, UpdateDevicesSpareStatusMutationVariables>;
export const UnassignDriverToDeviceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UnassignDriverToDevice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DriverAssignmentInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unassignDriverToDevice' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UnassignDriverToDeviceMutation, UnassignDriverToDeviceMutationVariables>;
export const LastPathDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LastPath' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'LastPathInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastPath' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'event_time' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LastPathQuery, LastPathQueryVariables>;
export const DriversWithIdentifiersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DriversWithIdentifiers' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'drivers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fleet_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assigned' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone_number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'first_license_acquirement_date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'license_expiration_date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'license_category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'driver_code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'identification_token' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tokenId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isExternal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'driverId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'cpf' } },
                { kind: 'Field', name: { kind: 'Name', value: 'driver_license' } },
                { kind: 'Field', name: { kind: 'Name', value: 'registry_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'profile_image_url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DriversWithIdentifiersQuery, DriversWithIdentifiersQueryVariables>;
export const DriverIdsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DriverIds' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'drivers' }, selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DriverIdsQuery, DriverIdsQueryVariables>;
export const DriversWithVehiclesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DriversWithVehicles' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'drivers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fleet_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assigned' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone_number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'first_license_acquirement_date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'license_expiration_date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'license_category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'driver_code' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'identification_token' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tokenId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isExternal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'driverId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'cpf' } },
                { kind: 'Field', name: { kind: 'Name', value: 'driver_license' } },
                { kind: 'Field', name: { kind: 'Name', value: 'registry_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'profile_image_url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vehicle' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'device' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DriversWithVehiclesQuery, DriversWithVehiclesQueryVariables>;
export const DriverNamesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DriverNames' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'drivers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DriverNamesQuery, DriverNamesQueryVariables>;
export const DeleteDriverDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteDriver' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'driverToDelete' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DeleteDriver' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteDriver' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'driverToDelete' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteDriverMutation, DeleteDriverMutationVariables>;
export const UpdateDriverDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateDriver' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'driverToUpdate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateDriver' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDriver' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'driverToUpdate' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fleet_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assigned' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone_number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'first_license_acquirement_date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'license_expiration_date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'license_category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'driver_code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cpf' } },
                { kind: 'Field', name: { kind: 'Name', value: 'driver_license' } },
                { kind: 'Field', name: { kind: 'Name', value: 'registry_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'profile_image_url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateDriverMutation, UpdateDriverMutationVariables>;
export const AddDriverDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddDriver' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'driverToAdd' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'AddDriver' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addDriver' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'driverToAdd' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fleet_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assigned' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone_number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'first_license_acquirement_date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'license_expiration_date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'license_category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'driver_code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'profile_image_url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddDriverMutation, AddDriverMutationVariables>;
export const BatchCreateDriversDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BatchCreateDrivers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BatchCreateDriversInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'batchCreateDrivers' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fleet_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone_number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cpf' } },
                { kind: 'Field', name: { kind: 'Name', value: 'driver_license' } },
                { kind: 'Field', name: { kind: 'Name', value: 'registry_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'license_category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'first_license_acquirement_date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'license_expiration_date' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BatchCreateDriversMutation, BatchCreateDriversMutationVariables>;
export const BilletsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'billets' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billets' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'companyId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'status' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } } },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BilletFields' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BilletFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Billet' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idDoc' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idCompany' } },
          { kind: 'Field', name: { kind: 'Name', value: 'boletoLink' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dataEmissao' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dataVencimento' } },
          { kind: 'Field', name: { kind: 'Name', value: 'barCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'digitableLine' } },
          { kind: 'Field', name: { kind: 'Name', value: 'titleValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nrDocumento' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nrNfse' } },
          { kind: 'Field', name: { kind: 'Name', value: 'validFrom' } },
          { kind: 'Field', name: { kind: 'Name', value: 'validTo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'runnedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seqCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nrDocEntry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nrNoteEntry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cardCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cardName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'datePayment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idContract' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payedValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'diaProRata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nfeLink' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nfeDataEmissao' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nfeHoraEmissao' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nfeTitleValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nfeIdContract' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BilletsQuery, BilletsQueryVariables>;
export const BilletsByCompaniesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'billetsByCompanies' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyIds' } },
          type: { kind: 'NonNullType', type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billetsByCompanies' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'companyIds' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'companyIds' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'status' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } } },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BilletFields' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BilletFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Billet' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idDoc' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idCompany' } },
          { kind: 'Field', name: { kind: 'Name', value: 'boletoLink' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dataEmissao' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dataVencimento' } },
          { kind: 'Field', name: { kind: 'Name', value: 'barCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'digitableLine' } },
          { kind: 'Field', name: { kind: 'Name', value: 'titleValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nrDocumento' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nrNfse' } },
          { kind: 'Field', name: { kind: 'Name', value: 'validFrom' } },
          { kind: 'Field', name: { kind: 'Name', value: 'validTo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'runnedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seqCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nrDocEntry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nrNoteEntry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cardCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cardName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'datePayment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idContract' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payedValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'diaProRata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nfeLink' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nfeDataEmissao' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nfeHoraEmissao' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nfeTitleValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nfeIdContract' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BilletsByCompaniesQuery, BilletsByCompaniesQueryVariables>;
export const RunningWithoutDriverVehiclesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'runningWithoutDriverVehicles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'timezone' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupIds' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'size' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'runningWithoutDriverVehicles' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'timezone' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'timezone' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'groupIds' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'groupIds' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'page' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'size' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'size' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'page' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalElements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vehicle' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'groupPath' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'groups' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'unassignedTripCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalTripCount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'unnamedClusters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'photoCount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastCapturedAt' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RunningWithoutDriverVehiclesQuery, RunningWithoutDriverVehiclesQueryVariables>;
export const GetFleetUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getFleetUsers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fleetId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fleetUsers' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'fleetId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fleetId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'full_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_login' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email_address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timezone_offset' } },
                { kind: 'Field', name: { kind: 'Name', value: 'occupation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'creation_date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fleet_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'groups_restriction' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'groups' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'path' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'has_custom_permissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'granted_permissions' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetFleetUsersQuery, GetFleetUsersQueryVariables>;
export const ContractsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'contracts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fleetId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contracts' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'fleetId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fleetId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contracts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'companyId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'corporateName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cnpj' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contractSignedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'industry' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'responsavel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastRegistrationChangeDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mrrCurrency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'billingDay' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dueDay' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'paymentMethod' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'paymentFrequency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'financialAdjustmentIndex' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'recentConversionEventName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'upsellBlockLoggedArea' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContractsQuery, ContractsQueryVariables>;
export const CompanyOnboardingStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'companyOnboardingStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fleetId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companyOnboardingStatus' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'fleetId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fleetId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hasAnyOnboardingContract' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasAnyContractSignedInLast90Days' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompanyOnboardingStatusQuery, CompanyOnboardingStatusQueryVariables>;
export const ValidateFuelTransactionsImportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ValidateFuelTransactionsImport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ValidateFuelTransactionsImportInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'validateFuelTransactionsImport' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'validRows' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'transactionTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'odometerInKm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantityInLiters' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCost' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'merchant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'cnpj' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'driverName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'invalidRows' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'data' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'transactionTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'odometer' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'quantityInLiters' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalCost' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'merchantName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'merchantCnpj' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'merchantCity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'merchantState' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'driverName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'rowIndex' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'column' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ValidateFuelTransactionsImportQuery, ValidateFuelTransactionsImportQueryVariables>;
export const ImportFuelTransactionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ImportFuelTransactions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ImportFuelTransactionsBatchInput' } } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'importFuelTransactions' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImportFuelTransactionsMutation, ImportFuelTransactionsMutationVariables>;
export const FuelCardAssociationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FuelCardAssociations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fuelCardAssociations' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fuelCardId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerLicensePlate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vehicle' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FuelCardAssociationsQuery, FuelCardAssociationsQueryVariables>;
export const UpdateFuelCardAssociationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateFuelCardAssociation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateFuelCardAssociationInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateFuelCardAssociation' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateFuelCardAssociationMutation, UpdateFuelCardAssociationMutationVariables>;
export const DeleteFuelCardAssociationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteFuelCardAssociation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'FuelCardAssociationStatusInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteFuelCardAssociation' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteFuelCardAssociationMutation, DeleteFuelCardAssociationMutationVariables>;
export const RestoreFuelCardAssociationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RestoreFuelCardAssociation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'FuelCardAssociationStatusInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'restoreFuelCardAssociation' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RestoreFuelCardAssociationMutation, RestoreFuelCardAssociationMutationVariables>;
export const BatchSetFuelConsumptionGoalsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BatchSetFuelConsumptionGoals' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpsertVehicleFuelConsumptionGoalInput' } } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'batchSetFuelConsumptionGoals' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'goals' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vehicle' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BatchSetFuelConsumptionGoalsMutation, BatchSetFuelConsumptionGoalsMutationVariables>;
export const FleetGeofenceRecommendationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FleetGeofenceRecommendations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fleetId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fleetGeofenceRecommendations' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'fleetId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fleetId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'area' } },
                { kind: 'Field', name: { kind: 'Name', value: 'format' } },
                { kind: 'Field', name: { kind: 'Name', value: 'radius' } },
                { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FleetGeofenceRecommendationsQuery, FleetGeofenceRecommendationsQueryVariables>;
export const CompleteFleetRecommendationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CompleteFleetRecommendation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fleetId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completeFleetRecommendation' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'fleetId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fleetId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'category' }, value: { kind: 'StringValue', value: 'POIS', block: false } },
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'finishedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dismissedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedBy' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompleteFleetRecommendationMutation, CompleteFleetRecommendationMutationVariables>;
export const DismissFleetRecommendationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DismissFleetRecommendation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fleetId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dismissFleetRecommendation' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'fleetId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fleetId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'category' }, value: { kind: 'StringValue', value: 'POIS', block: false } },
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'finishedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dismissedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedBy' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DismissFleetRecommendationMutation, DismissFleetRecommendationMutationVariables>;
export const FleetGroupRecommendationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FleetGroupRecommendations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fleetId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fleetGroupRecommendations' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'fleetId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fleetId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'suggestedName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vehicleIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dismissCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appliedPayloadJson' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FleetGroupRecommendationsQuery, FleetGroupRecommendationsQueryVariables>;
export const TouchFleetRecommendationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TouchFleetRecommendations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fleetId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'touchFleetRecommendations' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'fleetId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fleetId' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TouchFleetRecommendationsMutation, TouchFleetRecommendationsMutationVariables>;
export const ApplyGroupRecommendationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApplyGroupRecommendation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fleetId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplyGroupRecommendationInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyGroupRecommendation' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'fleetId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fleetId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'suggestedName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vehicleIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dismissCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appliedPayloadJson' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ApplyGroupRecommendationMutation, ApplyGroupRecommendationMutationVariables>;
export const DismissGroupRecommendationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DismissGroupRecommendation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fleetId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dismissGroupRecommendation' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'fleetId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fleetId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'suggestedName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vehicleIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dismissCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appliedPayloadJson' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DismissGroupRecommendationMutation, DismissGroupRecommendationMutationVariables>;
export const GetHomeSummaryVehiclesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetHomeSummaryVehicles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupIds' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'homeSummaryVehicles' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'groupIds' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'groupIds' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetHomeSummaryVehiclesQuery, GetHomeSummaryVehiclesQueryVariables>;
export const GetHomeSummaryGeofencesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetHomeSummaryGeofences' },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'homeSummaryGeofences' } }] },
    },
  ],
} as unknown as DocumentNode<GetHomeSummaryGeofencesQuery, GetHomeSummaryGeofencesQueryVariables>;
export const TokensDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Tokens' },
      variableDefinitions: [
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'fleetId' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tokens' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fleetId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'token_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cobli_internal_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fleet_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'driver_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'associated_to_fleet_at' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'token_type' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TokensQuery, TokensQueryVariables>;
export const DeleteTokenDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteToken' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteToken' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteTokenMutation, DeleteTokenMutationVariables>;
export const TokensV2Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TokensV2' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentificationTokenFilters' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tokensV2' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'driverId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isExternal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tokenId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cobliId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastUsage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lng' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vehicle' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'groups' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TokensV2Query, TokensV2QueryVariables>;
export const TokensV2ExistsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TokensV2Exists' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tokensV2' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TokensV2ExistsQuery, TokensV2ExistsQueryVariables>;
export const AssociateTokenToDriverDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AssociateTokenToDriver' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'driverId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'associateTokenToDriver' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'driverId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'driverId' } } },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssociateTokenToDriverMutation, AssociateTokenToDriverMutationVariables>;
export const DisassociateTokenFromDriverDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DisassociateTokenFromDriver' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disassociateTokenFromDriver' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DisassociateTokenFromDriverMutation, DisassociateTokenFromDriverMutationVariables>;
export const MaintenanceHistoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'maintenanceHistory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'GetMaintenanceHistoryInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'maintenanceHistory' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rows' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'occurrenceAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'odometerInKms' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalPrice' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'types' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recurrences' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'everyKms' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'everyDays' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'part' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vehicle' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'groups' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'branding' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'model' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tags' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }] },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MaintenanceHistoryQuery, MaintenanceHistoryQueryVariables>;
export const MaintenancePartsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'maintenanceParts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'GetMaintenancePartsInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'maintenanceParts' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rows' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'part' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MaintenancePartsQuery, MaintenancePartsQueryVariables>;
export const CreateMaintenanceHistoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createMaintenanceHistory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateMaintenanceHistoryInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createMaintenanceHistory' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'types' } },
                { kind: 'Field', name: { kind: 'Name', value: 'occurrenceAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'odometerInKms' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'parts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'part' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recurrences' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'everyKms' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vehicle' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'branding' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'model' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateMaintenanceHistoryMutation, CreateMaintenanceHistoryMutationVariables>;
export const UpdateMaintenanceHistoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateMaintenanceHistory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateMaintenanceHistoryInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateMaintenanceHistory' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'types' } },
                { kind: 'Field', name: { kind: 'Name', value: 'occurrenceAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'odometerInKms' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'parts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recurrences' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'everyKms' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateMaintenanceHistoryMutation, UpdateMaintenanceHistoryMutationVariables>;
export const DeleteMaintenanceHistoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteMaintenanceHistory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DeleteMaintenanceHistoryInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteMaintenanceHistory' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteMaintenanceHistoryMutation, DeleteMaintenanceHistoryMutationVariables>;
export const CreateMaintenancePartsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createMaintenanceParts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateMaintenancePartsInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createMaintenanceParts' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateMaintenancePartsMutation, CreateMaintenancePartsMutationVariables>;
export const UpdateMaintenancePartsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateMaintenanceParts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateMaintenancePartsInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateMaintenanceParts' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateMaintenancePartsMutation, UpdateMaintenancePartsMutationVariables>;
export const DeleteMaintenancePartsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteMaintenanceParts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DeleteMaintenancePartsInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteMaintenanceParts' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteMaintenancePartsMutation, DeleteMaintenancePartsMutationVariables>;
export const ValidateMaintenanceImportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ValidateMaintenanceImport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ValidateMaintenanceImportInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'validateMaintenanceImport' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'validRows' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vehicle' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'occurrenceAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'odometerInKms' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'partName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unitCost' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'partObservation' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'maintenanceObservations' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'invalidRows' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'maintenanceData' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'occurrenceAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'odometerInKms' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maintenanceObservation' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'items' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'serviceItemName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'unitCost' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'rowIndex' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'column' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'itemsData' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'partName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'unitCost' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'partObservation' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'rowIndex' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'errors' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'column' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ValidateMaintenanceImportQuery, ValidateMaintenanceImportQueryVariables>;
export const ImportMaintenanceHistoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'importMaintenanceHistory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ImportMaintenanceBatchInput' } } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'importMaintenanceHistory' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImportMaintenanceHistoryMutation, ImportMaintenanceHistoryMutationVariables>;
export const CreateMaintenanceReminderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createMaintenanceReminder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateReminderInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createMaintenanceReminder' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vehicle' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recurrenceInKm' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextOccurrenceInKm' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recurrenceInDays' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextOccurrenceDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'status' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'km' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'days' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'lastMaintenanceDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateMaintenanceReminderMutation, CreateMaintenanceReminderMutationVariables>;
export const UpdateMaintenanceReminderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateMaintenanceReminder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateReminderInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateMaintenanceReminder' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vehicle' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recurrenceInKm' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextOccurrenceInKm' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recurrenceInDays' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextOccurrenceDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'status' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'km' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'days' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'lastMaintenanceDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateMaintenanceReminderMutation, UpdateMaintenanceReminderMutationVariables>;
export const DeleteMaintenanceReminderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteMaintenanceReminder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DeleteMaintenanceReminderInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteMaintenanceReminder' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteMaintenanceReminderMutation, DeleteMaintenanceReminderMutationVariables>;
export const ReminderTitlesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'reminderTitles' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reminderTitles' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReminderTitlesQuery, ReminderTitlesQueryVariables>;
export const ReminderListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReminderList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'GetReminderListInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reminderList' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rows' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vehicle' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'branding' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'model' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'model' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isSuggestion' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tags' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }] },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'groups' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'recurrenceInKm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nextOccurrenceInKm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'recurrenceInDays' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nextOccurrenceDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'km' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'days' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastMaintenanceDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReminderListQuery, ReminderListQueryVariables>;
export const ReminderStatusSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReminderStatusSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'GetReminderStatusCountInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reminderStatusSummary' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'onTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'warning' } },
                { kind: 'Field', name: { kind: 'Name', value: 'delayed' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReminderStatusSummaryQuery, ReminderStatusSummaryQueryVariables>;
export const LatestMaintenanceByVehicleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'latestMaintenanceByVehicle' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'GetLatestMaintenanceInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestMaintenanceByVehicle' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'occurrenceAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'odometerInKms' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LatestMaintenanceByVehicleQuery, LatestMaintenanceByVehicleQueryVariables>;
export const CreateCheckpointManualDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createCheckpointManual' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateCheckpointManualInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCheckpointManual' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'manualOdometer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'odometerAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'odometerInKms' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vehicle' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCheckpointManualMutation, CreateCheckpointManualMutationVariables>;
export const OperationalSituationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OperationalSituations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'OperationalSituationsFilter' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operationalSituations' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'targetType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'situation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startsAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endsAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'full_name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'target' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'VehicleDTO' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', alias: { kind: 'Name', value: 'vehicleId' }, name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Device' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', alias: { kind: 'Name', value: 'deviceId' }, name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'cobliId' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'page' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalElements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OperationalSituationsQuery, OperationalSituationsQueryVariables>;
export const CreateOperationalSituationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateOperationalSituations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateOperationalSituationInput' } } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createOperationalSituations' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'situation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startsAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endsAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateOperationalSituationsMutation, CreateOperationalSituationsMutationVariables>;
export const EndOperationalSituationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EndOperationalSituation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'EndOperationalSituationInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'endOperationalSituation' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EndOperationalSituationMutation, EndOperationalSituationMutationVariables>;
export const GetPathsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPaths' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'vehicleId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startTime' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endTime' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tz' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'associationMethods' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paths' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'vehicleId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'vehicleId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'startTime' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'startTime' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'endTime' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'endTime' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'tz' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'tz' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'associationMethods' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'associationMethods' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'associationSource' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'driver' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'endLatitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endLongitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startLatitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startLongitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vehicle' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'model' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'groups' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'driver' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPathsQuery, GetPathsQueryVariables>;
export const HomeProductivityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'HomeProductivity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'start_date' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'end_date' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tz' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupIds' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'homeProductivitySummary' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'start_date' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'start_date' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'end_date' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'end_date' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'tz' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'tz' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'groupIds' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'groupIds' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'averageStopTimeInMinutes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'averageIdleOnTimeInMinutes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'averageEngineOnTimeInMinutes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HomeProductivityQuery, HomeProductivityQueryVariables>;
export const SafetyRankingProductivityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SafetyRankingProductivity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'timePeriodInput' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SafetyRankingInput' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dateInput' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SafetyRankingParamsInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'safetyRankingProductivity' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'timePeriodInput' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'averageKmPerVehicle' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'safetyRankingProductType' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'productType' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'safetyRankingScores' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'timePeriodInput' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classifiedCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'unclassifiedCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'averageFleetScore' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rows' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'score' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'variation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'drivenDistanceInKm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'drivenTimeInMinutes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'kmsPerEvent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalEventsCount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scoreDetail' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'occurrences' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'discount' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fleetEventsConfiguration' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fleet_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updated_by_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updated_by_name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'camera_events_config' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entire_fleet_camera_events_configuration' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'dms_events' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'min_speed_trigger_in_km_per_h' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'distracted_driving' },
                                    selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }] },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'yawn' },
                                    selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }] },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'phone_usage' },
                                    selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }] },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'eyes_closed' },
                                    selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }] },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'smoking' },
                                    selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }] },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'adas_events' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'min_speed_trigger_in_km_per_h' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'forward_collision_warning' },
                                    selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }] },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'harsh_events' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'light' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'acceleration' },
                                          selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }] },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'braking' },
                                          selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }] },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'cornering' },
                                          selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }] },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'impact' },
                                          selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }] },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'medium' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'acceleration' },
                                          selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }] },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'braking' },
                                          selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }] },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'cornering' },
                                          selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }] },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'impact' },
                                          selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }] },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'heavy' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'acceleration' },
                                          selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }] },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'braking' },
                                          selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }] },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'cornering' },
                                          selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }] },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'impact' },
                                          selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }] },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'safetyRankingParams' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'dateInput' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'params' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'distractedDriving' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'yawn' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneUsage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eyesClosed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'smoking' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tailgating' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fastAcceleration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'speedyTurn' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hardBreak' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roadSpeedLimit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vehicleSpeedLimit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'minDistanceInKm' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cameraCorrectionWeights' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'distractedDriving' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'yawn' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneUsage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eyesClosed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'smoking' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tailgating' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fastAcceleration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'speedyTurn' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hardBreak' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roadSpeedLimit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vehicleSpeedLimit' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'telemetryCorrectionWeights' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'distractedDriving' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'yawn' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneUsage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eyesClosed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'smoking' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tailgating' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fastAcceleration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'speedyTurn' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hardBreak' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roadSpeedLimit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vehicleSpeedLimit' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'full_name' } }] },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SafetyRankingProductivityQuery, SafetyRankingProductivityQueryVariables>;
export const DefaultSafetyRankingParamsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DefaultSafetyRankingParams' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SafetyRankingParamsInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'safetyRankingParams' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'params' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'distractedDriving' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'yawn' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneUsage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eyesClosed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'smoking' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tailgating' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fastAcceleration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'speedyTurn' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hardBreak' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roadSpeedLimit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vehicleSpeedLimit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'minDistanceInKm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ignoreDismissedEvents' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DefaultSafetyRankingParamsQuery, DefaultSafetyRankingParamsQueryVariables>;
export const NextMonthSafetyRankingParamsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NextMonthSafetyRankingParams' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SafetyRankingParamsInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'safetyRankingParams' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'params' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'distractedDriving' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'yawn' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneUsage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eyesClosed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'smoking' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tailgating' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fastAcceleration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'speedyTurn' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hardBreak' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roadSpeedLimit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vehicleSpeedLimit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'minDistanceInKm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ignoreDismissedEvents' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'full_name' } }] },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NextMonthSafetyRankingParamsQuery, NextMonthSafetyRankingParamsQueryVariables>;
export const GetHomeSpeedSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetHomeSpeedSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'begin' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'end' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tz' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'intervalInDays' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupIds' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'homeSpeedSummary' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'begin' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'begin' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'end' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'end' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'tz' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'tz' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'interval_in_days' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'intervalInDays' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'groupIds' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'groupIds' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'roadEvents' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'mediumEvents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'highEvents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'higherEvents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalEvents' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vehicleEvents' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'mediumEvents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'highEvents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'higherEvents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalEvents' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetHomeSpeedSummaryQuery, GetHomeSpeedSummaryQueryVariables>;
export const ExpensesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'expenses' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ExpensesListInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'expenses' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'occurredAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vehicle' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'groupPath' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'groupName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'tagNames' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'model' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCost' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'supplier' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'observation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deletedBy' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalElements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExpensesQuery, ExpensesQueryVariables>;
export const CategoriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'categories' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CategoriesQuery, CategoriesQueryVariables>;
export const SuppliersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'suppliers' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'suppliers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SuppliersQuery, SuppliersQueryVariables>;
export const VehicleExpensesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'vehicleExpenses' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'VehiclesExpensesInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleExpenses' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categoryCosts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'cost' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'costPerKm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'previousPeriodCostPerKm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'previousPeriodTotalCost' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'distanceDrivenInKm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCost' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vehicle' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'groupPath' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'groupName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'tagNames' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'model' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'empty' } },
                { kind: 'Field', name: { kind: 'Name', value: 'first' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last' } },
                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'numberOfElements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalElements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VehicleExpensesQuery, VehicleExpensesQueryVariables>;
export const ValidateExpensesImportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ValidateExpensesImport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ValidateExpensesImportInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'validateExpensesImport' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'validRows' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'occurredAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vehicleId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'groupPath' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'categoryId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCost' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'supplierName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'observation' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'invalidRows' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'data' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'occurredAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'categoryName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalCost' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'supplierName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'observation' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'rowIndex' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'column' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ValidateExpensesImportQuery, ValidateExpensesImportQueryVariables>;
export const ImportExpensesBatchDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ImportExpensesBatch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ImportExpensesBatchInput' } } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'importExpenses' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImportExpensesBatchMutation, ImportExpensesBatchMutationVariables>;
export const TrainingVideosDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'trainingVideos' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'trainingVideos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'categoryId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TrainingVideosQuery, TrainingVideosQueryVariables>;
export const TrainingVideosByCategoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'trainingVideosByCategory' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'trainingVideosByCategory' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'category' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'trainingVideos' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'categoryId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TrainingVideosByCategoryQuery, TrainingVideosByCategoryQueryVariables>;
export const UserTrainingMediaDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UserTrainingMedia' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userTrainingMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trainingMediaId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'finishedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserTrainingMediaQuery, UserTrainingMediaQueryVariables>;
export const UpdateUserTrainingMediaDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateUserTrainingMedia' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateUserTrainingMediaInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUserTrainingMedia' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'finishedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trainingMediaId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserTrainingMediaMutation, UpdateUserTrainingMediaMutationVariables>;
export const GetUserDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUserData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UserInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'hasCameraFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasRedeCan' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userPreferences' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fleet_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'user_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vehicle_group_ids' } },
                { kind: 'Field', name: { kind: 'Name', value: 'use_vehicles_cluster' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
                { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userAttributes' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'creation_date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'num_devices' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userFleets' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'managers' } },
                { kind: 'Field', name: { kind: 'Name', value: 'user_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fleet_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'groups_restriction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'associated_at' } },
                { kind: 'Field', name: { kind: 'Name', value: 'granted_permissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'has_no_valid_groups' } },
                { kind: 'Field', name: { kind: 'Name', value: 'has_only_groups_with_no_vehicles' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserDataQuery, GetUserDataQueryVariables>;
export const VehicleDeviceAssociationReportByDeviceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VehicleDeviceAssociationReportByDevice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'VehicleDeviceAssociationInfoInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleDeviceAssociationReportByDevice' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'associations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'device' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cobliId' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'target' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userEmail' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vehicle' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tags' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }] },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'groups' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'operationalSituation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'targetType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'situation' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'startsAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'endsAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VehicleDeviceAssociationReportByDeviceQuery, VehicleDeviceAssociationReportByDeviceQueryVariables>;
export const VehicleDeviceAssociationReportByVehicleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VehicleDeviceAssociationReportByVehicle' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'VehicleDeviceAssociationInfoInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleDeviceAssociationReportByVehicle' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'associations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'device' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cobliId' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'target' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userEmail' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vehicle' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tags' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }] },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'groups' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'operationalSituation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'targetType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'situation' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'startsAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'endsAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VehicleDeviceAssociationReportByVehicleQuery, VehicleDeviceAssociationReportByVehicleQueryVariables>;
export const VehicleGroupsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'vehicleGroups' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupIds' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleGroups' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'groupIds' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'groupIds' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'creatorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'path' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vehicles' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VehicleGroupsQuery, VehicleGroupsQueryVariables>;
export const VehicleGroupIdsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'vehicleGroupIds' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleGroups' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VehicleGroupIdsQuery, VehicleGroupIdsQueryVariables>;
export const VehicleGroupsWithPathDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'vehicleGroupsWithPath' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleGroups' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'path' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VehicleGroupsWithPathQuery, VehicleGroupsWithPathQueryVariables>;
export const VehicleGroupsWithUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'vehicleGroupsWithUsers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupIds' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleGroups' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'groupIds' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'groupIds' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'creatorId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vehicles' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'users' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'groups_restriction' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VehicleGroupsWithUsersQuery, VehicleGroupsWithUsersQueryVariables>;
export const CreateVehiclesGroupDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateVehiclesGroup' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'VehiclesGroupInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createVehiclesGroup' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'creatorId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vehicles' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateVehiclesGroupMutation, CreateVehiclesGroupMutationVariables>;
export const UpdateVehiclesGroupDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateVehiclesGroup' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'VehiclesGroupInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateVehiclesGroup' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'creatorId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vehicles' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateVehiclesGroupMutation, UpdateVehiclesGroupMutationVariables>;
export const VehicleModelsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'vehicleModels' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleModels' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                { kind: 'Field', name: { kind: 'Name', value: 'model' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VehicleModelsQuery, VehicleModelsQueryVariables>;
export const VehicleTagsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'vehicleTags' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleTags' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VehicleTagsQuery, VehicleTagsQueryVariables>;
export const DeleteVehicleTagDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteVehicleTag' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteVehicleTag' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteVehicleTagMutation, DeleteVehicleTagMutationVariables>;
export const GetFleetProductTypeForWebhooksDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getFleetProductTypeForWebhooks' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'safetyRankingProductType' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'productType' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetFleetProductTypeForWebhooksQuery, GetFleetProductTypeForWebhooksQueryVariables>;
